// This file is auto-generated. Do not edit manually.
// Run "npm run -w packages/iconik-api generate" to regenerate.
/** biome-ignore-all lint/complexity/noBannedTypes: some API definitions are unclear */
import { httpMethod } from '../constants';
import type { IconikApiHeaders, PartialBy } from '../types';

export const FilesHttpGetAnalysisProfiles =
  'FilesHttpGetAnalysisProfiles' as const;
export const FilesHttpPostAnalysisProfiles =
  'FilesHttpPostAnalysisProfiles' as const;
export const FilesHttpGetAnalysisProfilesByMediaTypeDefault =
  'FilesHttpGetAnalysisProfilesByMediaTypeDefault' as const;
export const FilesHttpDeleteAnalysisProfilesByProfileId =
  'FilesHttpDeleteAnalysisProfilesByProfileId' as const;
export const FilesHttpGetAnalysisProfilesByProfileId =
  'FilesHttpGetAnalysisProfilesByProfileId' as const;
export const FilesHttpPatchAnalysisProfilesByProfileId =
  'FilesHttpPatchAnalysisProfilesByProfileId' as const;
export const FilesHttpPutAnalysisProfilesByProfileId =
  'FilesHttpPutAnalysisProfilesByProfileId' as const;
export const FilesHttpDeleteAnalysisProfilesByProfileIdDefault =
  'FilesHttpDeleteAnalysisProfilesByProfileIdDefault' as const;
export const FilesHttpPostAnalysisProfilesByProfileIdDefault =
  'FilesHttpPostAnalysisProfilesByProfileIdDefault' as const;
export const FilesHttpGetAnalysisServiceAccounts =
  'FilesHttpGetAnalysisServiceAccounts' as const;
export const FilesHttpPostAnalysisServiceAccounts =
  'FilesHttpPostAnalysisServiceAccounts' as const;
export const FilesHttpDeleteAnalysisServiceAccountsByAnalysisServiceAccountId =
  'FilesHttpDeleteAnalysisServiceAccountsByAnalysisServiceAccountId' as const;
export const FilesHttpGetAnalysisServiceAccountsByAnalysisServiceAccountId =
  'FilesHttpGetAnalysisServiceAccountsByAnalysisServiceAccountId' as const;
export const FilesHttpPatchAnalysisServiceAccountsByAnalysisServiceAccountId =
  'FilesHttpPatchAnalysisServiceAccountsByAnalysisServiceAccountId' as const;
export const FilesHttpPutAnalysisServiceAccountsByAnalysisServiceAccountId =
  'FilesHttpPutAnalysisServiceAccountsByAnalysisServiceAccountId' as const;
export const FilesHttpGetAnalysisSettingsTranscriptionDefault =
  'FilesHttpGetAnalysisSettingsTranscriptionDefault' as const;
export const FilesHttpPostAssetsBulkKeyframes =
  'FilesHttpPostAssetsBulkKeyframes' as const;
export const FilesHttpPostAssetsExportLocationsByExportLocationId =
  'FilesHttpPostAssetsExportLocationsByExportLocationId' as const;
export const FilesHttpPostAssetsByAssetIdCustomKeyframe =
  'FilesHttpPostAssetsByAssetIdCustomKeyframe' as const;
export const FilesHttpPostAssetsByAssetIdCustomKeyframeByPosterId =
  'FilesHttpPostAssetsByAssetIdCustomKeyframeByPosterId' as const;
export const FilesHttpPostAssetsByAssetIdExportLocationsByExportLocationId =
  'FilesHttpPostAssetsByAssetIdExportLocationsByExportLocationId' as const;
export const FilesHttpGetAssetsByAssetIdFileSets =
  'FilesHttpGetAssetsByAssetIdFileSets' as const;
export const FilesHttpPostAssetsByAssetIdFileSets =
  'FilesHttpPostAssetsByAssetIdFileSets' as const;
export const FilesHttpPostAssetsByAssetIdFileSetsBulk =
  'FilesHttpPostAssetsByAssetIdFileSetsBulk' as const;
export const FilesHttpDeleteAssetsByAssetIdFileSetsByFileSetId =
  'FilesHttpDeleteAssetsByAssetIdFileSetsByFileSetId' as const;
export const FilesHttpGetAssetsByAssetIdFileSetsByFileSetId =
  'FilesHttpGetAssetsByAssetIdFileSetsByFileSetId' as const;
export const FilesHttpPatchAssetsByAssetIdFileSetsByFileSetId =
  'FilesHttpPatchAssetsByAssetIdFileSetsByFileSetId' as const;
export const FilesHttpPutAssetsByAssetIdFileSetsByFileSetId =
  'FilesHttpPutAssetsByAssetIdFileSetsByFileSetId' as const;
export const FilesHttpGetAssetsByAssetIdFileSetsByFileSetIdFiles =
  'FilesHttpGetAssetsByAssetIdFileSetsByFileSetIdFiles' as const;
export const FilesHttpDeleteAssetsByAssetIdFileSetsByFileSetIdPurge =
  'FilesHttpDeleteAssetsByAssetIdFileSetsByFileSetIdPurge' as const;
export const FilesHttpPutAssetsByAssetIdFileSetsByFileSetIdRestore =
  'FilesHttpPutAssetsByAssetIdFileSetsByFileSetIdRestore' as const;
export const FilesHttpGetAssetsByAssetIdFiles =
  'FilesHttpGetAssetsByAssetIdFiles' as const;
export const FilesHttpPostAssetsByAssetIdFiles =
  'FilesHttpPostAssetsByAssetIdFiles' as const;
export const FilesHttpDeleteAssetsByAssetIdFilesByFileId =
  'FilesHttpDeleteAssetsByAssetIdFilesByFileId' as const;
export const FilesHttpGetAssetsByAssetIdFilesByFileId =
  'FilesHttpGetAssetsByAssetIdFilesByFileId' as const;
export const FilesHttpPatchAssetsByAssetIdFilesByFileId =
  'FilesHttpPatchAssetsByAssetIdFilesByFileId' as const;
export const FilesHttpPutAssetsByAssetIdFilesByFileId =
  'FilesHttpPutAssetsByAssetIdFilesByFileId' as const;
export const FilesHttpPostAssetsByAssetIdFilesByFileIdCaptureByMilliseconds =
  'FilesHttpPostAssetsByAssetIdFilesByFileIdCaptureByMilliseconds' as const;
export const FilesHttpGetAssetsByAssetIdFilesByFileIdDownloadUrl =
  'FilesHttpGetAssetsByAssetIdFilesByFileIdDownloadUrl' as const;
export const FilesHttpPostAssetsByAssetIdFilesByFileIdEditProxies =
  'FilesHttpPostAssetsByAssetIdFilesByFileIdEditProxies' as const;
export const FilesHttpGetAssetsByAssetIdFilesByFileIdIsgHandlerUrl =
  'FilesHttpGetAssetsByAssetIdFilesByFileIdIsgHandlerUrl' as const;
export const FilesHttpPostAssetsByAssetIdFilesByFileIdKeyframes =
  'FilesHttpPostAssetsByAssetIdFilesByFileIdKeyframes' as const;
export const FilesHttpPostAssetsByAssetIdFilesByFileIdMediainfo =
  'FilesHttpPostAssetsByAssetIdFilesByFileIdMediainfo' as const;
export const FilesHttpPostAssetsByAssetIdFilesByFileIdMultipart =
  'FilesHttpPostAssetsByAssetIdFilesByFileIdMultipart' as const;
export const FilesHttpPostAssetsByAssetIdFilesByFileIdMultipartB2Cancel =
  'FilesHttpPostAssetsByAssetIdFilesByFileIdMultipartB2Cancel' as const;
export const FilesHttpPostAssetsByAssetIdFilesByFileIdMultipartB2Finish =
  'FilesHttpPostAssetsByAssetIdFilesByFileIdMultipartB2Finish' as const;
export const FilesHttpPostAssetsByAssetIdFilesByFileIdMultipartB2Start =
  'FilesHttpPostAssetsByAssetIdFilesByFileIdMultipartB2Start' as const;
export const FilesHttpPostAssetsByAssetIdFilesByFileIdMultipartCleanup =
  'FilesHttpPostAssetsByAssetIdFilesByFileIdMultipartCleanup' as const;
export const FilesHttpPostAssetsByAssetIdFilesByFileIdMultipartGcsComposeUrl =
  'FilesHttpPostAssetsByAssetIdFilesByFileIdMultipartGcsComposeUrl' as const;
export const FilesHttpGetAssetsByAssetIdFilesByFileIdMultipartUrl =
  'FilesHttpGetAssetsByAssetIdFilesByFileIdMultipartUrl' as const;
export const FilesHttpGetAssetsByAssetIdFilesByFileIdMultipartUrlPart =
  'FilesHttpGetAssetsByAssetIdFilesByFileIdMultipartUrlPart' as const;
export const FilesHttpPostAssetsByAssetIdFilesByFileIdMultipartUrlS3Part =
  'FilesHttpPostAssetsByAssetIdFilesByFileIdMultipartUrlS3Part' as const;
export const FilesHttpPostAssetsByAssetIdFilesByFileIdReindex =
  'FilesHttpPostAssetsByAssetIdFilesByFileIdReindex' as const;
export const FilesHttpPostAssetsByAssetIdFilesByFileIdSubtitles =
  'FilesHttpPostAssetsByAssetIdFilesByFileIdSubtitles' as const;
export const FilesHttpGetAssetsByAssetIdFormats =
  'FilesHttpGetAssetsByAssetIdFormats' as const;
export const FilesHttpPostAssetsByAssetIdFormats =
  'FilesHttpPostAssetsByAssetIdFormats' as const;
export const FilesHttpDeleteAssetsByAssetIdFormatsByFormatId =
  'FilesHttpDeleteAssetsByAssetIdFormatsByFormatId' as const;
export const FilesHttpGetAssetsByAssetIdFormatsByFormatId =
  'FilesHttpGetAssetsByAssetIdFormatsByFormatId' as const;
export const FilesHttpPatchAssetsByAssetIdFormatsByFormatId =
  'FilesHttpPatchAssetsByAssetIdFormatsByFormatId' as const;
export const FilesHttpPutAssetsByAssetIdFormatsByFormatId =
  'FilesHttpPutAssetsByAssetIdFormatsByFormatId' as const;
export const FilesHttpDeleteAssetsByAssetIdFormatsByFormatIdArchive =
  'FilesHttpDeleteAssetsByAssetIdFormatsByFormatIdArchive' as const;
export const FilesHttpPostAssetsByAssetIdFormatsByFormatIdArchive =
  'FilesHttpPostAssetsByAssetIdFormatsByFormatIdArchive' as const;
export const FilesHttpGetAssetsByAssetIdFormatsByFormatIdComponents =
  'FilesHttpGetAssetsByAssetIdFormatsByFormatIdComponents' as const;
export const FilesHttpPostAssetsByAssetIdFormatsByFormatIdComponents =
  'FilesHttpPostAssetsByAssetIdFormatsByFormatIdComponents' as const;
export const FilesHttpDeleteAssetsByAssetIdFormatsByFormatIdComponentsByComponentId =
  'FilesHttpDeleteAssetsByAssetIdFormatsByFormatIdComponentsByComponentId' as const;
export const FilesHttpGetAssetsByAssetIdFormatsByFormatIdComponentsByComponentId =
  'FilesHttpGetAssetsByAssetIdFormatsByFormatIdComponentsByComponentId' as const;
export const FilesHttpPutAssetsByAssetIdFormatsByFormatIdComponentsByComponentId =
  'FilesHttpPutAssetsByAssetIdFormatsByFormatIdComponentsByComponentId' as const;
export const FilesHttpGetAssetsByAssetIdFormatsByFormatIdFileSets =
  'FilesHttpGetAssetsByAssetIdFormatsByFormatIdFileSets' as const;
export const FilesHttpGetAssetsByAssetIdFormatsByFormatIdFileSetsSources =
  'FilesHttpGetAssetsByAssetIdFormatsByFormatIdFileSetsSources' as const;
export const FilesHttpGetAssetsByAssetIdFormatsByFormatIdFileSetsSourcesByStorageMethod =
  'FilesHttpGetAssetsByAssetIdFormatsByFormatIdFileSetsSourcesByStorageMethod' as const;
export const FilesHttpDeleteAssetsByAssetIdFormatsByFormatIdPurge =
  'FilesHttpDeleteAssetsByAssetIdFormatsByFormatIdPurge' as const;
export const FilesHttpPostAssetsByAssetIdFormatsByFormatIdRestore =
  'FilesHttpPostAssetsByAssetIdFormatsByFormatIdRestore' as const;
export const FilesHttpPutAssetsByAssetIdFormatsByFormatIdRestore =
  'FilesHttpPutAssetsByAssetIdFormatsByFormatIdRestore' as const;
export const FilesHttpGetAssetsByAssetIdFormatsByFormatIdStoragesByStorageIdFileSets =
  'FilesHttpGetAssetsByAssetIdFormatsByFormatIdStoragesByStorageIdFileSets' as const;
export const FilesHttpGetAssetsByAssetIdFormatsByName =
  'FilesHttpGetAssetsByAssetIdFormatsByName' as const;
export const FilesHttpGetAssetsByAssetIdKeyframes =
  'FilesHttpGetAssetsByAssetIdKeyframes' as const;
export const FilesHttpPostAssetsByAssetIdKeyframes =
  'FilesHttpPostAssetsByAssetIdKeyframes' as const;
export const FilesHttpDeleteAssetsByAssetIdKeyframesByKeyframeId =
  'FilesHttpDeleteAssetsByAssetIdKeyframesByKeyframeId' as const;
export const FilesHttpGetAssetsByAssetIdKeyframesByKeyframeId =
  'FilesHttpGetAssetsByAssetIdKeyframesByKeyframeId' as const;
export const FilesHttpPatchAssetsByAssetIdKeyframesByKeyframeId =
  'FilesHttpPatchAssetsByAssetIdKeyframesByKeyframeId' as const;
export const FilesHttpPutAssetsByAssetIdKeyframesByKeyframeId =
  'FilesHttpPutAssetsByAssetIdKeyframesByKeyframeId' as const;
export const FilesHttpDeleteAssetsByAssetIdKeyframesByKeyframeIdPublic =
  'FilesHttpDeleteAssetsByAssetIdKeyframesByKeyframeIdPublic' as const;
export const FilesHttpPostAssetsByAssetIdKeyframesByKeyframeIdPublic =
  'FilesHttpPostAssetsByAssetIdKeyframesByKeyframeIdPublic' as const;
export const FilesHttpPostAssetsByAssetIdMethodByStorageMethodKeyframes =
  'FilesHttpPostAssetsByAssetIdMethodByStorageMethodKeyframes' as const;
export const FilesHttpPostAssetsByAssetIdMethodByStorageMethodProxies =
  'FilesHttpPostAssetsByAssetIdMethodByStorageMethodProxies' as const;
export const FilesHttpGetAssetsByAssetIdProxies =
  'FilesHttpGetAssetsByAssetIdProxies' as const;
export const FilesHttpPostAssetsByAssetIdProxies =
  'FilesHttpPostAssetsByAssetIdProxies' as const;
export const FilesHttpDeleteAssetsByAssetIdProxiesByProxyId =
  'FilesHttpDeleteAssetsByAssetIdProxiesByProxyId' as const;
export const FilesHttpGetAssetsByAssetIdProxiesByProxyId =
  'FilesHttpGetAssetsByAssetIdProxiesByProxyId' as const;
export const FilesHttpPatchAssetsByAssetIdProxiesByProxyId =
  'FilesHttpPatchAssetsByAssetIdProxiesByProxyId' as const;
export const FilesHttpPutAssetsByAssetIdProxiesByProxyId =
  'FilesHttpPutAssetsByAssetIdProxiesByProxyId' as const;
export const FilesHttpPutAssetsByAssetIdProxiesByProxyIdContainers =
  'FilesHttpPutAssetsByAssetIdProxiesByProxyIdContainers' as const;
export const FilesHttpPostAssetsByAssetIdProxiesByProxyIdContainersByContainerIdFiles =
  'FilesHttpPostAssetsByAssetIdProxiesByProxyIdContainersByContainerIdFiles' as const;
export const FilesHttpPatchAssetsByAssetIdProxiesByProxyIdContainersByContainerIdFilesByFileId =
  'FilesHttpPatchAssetsByAssetIdProxiesByProxyIdContainersByContainerIdFilesByFileId' as const;
export const FilesHttpPutAssetsByAssetIdProxiesByProxyIdContainersByContainerIdFilesByFileId =
  'FilesHttpPutAssetsByAssetIdProxiesByProxyIdContainersByContainerIdFilesByFileId' as const;
export const FilesHttpGetAssetsByAssetIdProxiesByProxyIdDownloadUrl =
  'FilesHttpGetAssetsByAssetIdProxiesByProxyIdDownloadUrl' as const;
export const FilesHttpPostAssetsByAssetIdProxiesByProxyIdKeyframes =
  'FilesHttpPostAssetsByAssetIdProxiesByProxyIdKeyframes' as const;
export const FilesHttpPostAssetsByAssetIdProxiesByProxyIdMultipartCleanup =
  'FilesHttpPostAssetsByAssetIdProxiesByProxyIdMultipartCleanup' as const;
export const FilesHttpGetAssetsByAssetIdProxiesByProxyIdMultipartUrl =
  'FilesHttpGetAssetsByAssetIdProxiesByProxyIdMultipartUrl' as const;
export const FilesHttpGetAssetsByAssetIdProxiesByProxyIdMultipartUrlPart =
  'FilesHttpGetAssetsByAssetIdProxiesByProxyIdMultipartUrlPart' as const;
export const FilesHttpDeleteAssetsByAssetIdProxiesByProxyIdPublic =
  'FilesHttpDeleteAssetsByAssetIdProxiesByProxyIdPublic' as const;
export const FilesHttpPostAssetsByAssetIdProxiesByProxyIdPublic =
  'FilesHttpPostAssetsByAssetIdProxiesByProxyIdPublic' as const;
export const FilesHttpDeleteAssetsByAssetIdSegmentsBySegmentIdAttachments =
  'FilesHttpDeleteAssetsByAssetIdSegmentsBySegmentIdAttachments' as const;
export const FilesHttpGetAssetsByAssetIdSegmentsBySegmentIdAttachments =
  'FilesHttpGetAssetsByAssetIdSegmentsBySegmentIdAttachments' as const;
export const FilesHttpPostAssetsByAssetIdSegmentsBySegmentIdAttachments =
  'FilesHttpPostAssetsByAssetIdSegmentsBySegmentIdAttachments' as const;
export const FilesHttpDeleteAssetsByAssetIdSegmentsBySegmentIdAttachmentsByAttachmentId =
  'FilesHttpDeleteAssetsByAssetIdSegmentsBySegmentIdAttachmentsByAttachmentId' as const;
export const FilesHttpGetAssetsByAssetIdSegmentsBySegmentIdAttachmentsByAttachmentId =
  'FilesHttpGetAssetsByAssetIdSegmentsBySegmentIdAttachmentsByAttachmentId' as const;
export const FilesHttpPatchAssetsByAssetIdSegmentsBySegmentIdAttachmentsByAttachmentId =
  'FilesHttpPatchAssetsByAssetIdSegmentsBySegmentIdAttachmentsByAttachmentId' as const;
export const FilesHttpPutAssetsByAssetIdSegmentsBySegmentIdAttachmentsByAttachmentId =
  'FilesHttpPutAssetsByAssetIdSegmentsBySegmentIdAttachmentsByAttachmentId' as const;
export const FilesHttpGetAssetsByAssetIdSubtitles =
  'FilesHttpGetAssetsByAssetIdSubtitles' as const;
export const FilesHttpPostAssetsByAssetIdSubtitles =
  'FilesHttpPostAssetsByAssetIdSubtitles' as const;
export const FilesHttpGetAssetsByAssetIdSubtitlesByLanguage =
  'FilesHttpGetAssetsByAssetIdSubtitlesByLanguage' as const;
export const FilesHttpGetAssetsByAssetIdSubtitlesByLanguageCc =
  'FilesHttpGetAssetsByAssetIdSubtitlesByLanguageCc' as const;
export const FilesHttpGetAssetsByAssetIdSubtitlesByLanguageCcWebvtt =
  'FilesHttpGetAssetsByAssetIdSubtitlesByLanguageCcWebvtt' as const;
export const FilesHttpGetAssetsByAssetIdSubtitlesByLanguageWebvtt =
  'FilesHttpGetAssetsByAssetIdSubtitlesByLanguageWebvtt' as const;
export const FilesHttpDeleteAssetsByAssetIdSubtitlesBySubtitleId =
  'FilesHttpDeleteAssetsByAssetIdSubtitlesBySubtitleId' as const;
export const FilesHttpGetAssetsByAssetIdSubtitlesBySubtitleId =
  'FilesHttpGetAssetsByAssetIdSubtitlesBySubtitleId' as const;
export const FilesHttpPatchAssetsByAssetIdSubtitlesBySubtitleId =
  'FilesHttpPatchAssetsByAssetIdSubtitlesBySubtitleId' as const;
export const FilesHttpPutAssetsByAssetIdSubtitlesBySubtitleId =
  'FilesHttpPutAssetsByAssetIdSubtitlesBySubtitleId' as const;
export const FilesHttpDeleteAssetsByAssetIdSubtitlesBySubtitleIdCc =
  'FilesHttpDeleteAssetsByAssetIdSubtitlesBySubtitleIdCc' as const;
export const FilesHttpPostAssetsByAssetIdTemporaryFileSets =
  'FilesHttpPostAssetsByAssetIdTemporaryFileSets' as const;
export const FilesHttpDeleteAssetsByAssetIdTemporaryFileSetsByFileSetId =
  'FilesHttpDeleteAssetsByAssetIdTemporaryFileSetsByFileSetId' as const;
export const FilesHttpGetAssetsByAssetIdTemporaryFileSetsByFileSetIdFiles =
  'FilesHttpGetAssetsByAssetIdTemporaryFileSetsByFileSetIdFiles' as const;
export const FilesHttpPostAssetsByAssetIdTemporaryFiles =
  'FilesHttpPostAssetsByAssetIdTemporaryFiles' as const;
export const FilesHttpPatchAssetsByAssetIdTemporaryFilesByFileId =
  'FilesHttpPatchAssetsByAssetIdTemporaryFilesByFileId' as const;
export const FilesHttpPutAssetsByAssetIdTemporaryFilesByFileId =
  'FilesHttpPutAssetsByAssetIdTemporaryFilesByFileId' as const;
export const FilesHttpDeleteAssetsByAssetIdVersionsAllFileSets =
  'FilesHttpDeleteAssetsByAssetIdVersionsAllFileSets' as const;
export const FilesHttpDeleteAssetsByAssetIdVersionsAllFiles =
  'FilesHttpDeleteAssetsByAssetIdVersionsAllFiles' as const;
export const FilesHttpDeleteAssetsByAssetIdVersionsAllFormats =
  'FilesHttpDeleteAssetsByAssetIdVersionsAllFormats' as const;
export const FilesHttpDeleteAssetsByAssetIdVersionsAllKeyframes =
  'FilesHttpDeleteAssetsByAssetIdVersionsAllKeyframes' as const;
export const FilesHttpDeleteAssetsByAssetIdVersionsAllProxies =
  'FilesHttpDeleteAssetsByAssetIdVersionsAllProxies' as const;
export const FilesHttpDeleteAssetsByAssetIdVersionsAllSubtitles =
  'FilesHttpDeleteAssetsByAssetIdVersionsAllSubtitles' as const;
export const FilesHttpDeleteAssetsByAssetIdVersionsByVersionIdFileSets =
  'FilesHttpDeleteAssetsByAssetIdVersionsByVersionIdFileSets' as const;
export const FilesHttpGetAssetsByAssetIdVersionsByVersionIdFileSets =
  'FilesHttpGetAssetsByAssetIdVersionsByVersionIdFileSets' as const;
export const FilesHttpDeleteAssetsByAssetIdVersionsByVersionIdFiles =
  'FilesHttpDeleteAssetsByAssetIdVersionsByVersionIdFiles' as const;
export const FilesHttpGetAssetsByAssetIdVersionsByVersionIdFiles =
  'FilesHttpGetAssetsByAssetIdVersionsByVersionIdFiles' as const;
export const FilesHttpDeleteAssetsByAssetIdVersionsByVersionIdFormats =
  'FilesHttpDeleteAssetsByAssetIdVersionsByVersionIdFormats' as const;
export const FilesHttpGetAssetsByAssetIdVersionsByVersionIdFormats =
  'FilesHttpGetAssetsByAssetIdVersionsByVersionIdFormats' as const;
export const FilesHttpDeleteAssetsByAssetIdVersionsByVersionIdKeyframes =
  'FilesHttpDeleteAssetsByAssetIdVersionsByVersionIdKeyframes' as const;
export const FilesHttpGetAssetsByAssetIdVersionsByVersionIdKeyframes =
  'FilesHttpGetAssetsByAssetIdVersionsByVersionIdKeyframes' as const;
export const FilesHttpDeleteAssetsByAssetIdVersionsByVersionIdProxies =
  'FilesHttpDeleteAssetsByAssetIdVersionsByVersionIdProxies' as const;
export const FilesHttpGetAssetsByAssetIdVersionsByVersionIdProxies =
  'FilesHttpGetAssetsByAssetIdVersionsByVersionIdProxies' as const;
export const FilesHttpGetAssetsByAssetIdVersionsByVersionIdProxiesByProxyIdByManifestType =
  'FilesHttpGetAssetsByAssetIdVersionsByVersionIdProxiesByProxyIdByManifestType' as const;
export const FilesHttpDeleteAssetsByAssetIdVersionsByVersionIdSubtitles =
  'FilesHttpDeleteAssetsByAssetIdVersionsByVersionIdSubtitles' as const;
export const FilesHttpGetAssetsByAssetIdVersionsByVersionIdSubtitles =
  'FilesHttpGetAssetsByAssetIdVersionsByVersionIdSubtitles' as const;
export const FilesHttpGetAssetsByAssetIdVersionsByVersionIdSubtitlesByLanguageCcWebvtt =
  'FilesHttpGetAssetsByAssetIdVersionsByVersionIdSubtitlesByLanguageCcWebvtt' as const;
export const FilesHttpGetAssetsByAssetIdVersionsByVersionIdSubtitlesByLanguageWebvtt =
  'FilesHttpGetAssetsByAssetIdVersionsByVersionIdSubtitlesByLanguageWebvtt' as const;
export const FilesHttpPostAssetsByAssetIdVersionsByVersionIdTranscode =
  'FilesHttpPostAssetsByAssetIdVersionsByVersionIdTranscode' as const;
export const FilesHttpGetAssetsByAssetIdWatermarkMatches =
  'FilesHttpGetAssetsByAssetIdWatermarkMatches' as const;
export const FilesHttpPostCollectionsByCollectionIdCustomKeyframeByPosterId =
  'FilesHttpPostCollectionsByCollectionIdCustomKeyframeByPosterId' as const;
export const FilesHttpPostCollectionsByCollectionIdExportLocationsByExportLocationId =
  'FilesHttpPostCollectionsByCollectionIdExportLocationsByExportLocationId' as const;
export const FilesHttpGetCollectionsByCollectionIdKeyframes =
  'FilesHttpGetCollectionsByCollectionIdKeyframes' as const;
export const FilesHttpPostCollectionsByCollectionIdKeyframes =
  'FilesHttpPostCollectionsByCollectionIdKeyframes' as const;
export const FilesHttpPostCollectionsByCollectionIdKeyframesCopy =
  'FilesHttpPostCollectionsByCollectionIdKeyframesCopy' as const;
export const FilesHttpDeleteCollectionsByCollectionIdKeyframesByKeyframeId =
  'FilesHttpDeleteCollectionsByCollectionIdKeyframesByKeyframeId' as const;
export const FilesHttpGetCollectionsByCollectionIdKeyframesByKeyframeId =
  'FilesHttpGetCollectionsByCollectionIdKeyframesByKeyframeId' as const;
export const FilesHttpPatchCollectionsByCollectionIdKeyframesByKeyframeId =
  'FilesHttpPatchCollectionsByCollectionIdKeyframesByKeyframeId' as const;
export const FilesHttpPutCollectionsByCollectionIdKeyframesByKeyframeId =
  'FilesHttpPutCollectionsByCollectionIdKeyframesByKeyframeId' as const;
export const FilesHttpDeleteDeleteQueueFileSets =
  'FilesHttpDeleteDeleteQueueFileSets' as const;
export const FilesHttpGetDeleteQueueFileSets =
  'FilesHttpGetDeleteQueueFileSets' as const;
export const FilesHttpPostDeleteQueueFileSetsPurge =
  'FilesHttpPostDeleteQueueFileSetsPurge' as const;
export const FilesHttpPostDeleteQueueFileSetsPurgeAll =
  'FilesHttpPostDeleteQueueFileSetsPurgeAll' as const;
export const FilesHttpDeleteDeleteQueueFormats =
  'FilesHttpDeleteDeleteQueueFormats' as const;
export const FilesHttpGetDeleteQueueFormats =
  'FilesHttpGetDeleteQueueFormats' as const;
export const FilesHttpPostDeleteQueueFormatsPurge =
  'FilesHttpPostDeleteQueueFormatsPurge' as const;
export const FilesHttpPostDeleteQueueFormatsPurgeAll =
  'FilesHttpPostDeleteQueueFormatsPurgeAll' as const;
export const FilesHttpPostDrmAssetsByAssetIdVersionsByVersionIdProxiesByProxyIdAuth =
  'FilesHttpPostDrmAssetsByAssetIdVersionsByVersionIdProxiesByProxyIdAuth' as const;
export const FilesHttpGetExportLocations =
  'FilesHttpGetExportLocations' as const;
export const FilesHttpPostExportLocations =
  'FilesHttpPostExportLocations' as const;
export const FilesHttpDeleteExportLocationsByExportLocationId =
  'FilesHttpDeleteExportLocationsByExportLocationId' as const;
export const FilesHttpGetExportLocationsByExportLocationId =
  'FilesHttpGetExportLocationsByExportLocationId' as const;
export const FilesHttpPatchExportLocationsByExportLocationId =
  'FilesHttpPatchExportLocationsByExportLocationId' as const;
export const FilesHttpPutExportLocationsByExportLocationId =
  'FilesHttpPutExportLocationsByExportLocationId' as const;
export const FilesHttpPostExportLocationsByExportLocationIdBulkExport =
  'FilesHttpPostExportLocationsByExportLocationIdBulkExport' as const;
export const FilesHttpPostExportLocationsByExportLocationIdReindex =
  'FilesHttpPostExportLocationsByExportLocationIdReindex' as const;
export const FilesHttpPostExportsTemporaryFileSetsByFileSetIdStoragesByStorageId =
  'FilesHttpPostExportsTemporaryFileSetsByFileSetIdStoragesByStorageId' as const;
export const FilesHttpGetFileSetsByFileSetIdFiles =
  'FilesHttpGetFileSetsByFileSetIdFiles' as const;
export const FilesHttpPostFileSetsByFileSetIdStoragesByStorageId =
  'FilesHttpPostFileSetsByFileSetIdStoragesByStorageId' as const;
export const FilesHttpDeleteFileSetsByFileSetIdTransfersFromByStorageId =
  'FilesHttpDeleteFileSetsByFileSetIdTransfersFromByStorageId' as const;
export const FilesHttpDeleteFileSetsByFileSetIdTransfersToByStorageId =
  'FilesHttpDeleteFileSetsByFileSetIdTransfersToByStorageId' as const;
export const FilesHttpGetFilesChecksumByChecksum =
  'FilesHttpGetFilesChecksumByChecksum' as const;
export const FilesHttpDeleteFilesMissingStoragesByStorageId =
  'FilesHttpDeleteFilesMissingStoragesByStorageId' as const;
export const FilesHttpPostFilesStoragesByStorageId =
  'FilesHttpPostFilesStoragesByStorageId' as const;
export const FilesHttpPostFilesUpload = 'FilesHttpPostFilesUpload' as const;
export const FilesHttpDeleteFilesByFileIdDeletionsFromByStorageId =
  'FilesHttpDeleteFilesByFileIdDeletionsFromByStorageId' as const;
export const FilesHttpPostFormatsByFormatIdStoragesByStorageId =
  'FilesHttpPostFormatsByFormatIdStoragesByStorageId' as const;
export const FilesHttpPostFormatsByFormatNameArchiveBulk =
  'FilesHttpPostFormatsByFormatNameArchiveBulk' as const;
export const FilesHttpPostFormatsByFormatNameRestoreBulk =
  'FilesHttpPostFormatsByFormatNameRestoreBulk' as const;
export const FilesHttpGetLogos = 'FilesHttpGetLogos' as const;
export const FilesHttpPostLogos = 'FilesHttpPostLogos' as const;
export const FilesHttpDeleteLogosByLogoId =
  'FilesHttpDeleteLogosByLogoId' as const;
export const FilesHttpGetLogosByLogoId = 'FilesHttpGetLogosByLogoId' as const;
export const FilesHttpPatchLogosByLogoId =
  'FilesHttpPatchLogosByLogoId' as const;
export const FilesHttpPutMultipartGcsCompose =
  'FilesHttpPutMultipartGcsCompose' as const;
export const FilesHttpGetPlaylistsByPlaylistIdKeyframes =
  'FilesHttpGetPlaylistsByPlaylistIdKeyframes' as const;
export const FilesHttpPostPlaylistsByPlaylistIdKeyframes =
  'FilesHttpPostPlaylistsByPlaylistIdKeyframes' as const;
export const FilesHttpDeletePlaylistsByPlaylistIdKeyframesByKeyframeId =
  'FilesHttpDeletePlaylistsByPlaylistIdKeyframesByKeyframeId' as const;
export const FilesHttpGetPlaylistsByPlaylistIdKeyframesByKeyframeId =
  'FilesHttpGetPlaylistsByPlaylistIdKeyframesByKeyframeId' as const;
export const FilesHttpPatchPlaylistsByPlaylistIdKeyframesByKeyframeId =
  'FilesHttpPatchPlaylistsByPlaylistIdKeyframesByKeyframeId' as const;
export const FilesHttpPutPlaylistsByPlaylistIdKeyframesByKeyframeId =
  'FilesHttpPutPlaylistsByPlaylistIdKeyframesByKeyframeId' as const;
export const FilesHttpGetSharesStoragesByStorageIdFiles =
  'FilesHttpGetSharesStoragesByStorageIdFiles' as const;
export const FilesHttpGetStorageGatewayClusters =
  'FilesHttpGetStorageGatewayClusters' as const;
export const FilesHttpPostStorageGatewayClusters =
  'FilesHttpPostStorageGatewayClusters' as const;
export const FilesHttpDeleteStorageGatewayClustersByClusterId =
  'FilesHttpDeleteStorageGatewayClustersByClusterId' as const;
export const FilesHttpGetStorageGatewayClustersByClusterId =
  'FilesHttpGetStorageGatewayClustersByClusterId' as const;
export const FilesHttpPatchStorageGatewayClustersByClusterId =
  'FilesHttpPatchStorageGatewayClustersByClusterId' as const;
export const FilesHttpPutStorageGatewayClustersByClusterId =
  'FilesHttpPutStorageGatewayClustersByClusterId' as const;
export const FilesHttpGetStorageGateways =
  'FilesHttpGetStorageGateways' as const;
export const FilesHttpPostStorageGateways =
  'FilesHttpPostStorageGateways' as const;
export const FilesHttpGetStorageGatewaysTelemetry =
  'FilesHttpGetStorageGatewaysTelemetry' as const;
export const FilesHttpGetStorageGatewaysTelemetryByWorkerId =
  'FilesHttpGetStorageGatewaysTelemetryByWorkerId' as const;
export const FilesHttpDeleteStorageGatewaysByStorageGatewayId =
  'FilesHttpDeleteStorageGatewaysByStorageGatewayId' as const;
export const FilesHttpGetStorageGatewaysByStorageGatewayId =
  'FilesHttpGetStorageGatewaysByStorageGatewayId' as const;
export const FilesHttpPatchStorageGatewaysByStorageGatewayId =
  'FilesHttpPatchStorageGatewaysByStorageGatewayId' as const;
export const FilesHttpPutStorageGatewaysByStorageGatewayId =
  'FilesHttpPutStorageGatewaysByStorageGatewayId' as const;
export const FilesHttpPostStorageGatewaysByStorageGatewayIdLogs =
  'FilesHttpPostStorageGatewaysByStorageGatewayIdLogs' as const;
export const FilesHttpGetStorageGatewaysByStorageGatewayIdTelemetry =
  'FilesHttpGetStorageGatewaysByStorageGatewayIdTelemetry' as const;
export const FilesHttpPostStorageGatewaysByStorageGatewayIdTelemetry =
  'FilesHttpPostStorageGatewaysByStorageGatewayIdTelemetry' as const;
export const FilesHttpGetStorages = 'FilesHttpGetStorages' as const;
export const FilesHttpPostStorages = 'FilesHttpPostStorages' as const;
export const FilesHttpGetStoragesDropboxOauth =
  'FilesHttpGetStoragesDropboxOauth' as const;
export const FilesHttpGetStoragesDropboxWebhook =
  'FilesHttpGetStoragesDropboxWebhook' as const;
export const FilesHttpPostStoragesDropboxWebhook =
  'FilesHttpPostStoragesDropboxWebhook' as const;
export const FilesHttpPostStoragesFilesReindex =
  'FilesHttpPostStoragesFilesReindex' as const;
export const FilesHttpGetStoragesIsgLatestVersion =
  'FilesHttpGetStoragesIsgLatestVersion' as const;
export const FilesHttpGetStoragesMatchingByPurpose =
  'FilesHttpGetStoragesMatchingByPurpose' as const;
export const FilesHttpGetStoragesMatchingByPurposeMethodByMethod =
  'FilesHttpGetStoragesMatchingByPurposeMethodByMethod' as const;
export const FilesHttpPostStoragesReindex =
  'FilesHttpPostStoragesReindex' as const;
export const FilesHttpPostStoragesSwap = 'FilesHttpPostStoragesSwap' as const;
export const FilesHttpPostStoragesVerificationsAccess =
  'FilesHttpPostStoragesVerificationsAccess' as const;
export const FilesHttpPostStoragesVerificationsPermissions =
  'FilesHttpPostStoragesVerificationsPermissions' as const;
export const FilesHttpGetStoragesByPurposeDefault =
  'FilesHttpGetStoragesByPurposeDefault' as const;
export const FilesHttpDeleteStoragesByStorageId =
  'FilesHttpDeleteStoragesByStorageId' as const;
export const FilesHttpGetStoragesByStorageId =
  'FilesHttpGetStoragesByStorageId' as const;
export const FilesHttpPatchStoragesByStorageId =
  'FilesHttpPatchStoragesByStorageId' as const;
export const FilesHttpPutStoragesByStorageId =
  'FilesHttpPutStoragesByStorageId' as const;
export const FilesHttpDeleteStoragesByStorageIdAutoScan =
  'FilesHttpDeleteStoragesByStorageIdAutoScan' as const;
export const FilesHttpGetStoragesByStorageIdAutoScan =
  'FilesHttpGetStoragesByStorageIdAutoScan' as const;
export const FilesHttpPostStoragesByStorageIdAutoScan =
  'FilesHttpPostStoragesByStorageIdAutoScan' as const;
export const FilesHttpPostStoragesByStorageIdBulk =
  'FilesHttpPostStoragesByStorageIdBulk' as const;
export const FilesHttpDeleteStoragesByStorageIdDefault =
  'FilesHttpDeleteStoragesByStorageIdDefault' as const;
export const FilesHttpPostStoragesByStorageIdDefault =
  'FilesHttpPostStoragesByStorageIdDefault' as const;
export const FilesHttpGetStoragesByStorageIdDeletions =
  'FilesHttpGetStoragesByStorageIdDeletions' as const;
export const FilesHttpDeleteStoragesByStorageIdDeletionsByDeletionId =
  'FilesHttpDeleteStoragesByStorageIdDeletionsByDeletionId' as const;
export const FilesHttpGetStoragesByStorageIdDeletionsFrom =
  'FilesHttpGetStoragesByStorageIdDeletionsFrom' as const;
export const FilesHttpDeleteStoragesByStorageIdFiles =
  'FilesHttpDeleteStoragesByStorageIdFiles' as const;
export const FilesHttpGetStoragesByStorageIdFiles =
  'FilesHttpGetStoragesByStorageIdFiles' as const;
export const FilesHttpPatchStoragesByStorageIdFiles =
  'FilesHttpPatchStoragesByStorageIdFiles' as const;
export const FilesHttpPostStoragesByStorageIdFiles =
  'FilesHttpPostStoragesByStorageIdFiles' as const;
export const FilesHttpPutStoragesByStorageIdFiles =
  'FilesHttpPutStoragesByStorageIdFiles' as const;
export const FilesHttpPostStoragesByStorageIdFilesReindex =
  'FilesHttpPostStoragesByStorageIdFilesReindex' as const;
export const FilesHttpPostStoragesByStorageIdFilesByFileIdReindex =
  'FilesHttpPostStoragesByStorageIdFilesByFileIdReindex' as const;
export const FilesHttpGetStoragesByStorageIdGatewayEvents =
  'FilesHttpGetStoragesByStorageIdGatewayEvents' as const;
export const FilesHttpPostStoragesByStorageIdGatewayEvents =
  'FilesHttpPostStoragesByStorageIdGatewayEvents' as const;
export const FilesHttpPostStoragesByStorageIdGatewayEventsPurge =
  'FilesHttpPostStoragesByStorageIdGatewayEventsPurge' as const;
export const FilesHttpDeleteStoragesByStorageIdGatewayEventsByEventId =
  'FilesHttpDeleteStoragesByStorageIdGatewayEventsByEventId' as const;
export const FilesHttpGetStoragesByStorageIdGatewayReport =
  'FilesHttpGetStoragesByStorageIdGatewayReport' as const;
export const FilesHttpPutStoragesByStorageIdGatewayReport =
  'FilesHttpPutStoragesByStorageIdGatewayReport' as const;
export const FilesHttpPutStoragesByStorageIdGatewayStatus =
  'FilesHttpPutStoragesByStorageIdGatewayStatus' as const;
export const FilesHttpPostStoragesByStorageIdLogs =
  'FilesHttpPostStoragesByStorageIdLogs' as const;
export const FilesHttpPostStoragesByStorageIdReindex =
  'FilesHttpPostStoragesByStorageIdReindex' as const;
export const FilesHttpPostStoragesByStorageIdScan =
  'FilesHttpPostStoragesByStorageIdScan' as const;
export const FilesHttpPutStoragesByStorageIdSearchDocument =
  'FilesHttpPutStoragesByStorageIdSearchDocument' as const;
export const FilesHttpGetStoragesByStorageIdTemporaryFiles =
  'FilesHttpGetStoragesByStorageIdTemporaryFiles' as const;
export const FilesHttpGetStoragesByStorageIdTranscoders =
  'FilesHttpGetStoragesByStorageIdTranscoders' as const;
export const FilesHttpDeleteStoragesByStorageIdTranscodersByTranscoderId =
  'FilesHttpDeleteStoragesByStorageIdTranscodersByTranscoderId' as const;
export const FilesHttpPutStoragesByStorageIdTranscodersByTranscoderId =
  'FilesHttpPutStoragesByStorageIdTranscodersByTranscoderId' as const;
export const FilesHttpGetStoragesByStorageIdTransfersFrom =
  'FilesHttpGetStoragesByStorageIdTransfersFrom' as const;
export const FilesHttpDeleteStoragesByStorageIdTransfersFromByTransferId =
  'FilesHttpDeleteStoragesByStorageIdTransfersFromByTransferId' as const;
export const FilesHttpGetStoragesByStorageIdTransfersFromByTransferId =
  'FilesHttpGetStoragesByStorageIdTransfersFromByTransferId' as const;
export const FilesHttpGetStoragesByStorageIdTransfersTo =
  'FilesHttpGetStoragesByStorageIdTransfersTo' as const;
export const FilesHttpDeleteStoragesByStorageIdTransfersToByTransferId =
  'FilesHttpDeleteStoragesByStorageIdTransfersToByTransferId' as const;
export const FilesHttpGetStoragesByStorageIdTransfersToByTransferId =
  'FilesHttpGetStoragesByStorageIdTransfersToByTransferId' as const;
export const FilesHttpGetStoragesByStorageIdVerificationsAccess =
  'FilesHttpGetStoragesByStorageIdVerificationsAccess' as const;
export const FilesHttpGetStoragesByStorageIdVerificationsPermissions =
  'FilesHttpGetStoragesByStorageIdVerificationsPermissions' as const;
export const FilesHttpDeleteStoragesByStorageIdByObjectTypeFiles =
  'FilesHttpDeleteStoragesByStorageIdByObjectTypeFiles' as const;
export const FilesHttpGetTranscoders = 'FilesHttpGetTranscoders' as const;
export const FilesHttpPostTranscoders = 'FilesHttpPostTranscoders' as const;
export const FilesHttpDeleteTranscodersByTranscoderId =
  'FilesHttpDeleteTranscodersByTranscoderId' as const;
export const FilesHttpGetTranscodersByTranscoderId =
  'FilesHttpGetTranscodersByTranscoderId' as const;
export const FilesHttpPatchTranscodersByTranscoderId =
  'FilesHttpPatchTranscodersByTranscoderId' as const;
export const FilesHttpPutTranscodersByTranscoderId =
  'FilesHttpPutTranscodersByTranscoderId' as const;
export const FilesHttpPostTranscodersByTranscoderIdLogs =
  'FilesHttpPostTranscodersByTranscoderIdLogs' as const;
export const FilesHttpGetTranscodersByTranscoderIdOptionsByOptionName =
  'FilesHttpGetTranscodersByTranscoderIdOptionsByOptionName' as const;
export const FilesHttpPostTranscodersByTranscoderIdReindex =
  'FilesHttpPostTranscodersByTranscoderIdReindex' as const;
export const FilesHttpGetTranscodersByTranscoderIdStorages =
  'FilesHttpGetTranscodersByTranscoderIdStorages' as const;
export const FilesHttpPostTransfersByTransferIdUrls =
  'FilesHttpPostTransfersByTransferIdUrls' as const;
export const FilesHttpGetTransfersByTransferIdUrlsVerify =
  'FilesHttpGetTransfersByTransferIdUrlsVerify' as const;
export const FilesHttpPostV2AssetsBulkArchive =
  'FilesHttpPostV2AssetsBulkArchive' as const;
export const FilesHttpPostV2AssetsBulkRestore =
  'FilesHttpPostV2AssetsBulkRestore' as const;
export const FilesHttpPostV2AssetsExportLocationsByExportLocationIdBulkExport =
  'FilesHttpPostV2AssetsExportLocationsByExportLocationIdBulkExport' as const;
export const FilesHttpPostV2AssetsStoragesByStorageIdBulkTransfer =
  'FilesHttpPostV2AssetsStoragesByStorageIdBulkTransfer' as const;
export const FilesHttpPostV2AssetsByAssetIdFormatsByFormatIdArchive =
  'FilesHttpPostV2AssetsByAssetIdFormatsByFormatIdArchive' as const;
export const FilesHttpPostV2AssetsByAssetIdFormatsByFormatIdStoragesByStorageId =
  'FilesHttpPostV2AssetsByAssetIdFormatsByFormatIdStoragesByStorageId' as const;
export const FilesHttpPostV2CollectionsBulkArchive =
  'FilesHttpPostV2CollectionsBulkArchive' as const;
export const FilesHttpPostV2CollectionsBulkRestore =
  'FilesHttpPostV2CollectionsBulkRestore' as const;
export const FilesHttpPostV2CollectionsExportLocationsByExportLocationIdBulkExport =
  'FilesHttpPostV2CollectionsExportLocationsByExportLocationIdBulkExport' as const;
export const FilesHttpPostV2CollectionsStoragesByStorageIdBulkTransfer =
  'FilesHttpPostV2CollectionsStoragesByStorageIdBulkTransfer' as const;
export const FilesHttpPostV2SavedSearchesBulkArchive =
  'FilesHttpPostV2SavedSearchesBulkArchive' as const;
export const FilesHttpPostV2SavedSearchesBulkRestore =
  'FilesHttpPostV2SavedSearchesBulkRestore' as const;
export const FilesHttpPostV2SavedSearchesExportLocationsByExportLocationIdBulkExport =
  'FilesHttpPostV2SavedSearchesExportLocationsByExportLocationIdBulkExport' as const;
export const FilesHttpPostV2SavedSearchesStoragesByStorageIdBulkTransfer =
  'FilesHttpPostV2SavedSearchesStoragesByStorageIdBulkTransfer' as const;

/**
 * Original schema `AnalysisAmazonRekognitionSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AnalysisAmazonRekognitionSettingsSchema}
 */
export interface FilesAnalysisAmazonRekognitionSettingsSchema {
  access_key: string;
  bucket: string;
  endpoint: string;
  is_system?: boolean;
  path: string;
  region: string;
  secret_key: string;
}
/**
 * Original schema `AnalysisGoogleAISettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AnalysisGoogleAISettingsSchema}
 */
export interface FilesAnalysisGoogleAISettingsSchema {
  bucket_name: string;
  is_system?: boolean;
  json_key: string;
}
/**
 * Original schema `AnalysisIconikSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AnalysisIconikSettingsSchema}
 */
export interface FilesAnalysisIconikSettingsSchema {
  is_system?: boolean;
}
/**
 * Original schema `AnalysisProfileAmazonRekognitionSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AnalysisProfileAmazonRekognitionSettingsSchema}
 */
export interface FilesAnalysisProfileAmazonRekognitionSettingsSchema {
  is_system?: boolean;
  min_confidence?: number;
}
/**
 * Original schema `AnalysisProfileBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AnalysisProfileBaseSchema}
 */
export interface FilesAnalysisProfileBaseSchema {}
/**
 * Original schema `AnalysisProfileGoogleVideoIntelligenceSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AnalysisProfileGoogleVideoIntelligenceSettingsSchema}
 */
export interface FilesAnalysisProfileGoogleVideoIntelligenceSettingsSchema {
  frame_confidence_threshold?: number;
  is_system?: boolean;
  video_confidence_threshold?: number;
}
/**
 * Original schema `AnalysisProfileGoogleVisionSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AnalysisProfileGoogleVisionSettingsSchema}
 */
export interface FilesAnalysisProfileGoogleVisionSettingsSchema {
  is_system?: boolean;
  min_confidence?: number;
}
/**
 * Original schema `AnalysisProfileIconikFaceRecognitionSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AnalysisProfileIconikFaceRecognitionSettingsSchema}
 */
export interface FilesAnalysisProfileIconikFaceRecognitionSettingsSchema {
  confirmed_face_match_threshold?: number;
  detection_threshold?: number;
  directory_path: string;
  is_system?: boolean;
  storage_id: string;
  unconfirmed_face_match_threshold?: number;
}
/**
 * Original schema `AnalysisProfileRevAISettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AnalysisProfileRevAISettingsSchema}
 */
export interface FilesAnalysisProfileRevAISettingsSchema {
  is_system?: boolean;
  min_confidence?: number;
}
/**
 * Original schema `AnalysisProfileSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AnalysisProfileSchema}
 */
export interface FilesAnalysisProfileSchema {
  analysis_service_account_id: string;
  enabled?: boolean;
  id?: string;
  is_default?: boolean;
  media_type: 'image' | 'video' | 'transcription' | 'face_image' | 'face_video';
  name: string;
  service_type?:
    | 'GOOGLE_VISION'
    | 'GOOGLE_VIDEO_INTELLIGENCE'
    | 'AMAZON_REKOGNITION'
    | 'REV_AI'
    | 'ICONIK'
    | 'ICONIK_FACE_RECOGNITION';
  settings?: {
    [k: string]: unknown;
  };
}
/**
 * Original schema `AnalysisProfileServiceIdSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AnalysisProfileServiceIdSchema}
 */
export interface FilesAnalysisProfileServiceIdSchema {
  analysis_service_account_id: string;
}
/**
 * Original schema `AnalysisProfileSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AnalysisProfileSettingsSchema}
 */
export interface FilesAnalysisProfileSettingsSchema {
  is_system?: boolean;
}
/**
 * Original schema `AnalysisProfilesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AnalysisProfilesSchema}
 */
export interface FilesAnalysisProfilesSchema {
  objects?: FilesAnalysisProfileSchema[];
}
/**
 * Original schema `AnalysisRevAISettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AnalysisRevAISettingsSchema}
 */
export interface FilesAnalysisRevAISettingsSchema {
  access_token: string;
  custom_vocabulary?: string[] | null;
  is_system?: boolean;
  /**
   * View in which to save topic extraction time-based metadata
   */
  metadata_view_id?: string | null;
  /**
   * If a transcription summary is requested, save it to this metadata field
   */
  summary_metadata_field?: string | null;
  /**
   * If topics extraction is requested, save result to this metadata field
   */
  topics_metadata_field?: string | null;
}
/**
 * Original schema `AnalysisServiceAccountBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AnalysisServiceAccountBaseSchema}
 */
export interface FilesAnalysisServiceAccountBaseSchema {}
/**
 * Original schema `AnalysisServiceAccountReadSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AnalysisServiceAccountReadSchema}
 */
export interface FilesAnalysisServiceAccountReadSchema {
  id?: string;
  method: 'GOOGLE_AI' | 'AMAZON' | 'REV_AI' | 'ICONIK';
  name: string;
  settings: {
    [k: string]: unknown;
  };
}
/**
 * Original schema `AnalysisServiceAccountSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AnalysisServiceAccountSchema}
 */
export interface FilesAnalysisServiceAccountSchema {
  id?: string;
  method: 'GOOGLE_AI' | 'AMAZON' | 'REV_AI' | 'ICONIK';
  name: string;
  settings: {
    [k: string]: unknown;
  };
}
/**
 * Original schema `AnalysisServiceAccountsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AnalysisServiceAccountsSchema}
 */
export interface FilesAnalysisServiceAccountsSchema {
  objects?: FilesAnalysisServiceAccountReadSchema[];
}
/**
 * Original schema `AnalysisTranscriptionSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AnalysisTranscriptionSettingsSchema}
 */
export interface FilesAnalysisTranscriptionSettingsSchema {
  analysis_service_account_id: string;
  analysis_service_account_settings?: {
    [k: string]: unknown;
  };
  enabled?: boolean;
  id?: string;
  is_default?: boolean;
  media_type: 'image' | 'video' | 'transcription' | 'face_image' | 'face_video';
  name: string;
  service_type?:
    | 'GOOGLE_VISION'
    | 'GOOGLE_VIDEO_INTELLIGENCE'
    | 'AMAZON_REKOGNITION'
    | 'REV_AI'
    | 'ICONIK'
    | 'ICONIK_FACE_RECOGNITION';
  settings?: {
    [k: string]: unknown;
  };
}
/**
 * Original schema `ArchiveAssetFormatSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ArchiveAssetFormatSchema}
 */
export interface FilesArchiveAssetFormatSchema {
  delete_original?: boolean;
  destination_directory_path?: string;
  destination_filename?: string;
  destination_storage_id?: string | null;
  preferred_original_storage_id?: string | null;
}
/**
 * Original schema `ArchiveAssetRequest`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ArchiveAssetRequest}
 */
export interface FilesArchiveAssetRequest {
  all_versions?: boolean;
  delete_only_from_source?: boolean;
  delete_only_from_source_context?: FilesSourceContext;
  delete_original?: boolean;
  destination_directory_path?: string | null;
  /**
   * List of format names to transfer. If not specified, ORIGINAL will be transferred.
   *
   * @minItems 1
   */
  formats?: string[];
  /**
   * ID of the object to transfer.
   */
  id: string;
  preferred_original_storage_id?: string | null;
  /**
   * List of version IDs to transfer.
   */
  version_ids?: string[];
}
/**
 * Original schema `SourceContext`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-SourceContext}
 */
export interface FilesSourceContext {
  /**
   * external storage path / id
   */
  external_id?: string | null;
  /**
   * root collection path
   */
  root_collection_path?: string | null;
  /**
   * root collection storage ID
   */
  root_collection_storage_id?: string | null;
  storage_id?: string | null;
}
/**
 * Original schema `ArchiveAssetRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ArchiveAssetRequestSchema}
 */
export interface FilesArchiveAssetRequestSchema {
  all_versions?: boolean;
  delete_only_from_source?: boolean;
  delete_only_from_source_context?: FilesSourceContext;
  delete_original?: boolean;
  destination_directory_path?: string | null;
  /**
   * List of format names to transfer. If not specified, ORIGINAL will be transferred.
   *
   * @minItems 1
   */
  formats?: string[];
  /**
   * ID of the object to transfer.
   */
  id: string;
  preferred_original_storage_id?: string | null;
  /**
   * List of version IDs to transfer.
   */
  version_ids?: string[];
}
/**
 * Original schema `ArchiveCollectionRequest`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ArchiveCollectionRequest}
 */
export interface FilesArchiveCollectionRequest {
  all_versions?: boolean;
  delete_only_from_source?: boolean;
  delete_only_from_source_context?: FilesSourceContext;
  delete_original?: boolean;
  destination_directory_path?: string | null;
  /**
   * List of format names to transfer. If not specified, ORIGINAL will be transferred.
   *
   * @minItems 1
   */
  formats?: string[];
  /**
   * ID of the object to transfer.
   */
  id: string;
  /**
   * Whether to keep the collection structure when archiving collections.
   */
  keep_collection_structure?: boolean;
  /**
   * Whether to keep the parent collection structure when archiving collections.
   */
  keep_parent_collection_structure?: boolean;
  preferred_original_storage_id?: string | null;
}
/**
 * Original schema `ArchiveCollectionRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ArchiveCollectionRequestSchema}
 */
export interface FilesArchiveCollectionRequestSchema {
  all_versions?: boolean;
  delete_only_from_source?: boolean;
  delete_only_from_source_context?: FilesSourceContext;
  delete_original?: boolean;
  destination_directory_path?: string | null;
  /**
   * List of format names to transfer. If not specified, ORIGINAL will be transferred.
   *
   * @minItems 1
   */
  formats?: string[];
  /**
   * ID of the object to transfer.
   */
  id: string;
  /**
   * Whether to keep the collection structure when archiving collections.
   */
  keep_collection_structure?: boolean;
  /**
   * Whether to keep the parent collection structure when archiving collections.
   */
  keep_parent_collection_structure?: boolean;
  preferred_original_storage_id?: string | null;
}
/**
 * Original schema `ArchiveSavedSearchRequest`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ArchiveSavedSearchRequest}
 */
export interface FilesArchiveSavedSearchRequest {
  all_versions?: boolean;
  delete_only_from_source?: boolean;
  delete_only_from_source_context?: FilesSourceContext;
  delete_original?: boolean;
  destination_directory_path?: string | null;
  /**
   * List of format names to transfer. If not specified, ORIGINAL will be transferred.
   *
   * @minItems 1
   */
  formats?: string[];
  /**
   * ID of the object to transfer.
   */
  id: string;
  preferred_original_storage_id?: string | null;
}
/**
 * Original schema `ArchiveSavedSearchRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ArchiveSavedSearchRequestSchema}
 */
export interface FilesArchiveSavedSearchRequestSchema {
  all_versions?: boolean;
  delete_only_from_source?: boolean;
  delete_only_from_source_context?: FilesSourceContext;
  delete_original?: boolean;
  destination_directory_path?: string | null;
  /**
   * List of format names to transfer. If not specified, ORIGINAL will be transferred.
   *
   * @minItems 1
   */
  formats?: string[];
  /**
   * ID of the object to transfer.
   */
  id: string;
  preferred_original_storage_id?: string | null;
}
/**
 * Original schema `AssetBatchExportItemSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AssetBatchExportItemSchema}
 */
export interface FilesAssetBatchExportItemSchema {
  asset_id: string;
  file_name?: string | null;
  format_id?: string | null;
}
/**
 * Original schema `AssetBatchExportSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AssetBatchExportSchema}
 */
export interface FilesAssetBatchExportSchema {
  assets: FilesAssetBatchExportItemSchema[];
  export_metadata?: boolean | null;
  export_to_asset_folder?: boolean | null;
  metadata_format?: ('CSV' | 'JSON' | 'XML' | null) | null;
  metadata_view?: string | null;
  overwrite?: boolean | null;
  preferred_original_storage_id?: string | null;
  transcode_profile_ids?: string[] | null;
}
/**
 * Original schema `AssetExportSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AssetExportSchema}
 */
export interface FilesAssetExportSchema {
  export_metadata?: boolean | null;
  export_to_asset_folder?: boolean | null;
  file_name?: string | null;
  format_id?: string | null;
  metadata_format?: ('CSV' | 'JSON' | 'XML' | null) | null;
  metadata_view?: string | null;
  overwrite?: boolean | null;
  preferred_original_storage_id?: string | null;
  transcode_profile_ids?: string[] | null;
}
/**
 * Original schema `AssetLinkProxySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AssetLinkProxySchema}
 */
export interface FilesAssetLinkProxySchema {
  asset_id: string;
  filename?: string;
  name?: string;
  url: string;
  version_id: string;
}
/**
 * Original schema `AssetSubclipKeyframesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AssetSubclipKeyframesSchema}
 */
export interface FilesAssetSubclipKeyframesSchema {
  asset_id: string;
  filename?: string;
  name?: string;
  original_asset_id: string;
  original_segment_id?: string;
  original_version_id: string;
  time_end_milliseconds: number;
  time_start_milliseconds: number;
  version_id: string;
}
/**
 * Original schema `AssetVersionKeyframesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AssetVersionKeyframesSchema}
 */
export interface FilesAssetVersionKeyframesSchema {
  asset_id: string;
  keyframes?: FilesKeyframe[];
  version_id: string;
}
/**
 * Original schema `Keyframe`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-Keyframe}
 */
export interface FilesKeyframe {
  asset_id?: string | null;
  collection_id?: string | null;
  date_created?: string;
  date_modified?: string;
  filename?: string;
  format?: string | null;
  id?: string;
  is_custom_keyframe?: boolean;
  is_public?: boolean;
  name?: string;
  resolution?: FilesResolutionType;
  rotation?: number | null;
  size?: number | null;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  storage_method?: string;
  time_code?: FilesTimeCodeType;
  type: 'KEYFRAME_MAP' | 'KEYFRAME' | 'POSTER';
  upload_credentials?: {
    [k: string]: unknown;
  };
  upload_headers?: {
    [k: string]: unknown;
  };
  upload_method?: string;
  upload_url?: string;
  url?: string;
  version_id?: string | null;
}
/**
 * Original schema `ResolutionType`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ResolutionType}
 */
export interface FilesResolutionType {
  height?: number;
  width?: number;
}
/**
 * Original schema `TimeCodeType`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TimeCodeType}
 */
export interface FilesTimeCodeType {
  frames_number?: number;
  is_drop_frame?: boolean;
  time_base?: FilesTimeBaseType;
}
/**
 * Original schema `TimeBaseType`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TimeBaseType}
 */
export interface FilesTimeBaseType {
  denominator?: number;
  numerator?: number;
}
/**
 * Original schema `AssetVersionsKeyframesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AssetVersionsKeyframesSchema}
 */
export interface FilesAssetVersionsKeyframesSchema {
  objects?: FilesAssetVersionKeyframesSchema[];
}
/**
 * Original schema `AttachmentBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AttachmentBaseSchema}
 */
export interface FilesAttachmentBaseSchema {
  date_created?: string;
  date_modified?: string;
  filename?: string;
  format?: string | null;
  name?: string;
  size?: number | null;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  url?: string;
}
/**
 * Original schema `AttachmentCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AttachmentCreateSchema}
 */
export interface FilesAttachmentCreateSchema {
  asset_id?: string | null;
  content_type?: string;
  date_created?: string;
  date_modified?: string;
  filename?: string;
  format?: string | null;
  id?: string;
  name?: string;
  segment_id?: string;
  size?: number | null;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  storage_method?: string;
  upload_credentials?: {
    [k: string]: unknown;
  };
  upload_headers?: {
    [k: string]: unknown;
  };
  upload_method?: string;
  upload_url?: string;
  url?: string;
}
/**
 * Original schema `AttachmentSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AttachmentSchema}
 */
export interface FilesAttachmentSchema {
  asset_id?: string | null;
  date_created?: string;
  date_modified?: string;
  filename?: string;
  format?: string | null;
  id?: string;
  name?: string;
  segment_id?: string;
  size?: number | null;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  storage_method?: string;
  upload_credentials?: {
    [k: string]: unknown;
  };
  upload_headers?: {
    [k: string]: unknown;
  };
  upload_method?: string;
  upload_url?: string;
  url?: string;
}
/**
 * Original schema `AttachmentUpdateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AttachmentUpdateSchema}
 */
export interface FilesAttachmentUpdateSchema {
  content_type?: string;
  date_created?: string;
  date_modified?: string;
  filename?: string;
  format?: string | null;
  name?: string;
  size?: number | null;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  url?: string;
}
/**
 * Original schema `AttachmentsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AttachmentsSchema}
 */
export interface FilesAttachmentsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: FilesAttachmentSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `AzureSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AzureSettingsSchema}
 */
export interface FilesAzureSettingsSchema {
  access_group_id?: string | null;
  acl_template_id?: string | null;
  add_uuid_to_filenames?: boolean;
  aggregate_identical_files?: boolean;
  aggregate_ignore?: string[];
  aggregate_only_on_same_storage?: boolean;
  connection_string: string;
  container: string;
  delete?: boolean;
  enable_collection_directory_mapping?: boolean;
  filename_is_external_id?: boolean;
  folder_name_tags_metadata_field_name?: string;
  folder_name_tags_metadata_view_id?: string | null;
  is_system?: boolean;
  local_mount?: boolean;
  metadata_conversion_url?: string;
  metadata_conversion_url_headers?: string | null;
  metadata_view_id?: string | null;
  path: string;
  preload_edge_jobs?: number | null;
  read?: boolean;
  root_collection_id?: string;
  scan?: boolean;
  scan_directories?: string[];
  scan_ignore?: string[];
  sidecar_metadata_required?: boolean;
  title_includes_extension?: boolean;
  transcode_ignore?: string[];
  write?: boolean;
}
/**
 * Original schema `B2SettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-B2SettingsSchema}
 */
export interface FilesB2SettingsSchema {
  access_group_id?: string | null;
  account_id: string;
  acl_template_id?: string | null;
  add_uuid_to_filenames?: boolean;
  aggregate_identical_files?: boolean;
  aggregate_ignore?: string[];
  aggregate_only_on_same_storage?: boolean;
  authorization_token: string;
  bucket_id: string;
  bucket_name: string;
  delete?: boolean;
  enable_collection_directory_mapping?: boolean;
  filename_is_external_id?: boolean;
  folder_name_tags_metadata_field_name?: string;
  folder_name_tags_metadata_view_id?: string | null;
  is_system?: boolean;
  local_mount?: boolean;
  metadata_conversion_url?: string;
  metadata_conversion_url_headers?: string | null;
  metadata_view_id?: string | null;
  path: string;
  preload_edge_jobs?: number | null;
  read?: boolean;
  root_collection_id?: string;
  scan?: boolean;
  scan_directories?: string[];
  scan_ignore?: string[];
  sidecar_metadata_required?: boolean;
  title_includes_extension?: boolean;
  transcode_ignore?: string[];
  write?: boolean;
}
/**
 * Original schema `BaseExportSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-BaseExportSchema}
 */
export interface FilesBaseExportSchema {
  export_metadata?: boolean | null;
  export_to_asset_folder?: boolean | null;
  metadata_format?: ('CSV' | 'JSON' | 'XML' | null) | null;
  metadata_view?: string | null;
  overwrite?: boolean | null;
  preferred_original_storage_id?: string | null;
}
/**
 * Original schema `BaseQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-BaseQueryParamsSchema}
 */
export interface FilesBaseQueryParamsSchema {
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
}
/**
 * Original schema `BulkActionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-BulkActionSchema}
 */
export interface FilesBulkActionSchema {
  /**
   * @minItems 1
   * @maxItems 500
   */
  object_ids: string[];
  object_type: 'assets' | 'collections' | 'playlists' | 'saved_searches';
}
/**
 * Original schema `BulkArchiveAssetRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-BulkArchiveAssetRequestSchema}
 */
export interface FilesBulkArchiveAssetRequestSchema {
  /**
   * ID of the storage to archive the assets to.
   */
  destination_storage_id?: string | null;
  /**
   * List of assets to archive. Each asset should contain the asset ID.
   */
  objects?: FilesArchiveAssetRequest[];
  /**
   * Parent job ID
   */
  parent_job_id?: string | null;
}
/**
 * Original schema `BulkArchiveAssetSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-BulkArchiveAssetSchema}
 */
export interface FilesBulkArchiveAssetSchema {
  /**
   * If true, all versions of the asset will be transferred
   */
  all_versions?: boolean;
  /**
   * @minItems 1
   * @maxItems 500
   */
  asset_ids: string[];
  delete_only_from_source_folder?: boolean;
  delete_original?: boolean;
  destination_directory_path?: string;
  destination_storage_id?: string | null;
  /**
   * List of format names to transfer. If not specified, all formats will be transferred.
   */
  formats?: string[];
  preferred_original_storage_id?: string | null;
}
/**
 * Original schema `BulkArchiveCollectionRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-BulkArchiveCollectionRequestSchema}
 */
export interface FilesBulkArchiveCollectionRequestSchema {
  /**
   * ID of the storage to archive the collections to.
   */
  destination_storage_id?: string | null;
  /**
   * List of collections to archive. Each collection should contain the collection ID.
   */
  objects?: FilesArchiveCollectionRequest[];
}
/**
 * Original schema `BulkArchiveSavedSearchRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-BulkArchiveSavedSearchRequestSchema}
 */
export interface FilesBulkArchiveSavedSearchRequestSchema {
  /**
   * ID of the storage to archive the saved searches to.
   */
  destination_storage_id?: string | null;
  /**
   * List of saved searches to archive. Each saved search should contain the saved search ID.
   */
  objects?: FilesArchiveSavedSearchRequest[];
}
/**
 * Original schema `BulkAssetIdsWithFiles`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-BulkAssetIdsWithFiles}
 */
export interface FilesBulkAssetIdsWithFiles {
  asset_ids?: string[];
}
/**
 * Original schema `BulkCheckAssetHasFilesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-BulkCheckAssetHasFilesSchema}
 */
export interface FilesBulkCheckAssetHasFilesSchema {
  objects: FilesCheckAssetHasFiles[];
}
/**
 * Original schema `CheckAssetHasFiles`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-CheckAssetHasFiles}
 */
export interface FilesCheckAssetHasFiles {
  asset_id: string;
  version_id: string;
}
/**
 * Original schema `BulkExportAssetRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-BulkExportAssetRequestSchema}
 */
export interface FilesBulkExportAssetRequestSchema {
  /**
   * List of assets to export. Each asset should contain the asset ID.
   */
  objects?: FilesExportAssetRequest[];
  /**
   * Parent job ID
   */
  parent_job_id?: string | null;
}
/**
 * Original schema `ExportAssetRequest`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ExportAssetRequest}
 */
export interface FilesExportAssetRequest {
  /**
   * Name of the file to export.
   */
  destination_filename?: string | null;
  /**
   * Whether to export metadata.
   */
  export_metadata?: boolean | null;
  /**
   * Whether to export to asset folder.
   */
  export_to_asset_folder?: boolean;
  /**
   * List containing a single format name to transfer. If not specified, ORIGINAL will be transferred.
   *
   * @minItems 1
   * @maxItems 1
   */
  formats?: string[];
  /**
   * ID of the object to export.
   */
  id: string;
  /**
   * Whether to overwrite existing files.
   */
  overwrite?: boolean;
  preferred_original_storage_id?: string | null;
}
/**
 * Original schema `BulkExportCollectionRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-BulkExportCollectionRequestSchema}
 */
export interface FilesBulkExportCollectionRequestSchema {
  /**
   * List of collections to export. Each collection should contain the collection ID.
   */
  objects?: FilesExportCollectionRequest[];
}
/**
 * Original schema `ExportCollectionRequest`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ExportCollectionRequest}
 */
export interface FilesExportCollectionRequest {
  /**
   * Whether to export metadata.
   */
  export_metadata?: boolean | null;
  /**
   * Whether to export to asset folder.
   */
  export_to_asset_folder?: boolean;
  /**
   * List containing a single format name to transfer. If not specified, ORIGINAL will be transferred.
   *
   * @minItems 1
   * @maxItems 1
   */
  formats?: string[];
  /**
   * ID of the object to export.
   */
  id: string;
  /**
   * Whether to keep the collection structure when exporting collections.
   */
  keep_collection_structure?: boolean;
  /**
   * Whether to keep the parent collection structure when transferring collections.
   */
  keep_parent_collection_structure?: boolean;
  /**
   * Whether to overwrite existing files.
   */
  overwrite?: boolean;
  preferred_original_storage_id?: string | null;
}
/**
 * Original schema `BulkExportSavedSearchRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-BulkExportSavedSearchRequestSchema}
 */
export interface FilesBulkExportSavedSearchRequestSchema {
  /**
   * List of saved searches to export. Each saved search should contain the saved search ID.
   */
  objects?: FilesExportSavedSearchRequest[];
}
/**
 * Original schema `ExportSavedSearchRequest`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ExportSavedSearchRequest}
 */
export interface FilesExportSavedSearchRequest {
  /**
   * Whether to export metadata.
   */
  export_metadata?: boolean | null;
  /**
   * Whether to export to asset folder.
   */
  export_to_asset_folder?: boolean;
  /**
   * List containing a single format name to transfer. If not specified, ORIGINAL will be transferred.
   *
   * @minItems 1
   * @maxItems 1
   */
  formats?: string[];
  /**
   * ID of the object to export.
   */
  id: string;
  /**
   * Whether to overwrite existing files.
   */
  overwrite?: boolean;
  preferred_original_storage_id?: string | null;
}
/**
 * Original schema `BulkFilesetArchiveSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-BulkFilesetArchiveSchema}
 */
export interface FilesBulkFilesetArchiveSchema {
  allow_duplicate_transfers?: boolean;
  delete_only_from_source_folder?: boolean;
  delete_original?: boolean;
  destination_directory_path?: string | null;
  destination_storage_id?: string | null;
  keep_collection_structure?: boolean;
  keep_parent_collection_structure?: boolean;
  /**
   * @minItems 1
   * @maxItems 500
   */
  object_ids: string[];
  object_type: 'assets' | 'collections' | 'playlists' | 'saved_searches';
  preferred_original_storage_id?: string | null;
}
/**
 * Original schema `BulkFilesetExportSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-BulkFilesetExportSchema}
 */
export interface FilesBulkFilesetExportSchema {
  allow_duplicate_transfers?: boolean;
  delete_only_from_source_folder?: boolean;
  delete_original?: boolean;
  export_metadata?: boolean | null;
  export_to_asset_folder?: boolean | null;
  keep_collection_structure?: boolean;
  metadata_format?: ('CSV' | 'JSON' | 'XML' | null) | null;
  metadata_view?: string | null;
  /**
   * @minItems 1
   * @maxItems 500
   */
  object_ids: string[];
  object_type: 'assets' | 'collections';
  overwrite?: boolean | null;
  preferred_original_storage_id?: string | null;
}
/**
 * Original schema `BulkFilesetRestoreSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-BulkFilesetRestoreSchema}
 */
export interface FilesBulkFilesetRestoreSchema {
  allow_duplicate_transfers?: boolean;
  delete_only_from_source_folder?: boolean;
  delete_original?: boolean;
  destination_directory_path?: string | null;
  destination_storage_id?: string | null;
  keep_collection_structure?: boolean;
  keep_parent_collection_structure?: boolean;
  /**
   * @minItems 1
   * @maxItems 500
   */
  object_ids: string[];
  object_type: 'assets' | 'collections' | 'playlists' | 'saved_searches';
  preferred_original_storage_id?: string | null;
}
/**
 * Original schema `BulkFilesetSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-BulkFilesetSchema}
 */
export interface FilesBulkFilesetSchema {
  /**
   * @minItems 1
   * @maxItems 500
   */
  ids: string[];
}
/**
 * Original schema `BulkRestoreAssetRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-BulkRestoreAssetRequestSchema}
 */
export interface FilesBulkRestoreAssetRequestSchema {
  /**
   * ID of the storage to restore the assets to.
   */
  destination_storage_id?: string | null;
  /**
   * List of assets to restore. Each asset should contain the asset ID and the storage ID.
   */
  objects?: FilesRestoreAssetToStorageRequest[];
  /**
   * Parent job ID
   */
  parent_job_id?: string | null;
}
/**
 * Original schema `RestoreAssetToStorageRequest`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-RestoreAssetToStorageRequest}
 */
export interface FilesRestoreAssetToStorageRequest {
  all_versions?: boolean;
  destination_directory_path?: string | null;
  /**
   * List of format names to transfer. If not specified, ORIGINAL will be transferred.
   *
   * @minItems 1
   */
  formats?: string[];
  /**
   * ID of the object to transfer.
   */
  id: string;
  preferred_original_storage_id?: string | null;
  /**
   * The restore tier to use when retrieving from cold storage one of LOW, MID, HIGH.
   */
  restore_priority?: ('LOW' | 'MID' | 'HIGH' | null) | null;
  /**
   * List of version IDs to transfer.
   */
  version_ids?: string[];
}
/**
 * Original schema `BulkRestoreCollectionRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-BulkRestoreCollectionRequestSchema}
 */
export interface FilesBulkRestoreCollectionRequestSchema {
  /**
   * ID of the storage to restore the saved searches to.
   */
  destination_storage_id?: string | null;
  /**
   * List of collections to restore. Each collection should contain the collection ID.
   */
  objects?: FilesRestoreCollectionToStorageRequest[];
}
/**
 * Original schema `RestoreCollectionToStorageRequest`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-RestoreCollectionToStorageRequest}
 */
export interface FilesRestoreCollectionToStorageRequest {
  all_versions?: boolean;
  destination_directory_path?: string | null;
  /**
   * List of format names to transfer. If not specified, ORIGINAL will be transferred.
   *
   * @minItems 1
   */
  formats?: string[];
  /**
   * ID of the object to transfer.
   */
  id: string;
  /**
   * Whether to keep the collection structure when transferring collections.
   */
  keep_collection_structure?: boolean;
  /**
   * Whether to keep the parent collection structure when transferring collections.
   */
  keep_parent_collection_structure?: boolean;
  preferred_original_storage_id?: string | null;
  /**
   * The restore tier to use when retrieving from cold storage one of LOW, MID, HIGH.
   */
  restore_priority?: ('LOW' | 'MID' | 'HIGH' | null) | null;
  /**
   * List of version IDs to transfer.
   */
  version_ids?: string[];
}
/**
 * Original schema `BulkRestoreSavedSearchRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-BulkRestoreSavedSearchRequestSchema}
 */
export interface FilesBulkRestoreSavedSearchRequestSchema {
  /**
   * ID of the storage to restore the saved searches to.
   */
  destination_storage_id?: string | null;
  /**
   * List of saved searches to restore. Each saved search should contain the saved search ID.
   */
  objects?: FilesRestoreSavedSearchToStorageRequest[];
}
/**
 * Original schema `RestoreSavedSearchToStorageRequest`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-RestoreSavedSearchToStorageRequest}
 */
export interface FilesRestoreSavedSearchToStorageRequest {
  all_versions?: boolean;
  destination_directory_path?: string | null;
  /**
   * List of format names to transfer. If not specified, ORIGINAL will be transferred.
   *
   * @minItems 1
   */
  formats?: string[];
  /**
   * ID of the object to transfer.
   */
  id: string;
  preferred_original_storage_id?: string | null;
  /**
   * The restore tier to use when retrieving from cold storage one of LOW, MID, HIGH.
   */
  restore_priority?: ('LOW' | 'MID' | 'HIGH' | null) | null;
  /**
   * List of version IDs to transfer.
   */
  version_ids?: string[];
}
/**
 * Original schema `BulkTranscodeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-BulkTranscodeSchema}
 */
export interface FilesBulkTranscodeSchema {
  format_name?: string;
  /**
   * @minItems 1
   * @maxItems 500
   */
  object_ids: string[];
  object_type: 'assets' | 'collections' | 'playlists' | 'saved_searches';
  prefer_any_cloud?: boolean;
  preferred_storage_id?: string;
  preferred_storage_method?:
    | 'FILE'
    | 'HTTP'
    | 'FTP'
    | 'SFTP'
    | 'S3'
    | 'B2'
    | 'GCS'
    | 'PORTAL'
    | 'CUSTOM'
    | 'AZURE'
    | 'DROPBOX';
  priority?: number;
}
/**
 * Original schema `BulkTransferAssetRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-BulkTransferAssetRequestSchema}
 */
export interface FilesBulkTransferAssetRequestSchema {
  /**
   * List of assets to transfer. Each asset should contain the asset ID and the storage ID.
   */
  objects?: FilesTransferAssetToStorageRequest[];
  /**
   * Parent job ID
   */
  parent_job_id?: string | null;
}
/**
 * Original schema `TransferAssetToStorageRequest`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TransferAssetToStorageRequest}
 */
export interface FilesTransferAssetToStorageRequest {
  all_versions?: boolean;
  delete_only_from_source?: boolean;
  delete_only_from_source_context?: FilesSourceContext;
  delete_original?: boolean;
  destination_directory_path?: string | null;
  /**
   * List of format names to transfer. If not specified, ORIGINAL will be transferred.
   *
   * @minItems 1
   */
  formats?: string[];
  /**
   * ID of the object to transfer.
   */
  id: string;
  preferred_original_storage_id?: string | null;
  /**
   * List of version IDs to transfer.
   */
  version_ids?: string[];
}
/**
 * Original schema `BulkTransferAssetToStorageSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-BulkTransferAssetToStorageSchema}
 */
export interface FilesBulkTransferAssetToStorageSchema {
  /**
   * If true, all versions of the asset will be transferred
   */
  all_versions?: boolean;
  /**
   * @minItems 1
   * @maxItems 500
   */
  asset_ids: string[];
  destination_directory_path?: string;
  /**
   * List of format names to transfer. If not specified, all formats will be transferred.
   */
  formats?: string[];
}
/**
 * Original schema `BulkTransferCollectionRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-BulkTransferCollectionRequestSchema}
 */
export interface FilesBulkTransferCollectionRequestSchema {
  /**
   * List of collections to transfer. Each collection should contain the collection ID.
   */
  objects?: FilesTransferCollectionToStorageRequest[];
}
/**
 * Original schema `TransferCollectionToStorageRequest`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TransferCollectionToStorageRequest}
 */
export interface FilesTransferCollectionToStorageRequest {
  all_versions?: boolean;
  delete_only_from_source?: boolean;
  delete_only_from_source_context?: FilesSourceContext;
  delete_original?: boolean;
  destination_directory_path?: string | null;
  /**
   * List of format names to transfer. If not specified, ORIGINAL will be transferred.
   *
   * @minItems 1
   */
  formats?: string[];
  /**
   * ID of the object to transfer.
   */
  id: string;
  /**
   * Whether to keep the collection structure when transferring collections.
   */
  keep_collection_structure?: boolean;
  /**
   * Whether to keep the parent collection structure when transferring collections.
   */
  keep_parent_collection_structure?: boolean;
  preferred_original_storage_id?: string | null;
}
/**
 * Original schema `BulkTransferSavedSearchRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-BulkTransferSavedSearchRequestSchema}
 */
export interface FilesBulkTransferSavedSearchRequestSchema {
  /**
   * List of saved searches to transfer. Each saved search should contain the saved search ID.
   */
  objects?: FilesTransferSavedSearchToStorageRequest[];
}
/**
 * Original schema `TransferSavedSearchToStorageRequest`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TransferSavedSearchToStorageRequest}
 */
export interface FilesTransferSavedSearchToStorageRequest {
  all_versions?: boolean;
  delete_only_from_source?: boolean;
  delete_only_from_source_context?: FilesSourceContext;
  delete_original?: boolean;
  destination_directory_path?: string | null;
  /**
   * List of format names to transfer. If not specified, ORIGINAL will be transferred.
   *
   * @minItems 1
   */
  formats?: string[];
  /**
   * ID of the object to transfer.
   */
  id: string;
  preferred_original_storage_id?: string | null;
}
/**
 * Original schema `BulkTransferSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-BulkTransferSchema}
 */
export interface FilesBulkTransferSchema {
  allow_duplicate_transfers?: boolean;
  delete_only_from_source_folder?: boolean;
  delete_original?: boolean;
  keep_collection_structure?: boolean;
  /**
   * @minItems 1
   * @maxItems 500
   */
  object_ids: string[];
  object_type: 'assets' | 'collections' | 'playlists' | 'saved_searches';
  preferred_original_storage_id?: string | null;
}
/**
 * Original schema `BulkTransferToStorageSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-BulkTransferToStorageSchema}
 */
export interface FilesBulkTransferToStorageSchema {
  allow_duplicate_transfers?: boolean;
  delete_only_from_source_folder?: boolean;
  delete_original?: boolean;
  file_path?: string | null;
  format_name?: string;
  keep_collection_structure?: boolean;
  keep_parent_collection_structure?: boolean;
  /**
   * @minItems 1
   * @maxItems 500
   */
  object_ids: string[];
  object_type: 'assets' | 'collections' | 'playlists' | 'saved_searches';
  overwrite?: boolean;
  preferred_original_storage_id?: string | null;
}
/**
 * Original schema `CheckAssetHasFilesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-CheckAssetHasFilesSchema}
 */
export interface FilesCheckAssetHasFilesSchema {
  asset_id: string;
  version_id: string;
}
/**
 * Original schema `CollectionCopyKeyframesRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-CollectionCopyKeyframesRequestSchema}
 */
export interface FilesCollectionCopyKeyframesRequestSchema {
  custom_keyframe?: string | null;
  custom_poster?: string | null;
  id: string;
}
/**
 * Original schema `CollectionCopyKeyframesResponseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-CollectionCopyKeyframesResponseSchema}
 */
export interface FilesCollectionCopyKeyframesResponseSchema {
  custom_keyframe?: string | null;
  custom_poster?: string | null;
}
/**
 * Original schema `CollectionExportSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-CollectionExportSchema}
 */
export interface FilesCollectionExportSchema {
  delete_original?: boolean | null;
  export_metadata?: boolean | null;
  export_to_asset_folder?: boolean | null;
  keep_collection_structure?: boolean | null;
  metadata_format?: ('CSV' | 'JSON' | 'XML' | null) | null;
  metadata_view?: string | null;
  overwrite?: boolean | null;
  preferred_original_storage_id?: string | null;
}
/**
 * Original schema `CollectionKeyframeCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-CollectionKeyframeCreateSchema}
 */
export interface FilesCollectionKeyframeCreateSchema {
  collection_id?: string;
  content_type?: string;
  date_created?: string;
  date_modified?: string;
  filename?: string;
  format?: string | null;
  id?: string;
  is_custom_keyframe?: boolean;
  is_public?: boolean;
  name?: string;
  resolution?: FilesResolutionType;
  rotation?: number | null;
  size?: number | null;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  time_code?: FilesTimeCodeType;
  type: 'KEYFRAME_MAP' | 'KEYFRAME' | 'POSTER';
  upload_credentials?: {
    [k: string]: unknown;
  };
  upload_headers?: {
    [k: string]: unknown;
  };
  upload_method?: string;
  upload_url?: string;
  url?: string;
}
/**
 * Original schema `CollectionKeyframeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-CollectionKeyframeSchema}
 */
export interface FilesCollectionKeyframeSchema {
  collection_id?: string;
  date_created?: string;
  date_modified?: string;
  filename?: string;
  format?: string | null;
  id?: string;
  is_custom_keyframe?: boolean;
  is_public?: boolean;
  name?: string;
  resolution?: FilesResolutionType;
  rotation?: number | null;
  size?: number | null;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  time_code?: FilesTimeCodeType;
  type: 'KEYFRAME_MAP' | 'KEYFRAME' | 'POSTER';
  url?: string;
}
/**
 * Original schema `CollectionKeyframeUpdateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-CollectionKeyframeUpdateSchema}
 */
export interface FilesCollectionKeyframeUpdateSchema {
  date_created?: string;
  date_modified?: string;
  filename?: string;
  format?: string | null;
  is_custom_keyframe?: boolean;
  is_public?: boolean;
  name?: string;
  resolution?: FilesResolutionType;
  rotation?: number | null;
  size?: number | null;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  time_code?: FilesTimeCodeType;
  type: 'KEYFRAME_MAP' | 'KEYFRAME' | 'POSTER';
  url?: string;
}
/**
 * Original schema `CollectionKeyframesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-CollectionKeyframesSchema}
 */
export interface FilesCollectionKeyframesSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: FilesCollectionKeyframeSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `CompleteExportToLocalStorageSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-CompleteExportToLocalStorageSchema}
 */
export interface FilesCompleteExportToLocalStorageSchema {
  add_file_set?: boolean;
  asset_id?: string;
  asset_paths?: string[];
  collection_storage_id?: string;
  component_ids?: string[];
  delete_only_from_source_folder?: boolean;
  delete_remote_file_set_after_download?: boolean;
  delete_source_file_set_after_download?: boolean;
  destination_base_directory?: string;
  destination_directory_path: string;
  destination_file_set_name: string;
  destination_filename?: string;
  export_metadata_format?: string;
  export_metadata_view?: string;
  export_original?: boolean;
  export_posters?: boolean;
  export_proxy?: boolean;
  export_transcription_format?: string;
  file_set_id?: string;
  format_id?: string;
  id?: string;
  include_original_extension?: boolean;
  job_id?: string;
  job_steps?: {
    [k: string]: unknown;
  };
  local_storage_id?: string;
  original_storage_id?: string;
  original_url?: string;
  overwrite?: boolean;
  parent_job_id?: string;
  temporary_file_set_source?: boolean;
  transfer_type?: string;
}
/**
 * Original schema `ComponentSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ComponentSchema}
 */
export interface FilesComponentSchema {
  id?: string;
  /**
   * Sequence cannot have more than 10000. Excess values will be stripped
   */
  metadata?: {
    [k: string]: string;
  };
  name: string;
  type:
    | 'VIDEO'
    | 'AUDIO'
    | 'IMAGE'
    | 'TEXT'
    | 'OTHER'
    | 'NON_MEDIA'
    | 'EXIF'
    | 'IPTC'
    | 'XMP'
    | 'GENERAL'
    | 'MANIFEST';
}
/**
 * Original schema `ComponentsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ComponentsSchema}
 */
export interface FilesComponentsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: FilesComponentSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `CustomSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-CustomSettingsSchema}
 */
export interface FilesCustomSettingsSchema {
  custom?: string;
  delete?: boolean;
  is_system?: boolean;
  read?: boolean;
  write?: boolean;
}
/**
 * Original schema `DeleteQueueFileSetsQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-DeleteQueueFileSetsQueryParamsSchema}
 */
export interface FilesDeleteQueueFileSetsQueryParamsSchema {
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
}
/**
 * Original schema `DeleteQueueFormatsQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-DeleteQueueFormatsQueryParamsSchema}
 */
export interface FilesDeleteQueueFormatsQueryParamsSchema {
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
}
/**
 * Original schema `DeleteQueueSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-DeleteQueueSchema}
 */
export interface FilesDeleteQueueSchema {
  ids: string[];
}
/**
 * Original schema `DropboxSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-DropboxSettingsSchema}
 */
export interface FilesDropboxSettingsSchema {
  access_group_id?: string | null;
  account_id?: string;
  acl_template_id?: string | null;
  add_uuid_to_filenames?: boolean;
  aggregate_identical_files?: boolean;
  aggregate_ignore?: string[];
  aggregate_only_on_same_storage?: boolean;
  app_key?: string;
  app_secret?: string;
  delete?: boolean;
  enable_collection_directory_mapping?: boolean;
  enable_webhook?: boolean;
  filename_is_external_id?: boolean;
  folder_name_tags_metadata_field_name?: string;
  folder_name_tags_metadata_view_id?: string | null;
  is_system?: boolean;
  local_mount?: boolean;
  metadata_conversion_url?: string;
  metadata_conversion_url_headers?: string | null;
  metadata_view_id?: string | null;
  oauth_code?: string;
  oauth_code_verifier?: string;
  oauth_redirect_uri?: string;
  path: string;
  preload_edge_jobs?: number | null;
  read?: boolean;
  refresh_token?: string;
  root_collection_id?: string;
  scan?: boolean;
  scan_directories?: string[];
  scan_ignore?: string[];
  sidecar_metadata_required?: boolean;
  title_includes_extension?: boolean;
  transcode_ignore?: string[];
  webhook_last_event_time?: string | null;
  write?: boolean;
}
/**
 * Original schema `EditProxyResponseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-EditProxyResponseSchema}
 */
export interface FilesEditProxyResponseSchema {
  audio_bitrate?: number;
  audio_codec?: string;
  bitrate?: number;
  codec?: string;
  directory_path?: string;
  file_set_id?: string;
  format_id?: string;
  gop_length_seconds?: number;
  height?: number;
  id?: string;
  name?: string;
  transcoder_id?: string;
  type?: string;
  width?: number;
}
/**
 * Original schema `EditProxySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-EditProxySchema}
 */
export interface FilesEditProxySchema {
  allow_mxf?: boolean | null;
  directory_path: string | null;
  file_suffix?: string | null;
  force_storage_id?: boolean;
  height: number;
  ignore_transcoder_settings?: boolean;
  keep_extension?: boolean | null;
  name: string;
  storage_id: string;
  version_id: string;
  width: number;
}
/**
 * Original schema `EditProxySettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-EditProxySettingsSchema}
 */
export interface FilesEditProxySettingsSchema {
  audio_bitrate?: number;
  audio_codec?: string | null;
  bitrate?: number;
  codec?: string;
  data?: string;
  delete_after_upload?: boolean;
  destination_path?: string | null;
  exclude_patterns?: string[];
  /**
   * Maximum interval in seconds between keyframes in video encoding. The actual gop is calculated from framerate. 0 is treated as I-frame only
   */
  gop_length_seconds?: number | null;
  height: number;
  include_patterns?: string[];
  local?: boolean;
  local_destination_path?: string | null;
  min_height?: number;
  min_width?: number;
  priority?: number | null;
  storage_id?: string | null;
  width: number;
}
/**
 * Original schema `EditReadyTranscoderSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-EditReadyTranscoderSchema}
 */
export interface FilesEditReadyTranscoderSchema {
  apply_color_conversion?: boolean;
  bitrate?: number;
  create_edit_proxy?: boolean;
  delete_after_upload?: boolean;
  edit_proxy_height?: number;
  edit_proxy_local_storage_path?: string;
  edit_proxy_upload_storage_id?: string;
  edit_proxy_upload_storage_path?: string;
  edit_proxy_width?: number;
  editready_preset?: string;
  enable_multi_channel_audio?: boolean;
  exclude_patterns?: string[];
  include_patterns?: string[];
  local?: boolean;
  min_height?: number;
  min_width?: number;
  overwrite_edit_proxy?: boolean;
  videocodec?:
    | 'Apple_ProRes_422_HQ'
    | 'Apple_ProRes_422'
    | 'Apple_ProRes_4444'
    | 'Apple_ProRes_422_LT'
    | 'Apple_ProRes_422_Proxy';
  width: number;
}
/**
 * Original schema `ElementalMediaConvertSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ElementalMediaConvertSchema}
 */
export interface FilesElementalMediaConvertSchema {
  access_key: string;
  edit_proxy_directory_path?: string | null;
  edit_proxy_storage_id?: string | null;
  endpoint_url: string;
  exclude_patterns?: string[];
  file_group_custom_name: string;
  iam_role: string;
  include_patterns?: string[];
  job_template_name: string;
  keyframe_storage_id?: string | null;
  local?: boolean;
  priority?: number | null;
  proxy_storage_id?: string | null;
  queue_name?: string;
  region_name: string;
  s3_endpoint_url: string;
  s3_region_name?: string;
  secret_key: string;
  temp_upload_path?: string;
}
/**
 * Original schema `ElementalServerSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ElementalServerSchema}
 */
export interface FilesElementalServerSchema {
  api_key: string;
  base_url: string;
  exclude_patterns?: string[];
  include_patterns?: string[];
  keyframe_map_output_group_order?: number;
  keyframe_output_group_order?: number;
  local?: boolean;
  mount_point: string;
  priority?: number | null;
  profile: number;
  proxy_output_group_order?: number;
  username: string;
}
/**
 * Original schema `EncodingComSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-EncodingComSettingsSchema}
 */
export interface FilesEncodingComSettingsSchema {
  exclude_patterns?: string[];
  include_patterns?: string[];
  local?: boolean;
  priority?: number | null;
  user_id: string;
  user_key: string;
}
/**
 * Original schema `ExportAssetRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ExportAssetRequestSchema}
 */
export interface FilesExportAssetRequestSchema {
  /**
   * Name of the file to export.
   */
  destination_filename?: string | null;
  /**
   * Whether to export metadata.
   */
  export_metadata?: boolean | null;
  /**
   * Whether to export to asset folder.
   */
  export_to_asset_folder?: boolean;
  /**
   * List containing a single format name to transfer. If not specified, ORIGINAL will be transferred.
   *
   * @minItems 1
   * @maxItems 1
   */
  formats?: string[];
  /**
   * ID of the object to export.
   */
  id: string;
  /**
   * Whether to overwrite existing files.
   */
  overwrite?: boolean;
  preferred_original_storage_id?: string | null;
}
/**
 * Original schema `ExportCollectionRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ExportCollectionRequestSchema}
 */
export interface FilesExportCollectionRequestSchema {
  /**
   * Whether to export metadata.
   */
  export_metadata?: boolean | null;
  /**
   * Whether to export to asset folder.
   */
  export_to_asset_folder?: boolean;
  /**
   * List containing a single format name to transfer. If not specified, ORIGINAL will be transferred.
   *
   * @minItems 1
   * @maxItems 1
   */
  formats?: string[];
  /**
   * ID of the object to export.
   */
  id: string;
  /**
   * Whether to keep the collection structure when exporting collections.
   */
  keep_collection_structure?: boolean;
  /**
   * Whether to keep the parent collection structure when transferring collections.
   */
  keep_parent_collection_structure?: boolean;
  /**
   * Whether to overwrite existing files.
   */
  overwrite?: boolean;
  preferred_original_storage_id?: string | null;
}
/**
 * Original schema `ExportLocationSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ExportLocationSchema}
 */
export interface FilesExportLocationSchema {
  description?: string;
  export_metadata?: boolean;
  export_original?: boolean;
  export_posters?: boolean;
  export_proxy?: boolean;
  export_to_asset_folder?: boolean;
  export_transcriptions?: boolean;
  id?: string;
  include_original_extension?: boolean;
  metadata_format?: 'CSV' | 'JSON' | 'XML';
  metadata_view?: string;
  name: string;
  path: string;
  storage_id: string;
  system_domain_id?: string;
  transcode_profile_ids?: string[];
  transcription_format?: 'WEBVTT' | 'SRT';
}
/**
 * Original schema `ExportLocationsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ExportLocationsSchema}
 */
export interface FilesExportLocationsSchema {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: FilesExportLocationSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `ExportSavedSearchRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ExportSavedSearchRequestSchema}
 */
export interface FilesExportSavedSearchRequestSchema {
  /**
   * Whether to export metadata.
   */
  export_metadata?: boolean | null;
  /**
   * Whether to export to asset folder.
   */
  export_to_asset_folder?: boolean;
  /**
   * List containing a single format name to transfer. If not specified, ORIGINAL will be transferred.
   *
   * @minItems 1
   * @maxItems 1
   */
  formats?: string[];
  /**
   * ID of the object to export.
   */
  id: string;
  /**
   * Whether to overwrite existing files.
   */
  overwrite?: boolean;
  preferred_original_storage_id?: string | null;
}
/**
 * Original schema `ExternalReferences`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ExternalReferences}
 */
export interface FilesExternalReferences {
  action?: string;
  display_name?: string;
  icon?: string;
  uri: string;
}
/**
 * Original schema `FFmpegSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FFmpegSettingsSchema}
 */
export interface FilesFFmpegSettingsSchema {
  audio_bitrate?: number;
  bitrate?: number;
  data?: string;
  edit_proxy_folder?: string | null;
  enable_multi_channel_audio?: boolean;
  exclude_patterns?: string[];
  hdr_brightness?: number | null;
  hdr_contrast?: number | null;
  hdr_gamma?: number | null;
  hdr_saturation?: number | null;
  hdr_tonemap_desat?: number | null;
  hdr_tonemap_peak?: number | null;
  include_patterns?: string[];
  local?: boolean;
  merge_multichannel_audio_tracks?: boolean;
  overlay_coordinates?: string | null;
  overlay_url?: string | null;
  priority?: number | null;
  scaling_method?:
    | 'fast_bilinear'
    | 'bilinear'
    | 'bicubic'
    | 'experimental'
    | 'neighbor'
    | 'area'
    | 'bicublin'
    | 'gauss'
    | 'sinc'
    | 'lanczos'
    | 'spline'
    | 'accurate_rnd'
    | 'full_chroma_int'
    | 'full_chroma_inp'
    | 'bitexact';
  use_next_generation_transcoder?: boolean;
  width?: number;
}
/**
 * Original schema `FileBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FileBaseSchema}
 */
export interface FilesFileBaseSchema {
  asset_id?: string;
  checksum?: string | null;
  date_created?: string;
  date_modified?: string;
  directory_path: string;
  file_date_created?: string;
  file_date_modified?: string;
  file_set_id?: string;
  format_id?: string;
  id?: string;
  /**
   * If not specified, name will be autogenerated based on `id` and `original_name`
   */
  name?: string;
  original_name: string;
  parent_id?: string | null;
  size?: number;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  template?: string;
  template_engine?: ('SIMPLE' | 'JINJA2' | null) | null;
  type: 'FILE' | 'DIRECTORY' | 'SYMLINK' | 'SEQUENCE';
  user_id?: string | null;
  version_id?: string;
}
/**
 * Original schema `FileCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FileCreateSchema}
 */
export interface FilesFileCreateSchema {
  asset_id?: string;
  checksum?: string | null;
  content_type?: string;
  date_created?: string;
  date_modified?: string;
  directory_path: string;
  file_date_created?: string;
  file_date_modified?: string;
  file_set_id?: string;
  format_id?: string;
  id?: string;
  multipart_upload_url?: string;
  /**
   * If not specified, name will be autogenerated based on `id` and `original_name`
   */
  name?: string;
  original_name: string;
  parent_id?: string | null;
  size?: number;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  storage_method?: string;
  template?: string;
  template_engine?: ('SIMPLE' | 'JINJA2' | null) | null;
  type: 'FILE' | 'DIRECTORY' | 'SYMLINK' | 'SEQUENCE';
  upload_credentials?: {
    [k: string]: unknown;
  };
  upload_filename?: string;
  upload_headers?: {
    [k: string]: unknown;
  };
  upload_method?: string;
  upload_url?: string;
  user_id?: string | null;
  version_id?: string;
}
/**
 * Original schema `FileDeletionFromLocalStorageSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FileDeletionFromLocalStorageSchema}
 */
export interface FilesFileDeletionFromLocalStorageSchema {
  asset_id?: string;
  directory_path?: string;
  file_id: string;
  file_type?: string;
  filename: string;
  format_id?: string;
  id?: string;
  job_id: string;
  keep_source?: boolean;
  storage_id: string;
  template?: string;
  template_engine?: string;
  version_id?: string;
}
/**
 * Original schema `FileDeletionsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FileDeletionsSchema}
 */
export interface FilesFileDeletionsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: FilesFileDeletionFromLocalStorageSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `FileDownloadURLSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FileDownloadURLSchema}
 */
export interface FilesFileDownloadURLSchema {
  url?: string;
}
/**
 * Original schema `FileElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FileElasticSchema}
 */
export interface FilesFileElasticSchema {
  asset_id?: string;
  checksum?: string | null;
  date_created?: string;
  date_modified?: string;
  directory_path: string;
  file_date_created?: string;
  file_date_modified?: string;
  file_set_id?: string;
  file_set_status?: string | null;
  format_id?: string;
  format_status?: string | null;
  id?: string;
  /**
   * If not specified, name will be autogenerated based on `id` and `original_name`
   */
  name?: string;
  original_name: string;
  parent_id?: string | null;
  size?: number;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  template?: string;
  template_engine?: ('SIMPLE' | 'JINJA2' | null) | null;
  type: 'FILE' | 'DIRECTORY' | 'SYMLINK' | 'SEQUENCE';
  user_id?: string | null;
  version_id?: string;
}
/**
 * Original schema `FileExistenceCheckSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FileExistenceCheckSchema}
 */
export interface FilesFileExistenceCheckSchema {
  directory_path: string;
  file_name: string;
  file_type?: 'FILE' | 'DIRECTORY' | 'SYMLINK' | 'SEQUENCE';
  template?: string;
  template_engine?: string;
}
/**
 * Original schema `FileSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FileSchema}
 */
export interface FilesFileSchema {
  asset_id?: string;
  checksum?: string | null;
  date_created?: string;
  date_modified?: string;
  directory_path: string;
  file_date_created?: string;
  file_date_modified?: string;
  file_set_id: string;
  file_set_status?: string | null;
  format_id?: string;
  format_status?: string | null;
  id?: string;
  multipart_upload_url?: string;
  /**
   * If not specified, name will be autogenerated based on `id` and `original_name`
   */
  name?: string;
  original_name: string;
  parent_id?: string | null;
  size?: number;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  storage_method?: string;
  system_domain_id?: string;
  template?: string;
  template_engine?: ('SIMPLE' | 'JINJA2' | null) | null;
  type: 'FILE' | 'DIRECTORY' | 'SYMLINK' | 'SEQUENCE';
  upload_credentials?: {
    [k: string]: unknown;
  };
  upload_filename?: string;
  upload_headers?: {
    [k: string]: unknown;
  };
  upload_method?: string;
  /**
   * On a file creation for Backblaze B2 storage in case when request to Backblaze failed, upload_url field will be empty. You can try getting upload_url again by requesting created file with `generate_signed_post_url` set to true.
   */
  upload_url?: string;
  url?: string;
  user_id?: string | null;
  version_id?: string;
}
/**
 * Original schema `FileSetElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FileSetElasticSchema}
 */
export interface FilesFileSetElasticSchema {
  archive_file_set_id?: string;
  asset_id?: string;
  base_dir: string;
  component_ids: string[];
  date_created?: string;
  date_deleted?: string;
  date_modified?: string;
  deleted_by_user?: string;
  file_count?: number;
  format_id: string;
  id?: string;
  is_archive?: boolean;
  name: string;
  original_storage_id?: string;
  status?: 'ACTIVE' | 'ARCHIVED' | 'DELETED';
  storage_id?: string;
  type?: 'REGULAR' | 'MANY_FILES';
  version_id?: string;
}
/**
 * Original schema `FileSetSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FileSetSchema}
 */
export interface FilesFileSetSchema {
  archive_file_set_id?: string;
  asset_id?: string;
  base_dir: string;
  component_ids: string[];
  date_created?: string;
  date_deleted?: string;
  date_modified?: string;
  deleted_by_user?: string;
  file_count?: number;
  format_id: string;
  id?: string;
  is_archive?: boolean;
  name: string;
  original_storage_id?: string;
  status?: 'ACTIVE' | 'ARCHIVED' | 'DELETED';
  storage_id?: string;
  type?: 'REGULAR' | 'MANY_FILES';
  version_id?: string;
}
/**
 * Original schema `FileSetSourceSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FileSetSourceSchema}
 */
export interface FilesFileSetSourceSchema {
  archive_file_set_id?: string;
  asset_id?: string;
  base_dir: string;
  component_ids: string[];
  date_created?: string;
  date_deleted?: string;
  date_modified?: string;
  deleted_by_user?: string;
  file_count?: number;
  format_id: string;
  id?: string;
  is_archive?: boolean;
  name: string;
  original_storage_id?: string;
  status?: 'ACTIVE' | 'ARCHIVED' | 'DELETED';
  storage_id: string;
  storage_method: string;
  type?: 'REGULAR' | 'MANY_FILES';
  version_id?: string;
}
/**
 * Original schema `FileSetSourcesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FileSetSourcesSchema}
 */
export interface FilesFileSetSourcesSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: FilesFileSetSourceSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `FileSetsElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FileSetsElasticSchema}
 */
export interface FilesFileSetsElasticSchema {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: FilesFileSetElasticSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `FileSetsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FileSetsSchema}
 */
export interface FilesFileSetsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: FilesFileSetSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `FileSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FileSettingsSchema}
 */
export interface FilesFileSettingsSchema {
  access_group_id?: string | null;
  acl_template_id?: string | null;
  aggregate_identical_files?: boolean;
  aggregate_ignore?: string[];
  aggregate_only_on_same_storage?: boolean;
  allow_access_outside_scan_directories?: boolean;
  asset_versions_suffix?: string;
  auto_version_ignore?: string[];
  auto_version_ingest_throttle_value?: number;
  delete?: boolean;
  directory_assets_original_patterns?: string[];
  directory_assets_transcode_patterns?: string[];
  enable_auto_versioning?: boolean;
  enable_collection_directory_mapping?: boolean;
  enable_directory_assets?: boolean;
  filename_is_external_id?: boolean;
  folder_name_tags_metadata_field_name?: string;
  folder_name_tags_metadata_view_id?: string | null;
  gateway_user_id?: string;
  growing_files_threshold?: number;
  is_system?: boolean;
  local_keyframe_creation?: boolean;
  local_proxy_creation?: boolean;
  metadata_conversion_url?: string;
  metadata_conversion_url_headers?: string | null;
  metadata_view_id?: string | null;
  mount_point: string;
  prio_dirs?: FilesPrioDir[] | null;
  prio_patterns?: FilesPrioPattern[] | null;
  public_identity?: string;
  read?: boolean;
  remote_path?: string;
  remote_storage_id?: string;
  scan?: boolean;
  scan_directories?: string[];
  scan_ignore?: string[];
  scan_include?: string[];
  scan_interval_seconds?: number;
  sidecar_metadata_required?: boolean;
  skip_upload_on_any_remote_copy_found?: boolean;
  storage_addr?: string;
  title_includes_extension?: boolean;
  transcode_ignore?: string[];
  transcode_include?: string[];
  upload_files?: boolean;
  upload_ignore?: string[];
  write?: boolean;
}
/**
 * Original schema `PrioDir`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-PrioDir}
 */
export interface FilesPrioDir {
  directory?: string;
  priority?: number;
}
/**
 * Original schema `PrioPattern`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-PrioPattern}
 */
export interface FilesPrioPattern {
  pattern?: string;
  priority?: number;
}
/**
 * Original schema `FileShareUploadEditSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FileShareUploadEditSchema}
 */
export interface FilesFileShareUploadEditSchema {
  size?: number;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
}
/**
 * Original schema `FilesElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FilesElasticSchema}
 */
export interface FilesFilesElasticSchema {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: FilesFileElasticSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `FilesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FilesSchema}
 */
export interface FilesFilesSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: FilesFileSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `FilesetTransferBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FilesetTransferBaseSchema}
 */
export interface FilesFilesetTransferBaseSchema {
  asset_id?: string;
  asset_paths?: string[];
  collection_storage_id?: string;
  component_ids?: string[];
  delete_only_from_source_folder?: boolean;
  destination_filename?: string;
  id?: string;
  job_id?: string;
  job_steps?: {
    [k: string]: unknown;
  };
  original_storage_id?: string;
  original_url?: string;
  parent_job_id?: string;
  transfer_type?: string;
}
/**
 * Original schema `FlicsTranscoderSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FlicsTranscoderSchema}
 */
export interface FilesFlicsTranscoderSchema {
  audio_template_id?: string;
  create_edit_proxy?: boolean;
  delete_after_upload?: boolean;
  edit_proxy_local_storage_path?: string;
  edit_proxy_upload_storage_id?: string;
  edit_proxy_upload_storage_path?: string;
  enable_multi_channel_audio?: boolean;
  exclude_patterns?: string[];
  host?: string;
  image_template_id?: string;
  include_patterns?: string[];
  local?: boolean;
  max_concurrency?: number | null;
  mc_video_template_id?: string;
  secret_key?: string;
  storage_id_path_mapping?: unknown;
  storage_ids_mapping?: unknown;
  template_id?: string;
}
/**
 * Original schema `FormatArchiveSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FormatArchiveSchema}
 */
export interface FilesFormatArchiveSchema {
  delete_original?: boolean;
  destination_directory_path?: string;
  destination_file_set_name?: string;
  destination_storage_id?: string;
  destination_storage_method?: string;
  format_id?: string;
  original_file_set_id?: string;
}
/**
 * Original schema `FormatDeleteArchiveSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FormatDeleteArchiveSchema}
 */
export interface FilesFormatDeleteArchiveSchema {
  file_set_id?: string;
}
/**
 * Original schema `FormatElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FormatElasticSchema}
 */
export interface FilesFormatElasticSchema {
  archive_status?:
    | 'NOT_ARCHIVED'
    | 'ARCHIVING'
    | 'FAILED_TO_ARCHIVE'
    | 'ARCHIVED';
  asset_id?: string;
  components?: FilesComponentSchema[];
  date_created?: string;
  date_deleted?: string;
  date_modified?: string;
  deleted_by_user?: string;
  external_references?: FilesExternalReferences[];
  id?: string;
  is_online?: boolean;
  /**
   * Sequence cannot have more than 10000. Excess values will be stripped
   */
  metadata?: {
    [k: string]: string;
  }[];
  name: string;
  status?: 'ACTIVE' | 'DELETED';
  storage_methods?: string[];
  user_id?: string;
  version_id?: string;
  warnings?: string[];
}
/**
 * Original schema `FormatRestoreSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FormatRestoreSchema}
 */
export interface FilesFormatRestoreSchema {
  destination_directory_path?: string | null;
  destination_storage_id?: string;
  /**
   * Deprecated field. Use destination_storage_id instead
   */
  storage_id?: string;
}
/**
 * Original schema `FormatSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FormatSchema}
 */
export interface FilesFormatSchema {
  archive_status?:
    | 'NOT_ARCHIVED'
    | 'ARCHIVING'
    | 'FAILED_TO_ARCHIVE'
    | 'ARCHIVED';
  asset_id?: string;
  components?: FilesComponentSchema[];
  date_created?: string;
  date_deleted?: string;
  date_modified?: string;
  deleted_by_user?: string;
  external_references?: FilesExternalReferences[];
  id?: string;
  is_online?: boolean;
  /**
   * Sequence cannot have more than 10000. Excess values will be stripped
   */
  metadata?: {
    [k: string]: string;
  }[];
  name: string;
  status?: 'ACTIVE' | 'DELETED';
  storage_methods?: (
    | 'FILE'
    | 'HTTP'
    | 'FTP'
    | 'SFTP'
    | 'S3'
    | 'B2'
    | 'GCS'
    | 'PORTAL'
    | 'CUSTOM'
    | 'AZURE'
    | 'DROPBOX'
  )[];
  user_id?: string;
  version_id?: string;
  warnings?: string[];
  resolution?: FilesResolutionTypeSchema;
}
/**
 * Original schema `ResolutionTypeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ResolutionTypeSchema}
 */
export interface FilesResolutionTypeSchema {
  height?: number;
  width?: number;
}
/**
 * Original schema `FormatsElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FormatsElasticSchema}
 */
export interface FilesFormatsElasticSchema {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: FilesFormatElasticSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `FormatsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FormatsSchema}
 */
export interface FilesFormatsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: FilesFormatSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `FtpSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FtpSettingsSchema}
 */
export interface FilesFtpSettingsSchema {
  address: string;
  delete?: boolean;
  is_system?: boolean;
  password: string;
  read?: boolean;
  scan?: boolean;
  user: string;
  write?: boolean;
}
/**
 * Original schema `GatewayReportSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-GatewayReportSchema}
 */
export interface FilesGatewayReportSchema {
  await_checksum_files_number?: number | null;
  date_reported?: string;
  empty_files_number?: number | null;
  /**
   * @maxItems 10
   */
  error_log_lines?: string[];
  exported_files_number?: number | null;
  faulty_files_number?: number | null;
  host_info?: string;
  host_name?: string;
  id?: string;
  ingested_files_number?: number | null;
  ingested_files_uploads_number?: number | null;
  ingesting_files_number?: number | null;
  last_scan_time?: number | null;
  /**
   * @maxItems 50
   */
  log_lines?: string[];
  logs_url?: string;
  missing_files_number?: number | null;
  scanned_files_number?: number | null;
  skipped_files_number?: number | null;
  start_last_date?: string;
  start_status?: 'SUCCESS' | 'FAILED';
  start_status_message?: string;
  status?: 'OFFLINE' | 'LIVE' | 'UNKNOWN' | 'WARNING' | 'ERROR' | 'STOPPED';
  storage_id?: string;
  total_files_number?: number | null;
  total_folders_number?: number | null;
  version?: string;
  waiting_preview_transcode_jobs_number?: number | null;
  waiting_transcode_jobs_number?: number | null;
}
/**
 * Original schema `GatewayStatusSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-GatewayStatusSchema}
 */
export interface FilesGatewayStatusSchema {
  status?: string;
}
/**
 * Original schema `GoogleCloudStorageSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-GoogleCloudStorageSettingsSchema}
 */
export interface FilesGoogleCloudStorageSettingsSchema {
  access_group_id?: string | null;
  acl_template_id?: string | null;
  add_uuid_to_filenames?: boolean;
  aggregate_identical_files?: boolean;
  aggregate_ignore?: string[];
  aggregate_only_on_same_storage?: boolean;
  bucket: string;
  delete?: boolean;
  enable_collection_directory_mapping?: boolean;
  filename_is_external_id?: boolean;
  folder_name_tags_metadata_field_name?: string;
  folder_name_tags_metadata_view_id?: string | null;
  is_system?: boolean;
  json_key: string;
  local_mount?: boolean;
  metadata_conversion_url?: string;
  metadata_conversion_url_headers?: string | null;
  metadata_view_id?: string | null;
  path: string;
  preload_edge_jobs?: number | null;
  project: string;
  read?: boolean;
  root_collection_id?: string;
  scan?: boolean;
  scan_directories?: string[];
  scan_ignore?: string[];
  sidecar_metadata_required?: boolean;
  title_includes_extension?: boolean;
  transcode_ignore?: string[];
  write?: boolean;
}
/**
 * Original schema `HttpSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-HttpSettingsSchema}
 */
export interface FilesHttpSettingsSchema {
  address: string;
  auto?: boolean;
  delete?: boolean;
  is_system?: boolean;
  read?: boolean;
  scan?: boolean;
}
/**
 * Original schema `ISGConfigClusterSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ISGConfigClusterSettingsSchema}
 */
export interface FilesISGConfigClusterSettingsSchema {
  checksum_max_workers?: number;
  file_download_parallel_downloads_num?: number;
  file_upload_parallel_uploads_num?: number;
  max_transcoding_jobs?: number;
  scanner_concurrency_value?: number;
}
/**
 * Original schema `ISGConfigSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ISGConfigSettingsSchema}
 */
export interface FilesISGConfigSettingsSchema {
  checksum_max_workers?: number;
  file_download_parallel_downloads_num?: number;
  file_upload_parallel_uploads_num?: number;
  max_transcoding_jobs?: number;
  scanner_concurrency_value?: number;
}
/**
 * Original schema `ISGHandlerURLSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ISGHandlerURLSchema}
 */
export interface FilesISGHandlerURLSchema {
  url?: string;
}
/**
 * Original schema `IconikEdgeTranscoderSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-IconikEdgeTranscoderSchema}
 */
export interface FilesIconikEdgeTranscoderSchema {
  enable_multi_channel_audio?: boolean;
  exclude_patterns?: string[];
  include_patterns?: string[];
  local?: boolean;
  max_transcoding_jobs?: number;
  merge_multichannel_audio_tracks?: boolean;
  priority?: number | null;
}
/**
 * Original schema `IconikStorageGatewayBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-IconikStorageGatewayBaseSchema}
 */
export interface FilesIconikStorageGatewayBaseSchema {
  date_created?: string;
  date_modified?: string;
  description?: string;
  /**
   * Application toggle. If turned off ISG will enter idle state waiting to get enabled again.
   */
  enabled: boolean;
  id?: string;
  name: string;
  /**
   * Application configuration settings as key-value pairs
   */
  settings?:
    | FilesISGConfigSettingsSchema
    | ({
        [k: string]: unknown;
      } | null);
}
/**
 * Original schema `IconikStorageGatewayClusterReadSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-IconikStorageGatewayClusterReadSchema}
 */
export interface FilesIconikStorageGatewayClusterReadSchema {
  date_created?: string;
  date_modified?: string;
  /**
   * Database connection URI
   */
  db_connection_uri?: string;
  description?: string;
  /**
   * Application toggle. If turned off ISG will enter idle state waiting to get enabled again.
   */
  enabled: boolean;
  id?: string;
  leader_changed_at?: string;
  /**
   * Last reported leader ID.
   */
  leader_id?: string;
  name: string;
  nodes?: FilesIconikStorageGatewayRead[];
  /**
   * Application configuration settings as key-value pairs
   */
  settings?: FilesISGConfigClusterSettingsSchema;
  status?: 'OFFLINE' | 'ACTIVE' | 'WARNING' | 'ERROR' | 'STOPPED';
  storage_ids: string[];
  /**
   * Total number of files
   */
  total_files_number?: number;
  /**
   * Total number of scheduled transcode jobs
   */
  transcode_queue_total?: number;
  /**
   * Total number of scheduled auto-uploads
   */
  uploads_queue_total?: number;
  /**
   * The number of seconds jobs should remain invisible to other nodes
   */
  visibility_timeout?: number;
}
/**
 * Original schema `IconikStorageGatewayRead`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-IconikStorageGatewayRead}
 */
export interface FilesIconikStorageGatewayRead {
  cluster_id?: string;
  /**
   * Cluster storage IDs
   */
  cluster_storage_ids?: string[];
  date_created?: string;
  date_modified?: string;
  /**
   * Dedicated storage IDs
   */
  dedicated_storage_ids?: string[];
  description?: string;
  /**
   * Application toggle. If turned off ISG will enter idle state waiting to get enabled again.
   */
  enabled: boolean;
  id?: string;
  /**
   * Application configuration settings merged with cluster settings
   */
  merged_settings?: FilesISGConfigClusterSettingsSchema;
  name: string;
  public_identity?: string;
  /**
   * Set of roles this gateway can perform when part of cluster
   */
  roles?: ('MAIN' | 'CHECKSUM' | 'TRANSCODE' | 'TRANSFER')[];
  /**
   * Application configuration settings as key-value pairs
   */
  settings?:
    | FilesISGConfigSettingsSchema
    | ({
        [k: string]: unknown;
      } | null);
  status?: 'OFFLINE' | 'ACTIVE' | 'WARNING' | 'ERROR' | 'STOPPED';
  /**
   * Server address for direct transfers between storage gateways
   */
  storage_addr?: string;
  /**
   * Storage mount points mapped by storage ID
   */
  storages?: {
    [k: string]: FilesIconikStorageGatewayStorageMap;
  };
  telemetry?: FilesIconikStorageGatewayTelemetry;
}
/**
 * Original schema `IconikStorageGatewayStorageMap`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-IconikStorageGatewayStorageMap}
 */
export interface FilesIconikStorageGatewayStorageMap {
  mount_point: string;
}
/**
 * Original schema `IconikStorageGatewayTelemetry`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-IconikStorageGatewayTelemetry}
 */
export interface FilesIconikStorageGatewayTelemetry {
  /**
   * @maxItems 10
   */
  error_log_lines?: string[];
  host_info?: string;
  host_ip?: string;
  host_name?: string;
  is_leader?: boolean;
  /**
   * @maxItems 50
   */
  log_lines?: string[];
  start_last_date?: string;
  start_status?: 'SUCCESS' | 'FAILED';
  start_status_message?: string;
  status?: 'OFFLINE' | 'LIVE' | 'UNKNOWN' | 'WARNING' | 'ERROR' | 'STOPPED';
  storage_gateway_id?: string;
  version?: string;
  worker_id: string;
}
/**
 * Original schema `IconikStorageGatewayClusterSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-IconikStorageGatewayClusterSchema}
 */
export interface FilesIconikStorageGatewayClusterSchema {
  date_created?: string;
  date_modified?: string;
  /**
   * Database connection URI
   */
  db_connection_uri?: string;
  description?: string;
  /**
   * Application toggle. If turned off ISG will enter idle state waiting to get enabled again.
   */
  enabled: boolean;
  id?: string;
  name: string;
  /**
   * Application configuration settings as key-value pairs
   */
  settings?: FilesISGConfigClusterSettingsSchema;
  status?: 'OFFLINE' | 'ACTIVE' | 'WARNING' | 'ERROR' | 'STOPPED';
  storage_ids: string[];
  /**
   * Total number of files
   */
  total_files_number?: number;
  /**
   * Total number of scheduled transcode jobs
   */
  transcode_queue_total?: number;
  /**
   * Total number of scheduled auto-uploads
   */
  uploads_queue_total?: number;
  /**
   * The number of seconds jobs should remain invisible to other nodes
   */
  visibility_timeout?: number;
}
/**
 * Original schema `IconikStorageGatewayClustersSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-IconikStorageGatewayClustersSchema}
 */
export interface FilesIconikStorageGatewayClustersSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: FilesIconikStorageGatewayClusterReadSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `IconikStorageGatewayEventSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-IconikStorageGatewayEventSchema}
 */
export interface FilesIconikStorageGatewayEventSchema {
  data?: {
    [k: string]: unknown;
  };
  date_created?: string;
  id?: string;
  type:
    | 'RESTART'
    | 'DOWNLOAD'
    | 'DOWNLOAD_ABORT'
    | 'DOWNLOAD_CHANGE_PRIORITY'
    | 'UPLOAD'
    | 'UPLOAD_ABORT'
    | 'UPLOAD_CHANGE_PRIORITY'
    | 'INGEST_UPLOAD'
    | 'DELETE'
    | 'TRANSCODE'
    | 'ASSET_MERGED'
    | 'TRANSCODE_ABORT'
    | 'TRANSCODE_CHANGE_PRIORITY'
    | 'REQUEST_COLLECTION_MAP'
    | 'ABORT_COLLECTION_MAP'
    | 'COLLECTION_DELETED'
    | 'RESET_INGEST_VALIDATION'
    | 'SCHEDULE_CHECKSUM_CALCULATION'
    | 'ABORT_JOBS_BULK'
    | 'MARK_MISSING_OUTSIDE_SCAN_DIRS';
}
/**
 * Original schema `IconikStorageGatewayEventsPurgeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-IconikStorageGatewayEventsPurgeSchema}
 */
export interface FilesIconikStorageGatewayEventsPurgeSchema {
  /**
   * @minItems 1
   * @maxItems 100
   */
  event_ids: string[];
}
/**
 * Original schema `IconikStorageGatewayEventsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-IconikStorageGatewayEventsSchema}
 */
export interface FilesIconikStorageGatewayEventsSchema {
  objects?: FilesIconikStorageGatewayEventSchema[];
}
/**
 * Original schema `IconikStorageGatewayReadSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-IconikStorageGatewayReadSchema}
 */
export interface FilesIconikStorageGatewayReadSchema {
  cluster_id?: string;
  /**
   * Cluster storage IDs
   */
  cluster_storage_ids?: string[];
  date_created?: string;
  date_modified?: string;
  /**
   * Dedicated storage IDs
   */
  dedicated_storage_ids?: string[];
  description?: string;
  /**
   * Application toggle. If turned off ISG will enter idle state waiting to get enabled again.
   */
  enabled: boolean;
  id?: string;
  /**
   * Application configuration settings merged with cluster settings
   */
  merged_settings?: FilesISGConfigClusterSettingsSchema;
  name: string;
  public_identity?: string;
  /**
   * Set of roles this gateway can perform when part of cluster
   */
  roles?: ('MAIN' | 'CHECKSUM' | 'TRANSCODE' | 'TRANSFER')[];
  /**
   * Application configuration settings as key-value pairs
   */
  settings?:
    | FilesISGConfigSettingsSchema
    | ({
        [k: string]: unknown;
      } | null);
  status?: 'OFFLINE' | 'ACTIVE' | 'WARNING' | 'ERROR' | 'STOPPED';
  /**
   * Server address for direct transfers between storage gateways
   */
  storage_addr?: string;
  /**
   * Storage mount points mapped by storage ID
   */
  storages?: {
    [k: string]: FilesIconikStorageGatewayStorageMap;
  };
  telemetry?: FilesIconikStorageGatewayTelemetry;
}
/**
 * Original schema `IconikStorageGatewaySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-IconikStorageGatewaySchema}
 */
export interface FilesIconikStorageGatewaySchema {
  cluster_id?: string;
  date_created?: string;
  date_modified?: string;
  description?: string;
  /**
   * Application toggle. If turned off ISG will enter idle state waiting to get enabled again.
   */
  enabled: boolean;
  id?: string;
  name: string;
  public_identity?: string;
  /**
   * Set of roles this gateway can perform when part of cluster
   */
  roles?: ('MAIN' | 'CHECKSUM' | 'TRANSCODE' | 'TRANSFER')[];
  /**
   * Application configuration settings as key-value pairs
   */
  settings?:
    | FilesISGConfigSettingsSchema
    | ({
        [k: string]: unknown;
      } | null);
  /**
   * Server address for direct transfers between storage gateways
   */
  storage_addr?: string;
  /**
   * Storage mount points mapped by storage ID
   */
  storages?: {
    [k: string]: FilesIconikStorageGatewayStorageMap;
  };
}
/**
 * Original schema `IconikStorageGatewayStorageMapSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-IconikStorageGatewayStorageMapSchema}
 */
export interface FilesIconikStorageGatewayStorageMapSchema {
  mount_point: string;
}
/**
 * Original schema `IconikStorageGatewayTelemetrySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-IconikStorageGatewayTelemetrySchema}
 */
export interface FilesIconikStorageGatewayTelemetrySchema {
  /**
   * @maxItems 10
   */
  error_log_lines?: string[];
  host_info?: string;
  host_ip?: string;
  host_name?: string;
  is_leader?: boolean;
  /**
   * @maxItems 50
   */
  log_lines?: string[];
  start_last_date?: string;
  start_status?: 'SUCCESS' | 'FAILED';
  start_status_message?: string;
  status?: 'OFFLINE' | 'LIVE' | 'UNKNOWN' | 'WARNING' | 'ERROR' | 'STOPPED';
  storage_gateway_id?: string;
  version?: string;
  worker_id: string;
}
/**
 * Original schema `IconikStorageGatewaysSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-IconikStorageGatewaysSchema}
 */
export interface FilesIconikStorageGatewaysSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: FilesIconikStorageGatewayReadSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `IconikStorageGatewaysTelemetrySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-IconikStorageGatewaysTelemetrySchema}
 */
export interface FilesIconikStorageGatewaysTelemetrySchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: FilesIconikStorageGatewayTelemetrySchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `ImageMagickSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ImageMagickSettingsSchema}
 */
export interface FilesImageMagickSettingsSchema {
  data?: string;
  exclude_patterns?: string[];
  height?: number;
  include_patterns?: string[];
  local?: boolean;
  overlay_coordinates?: string | null;
  overlay_url?: string | null;
  priority?: number | null;
  width?: number;
}
/**
 * Original schema `JobsPrioritySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-JobsPrioritySchema}
 */
export interface FilesJobsPrioritySchema {
  /**
   * @minItems 1
   * @maxItems 500
   */
  job_ids: string[];
  priority: number;
}
/**
 * Original schema `JobsStateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-JobsStateSchema}
 */
export interface FilesJobsStateSchema {
  action: 'RESTART' | 'ABORT';
  /**
   * @minItems 1
   * @maxItems 500
   */
  job_ids: string[];
}
/**
 * Original schema `KeyframeBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-KeyframeBaseSchema}
 */
export interface FilesKeyframeBaseSchema {
  date_created?: string;
  date_modified?: string;
  filename?: string;
  format?: string | null;
  is_custom_keyframe?: boolean;
  is_public?: boolean;
  name?: string;
  resolution?: FilesResolutionType;
  rotation?: number | null;
  size?: number | null;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  time_code?: FilesTimeCodeType;
  type: 'KEYFRAME_MAP' | 'KEYFRAME' | 'POSTER';
  url?: string;
}
/**
 * Original schema `KeyframeCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-KeyframeCreateSchema}
 */
export interface FilesKeyframeCreateSchema {
  asset_id?: string | null;
  collection_id?: string | null;
  content_type?: string;
  date_created?: string;
  date_modified?: string;
  filename?: string;
  format?: string | null;
  id?: string;
  is_custom_keyframe?: boolean;
  is_public?: boolean;
  name?: string;
  resolution?: FilesResolutionType;
  rotation?: number | null;
  size?: number | null;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  storage_method?: string;
  time_code?: FilesTimeCodeType;
  type: 'KEYFRAME_MAP' | 'KEYFRAME' | 'POSTER';
  upload_credentials?: {
    [k: string]: unknown;
  };
  upload_headers?: {
    [k: string]: unknown;
  };
  upload_method?: string;
  upload_url?: string;
  url?: string;
  version_id?: string | null;
}
/**
 * Original schema `KeyframeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-KeyframeSchema}
 */
export interface FilesKeyframeSchema {
  asset_id?: string | null;
  collection_id?: string | null;
  date_created?: string;
  date_modified?: string;
  filename?: string;
  format?: string | null;
  id?: string;
  is_custom_keyframe?: boolean;
  is_public?: boolean;
  name?: string;
  resolution?: FilesResolutionType;
  rotation?: number | null;
  size?: number | null;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  storage_method?: string;
  time_code?: FilesTimeCodeType;
  type: 'KEYFRAME_MAP' | 'KEYFRAME' | 'POSTER';
  upload_credentials?: {
    [k: string]: unknown;
  };
  upload_headers?: {
    [k: string]: unknown;
  };
  upload_method?: string;
  upload_url?: string;
  url?: string;
  version_id?: string | null;
}
/**
 * Original schema `KeyframeUpdateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-KeyframeUpdateSchema}
 */
export interface FilesKeyframeUpdateSchema {
  date_created?: string;
  date_modified?: string;
  filename?: string;
  format?: string | null;
  is_custom_keyframe?: boolean;
  is_public?: boolean;
  name?: string;
  resolution?: FilesResolutionType;
  rotation?: number | null;
  size?: number | null;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  time_code?: FilesTimeCodeType;
  type: 'KEYFRAME_MAP' | 'KEYFRAME' | 'POSTER';
  url?: string;
}
/**
 * Original schema `KeyframesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-KeyframesSchema}
 */
export interface FilesKeyframesSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: FilesKeyframeSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `LibreOfficeSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-LibreOfficeSettingsSchema}
 */
export interface FilesLibreOfficeSettingsSchema {
  exclude_patterns?: string[];
  include_patterns?: string[];
  local?: boolean;
  priority?: number | null;
}
/**
 * Original schema `ListObjectsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ListObjectsSchema}
 */
export interface FilesListObjectsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `LogoCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-LogoCreateSchema}
 */
export interface FilesLogoCreateSchema {
  content_type?: string;
  date_created?: string;
  date_modified?: string;
  filename?: string;
  id?: string;
  name: string;
  storage_id?: string;
  storage_method?: string;
  system_domain_id?: string;
  upload_credentials?: {
    [k: string]: unknown;
  };
  upload_headers?: {
    [k: string]: unknown;
  };
  upload_method?: string;
  upload_url?: string;
  url?: string;
  user_id?: string;
}
/**
 * Original schema `LogoSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-LogoSchema}
 */
export interface FilesLogoSchema {
  date_created?: string;
  date_modified?: string;
  filename?: string;
  id?: string;
  name: string;
  storage_id?: string;
  storage_method?: string;
  system_domain_id?: string;
  upload_credentials?: {
    [k: string]: unknown;
  };
  upload_headers?: {
    [k: string]: unknown;
  };
  upload_method?: string;
  upload_url?: string;
  url?: string;
  user_id?: string;
}
/**
 * Original schema `LogosSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-LogosSchema}
 */
export interface FilesLogosSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: FilesLogoSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `MoveAssetResourceSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-MoveAssetResourceSchema}
 */
export interface FilesMoveAssetResourceSchema {
  destination_asset_id: string;
  destination_version_id: string;
  exclude_format_ids?: string[] | null;
  source_version_id: string;
}
/**
 * Original schema `MultiPartS3UrlPartSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-MultiPartS3UrlPartSchema}
 */
export interface FilesMultiPartS3UrlPartSchema {
  /**
   * base64-encoded md5 digest
   */
  checksum?: string | null;
  part_number?: number;
  url?: string;
}
/**
 * Original schema `MultiPartS3UrlPartsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-MultiPartS3UrlPartsSchema}
 */
export interface FilesMultiPartS3UrlPartsSchema {
  /**
   * @minItems 1
   */
  parts: FilesMultiPartS3UrlPartSchema[];
  upload_id: string;
}
/**
 * Original schema `MultiPartURLsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-MultiPartURLsSchema}
 */
export interface FilesMultiPartURLsSchema {
  abort_url?: string;
  complete_url?: string;
  list_parts_url?: string[];
}
/**
 * Original schema `MultiPartUploadComposeURLSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-MultiPartUploadComposeURLSchema}
 */
export interface FilesMultiPartUploadComposeURLSchema {
  compose_url?: string;
  delete_url?: string;
  key?: string;
  url?: string;
}
/**
 * Original schema `MultiPartUploadURLSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-MultiPartUploadURLSchema}
 */
export interface FilesMultiPartUploadURLSchema {
  delete_url?: string;
  download_url?: string;
  key?: string;
  number?: number;
  url?: string;
}
/**
 * Original schema `MultiPartUploadURLsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-MultiPartUploadURLsSchema}
 */
export interface FilesMultiPartUploadURLsSchema {
  objects?: FilesMultiPartUploadURLSchema[];
}
/**
 * Original schema `MultipartB2CancelUpload`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-MultipartB2CancelUpload}
 */
export interface FilesMultipartB2CancelUpload {
  upload_file_id: string;
}
/**
 * Original schema `MultipartB2FinishUpload`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-MultipartB2FinishUpload}
 */
export interface FilesMultipartB2FinishUpload {
  sha1_list: string[];
  upload_file_id: string;
}
/**
 * Original schema `MultipartB2StartUpload`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-MultipartB2StartUpload}
 */
export interface FilesMultipartB2StartUpload {
  authorization_token?: string;
  error?: string;
  error_code?: string;
  status?: string;
  upload_file_id?: string | null;
  upload_url?: string;
}
/**
 * Original schema `MultipartUploadCleanupSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-MultipartUploadCleanupSchema}
 */
export interface FilesMultipartUploadCleanupSchema {
  abort_upload?: boolean;
  parts_group_number?: number | null;
  parts_number?: number;
  temporary?: boolean;
  upload_id?: string;
}
/**
 * Original schema `MultipartUploadComposeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-MultipartUploadComposeSchema}
 */
export interface FilesMultipartUploadComposeSchema {
  content_type?: string | null;
  parts_group?: number | null;
}
/**
 * Original schema `MultipartUploadProxyCleanupSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-MultipartUploadProxyCleanupSchema}
 */
export interface FilesMultipartUploadProxyCleanupSchema {
  abort_upload?: boolean;
  upload_id?: string;
}
/**
 * Original schema `MultipartUploadSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-MultipartUploadSchema}
 */
export interface FilesMultipartUploadSchema {
  parts_group?: number | null;
  parts_range: string[];
}
/**
 * Original schema `PlaylistKeyframeCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-PlaylistKeyframeCreateSchema}
 */
export interface FilesPlaylistKeyframeCreateSchema {
  content_type?: string;
  date_created?: string;
  date_modified?: string;
  filename?: string;
  format?: string | null;
  id?: string;
  is_custom_keyframe?: boolean;
  is_public?: boolean;
  name?: string;
  playlist_id?: string;
  resolution?: FilesResolutionType;
  rotation?: number | null;
  size?: number | null;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  time_code?: FilesTimeCodeType;
  type: 'KEYFRAME_MAP' | 'KEYFRAME' | 'POSTER';
  upload_credentials?: {
    [k: string]: unknown;
  };
  upload_headers?: {
    [k: string]: unknown;
  };
  upload_method?: string;
  upload_url?: string;
  url?: string;
}
/**
 * Original schema `PlaylistKeyframeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-PlaylistKeyframeSchema}
 */
export interface FilesPlaylistKeyframeSchema {
  date_created?: string;
  date_modified?: string;
  filename?: string;
  format?: string | null;
  id?: string;
  is_custom_keyframe?: boolean;
  is_public?: boolean;
  name?: string;
  playlist_id?: string;
  resolution?: FilesResolutionType;
  rotation?: number | null;
  size?: number | null;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  time_code?: FilesTimeCodeType;
  type: 'KEYFRAME_MAP' | 'KEYFRAME' | 'POSTER';
  url?: string;
}
/**
 * Original schema `PlaylistKeyframeUpdateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-PlaylistKeyframeUpdateSchema}
 */
export interface FilesPlaylistKeyframeUpdateSchema {
  date_created?: string;
  date_modified?: string;
  filename?: string;
  format?: string | null;
  is_custom_keyframe?: boolean;
  is_public?: boolean;
  name?: string;
  resolution?: FilesResolutionType;
  rotation?: number | null;
  size?: number | null;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  time_code?: FilesTimeCodeType;
  type: 'KEYFRAME_MAP' | 'KEYFRAME' | 'POSTER';
  url?: string;
}
/**
 * Original schema `PlaylistKeyframesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-PlaylistKeyframesSchema}
 */
export interface FilesPlaylistKeyframesSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: FilesPlaylistKeyframeSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `PortalSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-PortalSettingsSchema}
 */
export interface FilesPortalSettingsSchema {
  delete?: boolean;
  is_system?: boolean;
  read?: boolean;
  scan?: boolean;
  write?: boolean;
}
/**
 * Original schema `PrioDirSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-PrioDirSchema}
 */
export interface FilesPrioDirSchema {
  directory?: string;
  priority?: number;
}
/**
 * Original schema `PrioPatternSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-PrioPatternSchema}
 */
export interface FilesPrioPatternSchema {
  pattern?: string;
  priority?: number;
}
/**
 * Original schema `ProxiesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ProxiesSchema}
 */
export interface FilesProxiesSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: FilesProxy[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `Proxy`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-Proxy}
 */
export interface FilesProxy {
  asset_id?: string;
  audio_bitrate?: number;
  audio_channels?: number | null;
  bit_rate?: number;
  codec?: string;
  date_created?: string;
  date_modified?: string;
  filename?: string;
  format?: string;
  frame_rate?: string | null;
  id?: string;
  is_drop_frame?: boolean | null;
  is_multichannel?: boolean | null;
  is_public?: boolean;
  multipart_upload_url?: string;
  name?: string;
  proxy_container_id?: string | null;
  resolution?: FilesResolutionType;
  rotation?: number | null;
  size?: number | null;
  start_time_code?: string | null;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  storage_method?: string;
  upload_credentials?: {
    [k: string]: unknown;
  };
  upload_headers?: {
    [k: string]: unknown;
  };
  upload_method?: string;
  upload_url?: string;
  url?: string;
  version_id?: string | null;
}
/**
 * Original schema `ProxyBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ProxyBaseSchema}
 */
export interface FilesProxyBaseSchema {
  asset_id?: string;
  audio_bitrate?: number;
  audio_channels?: number | null;
  bit_rate?: number;
  codec?: string;
  date_created?: string;
  date_modified?: string;
  filename?: string;
  format?: string;
  frame_rate?: string | null;
  id?: string;
  is_drop_frame?: boolean | null;
  is_multichannel?: boolean | null;
  is_public?: boolean;
  name?: string;
  proxy_container_id?: string | null;
  resolution?: FilesResolutionType;
  rotation?: number | null;
  size?: number | null;
  start_time_code?: string | null;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  url?: string;
  version_id?: string | null;
}
/**
 * Original schema `ProxyContainerByUserSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ProxyContainerByUserSchema}
 */
export interface FilesProxyContainerByUserSchema {
  bit_profile?: number;
  deep_fake?: number;
  drm?: string;
  fingerprint?: string;
  height?: number;
  id?: string;
  original_proxy_url?: string;
  pixel_density?: number;
  proxy_id?: string;
  sp_height?: number;
  sp_width?: number;
  strength?: number;
  super_pixel_density?: number;
  user_id?: string;
  watermark?: string;
  width?: number;
}
/**
 * Original schema `ProxyContainerSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ProxyContainerSchema}
 */
export interface FilesProxyContainerSchema {
  drm?: string;
  frame_count?: number;
  frame_rate?: number;
  id?: string;
  parent_container_id?: string | null;
  segment_duration?: number;
  user_id?: string | null;
  watermark?: string;
}
/**
 * Original schema `ProxyCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ProxyCreateSchema}
 */
export interface FilesProxyCreateSchema {
  asset_id?: string;
  audio_bitrate?: number;
  audio_channels?: number | null;
  bit_rate?: number;
  codec?: string;
  content_type?: string;
  date_created?: string;
  date_modified?: string;
  filename?: string;
  format?: string;
  frame_rate?: string | null;
  id?: string;
  is_drop_frame?: boolean | null;
  is_multichannel?: boolean | null;
  is_public?: boolean;
  multipart_upload_url?: string;
  name?: string;
  proxy_container_id?: string | null;
  resolution?: FilesResolutionType;
  rotation?: number | null;
  size?: number | null;
  start_time_code?: string | null;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  storage_method?: string;
  upload_credentials?: {
    [k: string]: unknown;
  };
  upload_headers?: {
    [k: string]: unknown;
  };
  upload_method?: string;
  upload_url?: string;
  url?: string;
  version_id?: string | null;
}
/**
 * Original schema `ProxyDownloadURLSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ProxyDownloadURLSchema}
 */
export interface FilesProxyDownloadURLSchema {
  url?: string;
}
/**
 * Original schema `ProxyFileSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ProxyFileSchema}
 */
export interface FilesProxyFileSchema {
  asset_id?: string;
  checksum?: string | null;
  date_created?: string;
  date_modified?: string;
  directory_path: string;
  file_date_created?: string;
  file_date_modified?: string;
  file_set_id?: string;
  format_id?: string;
  id?: string;
  /**
   * If not specified, name will be autogenerated based on `id` and `original_name`
   */
  name?: string;
  original_name: string;
  parent_id?: string | null;
  proxy_sequence_type: string;
  size?: number;
  status?: 'OPEN' | 'CLOSED' | 'FAILED';
  storage_id?: string;
  template?: string;
  template_engine?: ('SIMPLE' | 'JINJA2' | null) | null;
  type: 'FILE' | 'DIRECTORY' | 'SYMLINK' | 'SEQUENCE';
  user_id?: string | null;
  version_id?: string;
}
/**
 * Original schema `ProxyFileUpdateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ProxyFileUpdateSchema}
 */
export interface FilesProxyFileUpdateSchema {
  status: 'OPEN' | 'CLOSED' | 'FAILED';
}
/**
 * Original schema `ProxySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ProxySchema}
 */
export interface FilesProxySchema {
  asset_id?: string;
  audio_bitrate?: number;
  audio_channels?: number | null;
  bit_rate?: number;
  codec?: string;
  date_created?: string;
  date_modified?: string;
  filename?: string;
  format?: string;
  frame_rate?: string | null;
  id?: string;
  is_drop_frame?: boolean | null;
  is_multichannel?: boolean | null;
  is_public?: boolean;
  multipart_upload_url?: string;
  name?: string;
  proxy_container_id?: string | null;
  resolution?: FilesResolutionType;
  rotation?: number | null;
  size?: number | null;
  start_time_code?: string | null;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  storage_method?: string;
  upload_credentials?: {
    [k: string]: unknown;
  };
  upload_headers?: {
    [k: string]: unknown;
  };
  upload_method?: string;
  upload_url?: string;
  url?: string;
  version_id?: string | null;
}
/**
 * Original schema `ProxyUpdateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ProxyUpdateSchema}
 */
export interface FilesProxyUpdateSchema {
  asset_id?: string;
  audio_bitrate?: number;
  audio_channels?: number | null;
  bit_rate?: number;
  codec?: string;
  date_created?: string;
  date_modified?: string;
  filename?: string;
  format?: string;
  frame_rate?: string | null;
  id?: string;
  is_drop_frame?: boolean | null;
  is_multichannel?: boolean | null;
  is_public?: boolean;
  name?: string;
  proxy_container_id?: string | null;
  resolution?: FilesResolutionType;
  rotation?: number | null;
  size?: number | null;
  start_time_code?: string | null;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  url?: string;
  version_id?: string;
}
/**
 * Original schema `RedlineSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-RedlineSchema}
 */
export interface FilesRedlineSchema {
  default_lut3d_file?: string | null;
  edit_proxy_local_storage_path?: string;
  edit_proxy_upload_storage_id?: string;
  edit_proxy_upload_storage_path?: string;
  exclude_patterns?: string[];
  format?: 'QT transcode' | 'Apple ProRes' | '';
  include_patterns?: string[];
  keep_redline_proxy?: boolean;
  local?: boolean;
  opencl_device_indexes?: string[];
  prcodec?:
    | (
        | 'Apple_ProRes_422_HQ'
        | 'Apple_ProRes_422'
        | 'Apple_ProRes_422_LT'
        | 'Apple_ProRes_422_Proxy'
        | 'Apple_ProRes_4444'
        | 'Apple_ProRes_4444_XQ'
        | null
      )
    | null;
  priority?: number | null;
  qt_codec?:
    | 'H264'
    | 'H263'
    | 'AVID_1080P_DNxHD_36_8-bit'
    | 'AVID_1080P_DNxHD_115/120_8-bit'
    | 'AVID_1080P_DNxHD_175/185_8-bit'
    | 'AVID_1080P_DNxHD_175/185_10-bit'
    | 'AVID_720P_DNxHD_60/75_8-bit'
    | 'AVID_720P_DNxHD_90/110_8-bit'
    | 'AVID_720P_DNxHD_90/110_10-bit'
    | 'AVID_720P_DNxHD_120/145_8-bit'
    | 'AVID_720P_DNxHD_185/220_8-bit'
    | 'AVID_720P_DNxHD_185/220_10-bit'
    | 'Apple_ProRes_422_HQ'
    | 'Apple_ProRes_422'
    | 'Apple_ProRes_4444'
    | 'Apple_ProRes_422_LT'
    | 'Apple_ProRes_422_Proxy'
    | '';
  render_resolution?: number | null;
  use_metadata_cube_file_in_proxy?: boolean;
  use_rmd?: number | null;
}
/**
 * Original schema `ReindexExportLocationSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ReindexExportLocationSchema}
 */
export interface FilesReindexExportLocationSchema {
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `ReindexFileSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ReindexFileSchema}
 */
export interface FilesReindexFileSchema {
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `ReindexFileSetSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ReindexFileSetSchema}
 */
export interface FilesReindexFileSetSchema {
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `ReindexFormatSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ReindexFormatSchema}
 */
export interface FilesReindexFormatSchema {
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `ReindexStorageGatewaySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ReindexStorageGatewaySchema}
 */
export interface FilesReindexStorageGatewaySchema {
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `ReindexStorageSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ReindexStorageSchema}
 */
export interface FilesReindexStorageSchema {
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `ReindexTranscoderSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ReindexTranscoderSchema}
 */
export interface FilesReindexTranscoderSchema {
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `RestoreAssetToStorageRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-RestoreAssetToStorageRequestSchema}
 */
export interface FilesRestoreAssetToStorageRequestSchema {
  all_versions?: boolean;
  destination_directory_path?: string | null;
  /**
   * List of format names to transfer. If not specified, ORIGINAL will be transferred.
   *
   * @minItems 1
   */
  formats?: string[];
  /**
   * ID of the object to transfer.
   */
  id: string;
  preferred_original_storage_id?: string | null;
  /**
   * The restore tier to use when retrieving from cold storage one of LOW, MID, HIGH.
   */
  restore_priority?: ('LOW' | 'MID' | 'HIGH' | null) | null;
  /**
   * List of version IDs to transfer.
   */
  version_ids?: string[];
}
/**
 * Original schema `RestoreCollectionToStorageRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-RestoreCollectionToStorageRequestSchema}
 */
export interface FilesRestoreCollectionToStorageRequestSchema {
  all_versions?: boolean;
  destination_directory_path?: string | null;
  /**
   * List of format names to transfer. If not specified, ORIGINAL will be transferred.
   *
   * @minItems 1
   */
  formats?: string[];
  /**
   * ID of the object to transfer.
   */
  id: string;
  /**
   * Whether to keep the collection structure when transferring collections.
   */
  keep_collection_structure?: boolean;
  /**
   * Whether to keep the parent collection structure when transferring collections.
   */
  keep_parent_collection_structure?: boolean;
  preferred_original_storage_id?: string | null;
  /**
   * The restore tier to use when retrieving from cold storage one of LOW, MID, HIGH.
   */
  restore_priority?: ('LOW' | 'MID' | 'HIGH' | null) | null;
  /**
   * List of version IDs to transfer.
   */
  version_ids?: string[];
}
/**
 * Original schema `RestoreSavedSearchToStorageRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-RestoreSavedSearchToStorageRequestSchema}
 */
export interface FilesRestoreSavedSearchToStorageRequestSchema {
  all_versions?: boolean;
  destination_directory_path?: string | null;
  /**
   * List of format names to transfer. If not specified, ORIGINAL will be transferred.
   *
   * @minItems 1
   */
  formats?: string[];
  /**
   * ID of the object to transfer.
   */
  id: string;
  preferred_original_storage_id?: string | null;
  /**
   * The restore tier to use when retrieving from cold storage one of LOW, MID, HIGH.
   */
  restore_priority?: ('LOW' | 'MID' | 'HIGH' | null) | null;
  /**
   * List of version IDs to transfer.
   */
  version_ids?: string[];
}
/**
 * Original schema `S3SettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-S3SettingsSchema}
 */
export interface FilesS3SettingsSchema {
  access_group_id?: string | null;
  access_key?: string;
  acl_template_id?: string | null;
  add_uuid_to_filenames?: boolean;
  aggregate_identical_files?: boolean;
  aggregate_ignore?: string[];
  aggregate_only_on_same_storage?: boolean;
  bucket: string;
  delete?: boolean;
  enable_collection_directory_mapping?: boolean;
  endpoint: string;
  filename_is_external_id?: boolean;
  folder_name_tags_metadata_field_name?: string;
  folder_name_tags_metadata_view_id?: string | null;
  /**
   * Keep restored assets online for this many days to allow them to be copied before going back to Glacier
   */
  glacier_restore_timeout?: number | null;
  is_system?: boolean;
  local_mount?: boolean;
  metadata_conversion_url?: string;
  metadata_conversion_url_headers?: string | null;
  metadata_view_id?: string | null;
  notification_sqs_url?: string;
  path: string;
  preload_edge_jobs?: number | null;
  presign_md5_checksum?: boolean;
  read?: boolean;
  region: string;
  root_collection_id?: string;
  scan?: boolean;
  scan_directories?: string[];
  scan_ignore?: string[];
  secret_key?: string;
  session_token?: string;
  sidecar_metadata_required?: boolean;
  title_includes_extension?: boolean;
  transcode_ignore?: string[];
  use_acceleration?: boolean;
  write?: boolean;
}
/**
 * Original schema `SegmentAttachmentsCopyPairSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-SegmentAttachmentsCopyPairSchema}
 */
export interface FilesSegmentAttachmentsCopyPairSchema {
  destination_segment_id: string;
  source_segment_id: string;
}
/**
 * Original schema `SegmentAttachmentsCopyRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-SegmentAttachmentsCopyRequestSchema}
 */
export interface FilesSegmentAttachmentsCopyRequestSchema {
  /**
   * @maxItems 500
   */
  segments: FilesSegmentAttachmentsCopyPairSchema[];
}
/**
 * Original schema `SegmentAttachmentsCopyResponseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-SegmentAttachmentsCopyResponseSchema}
 */
export interface FilesSegmentAttachmentsCopyResponseSchema {
  destination_segment_ids_with_attachments?: string[];
}
/**
 * Original schema `SegmentAttachmentsMoveRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-SegmentAttachmentsMoveRequestSchema}
 */
export interface FilesSegmentAttachmentsMoveRequestSchema {
  destination_asset_id: string;
  /**
   * @maxItems 500
   */
  segment_ids: string[];
}
/**
 * Original schema `SegmentAttachmentsMoveResponseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-SegmentAttachmentsMoveResponseSchema}
 */
export interface FilesSegmentAttachmentsMoveResponseSchema {
  segment_ids?: string[];
}
/**
 * Original schema `SequenceUpdateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-SequenceUpdateSchema}
 */
export interface FilesSequenceUpdateSchema {
  asset_id?: string;
  checksum?: string | null;
  date_created?: string;
  date_modified?: string;
  directory_path: string;
  file_date_created?: string;
  file_date_modified?: string;
  file_set_id?: string;
  format_id?: string;
  id?: string;
  /**
   * If not specified, name will be autogenerated based on `id` and `original_name`
   */
  name?: string;
  original_name: string;
  parent_id?: string | null;
  size?: number;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  template?: string;
  template_engine?: ('SIMPLE' | 'JINJA2' | null) | null;
  type: 'FILE' | 'DIRECTORY' | 'SYMLINK' | 'SEQUENCE';
  user_id?: string | null;
  version_id?: string;
}
/**
 * Original schema `SftpSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-SftpSettingsSchema}
 */
export interface FilesSftpSettingsSchema {
  address: string;
  delete?: boolean;
  is_system?: boolean;
  password: string;
  read?: boolean;
  scan?: boolean;
  user: string;
  write?: boolean;
}
/**
 * Original schema `StorageAccessSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-StorageAccessSchema}
 */
export interface FilesStorageAccessSchema {
  method:
    | 'FILE'
    | 'HTTP'
    | 'FTP'
    | 'SFTP'
    | 'S3'
    | 'B2'
    | 'GCS'
    | 'PORTAL'
    | 'CUSTOM'
    | 'AZURE'
    | 'DROPBOX';
  settings: {
    [k: string]: unknown;
  };
}
/**
 * Original schema `StorageAutoScanSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-StorageAutoScanSchema}
 */
export interface FilesStorageAutoScanSchema {
  hours_interval?: number;
}
/**
 * Original schema `StorageBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-StorageBaseSchema}
 */
export interface FilesStorageBaseSchema {}
/**
 * Original schema `StorageFileSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-StorageFileSchema}
 */
export interface FilesStorageFileSchema {
  asset_id?: string;
  checksum?: string | null;
  date_created?: string;
  date_modified?: string;
  destination_storage_id?: string;
  directory_path: string;
  file_date_created?: string;
  file_date_modified?: string;
  file_set_id?: string;
  format_id?: string;
  id?: string;
  /**
   * If not specified, name will be autogenerated based on `id` and `original_name`
   */
  name?: string;
  original_name: string;
  parent_id?: string | null;
  size?: number;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  /**
   * Deprecated field. Use destination_storage_id instead
   */
  storage_id?: string;
  template?: string;
  template_engine?: ('SIMPLE' | 'JINJA2' | null) | null;
  type: 'FILE' | 'DIRECTORY' | 'SYMLINK' | 'SEQUENCE';
  url?: string;
  user_id?: string | null;
  version_id?: string;
}
/**
 * Original schema `StorageFileUpdateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-StorageFileUpdateSchema}
 */
export interface FilesStorageFileUpdateSchema {
  asset_id?: string;
  checksum?: string | null;
  date_created?: string;
  date_modified?: string;
  directory_path: string;
  file_date_created?: string;
  file_date_modified?: string;
  file_set_id?: string;
  format_id?: string;
  id?: string;
  name: string;
  original_name?: string;
  parent_id?: string | null;
  size?: number;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  template?: string;
  template_engine?: ('SIMPLE' | 'JINJA2' | null) | null;
  type?: 'FILE' | 'DIRECTORY' | 'SYMLINK' | 'SEQUENCE';
  user_id?: string | null;
  version_id?: string;
}
/**
 * Original schema `StorageFilesDeleteBulkSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-StorageFilesDeleteBulkSchema}
 */
export interface FilesStorageFilesDeleteBulkSchema {
  /**
   * The number of object_ids in the list is limited to a minimum of 0 and a maximum of 500
   *
   * @minItems 0
   * @maxItems 500
   */
  object_ids: string[];
  object_type: string;
}
/**
 * Original schema `StorageFilesQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-StorageFilesQueryParamsSchema}
 */
export interface FilesStorageFilesQueryParamsSchema {
  include_parent_statuses?: boolean;
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  scroll?: boolean;
  scroll_id?: string;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
}
/**
 * Original schema `StorageGatewayParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-StorageGatewayParamsSchema}
 */
export interface FilesStorageGatewayParamsSchema {
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
}
/**
 * Original schema `StoragePermissionsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-StoragePermissionsSchema}
 */
export interface FilesStoragePermissionsSchema {
  method:
    | 'FILE'
    | 'HTTP'
    | 'FTP'
    | 'SFTP'
    | 'S3'
    | 'B2'
    | 'GCS'
    | 'PORTAL'
    | 'CUSTOM'
    | 'AZURE'
    | 'DROPBOX';
  purpose: 'KEYFRAMES' | 'FILES' | 'PROXIES' | 'EXPORTS' | 'ARCHIVE' | 'FACES';
  settings: {
    [k: string]: unknown;
  };
}
/**
 * Original schema `StoragePrivateDataSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-StoragePrivateDataSchema}
 */
export interface FilesStoragePrivateDataSchema {
  bucket_location?: string;
  default?: boolean;
  description?: string | null;
  id?: string;
  last_scanned?: string | null;
  method:
    | 'FILE'
    | 'HTTP'
    | 'FTP'
    | 'SFTP'
    | 'S3'
    | 'B2'
    | 'GCS'
    | 'PORTAL'
    | 'CUSTOM'
    | 'AZURE'
    | 'DROPBOX';
  name: string;
  purpose: 'KEYFRAMES' | 'FILES' | 'PROXIES' | 'EXPORTS' | 'ARCHIVE' | 'FACES';
  scanner_status?: string | null;
  settings: {
    [k: string]: unknown;
  };
  status?: 'ACTIVE' | 'INACTIVE' | 'FAILING';
  status_message?: string | null;
  version?: string;
}
/**
 * Original schema `StorageReadSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-StorageReadSchema}
 */
export interface FilesStorageReadSchema {
  default?: boolean;
  description?: string | null;
  id?: string;
  isg_version?: string;
  last_scanned?: string | null;
  method:
    | 'FILE'
    | 'HTTP'
    | 'FTP'
    | 'SFTP'
    | 'S3'
    | 'B2'
    | 'GCS'
    | 'PORTAL'
    | 'CUSTOM'
    | 'AZURE'
    | 'DROPBOX';
  name: string;
  purpose: 'KEYFRAMES' | 'FILES' | 'PROXIES' | 'EXPORTS' | 'ARCHIVE' | 'FACES';
  scanner_status?: string | null;
  settings: {
    [k: string]: unknown;
  };
  status?: 'ACTIVE' | 'INACTIVE' | 'FAILING';
  status_message?: string | null;
  storage_gateway_cluster_id?: string;
  storage_gateway_ids?: string[];
  version?: string;
}
/**
 * Original schema `StorageScanSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-StorageScanSchema}
 */
export interface FilesStorageScanSchema {
  files?: string[] | null;
  /**
   * Will force scanning even if the scan is already active if any of `paths` or `files` are specified.
   */
  ignore_already_active?: boolean;
  paths?: string[] | null;
}
/**
 * Original schema `StorageSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-StorageSchema}
 */
export interface FilesStorageSchema {
  default?: boolean;
  description?: string | null;
  id?: string;
  last_scanned?: string | null;
  method:
    | 'FILE'
    | 'HTTP'
    | 'FTP'
    | 'SFTP'
    | 'S3'
    | 'B2'
    | 'GCS'
    | 'PORTAL'
    | 'CUSTOM'
    | 'AZURE'
    | 'DROPBOX';
  name: string;
  purpose: 'KEYFRAMES' | 'FILES' | 'PROXIES' | 'EXPORTS' | 'ARCHIVE' | 'FACES';
  scanner_status?: string | null;
  settings: {
    [k: string]: unknown;
  };
  status?: 'ACTIVE' | 'INACTIVE' | 'FAILING';
  status_message?: string | null;
  version?: string;
}
/**
 * Original schema `StorageValidationSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-StorageValidationSchema}
 */
export interface FilesStorageValidationSchema {
  method:
    | 'FILE'
    | 'HTTP'
    | 'FTP'
    | 'SFTP'
    | 'S3'
    | 'B2'
    | 'GCS'
    | 'PORTAL'
    | 'CUSTOM'
    | 'AZURE'
    | 'DROPBOX';
  settings: {
    [k: string]: unknown;
  };
}
/**
 * Original schema `StoragesQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-StoragesQueryParamsSchema}
 */
export interface FilesStoragesQueryParamsSchema {
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
}
/**
 * Original schema `StoragesReadSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-StoragesReadSchema}
 */
export interface FilesStoragesReadSchema {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: FilesStorageReadSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `Subtitle`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-Subtitle}
 */
export interface FilesSubtitle {
  asset_id: string;
  closed_captions: boolean;
  format_id: string;
  id: string;
  language: string;
  name?: string;
  version_id?: string;
}
/**
 * Original schema `SubtitleRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-SubtitleRequestSchema}
 */
export interface FilesSubtitleRequestSchema {
  create_transcription?: boolean;
  delete_old_transcriptions?: boolean;
  priority?: number | null;
}
/**
 * Original schema `SubtitleSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-SubtitleSchema}
 */
export interface FilesSubtitleSchema {
  asset_id: string;
  closed_captions: boolean;
  content?: string;
  format_id: string;
  id: string;
  language: string;
  name?: string;
  version_id?: string;
}
/**
 * Original schema `SubtitlesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-SubtitlesSchema}
 */
export interface FilesSubtitlesSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: FilesSubtitle[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `SwapStoragesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-SwapStoragesSchema}
 */
export interface FilesSwapStoragesSchema {
  destination_storage_id: string;
  source_storage_id: string;
  system_domain_id: string;
}
/**
 * Original schema `TelestreamCloudSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TelestreamCloudSchema}
 */
export interface FilesTelestreamCloudSchema {
  access_key: string;
  api_host?: string;
  api_port?: number;
  exclude_patterns?: string[];
  factory_id: string;
  include_patterns?: string[];
  keyframes_profile_id: string;
  local?: boolean;
  priority?: number | null;
  proxy_profile_id: string;
  secret_key: string;
  storage_id: string;
}
/**
 * Original schema `TemporaryFileCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TemporaryFileCreateSchema}
 */
export interface FilesTemporaryFileCreateSchema {
  asset_id?: string;
  checksum?: string | null;
  content_type?: string;
  date_created?: string;
  date_modified?: string;
  directory_path: string;
  file_date_created?: string;
  file_date_modified?: string;
  file_set_id?: string;
  format_id?: string;
  id?: string;
  multipart_upload_url?: string;
  /**
   * If not specified, name will be autogenerated based on `id` and `original_name`
   */
  name?: string;
  original_name: string;
  parent_id?: string | null;
  path_exist?: boolean;
  size?: number;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  storage_method?: string;
  template?: string;
  template_engine?: ('SIMPLE' | 'JINJA2' | null) | null;
  type: 'FILE' | 'DIRECTORY' | 'SYMLINK' | 'SEQUENCE';
  upload_credentials?: {
    [k: string]: unknown;
  };
  upload_filename?: string;
  upload_headers?: {
    [k: string]: unknown;
  };
  upload_method?: string;
  upload_url?: string;
  user_id?: string | null;
  version_id?: string;
}
/**
 * Original schema `TemporaryFileSetSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TemporaryFileSetSchema}
 */
export interface FilesTemporaryFileSetSchema {
  archive_file_set_id?: string;
  asset_id?: string;
  base_dir: string;
  component_ids: string[];
  date_created?: string;
  date_deleted?: string;
  date_modified?: string;
  deleted_by_user?: string;
  file_count?: number;
  format_id: string;
  id?: string;
  is_archive?: boolean;
  job_id: string;
  name: string;
  original_storage_id?: string;
  status?: 'ACTIVE' | 'ARCHIVED' | 'DELETED';
  storage_id?: string;
  type?: 'REGULAR' | 'MANY_FILES';
  version_id?: string;
}
/**
 * Original schema `TimeBaseTypeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TimeBaseTypeSchema}
 */
export interface FilesTimeBaseTypeSchema {
  denominator?: number;
  numerator?: number;
}
/**
 * Original schema `TimeCodeTypeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TimeCodeTypeSchema}
 */
export interface FilesTimeCodeTypeSchema {
  frames_number?: number;
  is_drop_frame?: boolean;
  time_base?: FilesTimeBaseTypeSchema;
}
/**
 * Original schema `TranscodeRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TranscodeRequestSchema}
 */
export interface FilesTranscodeRequestSchema {
  job_id?: string | null;
  priority?: number | null;
  set_as_custom_keyframe?: boolean | null;
  update_proxy_mediainfo?: boolean;
  use_storage_transcode_ignore_pattern?: boolean | null;
}
/**
 * Original schema `TranscodeResponseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TranscodeResponseSchema}
 */
export interface FilesTranscodeResponseSchema {
  job_id?: string;
}
/**
 * Original schema `TranscoderBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TranscoderBaseSchema}
 */
export interface FilesTranscoderBaseSchema {}
/**
 * Original schema `TranscoderByStorageReadSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TranscoderByStorageReadSchema}
 */
export interface FilesTranscoderByStorageReadSchema {
  id?: string;
  name?: string;
  settings?: {
    [k: string]: unknown;
  };
  storage_id?: string;
  type?:
    | 'VANTAGE'
    | 'FFMPEG'
    | 'EDIT_PROXY'
    | 'IMAGEMAGICK'
    | 'ENCODING_COM'
    | 'ZENCODER'
    | 'TELESTREAM_CLOUD'
    | 'ELEMENTAL_MEDIACONVERT'
    | 'ELEMENTAL_SERVER'
    | 'REDLINE'
    | 'ICONIK_EDGE_TRANSCODER'
    | 'WATCH_FOLDER_VIDEO'
    | 'EDITREADY'
    | 'FLICS'
    | 'WILDMOKA'
    | 'LIBREOFFICE';
}
/**
 * Original schema `TranscoderCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TranscoderCreateSchema}
 */
export interface FilesTranscoderCreateSchema {
  id?: string;
  name: string;
  settings: {
    [k: string]: unknown;
  };
  type:
    | 'VANTAGE'
    | 'FFMPEG'
    | 'EDIT_PROXY'
    | 'IMAGEMAGICK'
    | 'ENCODING_COM'
    | 'ZENCODER'
    | 'TELESTREAM_CLOUD'
    | 'ELEMENTAL_MEDIACONVERT'
    | 'ELEMENTAL_SERVER'
    | 'REDLINE'
    | 'ICONIK_EDGE_TRANSCODER'
    | 'WATCH_FOLDER_VIDEO'
    | 'EDITREADY'
    | 'FLICS'
    | 'WILDMOKA'
    | 'LIBREOFFICE';
}
/**
 * Original schema `TranscoderOptionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TranscoderOptionSchema}
 */
export interface FilesTranscoderOptionSchema {
  label?: string;
  value?: string;
}
/**
 * Original schema `TranscoderOptionsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TranscoderOptionsSchema}
 */
export interface FilesTranscoderOptionsSchema {
  objects?: FilesTranscoderOptionSchema[];
}
/**
 * Original schema `TranscoderReadSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TranscoderReadSchema}
 */
export interface FilesTranscoderReadSchema {
  id?: string;
  name: string;
  settings: {
    [k: string]: unknown;
  };
  storages?: FilesStorageReadSchema[];
  type:
    | 'VANTAGE'
    | 'FFMPEG'
    | 'EDIT_PROXY'
    | 'IMAGEMAGICK'
    | 'ENCODING_COM'
    | 'ZENCODER'
    | 'TELESTREAM_CLOUD'
    | 'ELEMENTAL_MEDIACONVERT'
    | 'ELEMENTAL_SERVER'
    | 'REDLINE'
    | 'ICONIK_EDGE_TRANSCODER'
    | 'WATCH_FOLDER_VIDEO'
    | 'EDITREADY'
    | 'FLICS'
    | 'WILDMOKA'
    | 'LIBREOFFICE';
}
/**
 * Original schema `TranscoderSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TranscoderSchema}
 */
export interface FilesTranscoderSchema {
  id?: string;
  name: string;
  settings: {
    [k: string]: unknown;
  };
  type:
    | 'VANTAGE'
    | 'FFMPEG'
    | 'EDIT_PROXY'
    | 'IMAGEMAGICK'
    | 'ENCODING_COM'
    | 'ZENCODER'
    | 'TELESTREAM_CLOUD'
    | 'ELEMENTAL_MEDIACONVERT'
    | 'ELEMENTAL_SERVER'
    | 'REDLINE'
    | 'ICONIK_EDGE_TRANSCODER'
    | 'WATCH_FOLDER_VIDEO'
    | 'EDITREADY'
    | 'FLICS'
    | 'WILDMOKA'
    | 'LIBREOFFICE';
}
/**
 * Original schema `TranscoderTokenRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TranscoderTokenRequestSchema}
 */
export interface FilesTranscoderTokenRequestSchema {
  expires_in?: number;
  payload?: {
    [k: string]: unknown;
  };
}
/**
 * Original schema `TranscoderTokenSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TranscoderTokenSchema}
 */
export interface FilesTranscoderTokenSchema {
  token?: string;
}
/**
 * Original schema `TranscoderUpdateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TranscoderUpdateSchema}
 */
export interface FilesTranscoderUpdateSchema {
  id?: string;
  name: string;
  settings: {
    [k: string]: unknown;
  };
  type:
    | 'VANTAGE'
    | 'FFMPEG'
    | 'EDIT_PROXY'
    | 'IMAGEMAGICK'
    | 'ENCODING_COM'
    | 'ZENCODER'
    | 'TELESTREAM_CLOUD'
    | 'ELEMENTAL_MEDIACONVERT'
    | 'ELEMENTAL_SERVER'
    | 'REDLINE'
    | 'ICONIK_EDGE_TRANSCODER'
    | 'WATCH_FOLDER_VIDEO'
    | 'EDITREADY'
    | 'FLICS'
    | 'WILDMOKA'
    | 'LIBREOFFICE';
}
/**
 * Original schema `TranscodersByStorageSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TranscodersByStorageSchema}
 */
export interface FilesTranscodersByStorageSchema {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: FilesTranscoderByStorageReadSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `TranscodersQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TranscodersQueryParamsSchema}
 */
export interface FilesTranscodersQueryParamsSchema {
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
}
/**
 * Original schema `TranscodersSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TranscodersSchema}
 */
export interface FilesTranscodersSchema {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: FilesTranscoderReadSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `TransferAssetToStorageRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TransferAssetToStorageRequestSchema}
 */
export interface FilesTransferAssetToStorageRequestSchema {
  all_versions?: boolean;
  delete_only_from_source?: boolean;
  delete_only_from_source_context?: FilesSourceContext;
  delete_original?: boolean;
  destination_directory_path?: string | null;
  /**
   * List of format names to transfer. If not specified, ORIGINAL will be transferred.
   *
   * @minItems 1
   */
  formats?: string[];
  /**
   * ID of the object to transfer.
   */
  id: string;
  preferred_original_storage_id?: string | null;
  /**
   * List of version IDs to transfer.
   */
  version_ids?: string[];
}
/**
 * Original schema `TransferAssetToStorageSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TransferAssetToStorageSchema}
 */
export interface FilesTransferAssetToStorageSchema {
  /**
   * If true, all versions of the asset will be transferred
   */
  all_versions?: boolean;
  destination_directory_path?: string;
  /**
   * List of format names to transfer. If not specified, all formats will be transferred.
   */
  formats?: string[];
  /**
   * List of version IDs to transfer. If not specified, the latest version will be transferred.
   */
  version_ids?: string[];
}
/**
 * Original schema `TransferBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TransferBaseSchema}
 */
export interface FilesTransferBaseSchema {
  destination_directory_path?: string;
}
/**
 * Original schema `TransferCloudSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TransferCloudSchema}
 */
export interface FilesTransferCloudSchema {
  asset_id?: string;
  asset_paths?: string[];
  celery_task_id?: string;
  collection_storage_id?: string;
  component_ids?: string[];
  date_created?: string;
  date_modified?: string;
  delete_only_from_source_folder?: boolean;
  delete_original?: boolean;
  destination_directory_path?: string;
  destination_filename?: string;
  destination_storage_id?: string;
  id?: string;
  job_id?: string;
  job_steps?: {
    [k: string]: unknown;
  };
  original_file_set_id?: string;
  original_storage_id?: string;
  original_url?: string;
  parent_job_id?: string;
  priority?: number;
  status?: 'Q' | 'U' | 'E' | 'D';
  success?: string;
  transfer_type?: string;
  user_id?: string;
}
/**
 * Original schema `TransferCollectionToStorageRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TransferCollectionToStorageRequestSchema}
 */
export interface FilesTransferCollectionToStorageRequestSchema {
  all_versions?: boolean;
  delete_only_from_source?: boolean;
  delete_only_from_source_context?: FilesSourceContext;
  delete_original?: boolean;
  destination_directory_path?: string | null;
  /**
   * List of format names to transfer. If not specified, ORIGINAL will be transferred.
   *
   * @minItems 1
   */
  formats?: string[];
  /**
   * ID of the object to transfer.
   */
  id: string;
  /**
   * Whether to keep the collection structure when transferring collections.
   */
  keep_collection_structure?: boolean;
  /**
   * Whether to keep the parent collection structure when transferring collections.
   */
  keep_parent_collection_structure?: boolean;
  preferred_original_storage_id?: string | null;
}
/**
 * Original schema `TransferFormatToStorageSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TransferFormatToStorageSchema}
 */
export interface FilesTransferFormatToStorageSchema {
  destination_directory_path?: string;
  destination_filename?: string;
}
/**
 * Original schema `TransferFromStorageReadSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TransferFromStorageReadSchema}
 */
export interface FilesTransferFromStorageReadSchema {
  add_file_set?: boolean;
  asset_id?: string;
  asset_paths?: string[];
  collection_storage_id?: string;
  component_ids?: string[];
  delete_local_file_set_after_upload?: boolean;
  delete_only_from_source_folder?: boolean;
  delete_source_file_set_after_download?: boolean;
  destination_directory_path?: string;
  destination_file_set_name?: string;
  destination_filename?: string;
  destination_storage_id?: string;
  destination_storage_method?: string;
  export_metadata_format?: string;
  export_metadata_view?: string;
  export_original?: boolean;
  export_posters?: boolean;
  export_proxy?: boolean;
  export_transcription_format?: string;
  format_id?: string;
  id?: string;
  include_original_extension?: boolean;
  job_id?: string;
  job_steps?: {
    [k: string]: unknown;
  };
  original_file_set_id?: string;
  original_storage_id?: string;
  original_url?: string;
  overwrite?: boolean;
  parent_job_id?: string;
  temporary_file_set_source?: boolean;
  transfer_type?: string;
}
/**
 * Original schema `TransferFromStorageSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TransferFromStorageSchema}
 */
export interface FilesTransferFromStorageSchema {
  asset_id?: string;
  asset_paths?: string[];
  collection_storage_id?: string;
  component_ids?: string[];
  delete_local_file_set_after_upload?: boolean;
  delete_only_from_source_folder?: boolean;
  delete_source_file_set_after_download?: boolean;
  destination_directory_path?: string;
  destination_file_set_name?: string;
  destination_filename?: string;
  destination_storage_id?: string;
  destination_storage_method?: string;
  format_id?: string;
  id?: string;
  job_id?: string;
  job_steps?: {
    [k: string]: unknown;
  };
  original_file_set_id?: string;
  original_storage_id?: string;
  original_url?: string;
  parent_job_id?: string;
  temporary_file_set_source?: boolean;
  transfer_type?: string;
}
/**
 * Original schema `TransferSavedSearchToStorageRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TransferSavedSearchToStorageRequestSchema}
 */
export interface FilesTransferSavedSearchToStorageRequestSchema {
  all_versions?: boolean;
  delete_only_from_source?: boolean;
  delete_only_from_source_context?: FilesSourceContext;
  delete_original?: boolean;
  destination_directory_path?: string | null;
  /**
   * List of format names to transfer. If not specified, ORIGINAL will be transferred.
   *
   * @minItems 1
   */
  formats?: string[];
  /**
   * ID of the object to transfer.
   */
  id: string;
  preferred_original_storage_id?: string | null;
}
/**
 * Original schema `TransferSignedURLSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TransferSignedURLSchema}
 */
export interface FilesTransferSignedURLSchema {
  url?: string;
}
/**
 * Original schema `TransferToStorageBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TransferToStorageBaseSchema}
 */
export interface FilesTransferToStorageBaseSchema {
  /**
   * If true, all versions of the asset will be transferred
   */
  all_versions?: boolean;
  destination_directory_path?: string;
  /**
   * List of format names to transfer. If not specified, all formats will be transferred.
   */
  formats?: string[];
}
/**
 * Original schema `TransferToStorageReadSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TransferToStorageReadSchema}
 */
export interface FilesTransferToStorageReadSchema {
  add_file_set?: boolean;
  asset_id?: string;
  asset_paths?: string[];
  collection_storage_id?: string;
  component_ids?: string[];
  delete_only_from_source_folder?: boolean;
  delete_remote_file_set_after_download?: boolean;
  delete_source_file_set_after_download?: boolean;
  destination_base_directory?: string;
  destination_directory_path: string;
  destination_file_set_name: string;
  destination_filename?: string;
  export_metadata_format?: string;
  export_metadata_view?: string;
  export_original?: boolean;
  export_posters?: boolean;
  export_proxy?: boolean;
  export_transcription_format?: string;
  file_set_id?: string;
  format_id?: string;
  id?: string;
  include_original_extension?: boolean;
  job_id?: string;
  job_steps?: {
    [k: string]: unknown;
  };
  local_storage_id?: string;
  original_storage_id?: string;
  original_url?: string;
  overwrite?: boolean;
  parent_job_id?: string;
  temporary_file_set_source?: boolean;
  transfer_type?: string;
}
/**
 * Original schema `TransferToStorageSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TransferToStorageSchema}
 */
export interface FilesTransferToStorageSchema {
  asset_id?: string;
  asset_paths?: string[];
  collection_storage_id?: string;
  component_ids?: string[];
  delete_only_from_source_folder?: boolean;
  delete_remote_file_set_after_download?: boolean;
  delete_source_file_set_after_download?: boolean;
  destination_base_directory?: string;
  destination_directory_path: string;
  destination_file_set_name: string;
  destination_filename?: string;
  file_set_id?: string;
  format_id?: string;
  id?: string;
  job_id?: string;
  job_steps?: {
    [k: string]: unknown;
  };
  local_storage_id?: string;
  original_storage_id?: string;
  original_url?: string;
  parent_job_id?: string;
  temporary_file_set_source?: boolean;
  transfer_type?: string;
}
/**
 * Original schema `TransfersFromStorageSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TransfersFromStorageSchema}
 */
export interface FilesTransfersFromStorageSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: FilesTransferFromStorageReadSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `TransfersToStorageSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TransfersToStorageSchema}
 */
export interface FilesTransfersToStorageSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: FilesTransferToStorageReadSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `UploadFilesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-UploadFilesSchema}
 */
export interface FilesUploadFilesSchema {
  asset_id?: string;
  asset_title?: string;
  collection_id?: string;
  create_keyframes?: boolean;
  file_name: string;
  /**
   * Sequence cannot have more than 10000. Excess values will be stripped
   */
  format_metadata?: {
    [k: string]: string;
  }[];
  format_name?: string;
  storage_id: string;
  version_id?: string;
}
/**
 * Original schema `UploadIconikStorageGatewayLogsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-UploadIconikStorageGatewayLogsSchema}
 */
export interface FilesUploadIconikStorageGatewayLogsSchema {
  filename: string;
}
/**
 * Original schema `VantageSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-VantageSettingsSchema}
 */
export interface FilesVantageSettingsSchema {
  exclude_patterns?: string[];
  host: string;
  include_patterns?: string[];
  local?: boolean;
  port: number;
  priority?: number | null;
  share_name: string;
  temp_proxy_folder: string;
  workflow_id: string;
}
/**
 * Original schema `VideoBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-VideoBaseSchema}
 */
export interface FilesVideoBaseSchema {
  audio_bitrate?: number;
  bitrate?: number;
  edit_proxy_folder?: string | null;
  enable_multi_channel_audio?: boolean;
  exclude_patterns?: string[];
  hdr_brightness?: number | null;
  hdr_contrast?: number | null;
  hdr_gamma?: number | null;
  hdr_saturation?: number | null;
  hdr_tonemap_desat?: number | null;
  hdr_tonemap_peak?: number | null;
  include_patterns?: string[];
  local?: boolean;
  merge_multichannel_audio_tracks?: boolean;
  priority?: number | null;
  scaling_method?:
    | 'fast_bilinear'
    | 'bilinear'
    | 'bicubic'
    | 'experimental'
    | 'neighbor'
    | 'area'
    | 'bicublin'
    | 'gauss'
    | 'sinc'
    | 'lanczos'
    | 'spline'
    | 'accurate_rnd'
    | 'full_chroma_int'
    | 'full_chroma_inp'
    | 'bitexact';
  width?: number;
}
/**
 * Original schema `WatchFolderVideoTranscoderSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-WatchFolderVideoTranscoderSchema}
 */
export interface FilesWatchFolderVideoTranscoderSchema {
  create_web_proxy_from_edit_proxy?: boolean;
  edit_proxy_local_storage_path?: string;
  edit_proxy_upload_storage_id?: string;
  edit_proxy_upload_storage_path?: string;
  exclude_patterns?: string[];
  file_grow_threshold: number;
  include_patterns?: string[];
  keep_as_edit_proxy?: boolean;
  keyframe_folder_name?: string;
  keyframe_map_folder_name?: string;
  local?: boolean;
  proxy_folder_name: string;
  proxy_timeout?: number;
  /**
   * If enabled a soft link is used to add original to the watch folder, if disabled a hard link is used with a fallback to copy.
   */
  use_symlink?: boolean;
  /**
   * A sub-folder is created with a unique name inside the watch folder per job.
   */
  use_unique_sub_folder_workflow?: boolean;
  watch_folder_location: string;
}
/**
 * Original schema `WildmokaSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-WildmokaSettingsSchema}
 */
export interface FilesWildmokaSettingsSchema {
  audio_bitrate?: number;
  bitrate?: number;
  edit_proxy_folder?: string | null;
  enable_multi_channel_audio?: boolean;
  exclude_patterns?: string[];
  hdr_brightness?: number | null;
  hdr_contrast?: number | null;
  hdr_gamma?: number | null;
  hdr_saturation?: number | null;
  hdr_tonemap_desat?: number | null;
  hdr_tonemap_peak?: number | null;
  include_patterns?: string[];
  local?: boolean;
  merge_multichannel_audio_tracks?: boolean;
  priority?: number | null;
  scaling_method?:
    | 'fast_bilinear'
    | 'bilinear'
    | 'bicubic'
    | 'experimental'
    | 'neighbor'
    | 'area'
    | 'bicublin'
    | 'gauss'
    | 'sinc'
    | 'lanczos'
    | 'spline'
    | 'accurate_rnd'
    | 'full_chroma_int'
    | 'full_chroma_inp'
    | 'bitexact';
  width?: number;
  /**
   * Wildmoka API endpoint URL
   */
  wm_endpoint_url?: string | null;
  /**
   * JWT issuer to use for authentication
   */
  wm_issuer?: string | null;
  /**
   * JWT secret key to use for authentication
   */
  wm_secret_key?: string | null;
  /**
   * Storage ID to use for Wildmoka segmented and analyzed formats
   */
  wm_storage_id?: string | null;
  /**
   * List of video variants to prepare
   */
  wm_video_variants?: string[];
}
/**
 * Original schema `ZencoderSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ZencoderSettingsSchema}
 */
export interface FilesZencoderSettingsSchema {
  api_key: string;
  exclude_patterns?: string[];
  include_patterns?: string[];
  local?: boolean;
  priority?: number | null;
}
/**
 * Original schema `AnalysisProfilesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AnalysisProfilesSchema}
 */
export interface FilesAnalysisProfilesSchemaWithId {
  objects: FilesAnalysisProfileSchemaWithIdNullable[];
}
/**
 * Original schema `AnalysisProfileSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AnalysisProfileSchema}
 */
export interface FilesAnalysisProfileSchemaWithIdNullable {
  analysis_service_account_id: string;
  enabled?: boolean | null;
  id: string;
  is_default?: boolean | null;
  media_type: 'image' | 'video' | 'transcription' | 'face_image' | 'face_video';
  name: string;
  service_type?:
    | (
        | 'GOOGLE_VISION'
        | 'GOOGLE_VIDEO_INTELLIGENCE'
        | 'AMAZON_REKOGNITION'
        | 'REV_AI'
        | 'ICONIK'
        | 'ICONIK_FACE_RECOGNITION'
      )
    | null;
  settings?: {
    [k: string]: unknown;
  } | null;
}
/**
 * Original schema `AnalysisProfileSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AnalysisProfileSchema}
 */
export interface FilesAnalysisProfileSchemaWithId {
  analysis_service_account_id: string;
  enabled?: boolean;
  id: string;
  is_default?: boolean;
  media_type: 'image' | 'video' | 'transcription' | 'face_image' | 'face_video';
  name: string;
  service_type?:
    | 'GOOGLE_VISION'
    | 'GOOGLE_VIDEO_INTELLIGENCE'
    | 'AMAZON_REKOGNITION'
    | 'REV_AI'
    | 'ICONIK'
    | 'ICONIK_FACE_RECOGNITION';
  settings?: {
    [k: string]: unknown;
  };
}
/**
 * Original schema `AnalysisServiceAccountsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AnalysisServiceAccountsSchema}
 */
export interface FilesAnalysisServiceAccountsSchemaWithId {
  objects: FilesAnalysisServiceAccountReadSchemaWithId[];
}
/**
 * Original schema `AnalysisServiceAccountReadSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AnalysisServiceAccountReadSchema}
 */
export interface FilesAnalysisServiceAccountReadSchemaWithId {
  id: string;
  method: 'GOOGLE_AI' | 'AMAZON' | 'REV_AI' | 'ICONIK';
  name: string;
  settings: {
    [k: string]: unknown;
  };
}
/**
 * Original schema `AnalysisTranscriptionSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AnalysisTranscriptionSettingsSchema}
 */
export interface FilesAnalysisTranscriptionSettingsSchemaWithId {
  analysis_service_account_id: string;
  analysis_service_account_settings?: {
    [k: string]: unknown;
  };
  enabled?: boolean;
  id: string;
  is_default?: boolean;
  media_type: 'image' | 'video' | 'transcription' | 'face_image' | 'face_video';
  name: string;
  service_type?:
    | 'GOOGLE_VISION'
    | 'GOOGLE_VIDEO_INTELLIGENCE'
    | 'AMAZON_REKOGNITION'
    | 'REV_AI'
    | 'ICONIK'
    | 'ICONIK_FACE_RECOGNITION';
  settings?: {
    [k: string]: unknown;
  };
}
/**
 * Original schema `AnalysisTranscriptionSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AnalysisTranscriptionSettingsSchema}
 */
export interface FilesAnalysisTranscriptionSettingsSchemaWithIdNullable {
  analysis_service_account_id: string;
  analysis_service_account_settings?: {
    [k: string]: unknown;
  } | null;
  enabled?: boolean | null;
  id: string;
  is_default?: boolean | null;
  media_type: 'image' | 'video' | 'transcription' | 'face_image' | 'face_video';
  name: string;
  service_type?:
    | (
        | 'GOOGLE_VISION'
        | 'GOOGLE_VIDEO_INTELLIGENCE'
        | 'AMAZON_REKOGNITION'
        | 'REV_AI'
        | 'ICONIK'
        | 'ICONIK_FACE_RECOGNITION'
      )
    | null;
  settings?: {
    [k: string]: unknown;
  } | null;
}
/**
 * Original schema `KeyframeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-KeyframeSchema}
 */
export interface FilesKeyframeSchemaWithId {
  asset_id?: string | null;
  collection_id?: string | null;
  date_created?: string;
  date_modified?: string;
  filename?: string;
  format?: string | null;
  id: string;
  is_custom_keyframe?: boolean;
  is_public?: boolean;
  name?: string;
  resolution?: FilesResolutionType;
  rotation?: number | null;
  size?: number | null;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  storage_method?: string;
  time_code?: FilesTimeCodeType;
  type: 'KEYFRAME_MAP' | 'KEYFRAME' | 'POSTER';
  upload_credentials?: {
    [k: string]: unknown;
  };
  upload_headers?: {
    [k: string]: unknown;
  };
  upload_method?: string;
  upload_url?: string;
  url?: string;
  version_id?: string | null;
}
/**
 * Original schema `FileSetsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FileSetsSchema}
 */
export interface FilesFileSetsSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: FilesFileSetSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  total: number;
}
/**
 * Original schema `FileSetSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FileSetSchema}
 */
export interface FilesFileSetSchemaWithIdNullable {
  archive_file_set_id?: string | null;
  asset_id?: string | null;
  base_dir: string;
  component_ids: string[];
  date_created?: string | null;
  date_deleted?: string | null;
  date_modified?: string | null;
  deleted_by_user?: string | null;
  file_count?: number | null;
  format_id: string;
  id: string;
  is_archive?: boolean | null;
  name: string;
  original_storage_id?: string | null;
  status?: ('ACTIVE' | 'ARCHIVED' | 'DELETED') | null;
  storage_id?: string | null;
  type?: ('REGULAR' | 'MANY_FILES') | null;
  version_id?: string | null;
}
/**
 * Original schema `FileSetSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FileSetSchema}
 */
export interface FilesFileSetSchemaWithId {
  archive_file_set_id?: string;
  asset_id?: string;
  base_dir: string;
  component_ids: string[];
  date_created?: string;
  date_deleted?: string;
  date_modified?: string;
  deleted_by_user?: string;
  file_count?: number;
  format_id: string;
  id: string;
  is_archive?: boolean;
  name: string;
  original_storage_id?: string;
  status?: 'ACTIVE' | 'ARCHIVED' | 'DELETED';
  storage_id?: string;
  type?: 'REGULAR' | 'MANY_FILES';
  version_id?: string;
}
/**
 * Original schema `FilesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FilesSchema}
 */
export interface FilesFilesSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: FilesFileSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  total: number;
}
/**
 * Original schema `FileSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FileSchema}
 */
export interface FilesFileSchemaWithIdNullable {
  asset_id?: string | null;
  checksum?: string | null;
  date_created?: string | null;
  date_modified?: string | null;
  directory_path: string;
  file_date_created?: string | null;
  file_date_modified?: string | null;
  file_set_id: string;
  file_set_status?: string | null;
  format_id?: string | null;
  format_status?: string | null;
  id: string;
  multipart_upload_url?: string | null;
  /**
   * If not specified, name will be autogenerated based on `id` and `original_name`
   */
  name?: string | null;
  original_name: string;
  parent_id?: string | null;
  size?: number | null;
  status?:
    | (
        | 'OPEN'
        | 'GROWING'
        | 'AWAITED'
        | 'CLOSED'
        | 'FAILED'
        | 'ARCHIVED'
        | 'MISSING'
        | 'REDISCOVERED'
        | 'DELETED'
      )
    | null;
  storage_id?: string | null;
  storage_method?: string | null;
  system_domain_id?: string | null;
  template?: string | null;
  template_engine?: ('SIMPLE' | 'JINJA2' | null) | null;
  type: 'FILE' | 'DIRECTORY' | 'SYMLINK' | 'SEQUENCE';
  upload_credentials?: {
    [k: string]: unknown;
  } | null;
  upload_filename?: string | null;
  upload_headers?: {
    [k: string]: unknown;
  } | null;
  upload_method?: string | null;
  /**
   * On a file creation for Backblaze B2 storage in case when request to Backblaze failed, upload_url field will be empty. You can try getting upload_url again by requesting created file with `generate_signed_post_url` set to true.
   */
  upload_url?: string | null;
  url?: string | null;
  user_id?: string | null;
  version_id?: string | null;
}
/**
 * Original schema `FileSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FileSchema}
 */
export interface FilesFileSchemaWithId {
  asset_id?: string;
  checksum?: string | null;
  date_created?: string;
  date_modified?: string;
  directory_path: string;
  file_date_created?: string;
  file_date_modified?: string;
  file_set_id: string;
  file_set_status?: string | null;
  format_id?: string;
  format_status?: string | null;
  id: string;
  multipart_upload_url?: string;
  /**
   * If not specified, name will be autogenerated based on `id` and `original_name`
   */
  name?: string;
  original_name: string;
  parent_id?: string | null;
  size?: number;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  storage_method?: string;
  system_domain_id?: string;
  template?: string;
  template_engine?: ('SIMPLE' | 'JINJA2' | null) | null;
  type: 'FILE' | 'DIRECTORY' | 'SYMLINK' | 'SEQUENCE';
  upload_credentials?: {
    [k: string]: unknown;
  };
  upload_filename?: string;
  upload_headers?: {
    [k: string]: unknown;
  };
  upload_method?: string;
  /**
   * On a file creation for Backblaze B2 storage in case when request to Backblaze failed, upload_url field will be empty. You can try getting upload_url again by requesting created file with `generate_signed_post_url` set to true.
   */
  upload_url?: string;
  url?: string;
  user_id?: string | null;
  version_id?: string;
}
/**
 * Original schema `FileDownloadURLSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FileDownloadURLSchema}
 */
export interface FilesFileDownloadURLSchemaNullable {
  url?: string | null;
}
/**
 * Original schema `EditProxyResponseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-EditProxyResponseSchema}
 */
export interface FilesEditProxyResponseSchemaWithId {
  audio_bitrate?: number;
  audio_codec?: string;
  bitrate?: number;
  codec?: string;
  directory_path?: string;
  file_set_id?: string;
  format_id?: string;
  gop_length_seconds?: number;
  height?: number;
  id: string;
  name?: string;
  transcoder_id?: string;
  type?: string;
  width?: number;
}
/**
 * Original schema `ISGHandlerURLSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ISGHandlerURLSchema}
 */
export interface FilesISGHandlerURLSchemaNullable {
  url?: string | null;
}
/**
 * Original schema `MultiPartURLsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-MultiPartURLsSchema}
 */
export interface FilesMultiPartURLsSchemaNullable {
  abort_url?: string | null;
  complete_url?: string | null;
  list_parts_url?: string[] | null;
}
/**
 * Original schema `MultiPartUploadURLsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-MultiPartUploadURLsSchema}
 */
export interface FilesMultiPartUploadURLsSchemaWithId {
  objects: FilesMultiPartUploadURLSchemaNullable[];
}
/**
 * Original schema `MultiPartUploadURLSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-MultiPartUploadURLSchema}
 */
export interface FilesMultiPartUploadURLSchemaNullable {
  delete_url?: string | null;
  download_url?: string | null;
  key?: string | null;
  number?: number | null;
  url?: string | null;
}
/**
 * Original schema `FormatsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FormatsSchema}
 */
export interface FilesFormatsSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: FilesFormatSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  total: number;
}
/**
 * Original schema `FormatSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FormatSchema}
 */
export interface FilesFormatSchemaWithIdNullable {
  archive_status?:
    | ('NOT_ARCHIVED' | 'ARCHIVING' | 'FAILED_TO_ARCHIVE' | 'ARCHIVED')
    | null;
  asset_id?: string | null;
  components?: FilesComponentSchema[] | null;
  date_created?: string | null;
  date_deleted?: string | null;
  date_modified?: string | null;
  deleted_by_user?: string | null;
  external_references?: FilesExternalReferences[] | null;
  id: string;
  is_online?: boolean | null;
  /**
   * Sequence cannot have more than 10000. Excess values will be stripped
   */
  metadata?:
    | {
        [k: string]: string;
      }[]
    | null;
  name: string;
  status?: ('ACTIVE' | 'DELETED') | null;
  storage_methods?:
    | (
        | 'FILE'
        | 'HTTP'
        | 'FTP'
        | 'SFTP'
        | 'S3'
        | 'B2'
        | 'GCS'
        | 'PORTAL'
        | 'CUSTOM'
        | 'AZURE'
        | 'DROPBOX'
      )[]
    | null;
  user_id?: string | null;
  version_id?: string | null;
  warnings?: string[] | null;
  resolution?: FilesResolutionTypeSchema | null;
}
/**
 * Original schema `FormatSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FormatSchema}
 */
export interface FilesFormatSchemaWithId {
  archive_status?:
    | 'NOT_ARCHIVED'
    | 'ARCHIVING'
    | 'FAILED_TO_ARCHIVE'
    | 'ARCHIVED';
  asset_id?: string;
  components?: FilesComponentSchema[];
  date_created?: string;
  date_deleted?: string;
  date_modified?: string;
  deleted_by_user?: string;
  external_references?: FilesExternalReferences[];
  id: string;
  is_online?: boolean;
  /**
   * Sequence cannot have more than 10000. Excess values will be stripped
   */
  metadata?: {
    [k: string]: string;
  }[];
  name: string;
  status?: 'ACTIVE' | 'DELETED';
  storage_methods?: (
    | 'FILE'
    | 'HTTP'
    | 'FTP'
    | 'SFTP'
    | 'S3'
    | 'B2'
    | 'GCS'
    | 'PORTAL'
    | 'CUSTOM'
    | 'AZURE'
    | 'DROPBOX'
  )[];
  user_id?: string;
  version_id?: string;
  warnings?: string[];
  resolution?: FilesResolutionTypeSchema;
}
/**
 * Original schema `ComponentsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ComponentsSchema}
 */
export interface FilesComponentsSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: FilesComponentSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  total: number;
}
/**
 * Original schema `ComponentSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ComponentSchema}
 */
export interface FilesComponentSchemaWithIdNullable {
  id: string;
  /**
   * Sequence cannot have more than 10000. Excess values will be stripped
   */
  metadata?: {
    [k: string]: string;
  } | null;
  name: string;
  type:
    | 'VIDEO'
    | 'AUDIO'
    | 'IMAGE'
    | 'TEXT'
    | 'OTHER'
    | 'NON_MEDIA'
    | 'EXIF'
    | 'IPTC'
    | 'XMP'
    | 'GENERAL'
    | 'MANIFEST';
}
/**
 * Original schema `ComponentSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ComponentSchema}
 */
export interface FilesComponentSchemaWithId {
  id: string;
  /**
   * Sequence cannot have more than 10000. Excess values will be stripped
   */
  metadata?: {
    [k: string]: string;
  };
  name: string;
  type:
    | 'VIDEO'
    | 'AUDIO'
    | 'IMAGE'
    | 'TEXT'
    | 'OTHER'
    | 'NON_MEDIA'
    | 'EXIF'
    | 'IPTC'
    | 'XMP'
    | 'GENERAL'
    | 'MANIFEST';
}
/**
 * Original schema `FileSetSourcesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FileSetSourcesSchema}
 */
export interface FilesFileSetSourcesSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: FilesFileSetSourceSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  total: number;
}
/**
 * Original schema `FileSetSourceSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FileSetSourceSchema}
 */
export interface FilesFileSetSourceSchemaWithIdNullable {
  archive_file_set_id?: string | null;
  asset_id?: string | null;
  base_dir: string;
  component_ids: string[];
  date_created?: string | null;
  date_deleted?: string | null;
  date_modified?: string | null;
  deleted_by_user?: string | null;
  file_count?: number | null;
  format_id: string;
  id: string;
  is_archive?: boolean | null;
  name: string;
  original_storage_id?: string | null;
  status?: ('ACTIVE' | 'ARCHIVED' | 'DELETED') | null;
  storage_id: string;
  storage_method: string;
  type?: ('REGULAR' | 'MANY_FILES') | null;
  version_id?: string | null;
}
/**
 * Original schema `FileSetSourceSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FileSetSourceSchema}
 */
export interface FilesFileSetSourceSchemaWithId {
  archive_file_set_id?: string;
  asset_id?: string;
  base_dir: string;
  component_ids: string[];
  date_created?: string;
  date_deleted?: string;
  date_modified?: string;
  deleted_by_user?: string;
  file_count?: number;
  format_id: string;
  id: string;
  is_archive?: boolean;
  name: string;
  original_storage_id?: string;
  status?: 'ACTIVE' | 'ARCHIVED' | 'DELETED';
  storage_id: string;
  storage_method: string;
  type?: 'REGULAR' | 'MANY_FILES';
  version_id?: string;
}
/**
 * Original schema `KeyframesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-KeyframesSchema}
 */
export interface FilesKeyframesSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: FilesKeyframeSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  total: number;
}
/**
 * Original schema `KeyframeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-KeyframeSchema}
 */
export interface FilesKeyframeSchemaWithIdNullable {
  asset_id?: string | null;
  collection_id?: string | null;
  date_created?: string | null;
  date_modified?: string | null;
  filename?: string | null;
  format?: string | null;
  id: string;
  is_custom_keyframe?: boolean | null;
  is_public?: boolean | null;
  name?: string | null;
  resolution?: FilesResolutionType | null;
  rotation?: number | null;
  size?: number | null;
  status?:
    | (
        | 'OPEN'
        | 'GROWING'
        | 'AWAITED'
        | 'CLOSED'
        | 'FAILED'
        | 'ARCHIVED'
        | 'MISSING'
        | 'REDISCOVERED'
        | 'DELETED'
      )
    | null;
  storage_id?: string | null;
  storage_method?: string | null;
  time_code?: FilesTimeCodeType | null;
  type: 'KEYFRAME_MAP' | 'KEYFRAME' | 'POSTER';
  upload_credentials?: {
    [k: string]: unknown;
  } | null;
  upload_headers?: {
    [k: string]: unknown;
  } | null;
  upload_method?: string | null;
  upload_url?: string | null;
  url?: string | null;
  version_id?: string | null;
}
/**
 * Original schema `KeyframeCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-KeyframeCreateSchema}
 */
export interface FilesKeyframeCreateSchemaWithId {
  asset_id?: string | null;
  collection_id?: string | null;
  content_type?: string;
  date_created?: string;
  date_modified?: string;
  filename?: string;
  format?: string | null;
  id: string;
  is_custom_keyframe?: boolean;
  is_public?: boolean;
  name?: string;
  resolution?: FilesResolutionType;
  rotation?: number | null;
  size?: number | null;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  storage_method?: string;
  time_code?: FilesTimeCodeType;
  type: 'KEYFRAME_MAP' | 'KEYFRAME' | 'POSTER';
  upload_credentials?: {
    [k: string]: unknown;
  };
  upload_headers?: {
    [k: string]: unknown;
  };
  upload_method?: string;
  upload_url?: string;
  url?: string;
  version_id?: string | null;
}
/**
 * Original schema `ProxyCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ProxyCreateSchema}
 */
export interface FilesProxyCreateSchemaWithId {
  asset_id?: string;
  audio_bitrate?: number;
  audio_channels?: number | null;
  bit_rate?: number;
  codec?: string;
  content_type?: string;
  date_created?: string;
  date_modified?: string;
  filename?: string;
  format?: string;
  frame_rate?: string | null;
  id: string;
  is_drop_frame?: boolean | null;
  is_multichannel?: boolean | null;
  is_public?: boolean;
  multipart_upload_url?: string;
  name?: string;
  proxy_container_id?: string | null;
  resolution?: FilesResolutionType;
  rotation?: number | null;
  size?: number | null;
  start_time_code?: string | null;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  storage_method?: string;
  upload_credentials?: {
    [k: string]: unknown;
  };
  upload_headers?: {
    [k: string]: unknown;
  };
  upload_method?: string;
  upload_url?: string;
  url?: string;
  version_id?: string | null;
}
/**
 * Original schema `ProxiesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ProxiesSchema}
 */
export interface FilesProxiesSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: FilesProxyWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  total: number;
}
/**
 * Original schema `Proxy`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-Proxy}
 */
export interface FilesProxyWithIdNullable {
  asset_id?: string | null;
  audio_bitrate?: number | null;
  audio_channels?: number | null;
  bit_rate?: number | null;
  codec?: string | null;
  date_created?: string | null;
  date_modified?: string | null;
  filename?: string | null;
  format?: string | null;
  frame_rate?: string | null;
  id: string;
  is_drop_frame?: boolean | null;
  is_multichannel?: boolean | null;
  is_public?: boolean | null;
  multipart_upload_url?: string | null;
  name?: string | null;
  proxy_container_id?: string | null;
  resolution?: FilesResolutionType | null;
  rotation?: number | null;
  size?: number | null;
  start_time_code?: string | null;
  status?:
    | (
        | 'OPEN'
        | 'GROWING'
        | 'AWAITED'
        | 'CLOSED'
        | 'FAILED'
        | 'ARCHIVED'
        | 'MISSING'
        | 'REDISCOVERED'
        | 'DELETED'
      )
    | null;
  storage_id?: string | null;
  storage_method?: string | null;
  upload_credentials?: {
    [k: string]: unknown;
  } | null;
  upload_headers?: {
    [k: string]: unknown;
  } | null;
  upload_method?: string | null;
  upload_url?: string | null;
  url?: string | null;
  version_id?: string | null;
}
/**
 * Original schema `Proxy`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-Proxy}
 */
export interface FilesProxyWithId {
  asset_id?: string;
  audio_bitrate?: number;
  audio_channels?: number | null;
  bit_rate?: number;
  codec?: string;
  date_created?: string;
  date_modified?: string;
  filename?: string;
  format?: string;
  frame_rate?: string | null;
  id: string;
  is_drop_frame?: boolean | null;
  is_multichannel?: boolean | null;
  is_public?: boolean;
  multipart_upload_url?: string;
  name?: string;
  proxy_container_id?: string | null;
  resolution?: FilesResolutionType;
  rotation?: number | null;
  size?: number | null;
  start_time_code?: string | null;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  storage_method?: string;
  upload_credentials?: {
    [k: string]: unknown;
  };
  upload_headers?: {
    [k: string]: unknown;
  };
  upload_method?: string;
  upload_url?: string;
  url?: string;
  version_id?: string | null;
}
/**
 * Original schema `ProxySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ProxySchema}
 */
export interface FilesProxySchemaWithId {
  asset_id?: string;
  audio_bitrate?: number;
  audio_channels?: number | null;
  bit_rate?: number;
  codec?: string;
  date_created?: string;
  date_modified?: string;
  filename?: string;
  format?: string;
  frame_rate?: string | null;
  id: string;
  is_drop_frame?: boolean | null;
  is_multichannel?: boolean | null;
  is_public?: boolean;
  multipart_upload_url?: string;
  name?: string;
  proxy_container_id?: string | null;
  resolution?: FilesResolutionType;
  rotation?: number | null;
  size?: number | null;
  start_time_code?: string | null;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  storage_method?: string;
  upload_credentials?: {
    [k: string]: unknown;
  };
  upload_headers?: {
    [k: string]: unknown;
  };
  upload_method?: string;
  upload_url?: string;
  url?: string;
  version_id?: string | null;
}
/**
 * Original schema `ProxySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ProxySchema}
 */
export interface FilesProxySchemaWithIdNullable {
  asset_id?: string | null;
  audio_bitrate?: number | null;
  audio_channels?: number | null;
  bit_rate?: number | null;
  codec?: string | null;
  date_created?: string | null;
  date_modified?: string | null;
  filename?: string | null;
  format?: string | null;
  frame_rate?: string | null;
  id: string;
  is_drop_frame?: boolean | null;
  is_multichannel?: boolean | null;
  is_public?: boolean | null;
  multipart_upload_url?: string | null;
  name?: string | null;
  proxy_container_id?: string | null;
  resolution?: FilesResolutionType | null;
  rotation?: number | null;
  size?: number | null;
  start_time_code?: string | null;
  status?:
    | (
        | 'OPEN'
        | 'GROWING'
        | 'AWAITED'
        | 'CLOSED'
        | 'FAILED'
        | 'ARCHIVED'
        | 'MISSING'
        | 'REDISCOVERED'
        | 'DELETED'
      )
    | null;
  storage_id?: string | null;
  storage_method?: string | null;
  upload_credentials?: {
    [k: string]: unknown;
  } | null;
  upload_headers?: {
    [k: string]: unknown;
  } | null;
  upload_method?: string | null;
  upload_url?: string | null;
  url?: string | null;
  version_id?: string | null;
}
/**
 * Original schema `ProxyFileSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ProxyFileSchema}
 */
export interface FilesProxyFileSchemaWithId {
  asset_id?: string;
  checksum?: string | null;
  date_created?: string;
  date_modified?: string;
  directory_path: string;
  file_date_created?: string;
  file_date_modified?: string;
  file_set_id?: string;
  format_id?: string;
  id: string;
  /**
   * If not specified, name will be autogenerated based on `id` and `original_name`
   */
  name?: string;
  original_name: string;
  parent_id?: string | null;
  proxy_sequence_type: string;
  size?: number;
  status?: 'OPEN' | 'CLOSED' | 'FAILED';
  storage_id?: string;
  template?: string;
  template_engine?: ('SIMPLE' | 'JINJA2' | null) | null;
  type: 'FILE' | 'DIRECTORY' | 'SYMLINK' | 'SEQUENCE';
  user_id?: string | null;
  version_id?: string;
}
/**
 * Original schema `ProxyDownloadURLSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ProxyDownloadURLSchema}
 */
export interface FilesProxyDownloadURLSchemaNullable {
  url?: string | null;
}
/**
 * Original schema `AttachmentsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AttachmentsSchema}
 */
export interface FilesAttachmentsSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: FilesAttachmentSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  total: number;
}
/**
 * Original schema `AttachmentSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AttachmentSchema}
 */
export interface FilesAttachmentSchemaWithIdNullable {
  asset_id?: string | null;
  date_created?: string | null;
  date_modified?: string | null;
  filename?: string | null;
  format?: string | null;
  id: string;
  name?: string | null;
  segment_id?: string | null;
  size?: number | null;
  status?:
    | (
        | 'OPEN'
        | 'GROWING'
        | 'AWAITED'
        | 'CLOSED'
        | 'FAILED'
        | 'ARCHIVED'
        | 'MISSING'
        | 'REDISCOVERED'
        | 'DELETED'
      )
    | null;
  storage_id?: string | null;
  storage_method?: string | null;
  upload_credentials?: {
    [k: string]: unknown;
  } | null;
  upload_headers?: {
    [k: string]: unknown;
  } | null;
  upload_method?: string | null;
  upload_url?: string | null;
  url?: string | null;
}
/**
 * Original schema `AttachmentSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AttachmentSchema}
 */
export interface FilesAttachmentSchemaWithId {
  asset_id?: string | null;
  date_created?: string;
  date_modified?: string;
  filename?: string;
  format?: string | null;
  id: string;
  name?: string;
  segment_id?: string;
  size?: number | null;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  storage_method?: string;
  upload_credentials?: {
    [k: string]: unknown;
  };
  upload_headers?: {
    [k: string]: unknown;
  };
  upload_method?: string;
  upload_url?: string;
  url?: string;
}
/**
 * Original schema `AttachmentCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-AttachmentCreateSchema}
 */
export interface FilesAttachmentCreateSchemaWithId {
  asset_id?: string | null;
  content_type?: string;
  date_created?: string;
  date_modified?: string;
  filename?: string;
  format?: string | null;
  id: string;
  name?: string;
  segment_id?: string;
  size?: number | null;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  storage_method?: string;
  upload_credentials?: {
    [k: string]: unknown;
  };
  upload_headers?: {
    [k: string]: unknown;
  };
  upload_method?: string;
  upload_url?: string;
  url?: string;
}
/**
 * Original schema `SubtitlesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-SubtitlesSchema}
 */
export interface FilesSubtitlesSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: FilesSubtitleNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  total: number;
}
/**
 * Original schema `Subtitle`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-Subtitle}
 */
export interface FilesSubtitleNullable {
  asset_id: string;
  closed_captions: boolean;
  format_id: string;
  id: string;
  language: string;
  name?: string | null;
  version_id?: string | null;
}
/**
 * Original schema `SubtitleSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-SubtitleSchema}
 */
export interface FilesSubtitleSchemaNullable {
  asset_id: string;
  closed_captions: boolean;
  content?: string | null;
  format_id: string;
  id: string;
  language: string;
  name?: string | null;
  version_id?: string | null;
}
/**
 * Original schema `TemporaryFileSetSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TemporaryFileSetSchema}
 */
export interface FilesTemporaryFileSetSchemaWithId {
  archive_file_set_id?: string;
  asset_id?: string;
  base_dir: string;
  component_ids: string[];
  date_created?: string;
  date_deleted?: string;
  date_modified?: string;
  deleted_by_user?: string;
  file_count?: number;
  format_id: string;
  id: string;
  is_archive?: boolean;
  job_id: string;
  name: string;
  original_storage_id?: string;
  status?: 'ACTIVE' | 'ARCHIVED' | 'DELETED';
  storage_id?: string;
  type?: 'REGULAR' | 'MANY_FILES';
  version_id?: string;
}
/**
 * Original schema `TemporaryFileCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TemporaryFileCreateSchema}
 */
export interface FilesTemporaryFileCreateSchemaWithId {
  asset_id?: string;
  checksum?: string | null;
  content_type?: string;
  date_created?: string;
  date_modified?: string;
  directory_path: string;
  file_date_created?: string;
  file_date_modified?: string;
  file_set_id?: string;
  format_id?: string;
  id: string;
  multipart_upload_url?: string;
  /**
   * If not specified, name will be autogenerated based on `id` and `original_name`
   */
  name?: string;
  original_name: string;
  parent_id?: string | null;
  path_exist?: boolean;
  size?: number;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  storage_method?: string;
  template?: string;
  template_engine?: ('SIMPLE' | 'JINJA2' | null) | null;
  type: 'FILE' | 'DIRECTORY' | 'SYMLINK' | 'SEQUENCE';
  upload_credentials?: {
    [k: string]: unknown;
  };
  upload_filename?: string;
  upload_headers?: {
    [k: string]: unknown;
  };
  upload_method?: string;
  upload_url?: string;
  user_id?: string | null;
  version_id?: string;
}
/**
 * Original schema `CollectionKeyframeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-CollectionKeyframeSchema}
 */
export interface FilesCollectionKeyframeSchemaWithId {
  collection_id?: string;
  date_created?: string;
  date_modified?: string;
  filename?: string;
  format?: string | null;
  id: string;
  is_custom_keyframe?: boolean;
  is_public?: boolean;
  name?: string;
  resolution?: FilesResolutionType;
  rotation?: number | null;
  size?: number | null;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  time_code?: FilesTimeCodeType;
  type: 'KEYFRAME_MAP' | 'KEYFRAME' | 'POSTER';
  url?: string;
}
/**
 * Original schema `CollectionKeyframesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-CollectionKeyframesSchema}
 */
export interface FilesCollectionKeyframesSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: FilesCollectionKeyframeSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  total: number;
}
/**
 * Original schema `CollectionKeyframeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-CollectionKeyframeSchema}
 */
export interface FilesCollectionKeyframeSchemaWithIdNullable {
  collection_id?: string | null;
  date_created?: string | null;
  date_modified?: string | null;
  filename?: string | null;
  format?: string | null;
  id: string;
  is_custom_keyframe?: boolean | null;
  is_public?: boolean | null;
  name?: string | null;
  resolution?: FilesResolutionType | null;
  rotation?: number | null;
  size?: number | null;
  status?:
    | (
        | 'OPEN'
        | 'GROWING'
        | 'AWAITED'
        | 'CLOSED'
        | 'FAILED'
        | 'ARCHIVED'
        | 'MISSING'
        | 'REDISCOVERED'
        | 'DELETED'
      )
    | null;
  storage_id?: string | null;
  time_code?: FilesTimeCodeType | null;
  type: 'KEYFRAME_MAP' | 'KEYFRAME' | 'POSTER';
  url?: string | null;
}
/**
 * Original schema `CollectionKeyframeCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-CollectionKeyframeCreateSchema}
 */
export interface FilesCollectionKeyframeCreateSchemaWithId {
  collection_id?: string;
  content_type?: string;
  date_created?: string;
  date_modified?: string;
  filename?: string;
  format?: string | null;
  id: string;
  is_custom_keyframe?: boolean;
  is_public?: boolean;
  name?: string;
  resolution?: FilesResolutionType;
  rotation?: number | null;
  size?: number | null;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  time_code?: FilesTimeCodeType;
  type: 'KEYFRAME_MAP' | 'KEYFRAME' | 'POSTER';
  upload_credentials?: {
    [k: string]: unknown;
  };
  upload_headers?: {
    [k: string]: unknown;
  };
  upload_method?: string;
  upload_url?: string;
  url?: string;
}
/**
 * Original schema `FileSetsElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FileSetsElasticSchema}
 */
export interface FilesFileSetsElasticSchemaWithId {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: FilesFileSetElasticSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  total: number;
}
/**
 * Original schema `FileSetElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FileSetElasticSchema}
 */
export interface FilesFileSetElasticSchemaWithIdNullable {
  archive_file_set_id?: string | null;
  asset_id?: string | null;
  base_dir: string;
  component_ids: string[];
  date_created?: string | null;
  date_deleted?: string | null;
  date_modified?: string | null;
  deleted_by_user?: string | null;
  file_count?: number | null;
  format_id: string;
  id: string;
  is_archive?: boolean | null;
  name: string;
  original_storage_id?: string | null;
  status?: ('ACTIVE' | 'ARCHIVED' | 'DELETED') | null;
  storage_id?: string | null;
  type?: ('REGULAR' | 'MANY_FILES') | null;
  version_id?: string | null;
}
/**
 * Original schema `FileSetElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FileSetElasticSchema}
 */
export interface FilesFileSetElasticSchemaWithId {
  archive_file_set_id?: string;
  asset_id?: string;
  base_dir: string;
  component_ids: string[];
  date_created?: string;
  date_deleted?: string;
  date_modified?: string;
  deleted_by_user?: string;
  file_count?: number;
  format_id: string;
  id: string;
  is_archive?: boolean;
  name: string;
  original_storage_id?: string;
  status?: 'ACTIVE' | 'ARCHIVED' | 'DELETED';
  storage_id?: string;
  type?: 'REGULAR' | 'MANY_FILES';
  version_id?: string;
}
/**
 * Original schema `FormatsElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FormatsElasticSchema}
 */
export interface FilesFormatsElasticSchemaWithId {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: FilesFormatElasticSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  total: number;
}
/**
 * Original schema `FormatElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FormatElasticSchema}
 */
export interface FilesFormatElasticSchemaWithIdNullable {
  archive_status?:
    | ('NOT_ARCHIVED' | 'ARCHIVING' | 'FAILED_TO_ARCHIVE' | 'ARCHIVED')
    | null;
  asset_id?: string | null;
  components?: FilesComponentSchema[] | null;
  date_created?: string | null;
  date_deleted?: string | null;
  date_modified?: string | null;
  deleted_by_user?: string | null;
  external_references?: FilesExternalReferences[] | null;
  id: string;
  is_online?: boolean | null;
  /**
   * Sequence cannot have more than 10000. Excess values will be stripped
   */
  metadata?:
    | {
        [k: string]: string;
      }[]
    | null;
  name: string;
  status?: ('ACTIVE' | 'DELETED') | null;
  storage_methods?: string[] | null;
  user_id?: string | null;
  version_id?: string | null;
  warnings?: string[] | null;
}
/**
 * Original schema `FormatElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FormatElasticSchema}
 */
export interface FilesFormatElasticSchemaWithId {
  archive_status?:
    | 'NOT_ARCHIVED'
    | 'ARCHIVING'
    | 'FAILED_TO_ARCHIVE'
    | 'ARCHIVED';
  asset_id?: string;
  components?: FilesComponentSchema[];
  date_created?: string;
  date_deleted?: string;
  date_modified?: string;
  deleted_by_user?: string;
  external_references?: FilesExternalReferences[];
  id: string;
  is_online?: boolean;
  /**
   * Sequence cannot have more than 10000. Excess values will be stripped
   */
  metadata?: {
    [k: string]: string;
  }[];
  name: string;
  status?: 'ACTIVE' | 'DELETED';
  storage_methods?: string[];
  user_id?: string;
  version_id?: string;
  warnings?: string[];
}
/**
 * Original schema `ExportLocationsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ExportLocationsSchema}
 */
export interface FilesExportLocationsSchemaWithId {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: FilesExportLocationSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  total: number;
}
/**
 * Original schema `ExportLocationSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ExportLocationSchema}
 */
export interface FilesExportLocationSchemaWithIdNullable {
  description?: string | null;
  export_metadata?: boolean | null;
  export_original?: boolean | null;
  export_posters?: boolean | null;
  export_proxy?: boolean | null;
  export_to_asset_folder?: boolean | null;
  export_transcriptions?: boolean | null;
  id: string;
  include_original_extension?: boolean | null;
  metadata_format?: ('CSV' | 'JSON' | 'XML') | null;
  metadata_view?: string | null;
  name: string;
  path: string;
  storage_id: string;
  system_domain_id?: string | null;
  transcode_profile_ids?: string[] | null;
  transcription_format?: ('WEBVTT' | 'SRT') | null;
}
/**
 * Original schema `ExportLocationSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-ExportLocationSchema}
 */
export interface FilesExportLocationSchemaWithId {
  description?: string;
  export_metadata?: boolean;
  export_original?: boolean;
  export_posters?: boolean;
  export_proxy?: boolean;
  export_to_asset_folder?: boolean;
  export_transcriptions?: boolean;
  id: string;
  include_original_extension?: boolean;
  metadata_format?: 'CSV' | 'JSON' | 'XML';
  metadata_view?: string;
  name: string;
  path: string;
  storage_id: string;
  system_domain_id?: string;
  transcode_profile_ids?: string[];
  transcription_format?: 'WEBVTT' | 'SRT';
}
/**
 * Original schema `LogosSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-LogosSchema}
 */
export interface FilesLogosSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: FilesLogoSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  total: number;
}
/**
 * Original schema `LogoSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-LogoSchema}
 */
export interface FilesLogoSchemaWithIdNullable {
  date_created?: string | null;
  date_modified?: string | null;
  filename?: string | null;
  id: string;
  name: string;
  storage_id?: string | null;
  storage_method?: string | null;
  system_domain_id?: string | null;
  upload_credentials?: {
    [k: string]: unknown;
  } | null;
  upload_headers?: {
    [k: string]: unknown;
  } | null;
  upload_method?: string | null;
  upload_url?: string | null;
  url?: string | null;
  user_id?: string | null;
}
/**
 * Original schema `LogoSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-LogoSchema}
 */
export interface FilesLogoSchemaWithId {
  date_created?: string;
  date_modified?: string;
  filename?: string;
  id: string;
  name: string;
  storage_id?: string;
  storage_method?: string;
  system_domain_id?: string;
  upload_credentials?: {
    [k: string]: unknown;
  };
  upload_headers?: {
    [k: string]: unknown;
  };
  upload_method?: string;
  upload_url?: string;
  url?: string;
  user_id?: string;
}
/**
 * Original schema `LogoCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-LogoCreateSchema}
 */
export interface FilesLogoCreateSchemaWithId {
  content_type?: string;
  date_created?: string;
  date_modified?: string;
  filename?: string;
  id: string;
  name: string;
  storage_id?: string;
  storage_method?: string;
  system_domain_id?: string;
  upload_credentials?: {
    [k: string]: unknown;
  };
  upload_headers?: {
    [k: string]: unknown;
  };
  upload_method?: string;
  upload_url?: string;
  url?: string;
  user_id?: string;
}
/**
 * Original schema `PlaylistKeyframesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-PlaylistKeyframesSchema}
 */
export interface FilesPlaylistKeyframesSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: FilesPlaylistKeyframeSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  total: number;
}
/**
 * Original schema `PlaylistKeyframeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-PlaylistKeyframeSchema}
 */
export interface FilesPlaylistKeyframeSchemaWithIdNullable {
  date_created?: string | null;
  date_modified?: string | null;
  filename?: string | null;
  format?: string | null;
  id: string;
  is_custom_keyframe?: boolean | null;
  is_public?: boolean | null;
  name?: string | null;
  playlist_id?: string | null;
  resolution?: FilesResolutionType | null;
  rotation?: number | null;
  size?: number | null;
  status?:
    | (
        | 'OPEN'
        | 'GROWING'
        | 'AWAITED'
        | 'CLOSED'
        | 'FAILED'
        | 'ARCHIVED'
        | 'MISSING'
        | 'REDISCOVERED'
        | 'DELETED'
      )
    | null;
  storage_id?: string | null;
  time_code?: FilesTimeCodeType | null;
  type: 'KEYFRAME_MAP' | 'KEYFRAME' | 'POSTER';
  url?: string | null;
}
/**
 * Original schema `PlaylistKeyframeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-PlaylistKeyframeSchema}
 */
export interface FilesPlaylistKeyframeSchemaWithId {
  date_created?: string;
  date_modified?: string;
  filename?: string;
  format?: string | null;
  id: string;
  is_custom_keyframe?: boolean;
  is_public?: boolean;
  name?: string;
  playlist_id?: string;
  resolution?: FilesResolutionType;
  rotation?: number | null;
  size?: number | null;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  time_code?: FilesTimeCodeType;
  type: 'KEYFRAME_MAP' | 'KEYFRAME' | 'POSTER';
  url?: string;
}
/**
 * Original schema `PlaylistKeyframeCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-PlaylistKeyframeCreateSchema}
 */
export interface FilesPlaylistKeyframeCreateSchemaWithId {
  content_type?: string;
  date_created?: string;
  date_modified?: string;
  filename?: string;
  format?: string | null;
  id: string;
  is_custom_keyframe?: boolean;
  is_public?: boolean;
  name?: string;
  playlist_id?: string;
  resolution?: FilesResolutionType;
  rotation?: number | null;
  size?: number | null;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  time_code?: FilesTimeCodeType;
  type: 'KEYFRAME_MAP' | 'KEYFRAME' | 'POSTER';
  upload_credentials?: {
    [k: string]: unknown;
  };
  upload_headers?: {
    [k: string]: unknown;
  };
  upload_method?: string;
  upload_url?: string;
  url?: string;
}
/**
 * Original schema `IconikStorageGatewayClustersSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-IconikStorageGatewayClustersSchema}
 */
export interface FilesIconikStorageGatewayClustersSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: FilesIconikStorageGatewayClusterReadSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  total: number;
}
/**
 * Original schema `IconikStorageGatewayClusterReadSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-IconikStorageGatewayClusterReadSchema}
 */
export interface FilesIconikStorageGatewayClusterReadSchemaWithIdNullable {
  date_created?: string | null;
  date_modified?: string | null;
  /**
   * Database connection URI
   */
  db_connection_uri?: string | null;
  description?: string | null;
  /**
   * Application toggle. If turned off ISG will enter idle state waiting to get enabled again.
   */
  enabled: boolean;
  id: string;
  leader_changed_at?: string | null;
  /**
   * Last reported leader ID.
   */
  leader_id?: string | null;
  name: string;
  nodes?: FilesIconikStorageGatewayRead[] | null;
  /**
   * Application configuration settings as key-value pairs
   */
  settings?: FilesISGConfigClusterSettingsSchema | null;
  status?: ('OFFLINE' | 'ACTIVE' | 'WARNING' | 'ERROR' | 'STOPPED') | null;
  storage_ids: string[];
  /**
   * Total number of files
   */
  total_files_number?: number | null;
  /**
   * Total number of scheduled transcode jobs
   */
  transcode_queue_total?: number | null;
  /**
   * Total number of scheduled auto-uploads
   */
  uploads_queue_total?: number | null;
  /**
   * The number of seconds jobs should remain invisible to other nodes
   */
  visibility_timeout?: number | null;
}
/**
 * Original schema `IconikStorageGatewayClusterReadSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-IconikStorageGatewayClusterReadSchema}
 */
export interface FilesIconikStorageGatewayClusterReadSchemaWithId {
  date_created?: string;
  date_modified?: string;
  /**
   * Database connection URI
   */
  db_connection_uri?: string;
  description?: string;
  /**
   * Application toggle. If turned off ISG will enter idle state waiting to get enabled again.
   */
  enabled: boolean;
  id: string;
  leader_changed_at?: string;
  /**
   * Last reported leader ID.
   */
  leader_id?: string;
  name: string;
  nodes?: FilesIconikStorageGatewayRead[];
  /**
   * Application configuration settings as key-value pairs
   */
  settings?: FilesISGConfigClusterSettingsSchema;
  status?: 'OFFLINE' | 'ACTIVE' | 'WARNING' | 'ERROR' | 'STOPPED';
  storage_ids: string[];
  /**
   * Total number of files
   */
  total_files_number?: number;
  /**
   * Total number of scheduled transcode jobs
   */
  transcode_queue_total?: number;
  /**
   * Total number of scheduled auto-uploads
   */
  uploads_queue_total?: number;
  /**
   * The number of seconds jobs should remain invisible to other nodes
   */
  visibility_timeout?: number;
}
/**
 * Original schema `IconikStorageGatewayClusterSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-IconikStorageGatewayClusterSchema}
 */
export interface FilesIconikStorageGatewayClusterSchemaWithId {
  date_created?: string;
  date_modified?: string;
  /**
   * Database connection URI
   */
  db_connection_uri?: string;
  description?: string;
  /**
   * Application toggle. If turned off ISG will enter idle state waiting to get enabled again.
   */
  enabled: boolean;
  id: string;
  name: string;
  /**
   * Application configuration settings as key-value pairs
   */
  settings?: FilesISGConfigClusterSettingsSchema;
  status?: 'OFFLINE' | 'ACTIVE' | 'WARNING' | 'ERROR' | 'STOPPED';
  storage_ids: string[];
  /**
   * Total number of files
   */
  total_files_number?: number;
  /**
   * Total number of scheduled transcode jobs
   */
  transcode_queue_total?: number;
  /**
   * Total number of scheduled auto-uploads
   */
  uploads_queue_total?: number;
  /**
   * The number of seconds jobs should remain invisible to other nodes
   */
  visibility_timeout?: number;
}
/**
 * Original schema `IconikStorageGatewaysSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-IconikStorageGatewaysSchema}
 */
export interface FilesIconikStorageGatewaysSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: FilesIconikStorageGatewayReadSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  total: number;
}
/**
 * Original schema `IconikStorageGatewayReadSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-IconikStorageGatewayReadSchema}
 */
export interface FilesIconikStorageGatewayReadSchemaWithIdNullable {
  cluster_id?: string | null;
  /**
   * Cluster storage IDs
   */
  cluster_storage_ids?: string[] | null;
  date_created?: string | null;
  date_modified?: string | null;
  /**
   * Dedicated storage IDs
   */
  dedicated_storage_ids?: string[] | null;
  description?: string | null;
  /**
   * Application toggle. If turned off ISG will enter idle state waiting to get enabled again.
   */
  enabled: boolean;
  id: string;
  /**
   * Application configuration settings merged with cluster settings
   */
  merged_settings?: FilesISGConfigClusterSettingsSchema | null;
  name: string;
  public_identity?: string | null;
  /**
   * Set of roles this gateway can perform when part of cluster
   */
  roles?: ('MAIN' | 'CHECKSUM' | 'TRANSCODE' | 'TRANSFER')[] | null;
  /**
   * Application configuration settings as key-value pairs
   */
  settings?:
    | (
        | FilesISGConfigSettingsSchema
        | ({
            [k: string]: unknown;
          } | null)
      )
    | null;
  status?: ('OFFLINE' | 'ACTIVE' | 'WARNING' | 'ERROR' | 'STOPPED') | null;
  /**
   * Server address for direct transfers between storage gateways
   */
  storage_addr?: string | null;
  /**
   * Storage mount points mapped by storage ID
   */
  storages?: {
    [k: string]: FilesIconikStorageGatewayStorageMap;
  } | null;
  telemetry?: FilesIconikStorageGatewayTelemetry | null;
}
/**
 * Original schema `IconikStorageGatewayReadSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-IconikStorageGatewayReadSchema}
 */
export interface FilesIconikStorageGatewayReadSchemaWithId {
  cluster_id?: string;
  /**
   * Cluster storage IDs
   */
  cluster_storage_ids?: string[];
  date_created?: string;
  date_modified?: string;
  /**
   * Dedicated storage IDs
   */
  dedicated_storage_ids?: string[];
  description?: string;
  /**
   * Application toggle. If turned off ISG will enter idle state waiting to get enabled again.
   */
  enabled: boolean;
  id: string;
  /**
   * Application configuration settings merged with cluster settings
   */
  merged_settings?: FilesISGConfigClusterSettingsSchema;
  name: string;
  public_identity?: string;
  /**
   * Set of roles this gateway can perform when part of cluster
   */
  roles?: ('MAIN' | 'CHECKSUM' | 'TRANSCODE' | 'TRANSFER')[];
  /**
   * Application configuration settings as key-value pairs
   */
  settings?:
    | FilesISGConfigSettingsSchema
    | ({
        [k: string]: unknown;
      } | null);
  status?: 'OFFLINE' | 'ACTIVE' | 'WARNING' | 'ERROR' | 'STOPPED';
  /**
   * Server address for direct transfers between storage gateways
   */
  storage_addr?: string;
  /**
   * Storage mount points mapped by storage ID
   */
  storages?: {
    [k: string]: FilesIconikStorageGatewayStorageMap;
  };
  telemetry?: FilesIconikStorageGatewayTelemetry;
}
/**
 * Original schema `IconikStorageGatewaySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-IconikStorageGatewaySchema}
 */
export interface FilesIconikStorageGatewaySchemaWithId {
  cluster_id?: string;
  date_created?: string;
  date_modified?: string;
  description?: string;
  /**
   * Application toggle. If turned off ISG will enter idle state waiting to get enabled again.
   */
  enabled: boolean;
  id: string;
  name: string;
  public_identity?: string;
  /**
   * Set of roles this gateway can perform when part of cluster
   */
  roles?: ('MAIN' | 'CHECKSUM' | 'TRANSCODE' | 'TRANSFER')[];
  /**
   * Application configuration settings as key-value pairs
   */
  settings?:
    | FilesISGConfigSettingsSchema
    | ({
        [k: string]: unknown;
      } | null);
  /**
   * Server address for direct transfers between storage gateways
   */
  storage_addr?: string;
  /**
   * Storage mount points mapped by storage ID
   */
  storages?: {
    [k: string]: FilesIconikStorageGatewayStorageMap;
  };
}
/**
 * Original schema `IconikStorageGatewaysTelemetrySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-IconikStorageGatewaysTelemetrySchema}
 */
export interface FilesIconikStorageGatewaysTelemetrySchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: FilesIconikStorageGatewayTelemetrySchemaNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  total: number;
}
/**
 * Original schema `IconikStorageGatewayTelemetrySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-IconikStorageGatewayTelemetrySchema}
 */
export interface FilesIconikStorageGatewayTelemetrySchemaNullable {
  error_log_lines?: string[] | null;
  host_info?: string | null;
  host_ip?: string | null;
  host_name?: string | null;
  is_leader?: boolean | null;
  log_lines?: string[] | null;
  start_last_date?: string | null;
  start_status?: ('SUCCESS' | 'FAILED') | null;
  start_status_message?: string | null;
  status?:
    | ('OFFLINE' | 'LIVE' | 'UNKNOWN' | 'WARNING' | 'ERROR' | 'STOPPED')
    | null;
  storage_gateway_id?: string | null;
  version?: string | null;
  worker_id: string;
}
/**
 * Original schema `StoragesReadSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-StoragesReadSchema}
 */
export interface FilesStoragesReadSchemaWithId {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: FilesStorageReadSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  total: number;
}
/**
 * Original schema `StorageReadSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-StorageReadSchema}
 */
export interface FilesStorageReadSchemaWithIdNullable {
  default?: boolean | null;
  description?: string | null;
  id: string;
  isg_version?: string | null;
  last_scanned?: string | null;
  method:
    | 'FILE'
    | 'HTTP'
    | 'FTP'
    | 'SFTP'
    | 'S3'
    | 'B2'
    | 'GCS'
    | 'PORTAL'
    | 'CUSTOM'
    | 'AZURE'
    | 'DROPBOX';
  name: string;
  purpose: 'KEYFRAMES' | 'FILES' | 'PROXIES' | 'EXPORTS' | 'ARCHIVE' | 'FACES';
  scanner_status?: string | null;
  settings: {
    [k: string]: unknown;
  };
  status?: ('ACTIVE' | 'INACTIVE' | 'FAILING') | null;
  status_message?: string | null;
  storage_gateway_cluster_id?: string | null;
  storage_gateway_ids?: string[] | null;
  version?: string | null;
}
/**
 * Original schema `StorageReadSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-StorageReadSchema}
 */
export interface FilesStorageReadSchemaWithId {
  default?: boolean;
  description?: string | null;
  id: string;
  isg_version?: string;
  last_scanned?: string | null;
  method:
    | 'FILE'
    | 'HTTP'
    | 'FTP'
    | 'SFTP'
    | 'S3'
    | 'B2'
    | 'GCS'
    | 'PORTAL'
    | 'CUSTOM'
    | 'AZURE'
    | 'DROPBOX';
  name: string;
  purpose: 'KEYFRAMES' | 'FILES' | 'PROXIES' | 'EXPORTS' | 'ARCHIVE' | 'FACES';
  scanner_status?: string | null;
  settings: {
    [k: string]: unknown;
  };
  status?: 'ACTIVE' | 'INACTIVE' | 'FAILING';
  status_message?: string | null;
  storage_gateway_cluster_id?: string;
  storage_gateway_ids?: string[];
  version?: string;
}
/**
 * Original schema `StorageSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-StorageSchema}
 */
export interface FilesStorageSchemaWithId {
  default?: boolean;
  description?: string | null;
  id: string;
  last_scanned?: string | null;
  method:
    | 'FILE'
    | 'HTTP'
    | 'FTP'
    | 'SFTP'
    | 'S3'
    | 'B2'
    | 'GCS'
    | 'PORTAL'
    | 'CUSTOM'
    | 'AZURE'
    | 'DROPBOX';
  name: string;
  purpose: 'KEYFRAMES' | 'FILES' | 'PROXIES' | 'EXPORTS' | 'ARCHIVE' | 'FACES';
  scanner_status?: string | null;
  settings: {
    [k: string]: unknown;
  };
  status?: 'ACTIVE' | 'INACTIVE' | 'FAILING';
  status_message?: string | null;
  version?: string;
}
/**
 * Original schema `StorageSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-StorageSchema}
 */
export interface FilesStorageSchemaWithIdNullable {
  default?: boolean | null;
  description?: string | null;
  id: string;
  last_scanned?: string | null;
  method:
    | 'FILE'
    | 'HTTP'
    | 'FTP'
    | 'SFTP'
    | 'S3'
    | 'B2'
    | 'GCS'
    | 'PORTAL'
    | 'CUSTOM'
    | 'AZURE'
    | 'DROPBOX';
  name: string;
  purpose: 'KEYFRAMES' | 'FILES' | 'PROXIES' | 'EXPORTS' | 'ARCHIVE' | 'FACES';
  scanner_status?: string | null;
  settings: {
    [k: string]: unknown;
  };
  status?: ('ACTIVE' | 'INACTIVE' | 'FAILING') | null;
  status_message?: string | null;
  version?: string | null;
}
/**
 * Original schema `StorageAutoScanSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-StorageAutoScanSchema}
 */
export interface FilesStorageAutoScanSchemaNullable {
  hours_interval?: number | null;
}
/**
 * Original schema `FileDeletionsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FileDeletionsSchema}
 */
export interface FilesFileDeletionsSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: FilesFileDeletionFromLocalStorageSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  total: number;
}
/**
 * Original schema `FileDeletionFromLocalStorageSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FileDeletionFromLocalStorageSchema}
 */
export interface FilesFileDeletionFromLocalStorageSchemaWithIdNullable {
  asset_id?: string | null;
  directory_path?: string | null;
  file_id: string;
  file_type?: string | null;
  filename: string;
  format_id?: string | null;
  id: string;
  job_id: string;
  keep_source?: boolean | null;
  storage_id: string;
  template?: string | null;
  template_engine?: string | null;
  version_id?: string | null;
}
/**
 * Original schema `FileDeletionFromLocalStorageSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FileDeletionFromLocalStorageSchema}
 */
export interface FilesFileDeletionFromLocalStorageSchemaWithId {
  asset_id?: string;
  directory_path?: string;
  file_id: string;
  file_type?: string;
  filename: string;
  format_id?: string;
  id: string;
  job_id: string;
  keep_source?: boolean;
  storage_id: string;
  template?: string;
  template_engine?: string;
  version_id?: string;
}
/**
 * Original schema `FilesElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FilesElasticSchema}
 */
export interface FilesFilesElasticSchemaWithId {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: FilesFileElasticSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  total: number;
}
/**
 * Original schema `FileElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FileElasticSchema}
 */
export interface FilesFileElasticSchemaWithIdNullable {
  asset_id?: string | null;
  checksum?: string | null;
  date_created?: string | null;
  date_modified?: string | null;
  directory_path: string;
  file_date_created?: string | null;
  file_date_modified?: string | null;
  file_set_id?: string | null;
  file_set_status?: string | null;
  format_id?: string | null;
  format_status?: string | null;
  id: string;
  /**
   * If not specified, name will be autogenerated based on `id` and `original_name`
   */
  name?: string | null;
  original_name: string;
  parent_id?: string | null;
  size?: number | null;
  status?:
    | (
        | 'OPEN'
        | 'GROWING'
        | 'AWAITED'
        | 'CLOSED'
        | 'FAILED'
        | 'ARCHIVED'
        | 'MISSING'
        | 'REDISCOVERED'
        | 'DELETED'
      )
    | null;
  storage_id?: string | null;
  template?: string | null;
  template_engine?: ('SIMPLE' | 'JINJA2' | null) | null;
  type: 'FILE' | 'DIRECTORY' | 'SYMLINK' | 'SEQUENCE';
  user_id?: string | null;
  version_id?: string | null;
}
/**
 * Original schema `FileElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FileElasticSchema}
 */
export interface FilesFileElasticSchemaWithId {
  asset_id?: string;
  checksum?: string | null;
  date_created?: string;
  date_modified?: string;
  directory_path: string;
  file_date_created?: string;
  file_date_modified?: string;
  file_set_id?: string;
  file_set_status?: string | null;
  format_id?: string;
  format_status?: string | null;
  id: string;
  /**
   * If not specified, name will be autogenerated based on `id` and `original_name`
   */
  name?: string;
  original_name: string;
  parent_id?: string | null;
  size?: number;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  template?: string;
  template_engine?: ('SIMPLE' | 'JINJA2' | null) | null;
  type: 'FILE' | 'DIRECTORY' | 'SYMLINK' | 'SEQUENCE';
  user_id?: string | null;
  version_id?: string;
}
/**
 * Original schema `FileBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-FileBaseSchema}
 */
export interface FilesFileBaseSchemaWithId {
  asset_id?: string;
  checksum?: string | null;
  date_created?: string;
  date_modified?: string;
  directory_path: string;
  file_date_created?: string;
  file_date_modified?: string;
  file_set_id?: string;
  format_id?: string;
  id: string;
  /**
   * If not specified, name will be autogenerated based on `id` and `original_name`
   */
  name?: string;
  original_name: string;
  parent_id?: string | null;
  size?: number;
  status?:
    | 'OPEN'
    | 'GROWING'
    | 'AWAITED'
    | 'CLOSED'
    | 'FAILED'
    | 'ARCHIVED'
    | 'MISSING'
    | 'REDISCOVERED'
    | 'DELETED';
  storage_id?: string;
  template?: string;
  template_engine?: ('SIMPLE' | 'JINJA2' | null) | null;
  type: 'FILE' | 'DIRECTORY' | 'SYMLINK' | 'SEQUENCE';
  user_id?: string | null;
  version_id?: string;
}
/**
 * Original schema `IconikStorageGatewayEventsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-IconikStorageGatewayEventsSchema}
 */
export interface FilesIconikStorageGatewayEventsSchemaWithId {
  objects: FilesIconikStorageGatewayEventSchemaWithIdNullable[];
}
/**
 * Original schema `IconikStorageGatewayEventSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-IconikStorageGatewayEventSchema}
 */
export interface FilesIconikStorageGatewayEventSchemaWithIdNullable {
  data?: {
    [k: string]: unknown;
  } | null;
  date_created?: string | null;
  id: string;
  type:
    | 'RESTART'
    | 'DOWNLOAD'
    | 'DOWNLOAD_ABORT'
    | 'DOWNLOAD_CHANGE_PRIORITY'
    | 'UPLOAD'
    | 'UPLOAD_ABORT'
    | 'UPLOAD_CHANGE_PRIORITY'
    | 'INGEST_UPLOAD'
    | 'DELETE'
    | 'TRANSCODE'
    | 'ASSET_MERGED'
    | 'TRANSCODE_ABORT'
    | 'TRANSCODE_CHANGE_PRIORITY'
    | 'REQUEST_COLLECTION_MAP'
    | 'ABORT_COLLECTION_MAP'
    | 'COLLECTION_DELETED'
    | 'RESET_INGEST_VALIDATION'
    | 'SCHEDULE_CHECKSUM_CALCULATION'
    | 'ABORT_JOBS_BULK'
    | 'MARK_MISSING_OUTSIDE_SCAN_DIRS';
}
/**
 * Original schema `IconikStorageGatewayEventSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-IconikStorageGatewayEventSchema}
 */
export interface FilesIconikStorageGatewayEventSchemaWithId {
  data?: {
    [k: string]: unknown;
  };
  date_created?: string;
  id: string;
  type:
    | 'RESTART'
    | 'DOWNLOAD'
    | 'DOWNLOAD_ABORT'
    | 'DOWNLOAD_CHANGE_PRIORITY'
    | 'UPLOAD'
    | 'UPLOAD_ABORT'
    | 'UPLOAD_CHANGE_PRIORITY'
    | 'INGEST_UPLOAD'
    | 'DELETE'
    | 'TRANSCODE'
    | 'ASSET_MERGED'
    | 'TRANSCODE_ABORT'
    | 'TRANSCODE_CHANGE_PRIORITY'
    | 'REQUEST_COLLECTION_MAP'
    | 'ABORT_COLLECTION_MAP'
    | 'COLLECTION_DELETED'
    | 'RESET_INGEST_VALIDATION'
    | 'SCHEDULE_CHECKSUM_CALCULATION'
    | 'ABORT_JOBS_BULK'
    | 'MARK_MISSING_OUTSIDE_SCAN_DIRS';
}
/**
 * Original schema `GatewayReportSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-GatewayReportSchema}
 */
export interface FilesGatewayReportSchemaWithId {
  await_checksum_files_number?: number | null;
  date_reported?: string;
  empty_files_number?: number | null;
  /**
   * @maxItems 10
   */
  error_log_lines?: string[];
  exported_files_number?: number | null;
  faulty_files_number?: number | null;
  host_info?: string;
  host_name?: string;
  id: string;
  ingested_files_number?: number | null;
  ingested_files_uploads_number?: number | null;
  ingesting_files_number?: number | null;
  last_scan_time?: number | null;
  /**
   * @maxItems 50
   */
  log_lines?: string[];
  logs_url?: string;
  missing_files_number?: number | null;
  scanned_files_number?: number | null;
  skipped_files_number?: number | null;
  start_last_date?: string;
  start_status?: 'SUCCESS' | 'FAILED';
  start_status_message?: string;
  status?: 'OFFLINE' | 'LIVE' | 'UNKNOWN' | 'WARNING' | 'ERROR' | 'STOPPED';
  storage_id?: string;
  total_files_number?: number | null;
  total_folders_number?: number | null;
  version?: string;
  waiting_preview_transcode_jobs_number?: number | null;
  waiting_transcode_jobs_number?: number | null;
}
/**
 * Original schema `GatewayReportSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-GatewayReportSchema}
 */
export interface FilesGatewayReportSchemaWithIdNullable {
  await_checksum_files_number?: number | null;
  date_reported?: string | null;
  empty_files_number?: number | null;
  error_log_lines?: string[] | null;
  exported_files_number?: number | null;
  faulty_files_number?: number | null;
  host_info?: string | null;
  host_name?: string | null;
  id: string;
  ingested_files_number?: number | null;
  ingested_files_uploads_number?: number | null;
  ingesting_files_number?: number | null;
  last_scan_time?: number | null;
  log_lines?: string[] | null;
  logs_url?: string | null;
  missing_files_number?: number | null;
  scanned_files_number?: number | null;
  skipped_files_number?: number | null;
  start_last_date?: string | null;
  start_status?: ('SUCCESS' | 'FAILED') | null;
  start_status_message?: string | null;
  status?:
    | ('OFFLINE' | 'LIVE' | 'UNKNOWN' | 'WARNING' | 'ERROR' | 'STOPPED')
    | null;
  storage_id?: string | null;
  total_files_number?: number | null;
  total_folders_number?: number | null;
  version?: string | null;
  waiting_preview_transcode_jobs_number?: number | null;
  waiting_transcode_jobs_number?: number | null;
}
/**
 * Original schema `TranscodersByStorageSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TranscodersByStorageSchema}
 */
export interface FilesTranscodersByStorageSchemaWithId {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: FilesTranscoderByStorageReadSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  total: number;
}
/**
 * Original schema `TranscoderByStorageReadSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TranscoderByStorageReadSchema}
 */
export interface FilesTranscoderByStorageReadSchemaWithIdNullable {
  id: string;
  name?: string | null;
  settings?: {
    [k: string]: unknown;
  } | null;
  storage_id?: string | null;
  type?:
    | (
        | 'VANTAGE'
        | 'FFMPEG'
        | 'EDIT_PROXY'
        | 'IMAGEMAGICK'
        | 'ENCODING_COM'
        | 'ZENCODER'
        | 'TELESTREAM_CLOUD'
        | 'ELEMENTAL_MEDIACONVERT'
        | 'ELEMENTAL_SERVER'
        | 'REDLINE'
        | 'ICONIK_EDGE_TRANSCODER'
        | 'WATCH_FOLDER_VIDEO'
        | 'EDITREADY'
        | 'FLICS'
        | 'WILDMOKA'
        | 'LIBREOFFICE'
      )
    | null;
}
/**
 * Original schema `TranscoderByStorageReadSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TranscoderByStorageReadSchema}
 */
export interface FilesTranscoderByStorageReadSchemaWithId {
  id: string;
  name?: string;
  settings?: {
    [k: string]: unknown;
  };
  storage_id?: string;
  type?:
    | 'VANTAGE'
    | 'FFMPEG'
    | 'EDIT_PROXY'
    | 'IMAGEMAGICK'
    | 'ENCODING_COM'
    | 'ZENCODER'
    | 'TELESTREAM_CLOUD'
    | 'ELEMENTAL_MEDIACONVERT'
    | 'ELEMENTAL_SERVER'
    | 'REDLINE'
    | 'ICONIK_EDGE_TRANSCODER'
    | 'WATCH_FOLDER_VIDEO'
    | 'EDITREADY'
    | 'FLICS'
    | 'WILDMOKA'
    | 'LIBREOFFICE';
}
/**
 * Original schema `TransfersFromStorageSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TransfersFromStorageSchema}
 */
export interface FilesTransfersFromStorageSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: FilesTransferFromStorageReadSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  total: number;
}
/**
 * Original schema `TransferFromStorageReadSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TransferFromStorageReadSchema}
 */
export interface FilesTransferFromStorageReadSchemaWithIdNullable {
  add_file_set?: boolean | null;
  asset_id?: string | null;
  asset_paths?: string[] | null;
  collection_storage_id?: string | null;
  component_ids?: string[] | null;
  delete_local_file_set_after_upload?: boolean | null;
  delete_only_from_source_folder?: boolean | null;
  delete_source_file_set_after_download?: boolean | null;
  destination_directory_path?: string | null;
  destination_file_set_name?: string | null;
  destination_filename?: string | null;
  destination_storage_id?: string | null;
  destination_storage_method?: string | null;
  export_metadata_format?: string | null;
  export_metadata_view?: string | null;
  export_original?: boolean | null;
  export_posters?: boolean | null;
  export_proxy?: boolean | null;
  export_transcription_format?: string | null;
  format_id?: string | null;
  id: string;
  include_original_extension?: boolean | null;
  job_id?: string | null;
  job_steps?: {
    [k: string]: unknown;
  } | null;
  original_file_set_id?: string | null;
  original_storage_id?: string | null;
  original_url?: string | null;
  overwrite?: boolean | null;
  parent_job_id?: string | null;
  temporary_file_set_source?: boolean | null;
  transfer_type?: string | null;
}
/**
 * Original schema `TransferFromStorageReadSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TransferFromStorageReadSchema}
 */
export interface FilesTransferFromStorageReadSchemaWithId {
  add_file_set?: boolean;
  asset_id?: string;
  asset_paths?: string[];
  collection_storage_id?: string;
  component_ids?: string[];
  delete_local_file_set_after_upload?: boolean;
  delete_only_from_source_folder?: boolean;
  delete_source_file_set_after_download?: boolean;
  destination_directory_path?: string;
  destination_file_set_name?: string;
  destination_filename?: string;
  destination_storage_id?: string;
  destination_storage_method?: string;
  export_metadata_format?: string;
  export_metadata_view?: string;
  export_original?: boolean;
  export_posters?: boolean;
  export_proxy?: boolean;
  export_transcription_format?: string;
  format_id?: string;
  id: string;
  include_original_extension?: boolean;
  job_id?: string;
  job_steps?: {
    [k: string]: unknown;
  };
  original_file_set_id?: string;
  original_storage_id?: string;
  original_url?: string;
  overwrite?: boolean;
  parent_job_id?: string;
  temporary_file_set_source?: boolean;
  transfer_type?: string;
}
/**
 * Original schema `TransfersToStorageSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TransfersToStorageSchema}
 */
export interface FilesTransfersToStorageSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: FilesTransferToStorageReadSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  total: number;
}
/**
 * Original schema `TransferToStorageReadSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TransferToStorageReadSchema}
 */
export interface FilesTransferToStorageReadSchemaWithIdNullable {
  add_file_set?: boolean | null;
  asset_id?: string | null;
  asset_paths?: string[] | null;
  collection_storage_id?: string | null;
  component_ids?: string[] | null;
  delete_only_from_source_folder?: boolean | null;
  delete_remote_file_set_after_download?: boolean | null;
  delete_source_file_set_after_download?: boolean | null;
  destination_base_directory?: string | null;
  destination_directory_path: string;
  destination_file_set_name: string;
  destination_filename?: string | null;
  export_metadata_format?: string | null;
  export_metadata_view?: string | null;
  export_original?: boolean | null;
  export_posters?: boolean | null;
  export_proxy?: boolean | null;
  export_transcription_format?: string | null;
  file_set_id?: string | null;
  format_id?: string | null;
  id: string;
  include_original_extension?: boolean | null;
  job_id?: string | null;
  job_steps?: {
    [k: string]: unknown;
  } | null;
  local_storage_id?: string | null;
  original_storage_id?: string | null;
  original_url?: string | null;
  overwrite?: boolean | null;
  parent_job_id?: string | null;
  temporary_file_set_source?: boolean | null;
  transfer_type?: string | null;
}
/**
 * Original schema `TransferToStorageReadSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TransferToStorageReadSchema}
 */
export interface FilesTransferToStorageReadSchemaWithId {
  add_file_set?: boolean;
  asset_id?: string;
  asset_paths?: string[];
  collection_storage_id?: string;
  component_ids?: string[];
  delete_only_from_source_folder?: boolean;
  delete_remote_file_set_after_download?: boolean;
  delete_source_file_set_after_download?: boolean;
  destination_base_directory?: string;
  destination_directory_path: string;
  destination_file_set_name: string;
  destination_filename?: string;
  export_metadata_format?: string;
  export_metadata_view?: string;
  export_original?: boolean;
  export_posters?: boolean;
  export_proxy?: boolean;
  export_transcription_format?: string;
  file_set_id?: string;
  format_id?: string;
  id: string;
  include_original_extension?: boolean;
  job_id?: string;
  job_steps?: {
    [k: string]: unknown;
  };
  local_storage_id?: string;
  original_storage_id?: string;
  original_url?: string;
  overwrite?: boolean;
  parent_job_id?: string;
  temporary_file_set_source?: boolean;
  transfer_type?: string;
}
/**
 * Original schema `TranscodersSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TranscodersSchema}
 */
export interface FilesTranscodersSchemaWithId {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: FilesTranscoderReadSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  total: number;
}
/**
 * Original schema `TranscoderReadSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TranscoderReadSchema}
 */
export interface FilesTranscoderReadSchemaWithIdNullable {
  id: string;
  name: string;
  settings: {
    [k: string]: unknown;
  };
  storages?: FilesStorageReadSchema[] | null;
  type:
    | 'VANTAGE'
    | 'FFMPEG'
    | 'EDIT_PROXY'
    | 'IMAGEMAGICK'
    | 'ENCODING_COM'
    | 'ZENCODER'
    | 'TELESTREAM_CLOUD'
    | 'ELEMENTAL_MEDIACONVERT'
    | 'ELEMENTAL_SERVER'
    | 'REDLINE'
    | 'ICONIK_EDGE_TRANSCODER'
    | 'WATCH_FOLDER_VIDEO'
    | 'EDITREADY'
    | 'FLICS'
    | 'WILDMOKA'
    | 'LIBREOFFICE';
}
/**
 * Original schema `TranscoderReadSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TranscoderReadSchema}
 */
export interface FilesTranscoderReadSchemaWithId {
  id: string;
  name: string;
  settings: {
    [k: string]: unknown;
  };
  storages?: FilesStorageReadSchema[];
  type:
    | 'VANTAGE'
    | 'FFMPEG'
    | 'EDIT_PROXY'
    | 'IMAGEMAGICK'
    | 'ENCODING_COM'
    | 'ZENCODER'
    | 'TELESTREAM_CLOUD'
    | 'ELEMENTAL_MEDIACONVERT'
    | 'ELEMENTAL_SERVER'
    | 'REDLINE'
    | 'ICONIK_EDGE_TRANSCODER'
    | 'WATCH_FOLDER_VIDEO'
    | 'EDITREADY'
    | 'FLICS'
    | 'WILDMOKA'
    | 'LIBREOFFICE';
}
/**
 * Original schema `TranscoderSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TranscoderSchema}
 */
export interface FilesTranscoderSchemaWithId {
  id: string;
  name: string;
  settings: {
    [k: string]: unknown;
  };
  type:
    | 'VANTAGE'
    | 'FFMPEG'
    | 'EDIT_PROXY'
    | 'IMAGEMAGICK'
    | 'ENCODING_COM'
    | 'ZENCODER'
    | 'TELESTREAM_CLOUD'
    | 'ELEMENTAL_MEDIACONVERT'
    | 'ELEMENTAL_SERVER'
    | 'REDLINE'
    | 'ICONIK_EDGE_TRANSCODER'
    | 'WATCH_FOLDER_VIDEO'
    | 'EDITREADY'
    | 'FLICS'
    | 'WILDMOKA'
    | 'LIBREOFFICE';
}
/**
 * Original schema `TranscoderOptionsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TranscoderOptionsSchema}
 */
export interface FilesTranscoderOptionsSchemaWithId {
  objects: FilesTranscoderOptionSchemaNullable[];
}
/**
 * Original schema `TranscoderOptionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#model-TranscoderOptionSchema}
 */
export interface FilesTranscoderOptionSchemaNullable {
  label?: string | null;
  value?: string | null;
}

export interface FilesHttpGetAnalysisProfilesQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * ID of a last profile set on previous page
   */
  last_id?: string;
}

/**
 * `GET /v1/analysis/profiles/`
 *
 * Get analysis profiles
 *
 *
 * Responses
 * - 200 - Returns analysis profiles
 * - 401 - Token is invalid
 * - 404 - Profiles don't exist
 *
 * Response {@link FilesAnalysisProfilesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_analysis_profiles_}
 */
export const httpGetAnalysisProfiles = (
  query?: FilesHttpGetAnalysisProfilesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAnalysisProfiles,
  method: httpMethod.get,
  url: '/API/files/v1/analysis/profiles/',

  query,
  headers,
});

/**
 * `POST /v1/analysis/profiles/`
 *
 * Create a new analysis profile
 *
 * Required roles:
 *  - can_write_analysis_profiles
 *
 * Responses
 * - 201 - Returns an analysis profile
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesAnalysisProfileSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_analysis_profiles_}
 */
export const httpPostAnalysisProfiles = (
  body: FilesAnalysisProfileSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAnalysisProfiles,
  method: httpMethod.post,
  url: '/API/files/v1/analysis/profiles/',

  body,
  headers,
});

/**
 * `GET /v1/analysis/profiles/{media_type}/default/`
 *
 * Get a default analysis profile
 *
 *
 * Responses
 * - 200 - The default analysis profile
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Permission denied
 * - 404 - Analysis profile does not exist
 *
 * Response {@link FilesAnalysisProfileSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_analysis_profiles__media_type__default_}
 */
export const httpGetAnalysisProfilesByMediaTypeDefault = (
  mediaType: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAnalysisProfilesByMediaTypeDefault,
  method: httpMethod.get,
  url: `/API/files/v1/analysis/profiles/${encodeURIComponent(mediaType)}/default/`,
  params: { mediaType },
  headers,
});

/**
 * `DELETE /v1/analysis/profiles/{profile_id}/`
 *
 * Delete an analysis profile
 *
 * Required roles:
 *  - can_delete_analysis_profiles
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Analysis profile doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_analysis_profiles__profile_id__}
 */
export const httpDeleteAnalysisProfilesByProfileId = (
  profileId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteAnalysisProfilesByProfileId,
  method: httpMethod.delete,
  url: `/API/files/v1/analysis/profiles/${encodeURIComponent(profileId)}/`,
  params: { profileId },
  headers,
});

/**
 * `GET /v1/analysis/profiles/{profile_id}/`
 *
 * Get an analysis profile
 *
 *
 * Responses
 * - 200 - Returns an analysis profile for provided media type
 * - 401 - Token is invalid
 * - 404 - Profile doesn't exist
 *
 * Response {@link FilesAnalysisProfileSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_analysis_profiles__profile_id__}
 */
export const httpGetAnalysisProfilesByProfileId = (
  profileId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAnalysisProfilesByProfileId,
  method: httpMethod.get,
  url: `/API/files/v1/analysis/profiles/${encodeURIComponent(profileId)}/`,
  params: { profileId },
  headers,
});

export type FilesAnalysisProfileSchemaPartial =
  Partial<FilesAnalysisProfileSchema>;

/**
 * `PATCH /v1/analysis/profiles/{profile_id}/`
 *
 * Update an analysis profile information
 *
 * Required roles:
 *  - can_write_analysis_profiles
 *
 * Responses
 * - 200 - Returns an analysis profile that was updated
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Profile doesn't exist
 *
 * Response {@link FilesAnalysisProfileSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/patch_v1_analysis_profiles__profile_id__}
 */
export const httpPatchAnalysisProfilesByProfileId = (
  profileId: string,
  body: FilesAnalysisProfileSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPatchAnalysisProfilesByProfileId,
  method: httpMethod.patch,
  url: `/API/files/v1/analysis/profiles/${encodeURIComponent(profileId)}/`,
  params: { profileId },
  body,
  headers,
});

/**
 * `PUT /v1/analysis/profiles/{profile_id}/`
 *
 * Update an analysis profile information
 *
 * Required roles:
 *  - can_write_analysis_profiles
 *
 * Responses
 * - 200 - Returns an analysis profile that was updated
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Profile doesn't exist
 *
 * Response {@link FilesAnalysisProfileSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/put_v1_analysis_profiles__profile_id__}
 */
export const httpPutAnalysisProfilesByProfileId = (
  profileId: string,
  body: FilesAnalysisProfileSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPutAnalysisProfilesByProfileId,
  method: httpMethod.put,
  url: `/API/files/v1/analysis/profiles/${encodeURIComponent(profileId)}/`,
  params: { profileId },
  body,
  headers,
});

/**
 * `DELETE /v1/analysis/profiles/{profile_id}/default/`
 *
 * Removes the default flag on an analysis profile
 *
 * Required roles:
 *  - can_write_analysis_profiles
 *
 * Responses
 * - 204 - Success
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_analysis_profiles__profile_id__default_}
 */
export const httpDeleteAnalysisProfilesByProfileIdDefault = (
  profileId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteAnalysisProfilesByProfileIdDefault,
  method: httpMethod.delete,
  url: `/API/files/v1/analysis/profiles/${encodeURIComponent(profileId)}/default/`,
  params: { profileId },
  headers,
});

/**
 * `POST /v1/analysis/profiles/{profile_id}/default/`
 *
 * Set an analysis profile to the default of its media type
 *
 * Required roles:
 *  - can_write_analysis_profiles
 *
 * Responses
 * - 201 - Success
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_analysis_profiles__profile_id__default_}
 */
export const httpPostAnalysisProfilesByProfileIdDefault = (
  profileId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAnalysisProfilesByProfileIdDefault,
  method: httpMethod.post,
  url: `/API/files/v1/analysis/profiles/${encodeURIComponent(profileId)}/default/`,
  params: { profileId },
  headers,
});

export interface FilesHttpGetAnalysisServiceAccountsQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * ID of a last service account set on previous page
   */
  last_id?: string;
}

/**
 * `GET /v1/analysis/service_accounts/`
 *
 * Get analysis service accounts
 *
 * Required roles:
 *  - can_read_analysis_service_accounts
 *
 * Responses
 * - 200 - Returns analysis service accounts
 * - 401 - Token is invalid
 * - 404 - Service accounts don't exist
 *
 * Response {@link FilesAnalysisServiceAccountsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_analysis_service_accounts_}
 */
export const httpGetAnalysisServiceAccounts = (
  query?: FilesHttpGetAnalysisServiceAccountsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAnalysisServiceAccounts,
  method: httpMethod.get,
  url: '/API/files/v1/analysis/service_accounts/',

  query,
  headers,
});

/**
 * `POST /v1/analysis/service_accounts/`
 *
 * Create a new analysis service account
 *
 * Required roles:
 *  - can_write_analysis_service_accounts
 *
 * Responses
 * - 201 - Returns an analysis service account
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesAnalysisServiceAccountReadSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_analysis_service_accounts_}
 */
export const httpPostAnalysisServiceAccounts = (
  body: FilesAnalysisServiceAccountSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAnalysisServiceAccounts,
  method: httpMethod.post,
  url: '/API/files/v1/analysis/service_accounts/',

  body,
  headers,
});

/**
 * `DELETE /v1/analysis/service_accounts/{analysis_service_account_id}/`
 *
 * Delete an analysis service account
 *
 * Required roles:
 *  - can_delete_analysis_service_accounts
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Analysis service account doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_analysis_service_accounts__analysis_service_account_id__}
 */
export const httpDeleteAnalysisServiceAccountsByAnalysisServiceAccountId = (
  analysisServiceAccountId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteAnalysisServiceAccountsByAnalysisServiceAccountId,
  method: httpMethod.delete,
  url: `/API/files/v1/analysis/service_accounts/${encodeURIComponent(analysisServiceAccountId)}/`,
  params: { analysisServiceAccountId },
  headers,
});

/**
 * `GET /v1/analysis/service_accounts/{analysis_service_account_id}/`
 *
 * Get an analysis service account
 *
 * Required roles:
 *  - can_read_analysis_service_accounts
 *
 * Responses
 * - 200 - Returns an analysis service account
 * - 401 - Token is invalid
 * - 404 - Service account doesn't exist
 *
 * Response {@link FilesAnalysisServiceAccountReadSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_analysis_service_accounts__analysis_service_account_id__}
 */
export const httpGetAnalysisServiceAccountsByAnalysisServiceAccountId = (
  analysisServiceAccountId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAnalysisServiceAccountsByAnalysisServiceAccountId,
  method: httpMethod.get,
  url: `/API/files/v1/analysis/service_accounts/${encodeURIComponent(analysisServiceAccountId)}/`,
  params: { analysisServiceAccountId },
  headers,
});

export type FilesAnalysisServiceAccountSchemaPartial =
  Partial<FilesAnalysisServiceAccountSchema>;

/**
 * `PATCH /v1/analysis/service_accounts/{analysis_service_account_id}/`
 *
 * Update an analysis service account information
 *
 * Required roles:
 *  - can_write_analysis_service_accounts
 *
 * Responses
 * - 200 - Returns an analysis service account that was updated
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Service account doesn't exist
 *
 * Response {@link FilesAnalysisServiceAccountSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/patch_v1_analysis_service_accounts__analysis_service_account_id__}
 */
export const httpPatchAnalysisServiceAccountsByAnalysisServiceAccountId = (
  analysisServiceAccountId: string,
  body: FilesAnalysisServiceAccountSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPatchAnalysisServiceAccountsByAnalysisServiceAccountId,
  method: httpMethod.patch,
  url: `/API/files/v1/analysis/service_accounts/${encodeURIComponent(analysisServiceAccountId)}/`,
  params: { analysisServiceAccountId },
  body,
  headers,
});

/**
 * `PUT /v1/analysis/service_accounts/{analysis_service_account_id}/`
 *
 * Update an analysis service account information
 *
 * Required roles:
 *  - can_write_analysis_service_accounts
 *
 * Responses
 * - 200 - Returns an analysis service account that was updated
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Service account doesn't exist
 *
 * Response {@link FilesAnalysisServiceAccountSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/put_v1_analysis_service_accounts__analysis_service_account_id__}
 */
export const httpPutAnalysisServiceAccountsByAnalysisServiceAccountId = (
  analysisServiceAccountId: string,
  body: FilesAnalysisServiceAccountSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPutAnalysisServiceAccountsByAnalysisServiceAccountId,
  method: httpMethod.put,
  url: `/API/files/v1/analysis/service_accounts/${encodeURIComponent(analysisServiceAccountId)}/`,
  params: { analysisServiceAccountId },
  body,
  headers,
});

/**
 * `GET /v1/analysis/settings/transcription/default/`
 *
 * Get default analysis settings for transcription
 *
 * Required roles:
 *  - can_transcribe_content
 *
 * Responses
 * - 200 - The transcription settings of the default analysis profile
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Permission denied
 *
 * Response {@link FilesAnalysisTranscriptionSettingsSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_analysis_settings_transcription_default_}
 */
export const httpGetAnalysisSettingsTranscriptionDefault = (
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAnalysisSettingsTranscriptionDefault,
  method: httpMethod.get,
  url: '/API/files/v1/analysis/settings/transcription/default/',

  headers,
});

/**
 * `POST /v1/assets/bulk/keyframes/`
 *
 * Create a transcode job for proxy and keyframes generation of multiple assets
 *
 * Required roles:
 *  - can_create_transcode_jobs
 *
 * Responses
 * - 200 - OK
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets_bulk_keyframes_}
 */
export const httpPostAssetsBulkKeyframes = (
  body: FilesBulkTranscodeSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsBulkKeyframes,
  method: httpMethod.post,
  url: '/API/files/v1/assets/bulk/keyframes/',

  body,
  headers,
});

export interface FilesHttpPostAssetsExportLocationsByExportLocationIdQuery {
  /**
   * Enable transfer through iconik host (creates egress)
   */
  allow_host_transfer?: boolean;
}

/**
 * `POST /v1/assets/export_locations/{export_location_id}/`
 *
 * Export multiple assets to export location
 *
 * Required roles:
 *  - can_write_exports
 *
 * Responses
 * - 200 - Returns an export job id
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets_export_locations__export_location_id__}
 * @deprecated
 */
export const httpPostAssetsExportLocationsByExportLocationId = (
  exportLocationId: string,
  body: FilesAssetBatchExportSchema,
  query?: FilesHttpPostAssetsExportLocationsByExportLocationIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsExportLocationsByExportLocationId,
  method: httpMethod.post,
  url: `/API/files/v1/assets/export_locations/${encodeURIComponent(exportLocationId)}/`,
  params: { exportLocationId },
  body,
  query,
  headers,
});

export interface FilesHttpPostAssetsByAssetIdCustomKeyframeQuery {
  /**
   * Content type to add to the pre-signed upload url
   */
  content_type?: string;
}

/**
 * `POST /v1/assets/{asset_id}/custom_keyframe/`
 *
 * Create keyframe of type poster for asset
 *
 * Required roles:
 *  - can_write_keyframes
 *
 * Responses
 * - 201 - Returns created keyframe
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesKeyframeSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__custom_keyframe_}
 */
export const httpPostAssetsByAssetIdCustomKeyframe = (
  assetId: string,
  query?: FilesHttpPostAssetsByAssetIdCustomKeyframeQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdCustomKeyframe,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/custom_keyframe/`,
  params: { assetId },
  query,
  headers,
});

export interface FilesHttpPostAssetsByAssetIdCustomKeyframeByPosterIdQuery {
  /**
   * set to false to keep current custom_poster and custom_keyframe on asset
   */
  overwrite?: boolean;
}

/**
 * `POST /v1/assets/{asset_id}/custom_keyframe/{poster_id}/`
 *
 * Set keyframe of type poster as asset keyframe
 *
 * Required roles:
 *  - can_write_keyframes
 *
 * Responses
 * - 201 - Returns custom keyframe
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesKeyframeSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__custom_keyframe__poster_id__}
 */
export const httpPostAssetsByAssetIdCustomKeyframeByPosterId = (
  assetId: string,
  posterId: string,
  query?: FilesHttpPostAssetsByAssetIdCustomKeyframeByPosterIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdCustomKeyframeByPosterId,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/custom_keyframe/${encodeURIComponent(posterId)}/`,
  params: { assetId, posterId },
  query,
  headers,
});

export interface FilesHttpPostAssetsByAssetIdExportLocationsByExportLocationIdQuery {
  /**
   * Enable transfer through iconik host (creates egress)
   */
  allow_host_transfer?: boolean;
}

/**
 * `POST /v1/assets/{asset_id}/export_locations/{export_location_id}/`
 *
 * Export asset to export location
 *
 * Required roles:
 *  - can_write_exports
 *
 * Responses
 * - 200 - Returns an export job id
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__export_locations__export_location_id__}
 */
export const httpPostAssetsByAssetIdExportLocationsByExportLocationId = (
  assetId: string,
  exportLocationId: string,
  body: FilesAssetExportSchema,
  query?: FilesHttpPostAssetsByAssetIdExportLocationsByExportLocationIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdExportLocationsByExportLocationId,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/export_locations/${encodeURIComponent(exportLocationId)}/`,
  params: { assetId, exportLocationId },
  body,
  query,
  headers,
});

export interface FilesHttpGetAssetsByAssetIdFileSetsQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * ID of a last file set on previous page
   */
  last_id?: string;
  /**
   * Set to true if you need a total amount of files in a file set
   */
  file_count?: boolean;
}

/**
 * `GET /v1/assets/{asset_id}/file_sets/`
 *
 * Get all asset's file sets
 *
 * Required roles:
 *  - can_read_files
 *
 * Responses
 * - 200 - Returns all file sets associated with this asset
 * - 401 - Token is invalid
 * - 404 - FileSets for this asset don't exist
 *
 * Response {@link FilesFileSetsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__file_sets_}
 */
export const httpGetAssetsByAssetIdFileSets = (
  assetId: string,
  query?: FilesHttpGetAssetsByAssetIdFileSetsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdFileSets,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/file_sets/`,
  params: { assetId },
  query,
  headers,
});

/**
 * `POST /v1/assets/{asset_id}/file_sets/`
 *
 * Create file set and associate to asset
 *
 * Required roles:
 *  - can_write_files
 *
 * Responses
 * - 201 - Returns a file set that was created for this asset
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesFileSetSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__file_sets_}
 */
export const httpPostAssetsByAssetIdFileSets = (
  assetId: string,
  body: FilesFileSetSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdFileSets,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/file_sets/`,
  params: { assetId },
  body,
  headers,
});

export interface FilesHttpPostAssetsByAssetIdFileSetsBulkQuery {
  /**
   * If true, keep source objects
   */
  keep_source?: boolean;
  /**
   * If true, skips the recycle bin and purges the file set immediately
   */
  immediately?: boolean;
  /**
   * If true, do not delete the last remaining file set.
   */
  do_not_delete_last_copy?: boolean;
}

/**
 * `POST /v1/assets/{asset_id}/file_sets/bulk/`
 *
 * Delete asset's file set, file entries, and actual files in bulk
 *
 * Required roles:
 *  - can_delete_files
 *
 * Responses
 * - 202 - Deletion jobs created
 * - 401 - Token is invalid
 * - 404 - File set for this asset doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__file_sets_bulk_}
 */
export const httpPostAssetsByAssetIdFileSetsBulk = (
  assetId: string,
  body: FilesBulkFilesetSchema,
  query?: FilesHttpPostAssetsByAssetIdFileSetsBulkQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdFileSetsBulk,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/file_sets/bulk/`,
  params: { assetId },
  body,
  query,
  headers,
});

export interface FilesHttpDeleteAssetsByAssetIdFileSetsByFileSetIdQuery {
  /**
   * If true, keep source objects
   */
  keep_source?: boolean;
  immediately?: string;
}

/**
 * `DELETE /v1/assets/{asset_id}/file_sets/{file_set_id}/`
 *
 * Delete asset's file set, file entries, and actual files
 *
 * Required roles:
 *  - can_delete_files
 *
 * Responses
 * - 200 - File set that has been marked as deleted
 * - 204 - Without body in case `immediately` option was provided
 * - 401 - Token is invalid
 * - 404 - File set for this asset doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_assets__asset_id__file_sets__file_set_id__}
 */
export const httpDeleteAssetsByAssetIdFileSetsByFileSetId = (
  assetId: string,
  fileSetId: string,
  query?: FilesHttpDeleteAssetsByAssetIdFileSetsByFileSetIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteAssetsByAssetIdFileSetsByFileSetId,
  method: httpMethod.delete,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/file_sets/${encodeURIComponent(fileSetId)}/`,
  params: { assetId, fileSetId },
  query,
  headers,
});

/**
 * `GET /v1/assets/{asset_id}/file_sets/{file_set_id}/`
 *
 * Get asset's file set
 *
 * Required roles:
 *  - can_read_files
 *
 * Responses
 * - 200 - Returns a file set associated with this asset
 * - 401 - Token is invalid
 * - 404 - File set for this asset doesn't exist
 *
 * Response {@link FilesFileSetSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__file_sets__file_set_id__}
 */
export const httpGetAssetsByAssetIdFileSetsByFileSetId = (
  assetId: string,
  fileSetId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdFileSetsByFileSetId,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/file_sets/${encodeURIComponent(fileSetId)}/`,
  params: { assetId, fileSetId },
  headers,
});

export type FilesFileSetSchemaPartial = Partial<FilesFileSetSchema>;

/**
 * `PATCH /v1/assets/{asset_id}/file_sets/{file_set_id}/`
 *
 * Update file set information
 *
 * Required roles:
 *  - can_write_files
 *
 * Responses
 * - 200 - Returns a file set that was updated
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - File set for this asset doesn't exist
 *
 * Response {@link FilesFileSetSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/patch_v1_assets__asset_id__file_sets__file_set_id__}
 */
export const httpPatchAssetsByAssetIdFileSetsByFileSetId = (
  assetId: string,
  fileSetId: string,
  body: FilesFileSetSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPatchAssetsByAssetIdFileSetsByFileSetId,
  method: httpMethod.patch,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/file_sets/${encodeURIComponent(fileSetId)}/`,
  params: { assetId, fileSetId },
  body,
  headers,
});

/**
 * `PUT /v1/assets/{asset_id}/file_sets/{file_set_id}/`
 *
 * Update file set information
 *
 * Required roles:
 *  - can_write_files
 *
 * Responses
 * - 200 - Returns a file set that was updated
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - File set for this asset doesn't exist
 *
 * Response {@link FilesFileSetSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/put_v1_assets__asset_id__file_sets__file_set_id__}
 */
export const httpPutAssetsByAssetIdFileSetsByFileSetId = (
  assetId: string,
  fileSetId: string,
  body: FilesFileSetSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPutAssetsByAssetIdFileSetsByFileSetId,
  method: httpMethod.put,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/file_sets/${encodeURIComponent(fileSetId)}/`,
  params: { assetId, fileSetId },
  body,
  headers,
});

export interface FilesHttpGetAssetsByAssetIdFileSetsByFileSetIdFilesQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  last_id?: string;
  /**
   * Set to false if you don't need a URL, will speed things up
   */
  generate_signed_url?: boolean;
  /**
   * Set to true if you need a total amount of files in a file set
   */
  file_count?: boolean;
}

/**
 * `GET /v1/assets/{asset_id}/file_sets/{file_set_id}/files/`
 *
 * Get files from a file set
 *
 * Required roles:
 *  - can_read_files
 *
 * Responses
 * - 200 - Returns files from a file set
 *
 * Response {@link FilesFilesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__file_sets__file_set_id__files_}
 */
export const httpGetAssetsByAssetIdFileSetsByFileSetIdFiles = (
  assetId: string,
  fileSetId: string,
  query?: FilesHttpGetAssetsByAssetIdFileSetsByFileSetIdFilesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdFileSetsByFileSetIdFiles,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/file_sets/${encodeURIComponent(fileSetId)}/files/`,
  params: { assetId, fileSetId },
  query,
  headers,
});

/**
 * `DELETE /v1/assets/{asset_id}/file_sets/{file_set_id}/purge/`
 *
 * Purge deleted asset's file set, file entries, and actual files.
 *
 * Required roles:
 *  - can_delete_files
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - File set for this asset doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_assets__asset_id__file_sets__file_set_id__purge_}
 */
export const httpDeleteAssetsByAssetIdFileSetsByFileSetIdPurge = (
  assetId: string,
  fileSetId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteAssetsByAssetIdFileSetsByFileSetIdPurge,
  method: httpMethod.delete,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/file_sets/${encodeURIComponent(fileSetId)}/purge/`,
  params: { assetId, fileSetId },
  headers,
});

/**
 * `PUT /v1/assets/{asset_id}/file_sets/{file_set_id}/restore/`
 *
 * Restore delete asset's file set
 *
 * Required roles:
 *  - can_write_files
 *
 * Responses
 * - 200 - File set that has been restored
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - File set for this asset doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/put_v1_assets__asset_id__file_sets__file_set_id__restore_}
 */
export const httpPutAssetsByAssetIdFileSetsByFileSetIdRestore = (
  assetId: string,
  fileSetId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPutAssetsByAssetIdFileSetsByFileSetIdRestore,
  method: httpMethod.put,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/file_sets/${encodeURIComponent(fileSetId)}/restore/`,
  params: { assetId, fileSetId },
  headers,
});

export interface FilesHttpGetAssetsByAssetIdFilesQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Set to True if you do need a URL, this makes the request slower.
   */
  generate_signed_url?: boolean;
  /**
   * Set to attachment if you want a download link. Note that this will not create a download in asset history
   *
   */
  content_disposition?: string;
  /**
   * ID of a last file on previous page
   */
  last_id?: string;
}

/**
 * `GET /v1/assets/{asset_id}/files/`
 *
 * Get all asset's files
 *
 * Required roles:
 *  - can_read_files
 *
 * Responses
 * - 200 - Returns all files associated with this asset
 * - 401 - Token is invalid
 * - 404 - Files for this asset don't exist
 *
 * Response {@link FilesFilesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__files_}
 */
export const httpGetAssetsByAssetIdFiles = (
  assetId: string,
  query?: FilesHttpGetAssetsByAssetIdFilesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdFiles,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/files/`,
  params: { assetId },
  query,
  headers,
});

/**
 * `POST /v1/assets/{asset_id}/files/`
 *
 * Create file and associate to asset
 *
 * Required roles:
 *  - can_write_files
 *
 * Responses
 * - 201 - Returns a file that was created for this asset
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesFileSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__files_}
 */
export const httpPostAssetsByAssetIdFiles = (
  assetId: string,
  body: FilesFileCreateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdFiles,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/files/`,
  params: { assetId },
  body,
  headers,
});

/**
 * `DELETE /v1/assets/{asset_id}/files/{file_id}/`
 *
 * Delete asset's file entry (Not the actual file, use DELETE file_set for that)
 *
 * Required roles:
 *  - can_delete_files
 *
 * Responses
 * - 204 - Without body
 * - 401 - Token is invalid
 * - 404 - File for this asset doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_assets__asset_id__files__file_id__}
 */
export const httpDeleteAssetsByAssetIdFilesByFileId = (
  assetId: string,
  fileId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteAssetsByAssetIdFilesByFileId,
  method: httpMethod.delete,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/files/${encodeURIComponent(fileId)}/`,
  params: { assetId, fileId },
  headers,
});

export interface FilesHttpGetAssetsByAssetIdFilesByFileIdQuery {
  /**
   * Set to true to get a new upload url for the file
   */
  generate_signed_post_url?: boolean;
  /**
   * Set to attachment if you want a download link. Note that this will not create an asset history entry for the download
   *
   */
  content_disposition?: string;
  /**
   * Content type to add to the pre-signed upload url
   */
  content_type?: string;
  /**
   * Set to true to get a new url for the file rather than using a cached url
   */
  bypass_url_cache?: boolean;
}

/**
 * `GET /v1/assets/{asset_id}/files/{file_id}/`
 *
 * Get asset's file
 *
 * Required roles:
 *  - can_read_files
 *
 * Responses
 * - 200 - Returns a file associated with this asset
 * - 401 - Token is invalid
 * - 404 - File for this asset doesn't exist
 *
 * Response {@link FilesFileSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__files__file_id__}
 */
export const httpGetAssetsByAssetIdFilesByFileId = (
  assetId: string,
  fileId: string,
  query?: FilesHttpGetAssetsByAssetIdFilesByFileIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdFilesByFileId,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/files/${encodeURIComponent(fileId)}/`,
  params: { assetId, fileId },
  query,
  headers,
});

export type FilesFileSchemaPartial = Partial<FilesFileSchema>;

/**
 * `PATCH /v1/assets/{asset_id}/files/{file_id}/`
 *
 * Update file information
 *
 * Required roles:
 *  - can_write_files
 *
 * Responses
 * - 200 - Returns a file that was updated
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - File for this asset doesn't exist
 *
 * Response {@link FilesFileSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/patch_v1_assets__asset_id__files__file_id__}
 */
export const httpPatchAssetsByAssetIdFilesByFileId = (
  assetId: string,
  fileId: string,
  body: FilesFileSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPatchAssetsByAssetIdFilesByFileId,
  method: httpMethod.patch,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/files/${encodeURIComponent(fileId)}/`,
  params: { assetId, fileId },
  body,
  headers,
});

/**
 * `PUT /v1/assets/{asset_id}/files/{file_id}/`
 *
 * Update file information
 *
 * Required roles:
 *  - can_write_files
 *
 * Responses
 * - 200 - Returns a file that was updated
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - File for this asset doesn't exist
 *
 * Response {@link FilesFileSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/put_v1_assets__asset_id__files__file_id__}
 */
export const httpPutAssetsByAssetIdFilesByFileId = (
  assetId: string,
  fileId: string,
  body: FilesFileSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPutAssetsByAssetIdFilesByFileId,
  method: httpMethod.put,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/files/${encodeURIComponent(fileId)}/`,
  params: { assetId, fileId },
  body,
  headers,
});

/**
 * `POST /v1/assets/{asset_id}/files/{file_id}/capture/{milliseconds}/`
 *
 * Create a transcode job for creating still keyframe
 *
 * Required roles:
 *  - can_create_poster
 *
 * Responses
 * - 200 - OK
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - File or asset not found
 *
 * Response {@link FilesTranscodeResponseSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__files__file_id__capture__milliseconds__}
 */
export const httpPostAssetsByAssetIdFilesByFileIdCaptureByMilliseconds = (
  assetId: string,
  fileId: string,
  milliseconds: string,
  body: FilesTranscodeRequestSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdFilesByFileIdCaptureByMilliseconds,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/files/${encodeURIComponent(fileId)}/capture/${encodeURIComponent(milliseconds)}/`,
  params: { assetId, fileId, milliseconds },
  body,
  headers,
});

/**
 * `GET /v1/assets/{asset_id}/files/{file_id}/download_url/`
 *
 * Get asset's file download URL
 *
 * Required roles:
 *  - can_read_files
 *
 * Responses
 * - 200 - Returns a file download url
 * - 401 - Token is invalid
 * - 404 - File for this asset doesn't exist
 *
 * Response {@link FilesFileDownloadURLSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__files__file_id__download_url_}
 */
export const httpGetAssetsByAssetIdFilesByFileIdDownloadUrl = (
  assetId: string,
  fileId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdFilesByFileIdDownloadUrl,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/files/${encodeURIComponent(fileId)}/download_url/`,
  params: { assetId, fileId },
  headers,
});

/**
 * `POST /v1/assets/{asset_id}/files/{file_id}/edit_proxies/`
 *
 * Create format, file_set, and file for edit proxy if storage has edit proxy transcoder configured
 *
 * Required roles:
 *  - can_create_transcode_jobs
 * - can_write_files
 *
 * Responses
 * - 201 - ID and status of the job
 * - 204 - No edit proxy created
 * - 401 - Token is invalid
 *
 * Response {@link FilesEditProxyResponseSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__files__file_id__edit_proxies_}
 */
export const httpPostAssetsByAssetIdFilesByFileIdEditProxies = (
  assetId: string,
  fileId: string,
  body: FilesEditProxySchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdFilesByFileIdEditProxies,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/files/${encodeURIComponent(fileId)}/edit_proxies/`,
  params: { assetId, fileId },
  body,
  headers,
});

/**
 * `GET /v1/assets/{asset_id}/files/{file_id}/isg_handler_url/`
 *
 * Get asset's file handler URL for ISG
 *
 * Required roles:
 *  - can_read_files
 *
 * Responses
 * - 200 - Returns a file handler URL for ISG
 * - 401 - Token is invalid
 * - 404 - File for this asset doesn't exist
 *
 * Response {@link FilesISGHandlerURLSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__files__file_id__isg_handler_url_}
 */
export const httpGetAssetsByAssetIdFilesByFileIdIsgHandlerUrl = (
  assetId: string,
  fileId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdFilesByFileIdIsgHandlerUrl,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/files/${encodeURIComponent(fileId)}/isg_handler_url/`,
  params: { assetId, fileId },
  headers,
});

/**
 * `POST /v1/assets/{asset_id}/files/{file_id}/keyframes/`
 *
 * Create a transcode job for proxy and keyframes
 *
 * Required roles:
 *  - can_create_transcode_jobs
 *
 * Responses
 * - 200 - OK
 * - 204 - Transcode was ignored by Storage ignore pattern
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - File or asset not found
 *
 * Response {@link FilesTranscodeResponseSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__files__file_id__keyframes_}
 */
export const httpPostAssetsByAssetIdFilesByFileIdKeyframes = (
  assetId: string,
  fileId: string,
  body: FilesTranscodeRequestSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdFilesByFileIdKeyframes,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/files/${encodeURIComponent(fileId)}/keyframes/`,
  params: { assetId, fileId },
  body,
  headers,
});

/**
 * `POST /v1/assets/{asset_id}/files/{file_id}/mediainfo/`
 *
 * Create a job for extracting mediainfo
 *
 * Required roles:
 *  - can_create_transcode_jobs
 *
 * Responses
 * - 200 - OK
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - File or asset not found
 *
 * Response {@link FilesTranscodeResponseSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__files__file_id__mediainfo_}
 */
export const httpPostAssetsByAssetIdFilesByFileIdMediainfo = (
  assetId: string,
  fileId: string,
  body: FilesTranscodeRequestSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdFilesByFileIdMediainfo,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/files/${encodeURIComponent(fileId)}/mediainfo/`,
  params: { assetId, fileId },
  body,
  headers,
});

export interface FilesHttpPostAssetsByAssetIdFilesByFileIdMultipartQuery {
  /**
   * Use temporary file record
   */
  temporary?: boolean;
}

/**
 * `POST /v1/assets/{asset_id}/files/{file_id}/multipart/`
 *
 * Complete multipart upload (GCS).
 *
 * Required roles:
 *  - can_write_files
 *
 * Responses
 * - 200 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__files__file_id__multipart_}
 * @deprecated
 */
export const httpPostAssetsByAssetIdFilesByFileIdMultipart = (
  assetId: string,
  fileId: string,
  body: FilesMultipartUploadSchema,
  query?: FilesHttpPostAssetsByAssetIdFilesByFileIdMultipartQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdFilesByFileIdMultipart,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/files/${encodeURIComponent(fileId)}/multipart/`,
  params: { assetId, fileId },
  body,
  query,
  headers,
});

export interface FilesHttpPostAssetsByAssetIdFilesByFileIdMultipartB2CancelQuery {
  /**
   * Use temporary file record
   */
  temporary?: boolean;
}

/**
 * `POST /v1/assets/{asset_id}/files/{file_id}/multipart/b2/cancel/`
 *
 * Cancel Backblaze B2 multipart upload.
 *
 * Required roles:
 *  - can_write_files
 *
 * Responses
 * - 200 - Upload canceled
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__files__file_id__multipart_b2_cancel_}
 */
export const httpPostAssetsByAssetIdFilesByFileIdMultipartB2Cancel = (
  assetId: string,
  fileId: string,
  body: FilesMultipartB2CancelUpload,
  query?: FilesHttpPostAssetsByAssetIdFilesByFileIdMultipartB2CancelQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdFilesByFileIdMultipartB2Cancel,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/files/${encodeURIComponent(fileId)}/multipart/b2/cancel/`,
  params: { assetId, fileId },
  body,
  query,
  headers,
});

export interface FilesHttpPostAssetsByAssetIdFilesByFileIdMultipartB2FinishQuery {
  /**
   * Use temporary file record
   */
  temporary?: boolean;
}

/**
 * `POST /v1/assets/{asset_id}/files/{file_id}/multipart/b2/finish/`
 *
 * Complete Backblaze B2 multipart upload.
 *
 * Required roles:
 *  - can_write_files
 *
 * Responses
 * - 200 - Successful upload
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__files__file_id__multipart_b2_finish_}
 */
export const httpPostAssetsByAssetIdFilesByFileIdMultipartB2Finish = (
  assetId: string,
  fileId: string,
  body: FilesMultipartB2FinishUpload,
  query?: FilesHttpPostAssetsByAssetIdFilesByFileIdMultipartB2FinishQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdFilesByFileIdMultipartB2Finish,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/files/${encodeURIComponent(fileId)}/multipart/b2/finish/`,
  params: { assetId, fileId },
  body,
  query,
  headers,
});

export interface FilesHttpPostAssetsByAssetIdFilesByFileIdMultipartB2StartQuery {
  /**
   * Use temporary file record
   */
  temporary?: boolean;
}

/**
 * `POST /v1/assets/{asset_id}/files/{file_id}/multipart/b2/start/`
 *
 * Start Backblaze B2 multipart upload.
 *
 * Required roles:
 *  - can_write_files
 *
 * Responses
 * - 200 - Returns part upload url
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesMultipartB2StartUpload}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__files__file_id__multipart_b2_start_}
 */
export const httpPostAssetsByAssetIdFilesByFileIdMultipartB2Start = (
  assetId: string,
  fileId: string,
  body: FilesMultipartB2StartUpload,
  query?: FilesHttpPostAssetsByAssetIdFilesByFileIdMultipartB2StartQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdFilesByFileIdMultipartB2Start,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/files/${encodeURIComponent(fileId)}/multipart/b2/start/`,
  params: { assetId, fileId },
  body,
  query,
  headers,
});

/**
 * `POST /v1/assets/{asset_id}/files/{file_id}/multipart/cleanup/`
 *
 * Cleanup multipart upload (GCS, S3).
 *
 * Required roles:
 *  - can_write_files
 *
 * Responses
 * - 200 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__files__file_id__multipart_cleanup_}
 */
export const httpPostAssetsByAssetIdFilesByFileIdMultipartCleanup = (
  assetId: string,
  fileId: string,
  body: FilesMultipartUploadCleanupSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdFilesByFileIdMultipartCleanup,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/files/${encodeURIComponent(fileId)}/multipart/cleanup/`,
  params: { assetId, fileId },
  body,
  headers,
});

export interface FilesHttpPostAssetsByAssetIdFilesByFileIdMultipartGcsComposeUrlQuery {
  /**
   * Use temporary file record
   */
  temporary?: boolean;
}

/**
 * `POST /v1/assets/{asset_id}/files/{file_id}/multipart/gcs/compose_url/`
 *
 * Get object compose url for GCS parallel upload.
 *
 * Required roles:
 *  - can_write_files
 *
 * Responses
 * - 200 - Return pre-signed compose url
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesMultiPartUploadComposeURLSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__files__file_id__multipart_gcs_compose_url_}
 */
export const httpPostAssetsByAssetIdFilesByFileIdMultipartGcsComposeUrl = (
  assetId: string,
  fileId: string,
  body: FilesMultipartUploadComposeSchema,
  query?: FilesHttpPostAssetsByAssetIdFilesByFileIdMultipartGcsComposeUrlQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdFilesByFileIdMultipartGcsComposeUrl,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/files/${encodeURIComponent(fileId)}/multipart/gcs/compose_url/`,
  params: { assetId, fileId },
  body,
  query,
  headers,
});

export interface FilesHttpGetAssetsByAssetIdFilesByFileIdMultipartUrlQuery {
  /**
   * Multipart UploadId
   */
  upload_id: string;
  /**
   * List of multipart upload urls of required type
   */
  type?: string;
  /**
   * Maximum PartNumber that multipart upload has
   */
  max_part_number?: number;
  /**
   * Use temporary file record
   */
  temporary?: boolean;
}

/**
 * `GET /v1/assets/{asset_id}/files/{file_id}/multipart_url/`
 *
 * Get presigned urls for multipart upload (S3).
 *
 * Required roles:
 *  - can_write_files
 *
 * Responses
 * - 200 - Returns presigned urls for multipart upload
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesMultiPartURLsSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__files__file_id__multipart_url_}
 */
export const httpGetAssetsByAssetIdFilesByFileIdMultipartUrl = (
  assetId: string,
  fileId: string,
  query?: FilesHttpGetAssetsByAssetIdFilesByFileIdMultipartUrlQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdFilesByFileIdMultipartUrl,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/files/${encodeURIComponent(fileId)}/multipart_url/`,
  params: { assetId, fileId },
  query,
  headers,
});

export interface FilesHttpGetAssetsByAssetIdFilesByFileIdMultipartUrlPartQuery {
  /**
   * Multipart UploadId
   */
  upload_id?: string;
  /**
   * Number of parts to upload
   */
  parts_num: number;
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * Use temporary file record
   */
  temporary?: boolean;
}

/**
 * `GET /v1/assets/{asset_id}/files/{file_id}/multipart_url/part/`
 *
 * Get presigned urls for multipart part upload (S3 & GCS).
 *
 * Required roles:
 *  - can_write_files
 *
 * Responses
 * - 200 - Returns presigned urls for multipart part upload
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesMultiPartUploadURLsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__files__file_id__multipart_url_part_}
 */
export const httpGetAssetsByAssetIdFilesByFileIdMultipartUrlPart = (
  assetId: string,
  fileId: string,
  query?: FilesHttpGetAssetsByAssetIdFilesByFileIdMultipartUrlPartQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdFilesByFileIdMultipartUrlPart,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/files/${encodeURIComponent(fileId)}/multipart_url/part/`,
  params: { assetId, fileId },
  query,
  headers,
});

export interface FilesHttpPostAssetsByAssetIdFilesByFileIdMultipartUrlS3PartQuery {
  /**
   * Use temporary file record
   */
  temporary?: boolean;
}

/**
 * `POST /v1/assets/{asset_id}/files/{file_id}/multipart_url/s3/part/`
 *
 * Create presigned urls for multipart part S3 upload.
 *
 * Required roles:
 *  - can_write_files
 *
 * Responses
 * - 200 - Returns presigned urls for S3 multipart part upload
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - File or asset not found
 *
 * Response {@link FilesMultiPartS3UrlPartsSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__files__file_id__multipart_url_s3_part_}
 */
export const httpPostAssetsByAssetIdFilesByFileIdMultipartUrlS3Part = (
  assetId: string,
  fileId: string,
  body: FilesMultiPartS3UrlPartsSchema,
  query?: FilesHttpPostAssetsByAssetIdFilesByFileIdMultipartUrlS3PartQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdFilesByFileIdMultipartUrlS3Part,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/files/${encodeURIComponent(fileId)}/multipart_url/s3/part/`,
  params: { assetId, fileId },
  body,
  query,
  headers,
});

/**
 * `POST /v1/assets/{asset_id}/files/{file_id}/reindex/`
 *
 * Trigger reindexing of a file
 *
 * Required roles:
 *  - can_reindex_storages
 *
 * Responses
 * - 201 - ID and status of the job
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__files__file_id__reindex_}
 */
export const httpPostAssetsByAssetIdFilesByFileIdReindex = (
  assetId: string,
  fileId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdFilesByFileIdReindex,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/files/${encodeURIComponent(fileId)}/reindex/`,
  params: { assetId, fileId },
  headers,
});

/**
 * `POST /v1/assets/{asset_id}/files/{file_id}/subtitles/`
 *
 * Create a transcode job for subtitle files
 *
 * Required roles:
 *  - can_create_transcode_jobs
 *
 * Responses
 * - 200 - OK
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - File or asset not found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__files__file_id__subtitles_}
 */
export const httpPostAssetsByAssetIdFilesByFileIdSubtitles = (
  assetId: string,
  fileId: string,
  body: FilesSubtitleRequestSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdFilesByFileIdSubtitles,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/files/${encodeURIComponent(fileId)}/subtitles/`,
  params: { assetId, fileId },
  body,
  headers,
});

export interface FilesHttpGetAssetsByAssetIdFormatsQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * ID of a last format on previous page
   */
  last_id?: string;
  /**
   * If true return asset's formats for all versions
   */
  include_all_versions?: boolean;
}

/**
 * `GET /v1/assets/{asset_id}/formats/`
 *
 * Get all asset's formats
 *
 * Required roles:
 *  - can_read_formats
 *
 * Responses
 * - 200 - Returns all formats associated with this asset
 * - 401 - Token is invalid
 * - 404 - Formats for this asset don't exist
 *
 * Response {@link FilesFormatsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__formats_}
 */
export const httpGetAssetsByAssetIdFormats = (
  assetId: string,
  query?: FilesHttpGetAssetsByAssetIdFormatsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdFormats,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/formats/`,
  params: { assetId },
  query,
  headers,
});

/**
 * `POST /v1/assets/{asset_id}/formats/`
 *
 * Create format and associate to asset
 *
 * Required roles:
 *  - can_write_formats
 *
 * Responses
 * - 201 - Returns a format that was created for this asset
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesFormatSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__formats_}
 */
export const httpPostAssetsByAssetIdFormats = (
  assetId: string,
  body: FilesFormatSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdFormats,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/formats/`,
  params: { assetId },
  body,
  headers,
});

export interface FilesHttpDeleteAssetsByAssetIdFormatsByFormatIdQuery {
  immediately?: string;
}

/**
 * `DELETE /v1/assets/{asset_id}/formats/{format_id}/`
 *
 * Delete asset's format
 *
 * Required roles:
 *  - can_delete_formats
 *
 * Responses
 * - 200 - Format that marked as deleted
 * - 204 - Without body in case `immediately` option was provided
 * - 401 - Token is invalid
 * - 404 - Format for this asset doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_assets__asset_id__formats__format_id__}
 */
export const httpDeleteAssetsByAssetIdFormatsByFormatId = (
  assetId: string,
  formatId: string,
  query?: FilesHttpDeleteAssetsByAssetIdFormatsByFormatIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteAssetsByAssetIdFormatsByFormatId,
  method: httpMethod.delete,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/formats/${encodeURIComponent(formatId)}/`,
  params: { assetId, formatId },
  query,
  headers,
});

/**
 * `GET /v1/assets/{asset_id}/formats/{format_id}/`
 *
 * Get asset's format
 *
 * Required roles:
 *  - can_read_formats
 *
 * Responses
 * - 200 - Returns a format associated with this asset
 * - 401 - Token is invalid
 * - 404 - Format for this asset doesn't exist
 *
 * Response {@link FilesFormatSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__formats__format_id__}
 */
export const httpGetAssetsByAssetIdFormatsByFormatId = (
  assetId: string,
  formatId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdFormatsByFormatId,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/formats/${encodeURIComponent(formatId)}/`,
  params: { assetId, formatId },
  headers,
});

export type FilesFormatSchemaPartial = Partial<FilesFormatSchema>;

export interface FilesHttpPatchAssetsByAssetIdFormatsByFormatIdQuery {
  /**
   * If true update component_ids for matching file sets
   */
  sync_components?: boolean;
}

/**
 * `PATCH /v1/assets/{asset_id}/formats/{format_id}/`
 *
 * Update format information
 *
 * Required roles:
 *  - can_write_formats
 *
 * Responses
 * - 200 - Returns a format that was updated
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Format for this asset doesn't exist
 *
 * Response {@link FilesFormatSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/patch_v1_assets__asset_id__formats__format_id__}
 */
export const httpPatchAssetsByAssetIdFormatsByFormatId = (
  assetId: string,
  formatId: string,
  body: FilesFormatSchemaPartial,
  query?: FilesHttpPatchAssetsByAssetIdFormatsByFormatIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPatchAssetsByAssetIdFormatsByFormatId,
  method: httpMethod.patch,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/formats/${encodeURIComponent(formatId)}/`,
  params: { assetId, formatId },
  body,
  query,
  headers,
});

export interface FilesHttpPutAssetsByAssetIdFormatsByFormatIdQuery {
  /**
   * If true update component_ids for matching file sets
   */
  sync_components?: boolean;
}

/**
 * `PUT /v1/assets/{asset_id}/formats/{format_id}/`
 *
 * Update format information
 *
 * Required roles:
 *  - can_write_formats
 *
 * Responses
 * - 200 - Returns a format that was updated
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Format for this asset doesn't exist
 *
 * Response {@link FilesFormatSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/put_v1_assets__asset_id__formats__format_id__}
 */
export const httpPutAssetsByAssetIdFormatsByFormatId = (
  assetId: string,
  formatId: string,
  body: FilesFormatSchema,
  query?: FilesHttpPutAssetsByAssetIdFormatsByFormatIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPutAssetsByAssetIdFormatsByFormatId,
  method: httpMethod.put,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/formats/${encodeURIComponent(formatId)}/`,
  params: { assetId, formatId },
  body,
  query,
  headers,
});

/**
 * `DELETE /v1/assets/{asset_id}/formats/{format_id}/archive/`
 *
 * Delete archived format
 *
 * Required roles:
 *  - can_delete_archived_formats
 *
 * Responses
 * - 202 - No body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Format for this asset doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_assets__asset_id__formats__format_id__archive_}
 */
export const httpDeleteAssetsByAssetIdFormatsByFormatIdArchive = (
  assetId: string,
  formatId: string,
  body: FilesFormatDeleteArchiveSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteAssetsByAssetIdFormatsByFormatIdArchive,
  method: httpMethod.delete,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/formats/${encodeURIComponent(formatId)}/archive/`,
  params: { assetId, formatId },
  body,
  headers,
});

export interface FilesHttpPostAssetsByAssetIdFormatsByFormatIdArchiveQuery {
  /**
   * Enable transfer through iconik host (creates egress)
   */
  allow_host_transfer?: boolean;
}

/**
 * `POST /v1/assets/{asset_id}/formats/{format_id}/archive/`
 *
 * Archive format
 *
 * Required roles:
 *  - can_archive_formats
 *
 * Responses
 * - 202 - No body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Format for this asset doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__formats__format_id__archive_}
 */
export const httpPostAssetsByAssetIdFormatsByFormatIdArchive = (
  assetId: string,
  formatId: string,
  body: FilesFormatArchiveSchema,
  query?: FilesHttpPostAssetsByAssetIdFormatsByFormatIdArchiveQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdFormatsByFormatIdArchive,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/formats/${encodeURIComponent(formatId)}/archive/`,
  params: { assetId, formatId },
  body,
  query,
  headers,
});

/**
 * `GET /v1/assets/{asset_id}/formats/{format_id}/components/`
 *
 * Get all components for a format in an asset
 *
 * Required roles:
 *  - can_read_formats
 *
 * Responses
 * - 200 - Returns all formats associated with this asset
 * - 400 - Invalid input (Wrong type of UUID or JSON)
 * - 401 - Token is invalid
 * - 404 - Asset/Format/Component don't exist
 *
 * Response {@link FilesComponentsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__formats__format_id__components_}
 */
export const httpGetAssetsByAssetIdFormatsByFormatIdComponents = (
  assetId: string,
  formatId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdFormatsByFormatIdComponents,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/formats/${encodeURIComponent(formatId)}/components/`,
  params: { assetId, formatId },
  headers,
});

/**
 * `POST /v1/assets/{asset_id}/formats/{format_id}/components/`
 *
 * Add a new format component
 *
 * Required roles:
 *  - can_create_formats
 *
 * Responses
 * - 200 - Returns the created component
 * - 400 - Invalid input (Wrong type of UUID or JSON)
 * - 401 - Token is invalid
 * - 404 - Formats for this asset don't exist
 *
 * Response {@link FilesComponentSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__formats__format_id__components_}
 */
export const httpPostAssetsByAssetIdFormatsByFormatIdComponents = (
  assetId: string,
  formatId: string,
  body: FilesComponentSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdFormatsByFormatIdComponents,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/formats/${encodeURIComponent(formatId)}/components/`,
  params: { assetId, formatId },
  body,
  headers,
});

/**
 * `DELETE /v1/assets/{asset_id}/formats/{format_id}/components/{component_id}/`
 *
 * Delete a component in a format
 *
 * Required roles:
 *  - can_delete_formats
 *
 * Responses
 * - 200 - Returns all formats associated with this asset
 * - 400 - Invalid input (Wrong type of UUID or JSON)
 * - 401 - Token is invalid
 * - 404 - Formats for this asset don't exist
 *
 * Response {@link FilesComponentsSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_assets__asset_id__formats__format_id__components__component_id__}
 */
export const httpDeleteAssetsByAssetIdFormatsByFormatIdComponentsByComponentId =
  (
    assetId: string,
    formatId: string,
    componentId: string,
    headers?: IconikApiHeaders,
  ) => ({
    id: FilesHttpDeleteAssetsByAssetIdFormatsByFormatIdComponentsByComponentId,
    method: httpMethod.delete,
    url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/formats/${encodeURIComponent(formatId)}/components/${encodeURIComponent(componentId)}/`,
    params: { assetId, formatId, componentId },
    headers,
  });

/**
 * `GET /v1/assets/{asset_id}/formats/{format_id}/components/{component_id}/`
 *
 * Get a component for a format in an asset
 *
 * Required roles:
 *  - can_read_formats
 *
 * Responses
 * - 200 - Returns all formats associated with this asset
 * - 400 - Invalid input (Wrong type of UUID or JSON)
 * - 401 - Token is invalid
 * - 404 - Asset/Format/Component don't exist
 *
 * Response {@link FilesComponentsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__formats__format_id__components__component_id__}
 */
export const httpGetAssetsByAssetIdFormatsByFormatIdComponentsByComponentId = (
  assetId: string,
  formatId: string,
  componentId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdFormatsByFormatIdComponentsByComponentId,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/formats/${encodeURIComponent(formatId)}/components/${encodeURIComponent(componentId)}/`,
  params: { assetId, formatId, componentId },
  headers,
});

/**
 * `PUT /v1/assets/{asset_id}/formats/{format_id}/components/{component_id}/`
 *
 * Update a component in a format
 *
 * Required roles:
 *  - can_create_formats
 *
 * Responses
 * - 200 - Returns the edited component
 * - 400 - Invalid input (Wrong type of UUID or JSON)
 * - 401 - Token is invalid
 * - 404 - Formats for this asset don't exist
 *
 * Response {@link FilesComponentSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/put_v1_assets__asset_id__formats__format_id__components__component_id__}
 */
export const httpPutAssetsByAssetIdFormatsByFormatIdComponentsByComponentId = (
  assetId: string,
  formatId: string,
  componentId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPutAssetsByAssetIdFormatsByFormatIdComponentsByComponentId,
  method: httpMethod.put,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/formats/${encodeURIComponent(formatId)}/components/${encodeURIComponent(componentId)}/`,
  params: { assetId, formatId, componentId },
  headers,
});

export interface FilesHttpGetAssetsByAssetIdFormatsByFormatIdFileSetsQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * ID of a last file set on previous page
   */
  last_id?: string;
}

/**
 * `GET /v1/assets/{asset_id}/formats/{format_id}/file_sets/`
 *
 * Get all asset's file sets in a specific format
 *
 * Required roles:
 *  - can_read_files
 *
 * Responses
 * - 200 - Returns all file sets associated with this asset
 * - 401 - Token is invalid
 * - 404 - FileSets for this asset don't exist
 *
 * Response {@link FilesFileSetsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__formats__format_id__file_sets_}
 */
export const httpGetAssetsByAssetIdFormatsByFormatIdFileSets = (
  assetId: string,
  formatId: string,
  query?: FilesHttpGetAssetsByAssetIdFormatsByFormatIdFileSetsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdFormatsByFormatIdFileSets,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/formats/${encodeURIComponent(formatId)}/file_sets/`,
  params: { assetId, formatId },
  query,
  headers,
});

/**
 * `GET /v1/assets/{asset_id}/formats/{format_id}/file_sets/sources/`
 *
 * Get all file sets with matching format and storage method
 *
 * Required roles:
 *  - can_read_files
 *
 * Responses
 * - 200 - Returns a files
 * - 400 - Invalid input (Wrong type of UUID or JSON)
 *
 * Response {@link FilesFileSetSourcesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__formats__format_id__file_sets_sources_}
 */
export const httpGetAssetsByAssetIdFormatsByFormatIdFileSetsSources = (
  assetId: string,
  formatId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdFormatsByFormatIdFileSetsSources,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/formats/${encodeURIComponent(formatId)}/file_sets/sources/`,
  params: { assetId, formatId },
  headers,
});

/**
 * `GET /v1/assets/{asset_id}/formats/{format_id}/file_sets/sources/{storage_method}/`
 *
 * Get all file sets with matching format and storage method
 *
 * Required roles:
 *  - can_read_files
 *
 * Responses
 * - 200 - Returns a files
 * - 400 - Invalid input (Wrong type of UUID or JSON)
 *
 * Response {@link FilesFileSetsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__formats__format_id__file_sets_sources__storage_method__}
 */
export const httpGetAssetsByAssetIdFormatsByFormatIdFileSetsSourcesByStorageMethod =
  (
    assetId: string,
    formatId: string,
    storageMethod: string,
    headers?: IconikApiHeaders,
  ) => ({
    id: FilesHttpGetAssetsByAssetIdFormatsByFormatIdFileSetsSourcesByStorageMethod,
    method: httpMethod.get,
    url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/formats/${encodeURIComponent(formatId)}/file_sets/sources/${encodeURIComponent(storageMethod)}/`,
    params: { assetId, formatId, storageMethod },
    headers,
  });

/**
 * `DELETE /v1/assets/{asset_id}/formats/{format_id}/purge/`
 *
 * Purge deleted asset's format
 *
 * Required roles:
 *  - can_delete_formats
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Format for this asset doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_assets__asset_id__formats__format_id__purge_}
 */
export const httpDeleteAssetsByAssetIdFormatsByFormatIdPurge = (
  assetId: string,
  formatId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteAssetsByAssetIdFormatsByFormatIdPurge,
  method: httpMethod.delete,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/formats/${encodeURIComponent(formatId)}/purge/`,
  params: { assetId, formatId },
  headers,
});

export interface FilesHttpPostAssetsByAssetIdFormatsByFormatIdRestoreQuery {
  /**
   * Enable transfer through iconik host (creates egress)
   */
  allow_host_transfer?: boolean;
}

/**
 * `POST /v1/assets/{asset_id}/formats/{format_id}/restore/`
 *
 * Restore archived format
 *
 * Required roles:
 *  - can_restore_archived_formats
 *
 * Responses
 * - 202 - No body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Format for this asset doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__formats__format_id__restore_}
 */
export const httpPostAssetsByAssetIdFormatsByFormatIdRestore = (
  assetId: string,
  formatId: string,
  body: FilesFormatRestoreSchema,
  query?: FilesHttpPostAssetsByAssetIdFormatsByFormatIdRestoreQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdFormatsByFormatIdRestore,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/formats/${encodeURIComponent(formatId)}/restore/`,
  params: { assetId, formatId },
  body,
  query,
  headers,
});

/**
 * `PUT /v1/assets/{asset_id}/formats/{format_id}/restore/`
 *
 * Restore deleted asset's format
 *
 * Required roles:
 *  - can_write_formats
 *
 * Responses
 * - 200 - Format that has been restored
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Format for this asset doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/put_v1_assets__asset_id__formats__format_id__restore_}
 */
export const httpPutAssetsByAssetIdFormatsByFormatIdRestore = (
  assetId: string,
  formatId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPutAssetsByAssetIdFormatsByFormatIdRestore,
  method: httpMethod.put,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/formats/${encodeURIComponent(formatId)}/restore/`,
  params: { assetId, formatId },
  headers,
});

export interface FilesHttpGetAssetsByAssetIdFormatsByFormatIdStoragesByStorageIdFileSetsQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * ID of a last file set on previous page
   */
  last_id?: string;
}

/**
 * `GET /v1/assets/{asset_id}/formats/{format_id}/storages/{storage_id}/file_sets/`
 *
 * Get all asset's file sets in a specific format on a specific storage
 *
 * Required roles:
 *  - can_read_files
 *
 * Responses
 * - 200 - Returns all file sets associated with this asset
 * - 401 - Token is invalid
 * - 404 - FileSets for this asset don't exist
 *
 * Response {@link FilesFileSetsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__formats__format_id__storages__storage_id__file_sets_}
 */
export const httpGetAssetsByAssetIdFormatsByFormatIdStoragesByStorageIdFileSets =
  (
    assetId: string,
    formatId: string,
    storageId: string,
    query?: FilesHttpGetAssetsByAssetIdFormatsByFormatIdStoragesByStorageIdFileSetsQuery,
    headers?: IconikApiHeaders,
  ) => ({
    id: FilesHttpGetAssetsByAssetIdFormatsByFormatIdStoragesByStorageIdFileSets,
    method: httpMethod.get,
    url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/formats/${encodeURIComponent(formatId)}/storages/${encodeURIComponent(storageId)}/file_sets/`,
    params: { assetId, formatId, storageId },
    query,
    headers,
  });

/**
 * `GET /v1/assets/{asset_id}/formats/{name}/`
 *
 * Get asset's format
 *
 * Required roles:
 *  - can_read_formats
 *
 * Responses
 * - 200 - Returns a format associated with this asset
 * - 401 - Token is invalid
 * - 404 - Format for this asset doesn't exist
 *
 * Response {@link FilesFormatSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__formats__name__}
 */
export const httpGetAssetsByAssetIdFormatsByName = (
  assetId: string,
  name: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdFormatsByName,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/formats/${encodeURIComponent(name)}/`,
  params: { assetId, name },
  headers,
});

export interface FilesHttpGetAssetsByAssetIdKeyframesQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Set to false if you don't need a URL, will speed things up
   */
  generate_signed_url?: boolean;
  /**
   * Set to attachment if you do not want a download link
   */
  content_disposition?: string;
  /**
   * ID of a last keyframe on previous page
   */
  last_id?: string;
  /**
   * If true return asset's keyframes for all versions
   */
  include_all_versions?: boolean;
}

/**
 * `GET /v1/assets/{asset_id}/keyframes/`
 *
 * Get all asset's keyframes
 *
 * Required roles:
 *  - can_read_assets
 *
 * Responses
 * - 200 - Returns all keyframes associated with this asset
 * - 401 - Token is invalid
 * - 404 - Keyframes for this asset don't exist
 *
 * Response {@link FilesKeyframesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__keyframes_}
 */
export const httpGetAssetsByAssetIdKeyframes = (
  assetId: string,
  query?: FilesHttpGetAssetsByAssetIdKeyframesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdKeyframes,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/keyframes/`,
  params: { assetId },
  query,
  headers,
});

export interface FilesHttpPostAssetsByAssetIdKeyframesQuery {
  /**
   * Set to True to get a google resumable upload link
   */
  use_google_resumable_upload?: boolean;
}

/**
 * `POST /v1/assets/{asset_id}/keyframes/`
 *
 * Create keyframe and associate to asset
 *
 * Required roles:
 *  - can_write_keyframes
 *
 * Responses
 * - 201 - Returns a keyframe that was created for this asset
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesKeyframeCreateSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__keyframes_}
 */
export const httpPostAssetsByAssetIdKeyframes = (
  assetId: string,
  body: FilesKeyframeCreateSchema,
  query?: FilesHttpPostAssetsByAssetIdKeyframesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdKeyframes,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/keyframes/`,
  params: { assetId },
  body,
  query,
  headers,
});

export interface FilesHttpDeleteAssetsByAssetIdKeyframesByKeyframeIdQuery {
  keep_poster?: boolean;
}

/**
 * `DELETE /v1/assets/{asset_id}/keyframes/{keyframe_id}/`
 *
 * Delete asset's keyframe
 *
 * Required roles:
 *  - can_write_keyframes
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Keyframe for this asset don't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_assets__asset_id__keyframes__keyframe_id__}
 */
export const httpDeleteAssetsByAssetIdKeyframesByKeyframeId = (
  assetId: string,
  keyframeId: string,
  query?: FilesHttpDeleteAssetsByAssetIdKeyframesByKeyframeIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteAssetsByAssetIdKeyframesByKeyframeId,
  method: httpMethod.delete,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/keyframes/${encodeURIComponent(keyframeId)}/`,
  params: { assetId, keyframeId },
  query,
  headers,
});

export interface FilesHttpGetAssetsByAssetIdKeyframesByKeyframeIdQuery {
  /**
   * Set to attachment if you do not want a download link
   */
  content_disposition?: string;
  /**
   * Content type to add to the pre-signed upload url
   */
  content_type?: string;
}

/**
 * `GET /v1/assets/{asset_id}/keyframes/{keyframe_id}/`
 *
 * Get asset's keyframe by ID
 *
 * Required roles:
 *  - can_read_assets
 *
 * Responses
 * - 200 - Returns a keyframe associated with this asset
 * - 401 - Token is invalid
 * - 404 - Keyframe for this asset don't exist
 *
 * Response {@link FilesKeyframeSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__keyframes__keyframe_id__}
 */
export const httpGetAssetsByAssetIdKeyframesByKeyframeId = (
  assetId: string,
  keyframeId: string,
  query?: FilesHttpGetAssetsByAssetIdKeyframesByKeyframeIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdKeyframesByKeyframeId,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/keyframes/${encodeURIComponent(keyframeId)}/`,
  params: { assetId, keyframeId },
  query,
  headers,
});

export type FilesKeyframeCreateSchemaPartial =
  Partial<FilesKeyframeCreateSchema>;

/**
 * `PATCH /v1/assets/{asset_id}/keyframes/{keyframe_id}/`
 *
 * Update keyframe information
 *
 * Required roles:
 *  - can_write_keyframes
 *
 * Responses
 * - 200 - Returns a keyframe that was updated
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Keyframe for this asset don't exist
 *
 * Response {@link FilesKeyframeSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/patch_v1_assets__asset_id__keyframes__keyframe_id__}
 */
export const httpPatchAssetsByAssetIdKeyframesByKeyframeId = (
  assetId: string,
  keyframeId: string,
  body: FilesKeyframeCreateSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPatchAssetsByAssetIdKeyframesByKeyframeId,
  method: httpMethod.patch,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/keyframes/${encodeURIComponent(keyframeId)}/`,
  params: { assetId, keyframeId },
  body,
  headers,
});

/**
 * `PUT /v1/assets/{asset_id}/keyframes/{keyframe_id}/`
 *
 * Update keyframe information
 *
 * Required roles:
 *  - can_write_keyframes
 *
 * Responses
 * - 200 - Returns a keyframe that was updated
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Keyframe for this asset don't exist
 *
 * Response {@link FilesKeyframeSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/put_v1_assets__asset_id__keyframes__keyframe_id__}
 */
export const httpPutAssetsByAssetIdKeyframesByKeyframeId = (
  assetId: string,
  keyframeId: string,
  body: FilesKeyframeCreateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPutAssetsByAssetIdKeyframesByKeyframeId,
  method: httpMethod.put,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/keyframes/${encodeURIComponent(keyframeId)}/`,
  params: { assetId, keyframeId },
  body,
  headers,
});

/**
 * `DELETE /v1/assets/{asset_id}/keyframes/{keyframe_id}/public/`
 *
 * Make the keyframe link private
 *
 * Required roles:
 *  - can_write_keyframes
 *
 * Responses
 * - 201 - Returns a keyframe that was updated
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesKeyframeSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_assets__asset_id__keyframes__keyframe_id__public_}
 */
export const httpDeleteAssetsByAssetIdKeyframesByKeyframeIdPublic = (
  assetId: string,
  keyframeId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteAssetsByAssetIdKeyframesByKeyframeIdPublic,
  method: httpMethod.delete,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/keyframes/${encodeURIComponent(keyframeId)}/public/`,
  params: { assetId, keyframeId },
  headers,
});

/**
 * `POST /v1/assets/{asset_id}/keyframes/{keyframe_id}/public/`
 *
 * Make the keyframe link public
 *
 * Required roles:
 *  - can_write_keyframes
 *
 * Responses
 * - 201 - Returns a keyframe that was updated
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesKeyframeSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__keyframes__keyframe_id__public_}
 */
export const httpPostAssetsByAssetIdKeyframesByKeyframeIdPublic = (
  assetId: string,
  keyframeId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdKeyframesByKeyframeIdPublic,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/keyframes/${encodeURIComponent(keyframeId)}/public/`,
  params: { assetId, keyframeId },
  headers,
});

export interface FilesHttpPostAssetsByAssetIdMethodByStorageMethodKeyframesQuery {
  /**
   * Set to True to get a google resumable upload link
   */
  use_google_resumable_upload?: boolean;
}

/**
 * `POST /v1/assets/{asset_id}/method/{storage_method}/keyframes/`
 *
 * Create keyframe and associate to asset
 *
 * Required roles:
 *  - can_write_keyframes
 *
 * Responses
 * - 201 - Returns a keyframe that was created for this asset
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesKeyframeCreateSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__method__storage_method__keyframes_}
 */
export const httpPostAssetsByAssetIdMethodByStorageMethodKeyframes = (
  assetId: string,
  storageMethod: string,
  body: FilesKeyframeCreateSchema,
  query?: FilesHttpPostAssetsByAssetIdMethodByStorageMethodKeyframesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdMethodByStorageMethodKeyframes,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/method/${encodeURIComponent(storageMethod)}/keyframes/`,
  params: { assetId, storageMethod },
  body,
  query,
  headers,
});

/**
 * `POST /v1/assets/{asset_id}/method/{storage_method}/proxies/`
 *
 * Create proxy and associate to asset
 *
 * Required roles:
 *  - can_write_proxies
 *
 * Responses
 * - 201 - Returns a proxy that was created for this asset
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesProxyCreateSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__method__storage_method__proxies_}
 */
export const httpPostAssetsByAssetIdMethodByStorageMethodProxies = (
  assetId: string,
  storageMethod: string,
  body: FilesProxyCreateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdMethodByStorageMethodProxies,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/method/${encodeURIComponent(storageMethod)}/proxies/`,
  params: { assetId, storageMethod },
  body,
  headers,
});

export interface FilesHttpGetAssetsByAssetIdProxiesQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Set to false if you don't need a URL, will speed things up
   */
  generate_signed_url?: boolean;
  /**
   * Set to attachment if you want a download link
   */
  content_disposition?: string;
  /**
   * ID of a last proxy on previous page
   */
  last_id?: string;
  /**
   * Set to true to get a new url for the file rather than using a cached url
   */
  bypass_url_cache?: boolean;
  /**
   * If true return asset's keyframes for all versions
   */
  include_all_versions?: boolean;
}

/**
 * `GET /v1/assets/{asset_id}/proxies/`
 *
 * Get all asset's proxies
 *
 * Required roles:
 *  - can_read_proxies
 *
 * Responses
 * - 200 - Returns all proxies associated with this asset
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Proxies for this asset doesn't exist
 *
 * Response {@link FilesProxiesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__proxies_}
 */
export const httpGetAssetsByAssetIdProxies = (
  assetId: string,
  query?: FilesHttpGetAssetsByAssetIdProxiesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdProxies,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/proxies/`,
  params: { assetId },
  query,
  headers,
});

/**
 * `POST /v1/assets/{asset_id}/proxies/`
 *
 * Create proxy and associate to asset
 *
 * Required roles:
 *  - can_write_proxies
 *
 * Responses
 * - 201 - Returns a proxy that was created for this asset
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesProxyCreateSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__proxies_}
 */
export const httpPostAssetsByAssetIdProxies = (
  assetId: string,
  body: FilesProxyCreateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdProxies,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/proxies/`,
  params: { assetId },
  body,
  headers,
});

/**
 * `DELETE /v1/assets/{asset_id}/proxies/{proxy_id}/`
 *
 * Delete asset's proxy
 *
 * Required roles:
 *  - can_delete_proxies
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Proxy for this asset doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_assets__asset_id__proxies__proxy_id__}
 */
export const httpDeleteAssetsByAssetIdProxiesByProxyId = (
  assetId: string,
  proxyId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteAssetsByAssetIdProxiesByProxyId,
  method: httpMethod.delete,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/proxies/${encodeURIComponent(proxyId)}/`,
  params: { assetId, proxyId },
  headers,
});

export interface FilesHttpGetAssetsByAssetIdProxiesByProxyIdQuery {
  /**
   * Set to attachment if you want a download link
   */
  content_disposition?: string;
  /**
   * Content type to add to the pre-signed upload url
   */
  content_type?: string;
}

/**
 * `GET /v1/assets/{asset_id}/proxies/{proxy_id}/`
 *
 * Get asset's proxy
 *
 * Required roles:
 *  - can_read_proxies
 *
 * Responses
 * - 200 - Returns proxy associated with this asset
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Proxy for this asset doesn't exist
 *
 * Response {@link FilesProxySchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__proxies__proxy_id__}
 */
export const httpGetAssetsByAssetIdProxiesByProxyId = (
  assetId: string,
  proxyId: string,
  query?: FilesHttpGetAssetsByAssetIdProxiesByProxyIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdProxiesByProxyId,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/proxies/${encodeURIComponent(proxyId)}/`,
  params: { assetId, proxyId },
  query,
  headers,
});

export type FilesProxyUpdateSchemaPartial = Partial<FilesProxyUpdateSchema>;

/**
 * `PATCH /v1/assets/{asset_id}/proxies/{proxy_id}/`
 *
 * Update proxy information
 *
 * Required roles:
 *  - can_write_proxies
 *
 * Responses
 * - 200 - Returns a proxy that was updated
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Proxy for this asset doesn't exist
 *
 * Response {@link FilesProxySchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/patch_v1_assets__asset_id__proxies__proxy_id__}
 */
export const httpPatchAssetsByAssetIdProxiesByProxyId = (
  assetId: string,
  proxyId: string,
  body: FilesProxyUpdateSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPatchAssetsByAssetIdProxiesByProxyId,
  method: httpMethod.patch,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/proxies/${encodeURIComponent(proxyId)}/`,
  params: { assetId, proxyId },
  body,
  headers,
});

/**
 * `PUT /v1/assets/{asset_id}/proxies/{proxy_id}/`
 *
 * Update proxy information
 *
 * Required roles:
 *  - can_write_proxies
 *
 * Responses
 * - 200 - Returns a proxy that was updated
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Proxy for this asset doesn't exist
 *
 * Response {@link FilesProxySchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/put_v1_assets__asset_id__proxies__proxy_id__}
 */
export const httpPutAssetsByAssetIdProxiesByProxyId = (
  assetId: string,
  proxyId: string,
  body: FilesProxyUpdateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPutAssetsByAssetIdProxiesByProxyId,
  method: httpMethod.put,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/proxies/${encodeURIComponent(proxyId)}/`,
  params: { assetId, proxyId },
  body,
  headers,
});

export interface FilesHttpPutAssetsByAssetIdProxiesByProxyIdContainersHeader
  extends IconikApiHeaders {
  DRM?: string;
  Watermark?: string;
}

/**
 * `PUT /v1/assets/{asset_id}/proxies/{proxy_id}/containers/`
 *
 * Create Proxy container.
 *
 * Required roles:
 *  - can_write_proxies
 *
 * Responses
 * - 201 - Returns created proxy file
 * - 302 - Redirect to playable url
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 425 - media not ready for streaming
 *
 * Response {@link FilesProxyContainerSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/put_v1_assets__asset_id__proxies__proxy_id__containers_}
 */
export const httpPutAssetsByAssetIdProxiesByProxyIdContainers = (
  assetId: string,
  proxyId: string,
  body: FilesProxyContainerSchema,
  headers?: FilesHttpPutAssetsByAssetIdProxiesByProxyIdContainersHeader,
) => ({
  id: FilesHttpPutAssetsByAssetIdProxiesByProxyIdContainers,
  method: httpMethod.put,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/proxies/${encodeURIComponent(proxyId)}/containers/`,
  params: { assetId, proxyId },
  body,
  headers,
});

export interface FilesHttpPostAssetsByAssetIdProxiesByProxyIdContainersByContainerIdFilesHeader
  extends IconikApiHeaders {
  DRM?: string;
  Watermark?: string;
}

/**
 * `POST /v1/assets/{asset_id}/proxies/{proxy_id}/containers/{container_id}/files/`
 *
 * Create Proxy file
 *
 * Required roles:
 *  - can_write_proxies
 *
 * Responses
 * - 201 - Created Proxy File
 * - 302 - Redirect to playable url
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 425 - media not ready for streaming
 *
 * Response {@link FilesProxyFileSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__proxies__proxy_id__containers__container_id__files_}
 */
export const httpPostAssetsByAssetIdProxiesByProxyIdContainersByContainerIdFiles =
  (
    assetId: string,
    proxyId: string,
    containerId: string,
    body: FilesProxyFileSchema,
    headers?: FilesHttpPostAssetsByAssetIdProxiesByProxyIdContainersByContainerIdFilesHeader,
  ) => ({
    id: FilesHttpPostAssetsByAssetIdProxiesByProxyIdContainersByContainerIdFiles,
    method: httpMethod.post,
    url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/proxies/${encodeURIComponent(proxyId)}/containers/${encodeURIComponent(containerId)}/files/`,
    params: { assetId, proxyId, containerId },
    body,
    headers,
  });

export type FilesProxyFileUpdateSchemaPartial =
  Partial<FilesProxyFileUpdateSchema>;

/**
 * `PATCH /v1/assets/{asset_id}/proxies/{proxy_id}/containers/{container_id}/files/{file_id}/`
 *
 * Update proxy file status
 *
 * Required roles:
 *  - can_write_proxies
 *
 * Responses
 * - 200 - Returns updated proxy file
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Proxy file doesn't exist
 *
 * Response {@link FilesProxyFileSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/patch_v1_assets__asset_id__proxies__proxy_id__containers__container_id__files__file_id__}
 */
export const httpPatchAssetsByAssetIdProxiesByProxyIdContainersByContainerIdFilesByFileId =
  (
    assetId: string,
    proxyId: string,
    containerId: string,
    fileId: string,
    body: FilesProxyFileUpdateSchemaPartial,
    headers?: IconikApiHeaders,
  ) => ({
    id: FilesHttpPatchAssetsByAssetIdProxiesByProxyIdContainersByContainerIdFilesByFileId,
    method: httpMethod.patch,
    url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/proxies/${encodeURIComponent(proxyId)}/containers/${encodeURIComponent(containerId)}/files/${encodeURIComponent(fileId)}/`,
    params: { assetId, proxyId, containerId, fileId },
    body,
    headers,
  });

/**
 * `PUT /v1/assets/{asset_id}/proxies/{proxy_id}/containers/{container_id}/files/{file_id}/`
 *
 * Update proxy file status
 *
 * Required roles:
 *  - can_write_proxies
 *
 * Responses
 * - 200 - Returns updated proxy file
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Proxy file doesn't exist
 *
 * Response {@link FilesProxyFileSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/put_v1_assets__asset_id__proxies__proxy_id__containers__container_id__files__file_id__}
 */
export const httpPutAssetsByAssetIdProxiesByProxyIdContainersByContainerIdFilesByFileId =
  (
    assetId: string,
    proxyId: string,
    containerId: string,
    fileId: string,
    body: FilesProxyFileUpdateSchema,
    headers?: IconikApiHeaders,
  ) => ({
    id: FilesHttpPutAssetsByAssetIdProxiesByProxyIdContainersByContainerIdFilesByFileId,
    method: httpMethod.put,
    url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/proxies/${encodeURIComponent(proxyId)}/containers/${encodeURIComponent(containerId)}/files/${encodeURIComponent(fileId)}/`,
    params: { assetId, proxyId, containerId, fileId },
    body,
    headers,
  });

/**
 * `GET /v1/assets/{asset_id}/proxies/{proxy_id}/download_url/`
 *
 * Get asset's proxy download url
 *
 * Required roles:
 *  - can_read_proxies
 *
 * Responses
 * - 200 - Returns proxy associated with this asset
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Proxy for this asset doesn't exist
 *
 * Response {@link FilesProxyDownloadURLSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__proxies__proxy_id__download_url_}
 */
export const httpGetAssetsByAssetIdProxiesByProxyIdDownloadUrl = (
  assetId: string,
  proxyId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdProxiesByProxyIdDownloadUrl,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/proxies/${encodeURIComponent(proxyId)}/download_url/`,
  params: { assetId, proxyId },
  headers,
});

/**
 * `POST /v1/assets/{asset_id}/proxies/{proxy_id}/keyframes/`
 *
 * Create a transcode job for keyframes from a proxy
 *
 * Required roles:
 *  - can_create_transcode_jobs
 *
 * Responses
 * - 200 - OK
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - File or asset not found
 *
 * Response {@link FilesTranscodeResponseSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__proxies__proxy_id__keyframes_}
 */
export const httpPostAssetsByAssetIdProxiesByProxyIdKeyframes = (
  assetId: string,
  proxyId: string,
  body: FilesTranscodeRequestSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdProxiesByProxyIdKeyframes,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/proxies/${encodeURIComponent(proxyId)}/keyframes/`,
  params: { assetId, proxyId },
  body,
  headers,
});

/**
 * `POST /v1/assets/{asset_id}/proxies/{proxy_id}/multipart/cleanup/`
 *
 * Cleanup S3 multipart upload
 *
 * Required roles:
 *  - can_write_proxies
 *
 * Responses
 * - 200 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__proxies__proxy_id__multipart_cleanup_}
 */
export const httpPostAssetsByAssetIdProxiesByProxyIdMultipartCleanup = (
  assetId: string,
  proxyId: string,
  body: FilesMultipartUploadProxyCleanupSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdProxiesByProxyIdMultipartCleanup,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/proxies/${encodeURIComponent(proxyId)}/multipart/cleanup/`,
  params: { assetId, proxyId },
  body,
  headers,
});

export interface FilesHttpGetAssetsByAssetIdProxiesByProxyIdMultipartUrlQuery {
  /**
   * Multipart UploadId
   */
  upload_id: string;
  /**
   * List of multipart upload urls of required type
   */
  type?: string;
  /**
   * Maximum PartNumber that multipart upload has
   */
  max_part_number?: number;
}

/**
 * `GET /v1/assets/{asset_id}/proxies/{proxy_id}/multipart_url/`
 *
 * Get presigned urls for S3 multipart upload.
 *
 * Required roles:
 *  - can_write_proxies
 *
 * Responses
 * - 200 - Returns presigned urls for multipart upload
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesMultiPartURLsSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__proxies__proxy_id__multipart_url_}
 */
export const httpGetAssetsByAssetIdProxiesByProxyIdMultipartUrl = (
  assetId: string,
  proxyId: string,
  query?: FilesHttpGetAssetsByAssetIdProxiesByProxyIdMultipartUrlQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdProxiesByProxyIdMultipartUrl,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/proxies/${encodeURIComponent(proxyId)}/multipart_url/`,
  params: { assetId, proxyId },
  query,
  headers,
});

export interface FilesHttpGetAssetsByAssetIdProxiesByProxyIdMultipartUrlPartQuery {
  /**
   * Multipart UploadId
   */
  upload_id?: string;
  /**
   * Number of parts to upload
   */
  parts_num: number;
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Which page number to fetch
   */
  page?: number;
}

/**
 * `GET /v1/assets/{asset_id}/proxies/{proxy_id}/multipart_url/part/`
 *
 * Get presigned urls for S3 multipart part upload.
 *
 * Required roles:
 *  - can_write_proxies
 *
 * Responses
 * - 200 - Returns presigned urls for multipart part upload
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesMultiPartUploadURLsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__proxies__proxy_id__multipart_url_part_}
 */
export const httpGetAssetsByAssetIdProxiesByProxyIdMultipartUrlPart = (
  assetId: string,
  proxyId: string,
  query?: FilesHttpGetAssetsByAssetIdProxiesByProxyIdMultipartUrlPartQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdProxiesByProxyIdMultipartUrlPart,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/proxies/${encodeURIComponent(proxyId)}/multipart_url/part/`,
  params: { assetId, proxyId },
  query,
  headers,
});

/**
 * `DELETE /v1/assets/{asset_id}/proxies/{proxy_id}/public/`
 *
 * Make the proxy link private
 *
 * Required roles:
 *  - can_write_proxies
 *
 * Responses
 * - 201 - Returns a proxy that was updated
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesProxySchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_assets__asset_id__proxies__proxy_id__public_}
 */
export const httpDeleteAssetsByAssetIdProxiesByProxyIdPublic = (
  assetId: string,
  proxyId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteAssetsByAssetIdProxiesByProxyIdPublic,
  method: httpMethod.delete,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/proxies/${encodeURIComponent(proxyId)}/public/`,
  params: { assetId, proxyId },
  headers,
});

/**
 * `POST /v1/assets/{asset_id}/proxies/{proxy_id}/public/`
 *
 * Make the proxy link public
 *
 * Required roles:
 *  - can_write_proxies
 *
 * Responses
 * - 201 - Returns a proxy that was updated
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesProxySchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__proxies__proxy_id__public_}
 */
export const httpPostAssetsByAssetIdProxiesByProxyIdPublic = (
  assetId: string,
  proxyId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdProxiesByProxyIdPublic,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/proxies/${encodeURIComponent(proxyId)}/public/`,
  params: { assetId, proxyId },
  headers,
});

export interface FilesHttpDeleteAssetsByAssetIdSegmentsBySegmentIdAttachmentsQuery {
  /**
   * Set to false to not have the segment's has_attachments updated, or
   * the segment reindexed, afterwards, e.g. when the segment itself has
   * already been deleted
   *
   */
  reindex?: boolean;
}

/**
 * `DELETE /v1/assets/{asset_id}/segments/{segment_id}/attachments/`
 *
 * Delete all of a segment's attachments
 *
 * Required roles:
 *  - can_write_segments
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Not allowed to change another user's comment
 * - 404 - Segment doesn't exist for this asset, or is not a comment
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_assets__asset_id__segments__segment_id__attachments_}
 */
export const httpDeleteAssetsByAssetIdSegmentsBySegmentIdAttachments = (
  assetId: string,
  segmentId: string,
  query?: FilesHttpDeleteAssetsByAssetIdSegmentsBySegmentIdAttachmentsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteAssetsByAssetIdSegmentsBySegmentIdAttachments,
  method: httpMethod.delete,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/segments/${encodeURIComponent(segmentId)}/attachments/`,
  params: { assetId, segmentId },
  query,
  headers,
});

export interface FilesHttpGetAssetsByAssetIdSegmentsBySegmentIdAttachmentsQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Set to false if you don't need a URL, will speed things up
   */
  generate_signed_url?: boolean;
  /**
   * Set to attachment to force a download instead of inline display
   */
  content_disposition?: string;
  /**
   * ID of a last attachment on previous page
   */
  last_id?: string;
}

/**
 * `GET /v1/assets/{asset_id}/segments/{segment_id}/attachments/`
 *
 * Get all attachments for a segment
 *
 * Required roles:
 *  - can_read_assets
 * - can_read_segments
 *
 * Responses
 * - 200 - Returns all attachments associated with this segment
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - No such segment on this asset, not a comment
 *
 * Response {@link FilesAttachmentsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__segments__segment_id__attachments_}
 */
export const httpGetAssetsByAssetIdSegmentsBySegmentIdAttachments = (
  assetId: string,
  segmentId: string,
  query?: FilesHttpGetAssetsByAssetIdSegmentsBySegmentIdAttachmentsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdSegmentsBySegmentIdAttachments,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/segments/${encodeURIComponent(segmentId)}/attachments/`,
  params: { assetId, segmentId },
  query,
  headers,
});

export interface FilesHttpPostAssetsByAssetIdSegmentsBySegmentIdAttachmentsQuery {
  /**
   * Set to True to get a google resumable upload link
   */
  use_google_resumable_upload?: boolean;
}

/**
 * `POST /v1/assets/{asset_id}/segments/{segment_id}/attachments/`
 *
 * Create an attachment and associate it with a segment
 *
 * Required roles:
 *  - can_write_segments
 *
 * Responses
 * - 201 - Returns the attachment that was created for this segment
 * - 400 - Bad request, or the segment is not a comment
 * - 401 - Token is invalid
 * - 403 - Not allowed to change another user's comment
 * - 404 - Segment doesn't exist for this asset
 *
 * Response {@link FilesAttachmentCreateSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__segments__segment_id__attachments_}
 */
export const httpPostAssetsByAssetIdSegmentsBySegmentIdAttachments = (
  assetId: string,
  segmentId: string,
  body: FilesAttachmentCreateSchema,
  query?: FilesHttpPostAssetsByAssetIdSegmentsBySegmentIdAttachmentsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdSegmentsBySegmentIdAttachments,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/segments/${encodeURIComponent(segmentId)}/attachments/`,
  params: { assetId, segmentId },
  body,
  query,
  headers,
});

/**
 * `DELETE /v1/assets/{asset_id}/segments/{segment_id}/attachments/{attachment_id}/`
 *
 * Delete a segment's attachment
 *
 * Required roles:
 *  - can_write_segments
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Not allowed to change another user's comment
 * - 404 - Attachment for this segment doesn't exist, or the segment is not a comment
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_assets__asset_id__segments__segment_id__attachments__attachment_id__}
 */
export const httpDeleteAssetsByAssetIdSegmentsBySegmentIdAttachmentsByAttachmentId =
  (
    assetId: string,
    segmentId: string,
    attachmentId: string,
    headers?: IconikApiHeaders,
  ) => ({
    id: FilesHttpDeleteAssetsByAssetIdSegmentsBySegmentIdAttachmentsByAttachmentId,
    method: httpMethod.delete,
    url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/segments/${encodeURIComponent(segmentId)}/attachments/${encodeURIComponent(attachmentId)}/`,
    params: { assetId, segmentId, attachmentId },
    headers,
  });

export interface FilesHttpGetAssetsByAssetIdSegmentsBySegmentIdAttachmentsByAttachmentIdQuery {
  /**
   * Set to attachment if you do not want a download link
   */
  content_disposition?: string;
  /**
   * Content type to add to the pre-signed upload url
   */
  content_type?: string;
}

/**
 * `GET /v1/assets/{asset_id}/segments/{segment_id}/attachments/{attachment_id}/`
 *
 * Get a segment's attachment
 *
 * Required roles:
 *  - can_read_assets
 * - can_read_segments
 *
 * Responses
 * - 200 - Returns the attachment
 * - 401 - Token is invalid
 * - 404 - No such attachment, segment is not a comment
 *
 * Response {@link FilesAttachmentSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__segments__segment_id__attachments__attachment_id__}
 */
export const httpGetAssetsByAssetIdSegmentsBySegmentIdAttachmentsByAttachmentId =
  (
    assetId: string,
    segmentId: string,
    attachmentId: string,
    query?: FilesHttpGetAssetsByAssetIdSegmentsBySegmentIdAttachmentsByAttachmentIdQuery,
    headers?: IconikApiHeaders,
  ) => ({
    id: FilesHttpGetAssetsByAssetIdSegmentsBySegmentIdAttachmentsByAttachmentId,
    method: httpMethod.get,
    url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/segments/${encodeURIComponent(segmentId)}/attachments/${encodeURIComponent(attachmentId)}/`,
    params: { assetId, segmentId, attachmentId },
    query,
    headers,
  });

export type FilesAttachmentUpdateSchemaPartial =
  Partial<FilesAttachmentUpdateSchema>;

/**
 * `PATCH /v1/assets/{asset_id}/segments/{segment_id}/attachments/{attachment_id}/`
 *
 * Update attachment information
 *
 * Required roles:
 *  - can_write_segments
 *
 * Responses
 * - 200 - Returns the attachment that was updated
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Not allowed to change another user's comment
 * - 404 - Attachment for this segment doesn't exist, or the segment is not a comment
 *
 * Response {@link FilesAttachmentSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/patch_v1_assets__asset_id__segments__segment_id__attachments__attachment_id__}
 */
export const httpPatchAssetsByAssetIdSegmentsBySegmentIdAttachmentsByAttachmentId =
  (
    assetId: string,
    segmentId: string,
    attachmentId: string,
    body: FilesAttachmentUpdateSchemaPartial,
    headers?: IconikApiHeaders,
  ) => ({
    id: FilesHttpPatchAssetsByAssetIdSegmentsBySegmentIdAttachmentsByAttachmentId,
    method: httpMethod.patch,
    url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/segments/${encodeURIComponent(segmentId)}/attachments/${encodeURIComponent(attachmentId)}/`,
    params: { assetId, segmentId, attachmentId },
    body,
    headers,
  });

/**
 * `PUT /v1/assets/{asset_id}/segments/{segment_id}/attachments/{attachment_id}/`
 *
 * Update attachment information
 *
 * Required roles:
 *  - can_write_segments
 *
 * Responses
 * - 200 - Returns the attachment that was updated
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Not allowed to change another user's comment
 * - 404 - Attachment for this segment doesn't exist, or the segment is not a comment
 *
 * Response {@link FilesAttachmentSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/put_v1_assets__asset_id__segments__segment_id__attachments__attachment_id__}
 */
export const httpPutAssetsByAssetIdSegmentsBySegmentIdAttachmentsByAttachmentId =
  (
    assetId: string,
    segmentId: string,
    attachmentId: string,
    body: FilesAttachmentUpdateSchema,
    headers?: IconikApiHeaders,
  ) => ({
    id: FilesHttpPutAssetsByAssetIdSegmentsBySegmentIdAttachmentsByAttachmentId,
    method: httpMethod.put,
    url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/segments/${encodeURIComponent(segmentId)}/attachments/${encodeURIComponent(attachmentId)}/`,
    params: { assetId, segmentId, attachmentId },
    body,
    headers,
  });

export interface FilesHttpGetAssetsByAssetIdSubtitlesQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * ID of a last subtitle on previous page
   */
  last_id?: string;
}

/**
 * `GET /v1/assets/{asset_id}/subtitles/`
 *
 * Get all asset's subtitles
 *
 * Required roles:
 *  - can_read_asset_subtitles
 *
 * Responses
 * - 200 - Returns all subtitles associated with this asset
 * - 401 - Token is invalid
 * - 404 - Subtitles for this asset don't exist
 *
 * Response {@link FilesSubtitlesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__subtitles_}
 */
export const httpGetAssetsByAssetIdSubtitles = (
  assetId: string,
  query?: FilesHttpGetAssetsByAssetIdSubtitlesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdSubtitles,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/subtitles/`,
  params: { assetId },
  query,
  headers,
});

export type FilesSubtitleSchemaOptionalId = PartialBy<
  FilesSubtitleSchema,
  'id'
>;

/**
 * `POST /v1/assets/{asset_id}/subtitles/`
 *
 * Create subtitle proxy and associate to asset
 *
 * Required roles:
 *  - can_write_asset_subtitles
 *
 * Responses
 * - 201 - Returns a format that was created for this asset
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesSubtitleSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__subtitles_}
 */
export const httpPostAssetsByAssetIdSubtitles = (
  assetId: string,
  body: FilesSubtitleSchemaOptionalId,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdSubtitles,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/subtitles/`,
  params: { assetId },
  body,
  headers,
});

/**
 * `GET /v1/assets/{asset_id}/subtitles/{language}/`
 *
 * Get asset's subtitle for a particular language
 *
 * Required roles:
 *  - can_read_asset_subtitles
 *
 * Responses
 * - 200 - Returns a format associated with this asset
 * - 401 - Token is invalid
 * - 404 - Subtitle for this asset doesn't exist
 *
 * Response {@link FilesSubtitleSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__subtitles__language__}
 */
export const httpGetAssetsByAssetIdSubtitlesByLanguage = (
  assetId: string,
  language: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdSubtitlesByLanguage,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/subtitles/${encodeURIComponent(language)}/`,
  params: { assetId, language },
  headers,
});

/**
 * `GET /v1/assets/{asset_id}/subtitles/{language}/cc/`
 *
 * Get asset's closed captions subtitle for a particular language
 *
 * Required roles:
 *  - can_read_asset_subtitles
 *
 * Responses
 * - 200 - Returns a subtitle associated with this asset
 * - 401 - Token is invalid
 * - 404 - Subtitle for this asset doesn't exist
 *
 * Response {@link FilesSubtitleSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__subtitles__language__cc_}
 */
export const httpGetAssetsByAssetIdSubtitlesByLanguageCc = (
  assetId: string,
  language: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdSubtitlesByLanguageCc,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/subtitles/${encodeURIComponent(language)}/cc/`,
  params: { assetId, language },
  headers,
});

/**
 * Returns a subtitle file associated with this asset in a particular language
 */
export type FilesHttpGetAssetsByAssetIdSubtitlesByLanguageCcWebvttResponse =
  string;

/**
 * `GET /v1/assets/{asset_id}/subtitles/{language}/cc/webvtt/`
 *
 * Get asset's closed captions subtitle file for a particular language
 *
 * Required roles:
 *  - can_read_asset_subtitles
 *
 * Responses
 * - 200 - Returns a subtitle file associated with this asset in a particular language
 * - 401 - Token is invalid
 * - 404 - Subtitle for this asset doesn't exist
 *
 * Response {@link FilesHttpGetAssetsByAssetIdSubtitlesByLanguageCcWebvttResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__subtitles__language__cc_webvtt_}
 */
export const httpGetAssetsByAssetIdSubtitlesByLanguageCcWebvtt = (
  assetId: string,
  language: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdSubtitlesByLanguageCcWebvtt,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/subtitles/${encodeURIComponent(language)}/cc/webvtt/`,
  params: { assetId, language },
  headers,
});

/**
 * Returns a subtitle file associated with this asset in a particular language
 */
export type FilesHttpGetAssetsByAssetIdSubtitlesByLanguageWebvttResponse =
  string;

/**
 * `GET /v1/assets/{asset_id}/subtitles/{language}/webvtt/`
 *
 * Get asset's subtitle file for a particular language
 *
 * Required roles:
 *  - can_read_asset_subtitles
 *
 * Responses
 * - 200 - Returns a subtitle file associated with this asset in a particular language
 * - 401 - Token is invalid
 * - 404 - Subtitle for this asset doesn't exist
 *
 * Response {@link FilesHttpGetAssetsByAssetIdSubtitlesByLanguageWebvttResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__subtitles__language__webvtt_}
 */
export const httpGetAssetsByAssetIdSubtitlesByLanguageWebvtt = (
  assetId: string,
  language: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdSubtitlesByLanguageWebvtt,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/subtitles/${encodeURIComponent(language)}/webvtt/`,
  params: { assetId, language },
  headers,
});

/**
 * `DELETE /v1/assets/{asset_id}/subtitles/{subtitle_id}/`
 *
 * Delete asset's subtitle
 *
 * Required roles:
 *  - can_delete_assets
 *
 * Responses
 * - 204 - Without body
 * - 401 - Token is invalid
 * - 404 - Subtitle for this asset doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_assets__asset_id__subtitles__subtitle_id__}
 */
export const httpDeleteAssetsByAssetIdSubtitlesBySubtitleId = (
  assetId: string,
  subtitleId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteAssetsByAssetIdSubtitlesBySubtitleId,
  method: httpMethod.delete,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/subtitles/${encodeURIComponent(subtitleId)}/`,
  params: { assetId, subtitleId },
  headers,
});

/**
 * `GET /v1/assets/{asset_id}/subtitles/{subtitle_id}/`
 *
 * Get asset's subtitle for a language
 *
 * Required roles:
 *  - can_read_asset_subtitles
 *
 * Responses
 * - 200 - Returns a subtitle associated with this asset
 * - 401 - Token is invalid
 * - 404 - Subtitle for this asset doesn't exist
 *
 * Response {@link FilesSubtitleSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__subtitles__subtitle_id__}
 */
export const httpGetAssetsByAssetIdSubtitlesBySubtitleId = (
  assetId: string,
  subtitleId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdSubtitlesBySubtitleId,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/subtitles/${encodeURIComponent(subtitleId)}/`,
  params: { assetId, subtitleId },
  headers,
});

export type FilesSubtitleSchemaPartial = Partial<FilesSubtitleSchema>;

/**
 * `PATCH /v1/assets/{asset_id}/subtitles/{subtitle_id}/`
 *
 * Update subtitle information
 *
 * Required roles:
 *  - can_write_asset_subtitles
 *
 * Responses
 * - 200 - Returns a subtitle that was updated
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Subtitle for this asset doesn't exist
 *
 * Response {@link FilesSubtitleSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/patch_v1_assets__asset_id__subtitles__subtitle_id__}
 */
export const httpPatchAssetsByAssetIdSubtitlesBySubtitleId = (
  assetId: string,
  subtitleId: string,
  body: FilesSubtitleSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPatchAssetsByAssetIdSubtitlesBySubtitleId,
  method: httpMethod.patch,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/subtitles/${encodeURIComponent(subtitleId)}/`,
  params: { assetId, subtitleId },
  body,
  headers,
});

/**
 * `PUT /v1/assets/{asset_id}/subtitles/{subtitle_id}/`
 *
 * Update subtitle information
 *
 * Required roles:
 *  - can_write_asset_subtitles
 *
 * Responses
 * - 200 - Returns a subtitle that was updated
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Subtitle for this asset doesn't exist
 *
 * Response {@link FilesSubtitleSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/put_v1_assets__asset_id__subtitles__subtitle_id__}
 */
export const httpPutAssetsByAssetIdSubtitlesBySubtitleId = (
  assetId: string,
  subtitleId: string,
  body: FilesSubtitleSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPutAssetsByAssetIdSubtitlesBySubtitleId,
  method: httpMethod.put,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/subtitles/${encodeURIComponent(subtitleId)}/`,
  params: { assetId, subtitleId },
  body,
  headers,
});

/**
 * `DELETE /v1/assets/{asset_id}/subtitles/{subtitle_id}/cc/`
 *
 * Delete asset's subtitle
 *
 * Required roles:
 *  - can_delete_assets
 *
 * Responses
 * - 204 - Without body
 * - 401 - Token is invalid
 * - 404 - Subtitle for this asset doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_assets__asset_id__subtitles__subtitle_id__cc_}
 */
export const httpDeleteAssetsByAssetIdSubtitlesBySubtitleIdCc = (
  assetId: string,
  subtitleId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteAssetsByAssetIdSubtitlesBySubtitleIdCc,
  method: httpMethod.delete,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/subtitles/${encodeURIComponent(subtitleId)}/cc/`,
  params: { assetId, subtitleId },
  headers,
});

/**
 * `POST /v1/assets/{asset_id}/temporary_file_sets/`
 *
 * Create temporary file set and associate to asset
 *
 * Required roles:
 *  - can_write_files
 *
 * Responses
 * - 201 - Returns a file set that was created for this asset
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesTemporaryFileSetSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__temporary_file_sets_}
 */
export const httpPostAssetsByAssetIdTemporaryFileSets = (
  assetId: string,
  body: FilesTemporaryFileSetSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdTemporaryFileSets,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/temporary_file_sets/`,
  params: { assetId },
  body,
  headers,
});

export interface FilesHttpDeleteAssetsByAssetIdTemporaryFileSetsByFileSetIdQuery {
  delete_cloud_objects?: boolean;
}

/**
 * `DELETE /v1/assets/{asset_id}/temporary_file_sets/{file_set_id}/`
 *
 * Delete temporary file set with files
 *
 * Required roles:
 *  - can_delete_files
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - File set for this asset doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_assets__asset_id__temporary_file_sets__file_set_id__}
 */
export const httpDeleteAssetsByAssetIdTemporaryFileSetsByFileSetId = (
  assetId: string,
  fileSetId: string,
  query?: FilesHttpDeleteAssetsByAssetIdTemporaryFileSetsByFileSetIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteAssetsByAssetIdTemporaryFileSetsByFileSetId,
  method: httpMethod.delete,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/temporary_file_sets/${encodeURIComponent(fileSetId)}/`,
  params: { assetId, fileSetId },
  query,
  headers,
});

export interface FilesHttpGetAssetsByAssetIdTemporaryFileSetsByFileSetIdFilesQuery {
  /**
   * Set to false if you don't need a URL, will speed things up
   */
  generate_signed_url?: boolean;
}

/**
 * `GET /v1/assets/{asset_id}/temporary_file_sets/{file_set_id}/files/`
 *
 * Get files from a temporary file set
 *
 * Required roles:
 *  - can_read_files
 *
 * Responses
 * - 200 - Returns files from a file set
 *
 * Response {@link FilesFilesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__temporary_file_sets__file_set_id__files_}
 */
export const httpGetAssetsByAssetIdTemporaryFileSetsByFileSetIdFiles = (
  assetId: string,
  fileSetId: string,
  query?: FilesHttpGetAssetsByAssetIdTemporaryFileSetsByFileSetIdFilesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdTemporaryFileSetsByFileSetIdFiles,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/temporary_file_sets/${encodeURIComponent(fileSetId)}/files/`,
  params: { assetId, fileSetId },
  query,
  headers,
});

export interface FilesHttpPostAssetsByAssetIdTemporaryFilesQuery {
  store?: boolean;
}

/**
 * `POST /v1/assets/{asset_id}/temporary_files/`
 *
 * Create temporary transfer file for FILE storage transfers
 *
 * Required roles:
 *  - can_write_files
 *
 * Responses
 * - 201 - Returns a file that was created for this asset
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesTemporaryFileCreateSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__temporary_files_}
 */
export const httpPostAssetsByAssetIdTemporaryFiles = (
  assetId: string,
  body: FilesTemporaryFileCreateSchema,
  query?: FilesHttpPostAssetsByAssetIdTemporaryFilesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdTemporaryFiles,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/temporary_files/`,
  params: { assetId },
  body,
  query,
  headers,
});

/**
 * `PATCH /v1/assets/{asset_id}/temporary_files/{file_id}/`
 *
 * Update temporary file's info
 *
 * Required roles:
 *  - can_write_files
 *
 * Responses
 * - 200 - Returns updated file
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Asset access denied
 * - 404 - No file found
 *
 * Response {@link FilesFileSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/patch_v1_assets__asset_id__temporary_files__file_id__}
 */
export const httpPatchAssetsByAssetIdTemporaryFilesByFileId = (
  assetId: string,
  fileId: string,
  body: FilesFileSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPatchAssetsByAssetIdTemporaryFilesByFileId,
  method: httpMethod.patch,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/temporary_files/${encodeURIComponent(fileId)}/`,
  params: { assetId, fileId },
  body,
  headers,
});

/**
 * `PUT /v1/assets/{asset_id}/temporary_files/{file_id}/`
 *
 * Update temporary file's info
 *
 * Required roles:
 *  - can_write_files
 *
 * Responses
 * - 200 - Returns updated file
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Asset access denied
 * - 404 - No file found
 *
 * Response {@link FilesFileSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/put_v1_assets__asset_id__temporary_files__file_id__}
 */
export const httpPutAssetsByAssetIdTemporaryFilesByFileId = (
  assetId: string,
  fileId: string,
  body: FilesFileSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPutAssetsByAssetIdTemporaryFilesByFileId,
  method: httpMethod.put,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/temporary_files/${encodeURIComponent(fileId)}/`,
  params: { assetId, fileId },
  body,
  headers,
});

export interface FilesHttpDeleteAssetsByAssetIdVersionsAllFileSetsQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * ID of a last file set on previous page
   */
  last_id?: string;
}

/**
 * `DELETE /v1/assets/{asset_id}/versions/all/file_sets/`
 *
 * Delete asset's file sets
 *
 * Required roles:
 *  - can_delete_files
 *
 * Responses
 * - 200 - File sets were scheduled for deletion
 * - 401 - Token is invalid
 * - 404 - FileSets for this asset don't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_assets__asset_id__versions_all_file_sets_}
 */
export const httpDeleteAssetsByAssetIdVersionsAllFileSets = (
  assetId: string,
  query?: FilesHttpDeleteAssetsByAssetIdVersionsAllFileSetsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteAssetsByAssetIdVersionsAllFileSets,
  method: httpMethod.delete,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/versions/all/file_sets/`,
  params: { assetId },
  query,
  headers,
});

/**
 * `DELETE /v1/assets/{asset_id}/versions/all/files/`
 *
 * Delete asset's files entries by version (Not the actual file, use DELETE file_set for that)
 *
 * Required roles:
 *  - can_delete_files
 *
 * Responses
 * - 204 - Without body
 * - 401 - Token is invalid
 * - 404 - File for this asset doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_assets__asset_id__versions_all_files_}
 */
export const httpDeleteAssetsByAssetIdVersionsAllFiles = (
  assetId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteAssetsByAssetIdVersionsAllFiles,
  method: httpMethod.delete,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/versions/all/files/`,
  params: { assetId },
  headers,
});

export interface FilesHttpDeleteAssetsByAssetIdVersionsAllFormatsQuery {
  /**
   * Permanently delete format without sending it to the Recycle Bin
   */
  immediately?: boolean;
}

/**
 * `DELETE /v1/assets/{asset_id}/versions/all/formats/`
 *
 * Delete asset's formats all versions
 *
 * Required roles:
 *  - can_delete_formats
 *
 * Responses
 * - 200 - Formats were scheduled for deletion
 * - 204 - Without body in case `immediately` option was provided
 * - 401 - Token is invalid
 * - 404 - Format for this asset doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_assets__asset_id__versions_all_formats_}
 */
export const httpDeleteAssetsByAssetIdVersionsAllFormats = (
  assetId: string,
  query?: FilesHttpDeleteAssetsByAssetIdVersionsAllFormatsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteAssetsByAssetIdVersionsAllFormats,
  method: httpMethod.delete,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/versions/all/formats/`,
  params: { assetId },
  query,
  headers,
});

/**
 * `DELETE /v1/assets/{asset_id}/versions/all/keyframes/`
 *
 * Delete asset's keyframes all versions
 *
 * Required roles:
 *  - can_write_keyframes
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Keyframe for this asset don't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_assets__asset_id__versions_all_keyframes_}
 */
export const httpDeleteAssetsByAssetIdVersionsAllKeyframes = (
  assetId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteAssetsByAssetIdVersionsAllKeyframes,
  method: httpMethod.delete,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/versions/all/keyframes/`,
  params: { assetId },
  headers,
});

/**
 * `DELETE /v1/assets/{asset_id}/versions/all/proxies/`
 *
 * Delete asset's proxies all versions
 *
 * Required roles:
 *  - can_delete_proxies
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Proxy for this asset doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_assets__asset_id__versions_all_proxies_}
 */
export const httpDeleteAssetsByAssetIdVersionsAllProxies = (
  assetId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteAssetsByAssetIdVersionsAllProxies,
  method: httpMethod.delete,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/versions/all/proxies/`,
  params: { assetId },
  headers,
});

/**
 * `DELETE /v1/assets/{asset_id}/versions/all/subtitles/`
 *
 * Delete asset's subtitles all versions
 *
 * Required roles:
 *  - can_delete_assets
 *
 * Responses
 * - 204 - Without body
 * - 401 - Token is invalid
 * - 404 - Subtitle for this asset doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_assets__asset_id__versions_all_subtitles_}
 */
export const httpDeleteAssetsByAssetIdVersionsAllSubtitles = (
  assetId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteAssetsByAssetIdVersionsAllSubtitles,
  method: httpMethod.delete,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/versions/all/subtitles/`,
  params: { assetId },
  headers,
});

export interface FilesHttpDeleteAssetsByAssetIdVersionsByVersionIdFileSetsQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * ID of a last file set on previous page
   */
  last_id?: string;
}

/**
 * `DELETE /v1/assets/{asset_id}/versions/{version_id}/file_sets/`
 *
 * Delete asset's file sets by version
 *
 * Required roles:
 *  - can_delete_files
 *
 * Responses
 * - 200 - File sets were scheduled for deletion
 * - 401 - Token is invalid
 * - 404 - FileSets for this asset don't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_assets__asset_id__versions__version_id__file_sets_}
 */
export const httpDeleteAssetsByAssetIdVersionsByVersionIdFileSets = (
  assetId: string,
  versionId: string,
  query?: FilesHttpDeleteAssetsByAssetIdVersionsByVersionIdFileSetsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteAssetsByAssetIdVersionsByVersionIdFileSets,
  method: httpMethod.delete,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/file_sets/`,
  params: { assetId, versionId },
  query,
  headers,
});

export interface FilesHttpGetAssetsByAssetIdVersionsByVersionIdFileSetsQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * ID of a last file set on previous page
   */
  last_id?: string;
  /**
   * Set to true if you need a total amount of files in a file set
   */
  file_count?: boolean;
}

/**
 * `GET /v1/assets/{asset_id}/versions/{version_id}/file_sets/`
 *
 * Get all asset's file sets by version
 *
 * Required roles:
 *  - can_read_files
 *
 * Responses
 * - 200 - Returns all file sets associated with this asset
 * - 401 - Token is invalid
 * - 404 - FileSets for this asset don't exist
 *
 * Response {@link FilesFileSetsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__versions__version_id__file_sets_}
 */
export const httpGetAssetsByAssetIdVersionsByVersionIdFileSets = (
  assetId: string,
  versionId: string,
  query?: FilesHttpGetAssetsByAssetIdVersionsByVersionIdFileSetsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdVersionsByVersionIdFileSets,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/file_sets/`,
  params: { assetId, versionId },
  query,
  headers,
});

/**
 * `DELETE /v1/assets/{asset_id}/versions/{version_id}/files/`
 *
 * Delete asset's files entries by version (Not the actual file, use DELETE file_set for that)
 *
 * Required roles:
 *  - can_delete_files
 *
 * Responses
 * - 204 - Without body
 * - 401 - Token is invalid
 * - 404 - File for this asset doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_assets__asset_id__versions__version_id__files_}
 */
export const httpDeleteAssetsByAssetIdVersionsByVersionIdFiles = (
  assetId: string,
  versionId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteAssetsByAssetIdVersionsByVersionIdFiles,
  method: httpMethod.delete,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/files/`,
  params: { assetId, versionId },
  headers,
});

export interface FilesHttpGetAssetsByAssetIdVersionsByVersionIdFilesQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Set to False if you do not need a URL, will slow things down otherwise
   */
  generate_signed_url?: boolean;
  /**
   * Set to attachment if you want a download link. Note that this will not create a download in asset history
   *
   */
  content_disposition?: string;
  /**
   * ID of a last file on previous page
   */
  last_id?: string;
}

/**
 * `GET /v1/assets/{asset_id}/versions/{version_id}/files/`
 *
 * Get all asset's files by version
 *
 * Required roles:
 *  - can_read_files
 *
 * Responses
 * - 200 - Returns all files associated with this asset
 * - 401 - Token is invalid
 * - 404 - Files for this asset don't exist
 *
 * Response {@link FilesFilesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__versions__version_id__files_}
 */
export const httpGetAssetsByAssetIdVersionsByVersionIdFiles = (
  assetId: string,
  versionId: string,
  query?: FilesHttpGetAssetsByAssetIdVersionsByVersionIdFilesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdVersionsByVersionIdFiles,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/files/`,
  params: { assetId, versionId },
  query,
  headers,
});

export interface FilesHttpDeleteAssetsByAssetIdVersionsByVersionIdFormatsQuery {
  /**
   * Permanently delete format without sending it to the Recycle Bin
   */
  immediately?: boolean;
}

/**
 * `DELETE /v1/assets/{asset_id}/versions/{version_id}/formats/`
 *
 * Delete asset's formats by version
 *
 * Required roles:
 *  - can_delete_formats
 *
 * Responses
 * - 200 - Formats were scheduled for deletion
 * - 204 - Without body in case `immediately` option was provided
 * - 401 - Token is invalid
 * - 404 - Format for this asset doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_assets__asset_id__versions__version_id__formats_}
 */
export const httpDeleteAssetsByAssetIdVersionsByVersionIdFormats = (
  assetId: string,
  versionId: string,
  query?: FilesHttpDeleteAssetsByAssetIdVersionsByVersionIdFormatsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteAssetsByAssetIdVersionsByVersionIdFormats,
  method: httpMethod.delete,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/formats/`,
  params: { assetId, versionId },
  query,
  headers,
});

export interface FilesHttpGetAssetsByAssetIdVersionsByVersionIdFormatsQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * ID of a last format on previous page
   */
  last_id?: string;
}

/**
 * `GET /v1/assets/{asset_id}/versions/{version_id}/formats/`
 *
 * Get all asset's formats by version
 *
 * Required roles:
 *  - can_read_formats
 *
 * Responses
 * - 200 - Returns all formats associated with this asset
 * - 401 - Token is invalid
 * - 404 - Formats for this asset don't exist
 *
 * Response {@link FilesFormatsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__versions__version_id__formats_}
 */
export const httpGetAssetsByAssetIdVersionsByVersionIdFormats = (
  assetId: string,
  versionId: string,
  query?: FilesHttpGetAssetsByAssetIdVersionsByVersionIdFormatsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdVersionsByVersionIdFormats,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/formats/`,
  params: { assetId, versionId },
  query,
  headers,
});

export interface FilesHttpDeleteAssetsByAssetIdVersionsByVersionIdKeyframesQuery {
  keep_poster?: boolean;
}

/**
 * `DELETE /v1/assets/{asset_id}/versions/{version_id}/keyframes/`
 *
 * Delete asset's keyframes by version
 *
 * Required roles:
 *  - can_write_keyframes
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Keyframe for this asset don't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_assets__asset_id__versions__version_id__keyframes_}
 */
export const httpDeleteAssetsByAssetIdVersionsByVersionIdKeyframes = (
  assetId: string,
  versionId: string,
  query?: FilesHttpDeleteAssetsByAssetIdVersionsByVersionIdKeyframesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteAssetsByAssetIdVersionsByVersionIdKeyframes,
  method: httpMethod.delete,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/keyframes/`,
  params: { assetId, versionId },
  query,
  headers,
});

export interface FilesHttpGetAssetsByAssetIdVersionsByVersionIdKeyframesQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Set to false if you don't need a URL, will speed things up
   */
  generate_signed_url?: boolean;
  /**
   * Set to attachment if you do not want a download link
   */
  content_disposition?: string;
  /**
   * ID of a last keyframe on previous page
   */
  last_id?: string;
}

/**
 * `GET /v1/assets/{asset_id}/versions/{version_id}/keyframes/`
 *
 * Get all asset's keyframes by version
 *
 * Required roles:
 *  - can_read_assets
 *
 * Responses
 * - 200 - Returns all keyframes associated with this asset
 * - 401 - Token is invalid
 * - 404 - Keyframes for this asset don't exist
 *
 * Response {@link FilesKeyframesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__versions__version_id__keyframes_}
 */
export const httpGetAssetsByAssetIdVersionsByVersionIdKeyframes = (
  assetId: string,
  versionId: string,
  query?: FilesHttpGetAssetsByAssetIdVersionsByVersionIdKeyframesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdVersionsByVersionIdKeyframes,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/keyframes/`,
  params: { assetId, versionId },
  query,
  headers,
});

/**
 * `DELETE /v1/assets/{asset_id}/versions/{version_id}/proxies/`
 *
 * Delete asset's proxies by version
 *
 * Required roles:
 *  - can_delete_proxies
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Proxy for this asset doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_assets__asset_id__versions__version_id__proxies_}
 */
export const httpDeleteAssetsByAssetIdVersionsByVersionIdProxies = (
  assetId: string,
  versionId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteAssetsByAssetIdVersionsByVersionIdProxies,
  method: httpMethod.delete,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/proxies/`,
  params: { assetId, versionId },
  headers,
});

export interface FilesHttpGetAssetsByAssetIdVersionsByVersionIdProxiesQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Set to false if you don't need a URL, will speed things up
   */
  generate_signed_url?: boolean;
  /**
   * Set to attachment if you want a download link
   */
  content_disposition?: string;
  /**
   * ID of a last proxy on previous page
   */
  last_id?: string;
}

/**
 * `GET /v1/assets/{asset_id}/versions/{version_id}/proxies/`
 *
 * Get all asset's proxies by version
 *
 * Required roles:
 *  - can_read_proxies
 *
 * Responses
 * - 200 - Returns all proxies associated with this asset
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Proxies for this asset doesn't exist
 *
 * Response {@link FilesProxiesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__versions__version_id__proxies_}
 */
export const httpGetAssetsByAssetIdVersionsByVersionIdProxies = (
  assetId: string,
  versionId: string,
  query?: FilesHttpGetAssetsByAssetIdVersionsByVersionIdProxiesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdVersionsByVersionIdProxies,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/proxies/`,
  params: { assetId, versionId },
  query,
  headers,
});

export interface FilesHttpGetAssetsByAssetIdVersionsByVersionIdProxiesByProxyIdByManifestTypeQuery {
  path?: string;
  relative?: boolean;
  /**
   * Returns a direct cloud-storage signed URL instead of a storage-accessor URL. Signed URLs are bearer tokens that can be shared or reused until expiry and may bypass storage-accessor logging and access controls. Use only when this behavior is explicitly required.
   */
  presigned?: boolean;
  recreate?: boolean;
}

export interface FilesHttpGetAssetsByAssetIdVersionsByVersionIdProxiesByProxyIdByManifestTypeHeader
  extends IconikApiHeaders {
  DRM?: string;
  Watermark?: string;
}

/**
 * `GET /v1/assets/{asset_id}/versions/{version_id}/proxies/{proxy_id}/{manifest_type}/`
 *
 * Retrieve manifest/playlist for asset proxy
 *
 * Required roles:
 *  - can_read_proxies
 *
 * Responses
 * - 200 - Returns manifest/playlist for asset proxy or dictionary containing redirect url to playable media.
 * - 302 - Redirects to an equivalent HLS manifest when the requested DASH manifest is unavailable.
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 425 - media not ready for streaming
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__versions__version_id__proxies__proxy_id___manifest_type__}
 */
export const httpGetAssetsByAssetIdVersionsByVersionIdProxiesByProxyIdByManifestType =
  (
    assetId: string,
    versionId: string,
    proxyId: string,
    manifestType: string,
    query?: FilesHttpGetAssetsByAssetIdVersionsByVersionIdProxiesByProxyIdByManifestTypeQuery,
    headers?: FilesHttpGetAssetsByAssetIdVersionsByVersionIdProxiesByProxyIdByManifestTypeHeader,
  ) => ({
    id: FilesHttpGetAssetsByAssetIdVersionsByVersionIdProxiesByProxyIdByManifestType,
    method: httpMethod.get,
    url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/proxies/${encodeURIComponent(proxyId)}/${encodeURIComponent(manifestType)}/`,
    params: { assetId, versionId, proxyId, manifestType },
    query,
    headers,
  });

/**
 * `DELETE /v1/assets/{asset_id}/versions/{version_id}/subtitles/`
 *
 * Delete asset's subtitles by version
 *
 * Required roles:
 *  - can_delete_assets
 *
 * Responses
 * - 204 - Without body
 * - 401 - Token is invalid
 * - 404 - Subtitle for this asset doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_assets__asset_id__versions__version_id__subtitles_}
 */
export const httpDeleteAssetsByAssetIdVersionsByVersionIdSubtitles = (
  assetId: string,
  versionId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteAssetsByAssetIdVersionsByVersionIdSubtitles,
  method: httpMethod.delete,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/subtitles/`,
  params: { assetId, versionId },
  headers,
});

export interface FilesHttpGetAssetsByAssetIdVersionsByVersionIdSubtitlesQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * ID of a last subtitle on previous page
   */
  last_id?: string;
}

/**
 * `GET /v1/assets/{asset_id}/versions/{version_id}/subtitles/`
 *
 * Get all asset's subtitles by version
 *
 * Required roles:
 *  - can_read_asset_subtitles
 *
 * Responses
 * - 200 - Returns all subtitles associated with this asset
 * - 401 - Token is invalid
 * - 404 - Subtitles for this asset don't exist
 *
 * Response {@link FilesSubtitlesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__versions__version_id__subtitles_}
 */
export const httpGetAssetsByAssetIdVersionsByVersionIdSubtitles = (
  assetId: string,
  versionId: string,
  query?: FilesHttpGetAssetsByAssetIdVersionsByVersionIdSubtitlesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdVersionsByVersionIdSubtitles,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/subtitles/`,
  params: { assetId, versionId },
  query,
  headers,
});

/**
 * Returns a subtitle file associated with this asset in a particular language
 */
export type FilesHttpGetAssetsByAssetIdVersionsByVersionIdSubtitlesByLanguageCcWebvttResponse =
  string;

/**
 * `GET /v1/assets/{asset_id}/versions/{version_id}/subtitles/{language}/cc/webvtt/`
 *
 * Get asset's closed captions subtitle file for a particular language by version
 *
 * Required roles:
 *  - can_read_asset_subtitles
 *
 * Responses
 * - 200 - Returns a subtitle file associated with this asset in a particular language
 * - 401 - Token is invalid
 * - 404 - Subtitle for this asset doesn't exist
 *
 * Response {@link FilesHttpGetAssetsByAssetIdVersionsByVersionIdSubtitlesByLanguageCcWebvttResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__versions__version_id__subtitles__language__cc_webvtt_}
 */
export const httpGetAssetsByAssetIdVersionsByVersionIdSubtitlesByLanguageCcWebvtt =
  (
    assetId: string,
    versionId: string,
    language: string,
    headers?: IconikApiHeaders,
  ) => ({
    id: FilesHttpGetAssetsByAssetIdVersionsByVersionIdSubtitlesByLanguageCcWebvtt,
    method: httpMethod.get,
    url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/subtitles/${encodeURIComponent(language)}/cc/webvtt/`,
    params: { assetId, versionId, language },
    headers,
  });

/**
 * Returns a subtitle file associated with this asset in a particular language
 */
export type FilesHttpGetAssetsByAssetIdVersionsByVersionIdSubtitlesByLanguageWebvttResponse =
  string;

/**
 * `GET /v1/assets/{asset_id}/versions/{version_id}/subtitles/{language}/webvtt/`
 *
 * Get asset's subtitle file for a particular language by version
 *
 * Required roles:
 *  - can_read_asset_subtitles
 *
 * Responses
 * - 200 - Returns a subtitle file associated with this asset in a particular language
 * - 401 - Token is invalid
 * - 404 - Subtitle for this asset doesn't exist
 *
 * Response {@link FilesHttpGetAssetsByAssetIdVersionsByVersionIdSubtitlesByLanguageWebvttResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__versions__version_id__subtitles__language__webvtt_}
 */
export const httpGetAssetsByAssetIdVersionsByVersionIdSubtitlesByLanguageWebvtt =
  (
    assetId: string,
    versionId: string,
    language: string,
    headers?: IconikApiHeaders,
  ) => ({
    id: FilesHttpGetAssetsByAssetIdVersionsByVersionIdSubtitlesByLanguageWebvtt,
    method: httpMethod.get,
    url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/subtitles/${encodeURIComponent(language)}/webvtt/`,
    params: { assetId, versionId, language },
    headers,
  });

/**
 * `POST /v1/assets/{asset_id}/versions/{version_id}/transcode/`
 *
 * Create a transcode job for a specific asset version
 *
 * Required roles:
 *  - can_create_transcode_jobs
 *
 * Responses
 * - 200 - Transcode job created successfully
 * - 400 - Bad request
 * - 401 - Unauthorized
 * - 404 - Asset or version not found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_assets__asset_id__versions__version_id__transcode_}
 */
export const httpPostAssetsByAssetIdVersionsByVersionIdTranscode = (
  assetId: string,
  versionId: string,
  body: FilesTranscodeRequestSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostAssetsByAssetIdVersionsByVersionIdTranscode,
  method: httpMethod.post,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/transcode/`,
  params: { assetId, versionId },
  body,
  headers,
});

export interface FilesHttpGetAssetsByAssetIdWatermarkMatchesQuery {
  proxy_id?: string;
  version_id?: string;
}

/**
 * `GET /v1/assets/{asset_id}/watermark_matches/`
 *
 * Get all ProxyContainerByUser records for an asset's proxies,
 *
 * allowing matching against embedded watermarks.
 *
 * Responses
 * - 200 - Returns watermark match candidates
 * - 401 - Unauthorized
 * - 403 - Forbidden - requires admin
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_assets__asset_id__watermark_matches_}
 */
export const httpGetAssetsByAssetIdWatermarkMatches = (
  assetId: string,
  query?: FilesHttpGetAssetsByAssetIdWatermarkMatchesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetAssetsByAssetIdWatermarkMatches,
  method: httpMethod.get,
  url: `/API/files/v1/assets/${encodeURIComponent(assetId)}/watermark_matches/`,
  params: { assetId },
  query,
  headers,
});

export interface FilesHttpPostCollectionsByCollectionIdCustomKeyframeByPosterIdQuery {
  /**
   * set to false to keep current custom_poster and custom_keyframe on asset
   */
  overwrite?: boolean;
}

/**
 * `POST /v1/collections/{collection_id}/custom_keyframe/{poster_id}/`
 *
 * Set keyframe of type poster as collection keyframe
 *
 * Required roles:
 *  - can_write_keyframes
 *
 * Responses
 * - 201 - Returns custom keyframe
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesCollectionKeyframeSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_collections__collection_id__custom_keyframe__poster_id__}
 */
export const httpPostCollectionsByCollectionIdCustomKeyframeByPosterId = (
  collectionId: string,
  posterId: string,
  query?: FilesHttpPostCollectionsByCollectionIdCustomKeyframeByPosterIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostCollectionsByCollectionIdCustomKeyframeByPosterId,
  method: httpMethod.post,
  url: `/API/files/v1/collections/${encodeURIComponent(collectionId)}/custom_keyframe/${encodeURIComponent(posterId)}/`,
  params: { collectionId, posterId },
  query,
  headers,
});

export interface FilesHttpPostCollectionsByCollectionIdExportLocationsByExportLocationIdQuery {
  /**
   * Enable transfer through iconik host (creates egress)
   */
  allow_host_transfer?: boolean;
}

/**
 * `POST /v1/collections/{collection_id}/export_locations/{export_location_id}/`
 *
 * Export collection assets to export location
 *
 * Required roles:
 *  - can_write_exports
 *
 * Responses
 * - 200 - Returns an export job id
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_collections__collection_id__export_locations__export_location_id__}
 */
export const httpPostCollectionsByCollectionIdExportLocationsByExportLocationId =
  (
    collectionId: string,
    exportLocationId: string,
    body: FilesCollectionExportSchema,
    query?: FilesHttpPostCollectionsByCollectionIdExportLocationsByExportLocationIdQuery,
    headers?: IconikApiHeaders,
  ) => ({
    id: FilesHttpPostCollectionsByCollectionIdExportLocationsByExportLocationId,
    method: httpMethod.post,
    url: `/API/files/v1/collections/${encodeURIComponent(collectionId)}/export_locations/${encodeURIComponent(exportLocationId)}/`,
    params: { collectionId, exportLocationId },
    body,
    query,
    headers,
  });

export interface FilesHttpGetCollectionsByCollectionIdKeyframesQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Set to false if you don't need a URL, will speed things up
   */
  generate_signed_url?: boolean;
  /**
   * ID of a last collection keyframe on previous page
   */
  last_id?: string;
}

/**
 * `GET /v1/collections/{collection_id}/keyframes/`
 *
 * Get all collection's keyframes
 *
 * Required roles:
 *  - can_read_collections
 *
 * Responses
 * - 200 - Returns all keyframes associated with this collection
 * - 401 - Token is invalid
 * - 404 - Keyframes for this collection don't exist
 *
 * Response {@link FilesCollectionKeyframesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_collections__collection_id__keyframes_}
 */
export const httpGetCollectionsByCollectionIdKeyframes = (
  collectionId: string,
  query?: FilesHttpGetCollectionsByCollectionIdKeyframesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetCollectionsByCollectionIdKeyframes,
  method: httpMethod.get,
  url: `/API/files/v1/collections/${encodeURIComponent(collectionId)}/keyframes/`,
  params: { collectionId },
  query,
  headers,
});

/**
 * `POST /v1/collections/{collection_id}/keyframes/`
 *
 * Create keyframe and associate to collection
 *
 * Required roles:
 *  - can_write_keyframes
 *
 * Responses
 * - 201 - Returns a keyframe that was created for this collection
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesCollectionKeyframeCreateSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_collections__collection_id__keyframes_}
 */
export const httpPostCollectionsByCollectionIdKeyframes = (
  collectionId: string,
  body: FilesCollectionKeyframeCreateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostCollectionsByCollectionIdKeyframes,
  method: httpMethod.post,
  url: `/API/files/v1/collections/${encodeURIComponent(collectionId)}/keyframes/`,
  params: { collectionId },
  body,
  headers,
});

export type FilesCollectionCopyKeyframesRequestSchemaOptionalId = PartialBy<
  FilesCollectionCopyKeyframesRequestSchema,
  'id'
>;

/**
 * `POST /v1/collections/{collection_id}/keyframes/copy/`
 *
 * Copy collection keyframe to another collection
 *
 * Required roles:
 *  - can_write_keyframes
 *
 * Responses
 * - 201 - Returns all keyframe that were created for this collection
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesCollectionCopyKeyframesResponseSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_collections__collection_id__keyframes_copy_}
 */
export const httpPostCollectionsByCollectionIdKeyframesCopy = (
  collectionId: string,
  body: FilesCollectionCopyKeyframesRequestSchemaOptionalId,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostCollectionsByCollectionIdKeyframesCopy,
  method: httpMethod.post,
  url: `/API/files/v1/collections/${encodeURIComponent(collectionId)}/keyframes/copy/`,
  params: { collectionId },
  body,
  headers,
});

export interface FilesHttpDeleteCollectionsByCollectionIdKeyframesByKeyframeIdQuery {
  /**
   * set to true to force a regeneration of default keyframes
   */
  regenerate_keyframes?: boolean;
}

/**
 * `DELETE /v1/collections/{collection_id}/keyframes/{keyframe_id}/`
 *
 * Delete collection's keyframe
 *
 * Required roles:
 *  - can_write_keyframes
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Keyframe for this collection don't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_collections__collection_id__keyframes__keyframe_id__}
 */
export const httpDeleteCollectionsByCollectionIdKeyframesByKeyframeId = (
  collectionId: string,
  keyframeId: string,
  query?: FilesHttpDeleteCollectionsByCollectionIdKeyframesByKeyframeIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteCollectionsByCollectionIdKeyframesByKeyframeId,
  method: httpMethod.delete,
  url: `/API/files/v1/collections/${encodeURIComponent(collectionId)}/keyframes/${encodeURIComponent(keyframeId)}/`,
  params: { collectionId, keyframeId },
  query,
  headers,
});

/**
 * `GET /v1/collections/{collection_id}/keyframes/{keyframe_id}/`
 *
 * Get collection's proxy
 *
 * Required roles:
 *  - can_read_collections
 *
 * Responses
 * - 200 - Returns a keyframe associated with this collection
 * - 401 - Token is invalid
 * - 404 - Keyframe for this collection don't exist
 *
 * Response {@link FilesCollectionKeyframeSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_collections__collection_id__keyframes__keyframe_id__}
 */
export const httpGetCollectionsByCollectionIdKeyframesByKeyframeId = (
  collectionId: string,
  keyframeId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetCollectionsByCollectionIdKeyframesByKeyframeId,
  method: httpMethod.get,
  url: `/API/files/v1/collections/${encodeURIComponent(collectionId)}/keyframes/${encodeURIComponent(keyframeId)}/`,
  params: { collectionId, keyframeId },
  headers,
});

export type FilesCollectionKeyframeSchemaPartial =
  Partial<FilesCollectionKeyframeSchema>;

/**
 * `PATCH /v1/collections/{collection_id}/keyframes/{keyframe_id}/`
 *
 * Update keyframe information
 *
 * Required roles:
 *  - can_write_keyframes
 *
 * Responses
 * - 200 - Returns a keyframe that was updated
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Keyframe for this collection don't exist
 *
 * Response {@link FilesCollectionKeyframeSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/patch_v1_collections__collection_id__keyframes__keyframe_id__}
 */
export const httpPatchCollectionsByCollectionIdKeyframesByKeyframeId = (
  collectionId: string,
  keyframeId: string,
  body: FilesCollectionKeyframeSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPatchCollectionsByCollectionIdKeyframesByKeyframeId,
  method: httpMethod.patch,
  url: `/API/files/v1/collections/${encodeURIComponent(collectionId)}/keyframes/${encodeURIComponent(keyframeId)}/`,
  params: { collectionId, keyframeId },
  body,
  headers,
});

/**
 * `PUT /v1/collections/{collection_id}/keyframes/{keyframe_id}/`
 *
 * Update keyframe information
 *
 * Required roles:
 *  - can_write_keyframes
 *
 * Responses
 * - 200 - Returns a keyframe that was updated
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Keyframe for this collection don't exist
 *
 * Response {@link FilesCollectionKeyframeSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/put_v1_collections__collection_id__keyframes__keyframe_id__}
 */
export const httpPutCollectionsByCollectionIdKeyframesByKeyframeId = (
  collectionId: string,
  keyframeId: string,
  body: FilesCollectionKeyframeSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPutCollectionsByCollectionIdKeyframesByKeyframeId,
  method: httpMethod.put,
  url: `/API/files/v1/collections/${encodeURIComponent(collectionId)}/keyframes/${encodeURIComponent(keyframeId)}/`,
  params: { collectionId, keyframeId },
  body,
  headers,
});

/**
 * `DELETE /v1/delete_queue/file_sets/`
 *
 * Restore file sets from delete queue
 *
 * Required roles:
 *  - can_write_files
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_delete_queue_file_sets_}
 */
export const httpDeleteDeleteQueueFileSets = (
  body: FilesDeleteQueueSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteDeleteQueueFileSets,
  method: httpMethod.delete,
  url: '/API/files/v1/delete_queue/file_sets/',

  body,
  headers,
});

export interface FilesHttpGetDeleteQueueFileSetsQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * A comma separated list of fieldnames with order. For example - first_name,asc;last_name,desc
   */
  sort?: string;
  /**
   * Search using query
   */
  query?: string;
  /**
   * filter by field_name
   */
  field_name?: string;
}

/**
 * `GET /v1/delete_queue/file_sets/`
 *
 * Get deleted file sets
 *
 * Required roles:
 *  - can_read_files
 *
 * Responses
 * - 200 - Returns a list of file sets
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link FilesFileSetsElasticSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_delete_queue_file_sets_}
 */
export const httpGetDeleteQueueFileSets = (
  query?: FilesHttpGetDeleteQueueFileSetsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetDeleteQueueFileSets,
  method: httpMethod.get,
  url: '/API/files/v1/delete_queue/file_sets/',

  query,
  headers,
});

/**
 * `POST /v1/delete_queue/file_sets/purge/`
 *
 * Purge file sets from delete queue (Permanently delete)
 *
 * Required roles:
 *  - can_purge_files
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_delete_queue_file_sets_purge_}
 */
export const httpPostDeleteQueueFileSetsPurge = (
  body: FilesDeleteQueueSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostDeleteQueueFileSetsPurge,
  method: httpMethod.post,
  url: '/API/files/v1/delete_queue/file_sets/purge/',

  body,
  headers,
});

/**
 * `POST /v1/delete_queue/file_sets/purge/all/`
 *
 * Purge all file sets from delete queue (Permanently delete)
 *
 * Required roles:
 *  - can_purge_files
 *
 * Responses
 * - 204 - Without body
 * - 401 - Token is invalid
 * - 403 - User does not have permission
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_delete_queue_file_sets_purge_all_}
 */
export const httpPostDeleteQueueFileSetsPurgeAll = (
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostDeleteQueueFileSetsPurgeAll,
  method: httpMethod.post,
  url: '/API/files/v1/delete_queue/file_sets/purge/all/',

  headers,
});

/**
 * `DELETE /v1/delete_queue/formats/`
 *
 * Restore formats from delete queue
 *
 * Required roles:
 *  - can_write_formats
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_delete_queue_formats_}
 */
export const httpDeleteDeleteQueueFormats = (
  body: FilesDeleteQueueSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteDeleteQueueFormats,
  method: httpMethod.delete,
  url: '/API/files/v1/delete_queue/formats/',

  body,
  headers,
});

export interface FilesHttpGetDeleteQueueFormatsQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * A comma separated list of fieldnames with order. For example - first_name,asc;last_name,desc
   */
  sort?: string;
  /**
   * Search using query
   */
  query?: string;
  /**
   * filter by field_name
   */
  field_name?: string;
}

/**
 * `GET /v1/delete_queue/formats/`
 *
 * Get deleted formats
 *
 * Required roles:
 *  - can_read_formats
 *
 * Responses
 * - 200 - Returns a list of formats
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link FilesFormatsElasticSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_delete_queue_formats_}
 */
export const httpGetDeleteQueueFormats = (
  query?: FilesHttpGetDeleteQueueFormatsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetDeleteQueueFormats,
  method: httpMethod.get,
  url: '/API/files/v1/delete_queue/formats/',

  query,
  headers,
});

/**
 * `POST /v1/delete_queue/formats/purge/`
 *
 * Purge formats from delete queue (Permanently delete)
 *
 * Required roles:
 *  - can_purge_formats
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_delete_queue_formats_purge_}
 */
export const httpPostDeleteQueueFormatsPurge = (
  body: FilesDeleteQueueSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostDeleteQueueFormatsPurge,
  method: httpMethod.post,
  url: '/API/files/v1/delete_queue/formats/purge/',

  body,
  headers,
});

/**
 * `POST /v1/delete_queue/formats/purge/all/`
 *
 * Purge all formats from delete queue (Permanently delete)
 *
 * Required roles:
 *  - can_purge_formats
 *
 * Responses
 * - 204 - Without body
 * - 401 - Token is invalid
 * - 403 - User does not have permission
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_delete_queue_formats_purge_all_}
 */
export const httpPostDeleteQueueFormatsPurgeAll = (
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostDeleteQueueFormatsPurgeAll,
  method: httpMethod.post,
  url: '/API/files/v1/delete_queue/formats/purge/all/',

  headers,
});

/**
 * Authentication token
 */
export interface FilesHttpPostDrmAssetsByAssetIdVersionsByVersionIdProxiesByProxyIdAuthResponse {
  server_url?: string;
  token?: string;
}

export interface FilesHttpPostDrmAssetsByAssetIdVersionsByVersionIdProxiesByProxyIdAuthHeader
  extends IconikApiHeaders {
  DRM?: string;
  WATERMARK?: string;
}

/**
 * `POST /v1/drm/assets/{asset_id}/versions/{version_id}/proxies/{proxy_id}/auth/`
 *
 * Get authentication token for a given asset proxy.
 *
 * Required roles:
 *  - can_read_proxies
 *
 * Responses
 * - 200 - Authentication token
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Permission on storage denied
 * - 404 - Asset or storage not found
 *
 * Response {@link FilesHttpPostDrmAssetsByAssetIdVersionsByVersionIdProxiesByProxyIdAuthResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_drm_assets__asset_id__versions__version_id__proxies__proxy_id__auth_}
 */
export const httpPostDrmAssetsByAssetIdVersionsByVersionIdProxiesByProxyIdAuth =
  (
    assetId: string,
    versionId: string,
    proxyId: string,
    headers?: FilesHttpPostDrmAssetsByAssetIdVersionsByVersionIdProxiesByProxyIdAuthHeader,
  ) => ({
    id: FilesHttpPostDrmAssetsByAssetIdVersionsByVersionIdProxiesByProxyIdAuth,
    method: httpMethod.post,
    url: `/API/files/v1/drm/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/proxies/${encodeURIComponent(proxyId)}/auth/`,
    params: { assetId, versionId, proxyId },
    headers,
  });

export interface FilesHttpGetExportLocationsQuery {
  /**
   * Search query
   */
  query?: string;
  /**
   * Filter list of id:s (comma separated)
   */
  ids?: string;
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * ID of a last export_location on previous page
   */
  last_id?: string;
  /**
   * A comma separated list of fieldnames with order. For example - name,asc;id,desc
   */
  sort?: string;
}

/**
 * `GET /v1/export_locations/`
 *
 * Get all export_locations
 *
 * Required roles:
 *  - can_read_export_locations
 *
 * Responses
 * - 200 - Returns a list of export_locations
 * - 401 - Token is invalid
 *
 * Response {@link FilesExportLocationsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_export_locations_}
 */
export const httpGetExportLocations = (
  query?: FilesHttpGetExportLocationsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetExportLocations,
  method: httpMethod.get,
  url: '/API/files/v1/export_locations/',

  query,
  headers,
});

/**
 * `POST /v1/export_locations/`
 *
 * Create a new export_location
 *
 * Required roles:
 *  - can_write_export_locations
 *
 * Responses
 * - 201 - Returns a created export_location entry
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesExportLocationSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_export_locations_}
 */
export const httpPostExportLocations = (
  body: FilesExportLocationSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostExportLocations,
  method: httpMethod.post,
  url: '/API/files/v1/export_locations/',

  body,
  headers,
});

/**
 * `DELETE /v1/export_locations/{export_location_id}/`
 *
 * Delete a particular export_location by id
 *
 * Required roles:
 *  - can_delete_export_locations
 *
 * Responses
 * - 204 - Without body
 * - 401 - Token is invalid
 * - 404 - ExportLocation doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_export_locations__export_location_id__}
 */
export const httpDeleteExportLocationsByExportLocationId = (
  exportLocationId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteExportLocationsByExportLocationId,
  method: httpMethod.delete,
  url: `/API/files/v1/export_locations/${encodeURIComponent(exportLocationId)}/`,
  params: { exportLocationId },
  headers,
});

/**
 * `GET /v1/export_locations/{export_location_id}/`
 *
 * Returns a particular export_location by id
 *
 * Required roles:
 *  - can_read_export_locations
 *
 * Responses
 * - 200 - Returns a export_location
 * - 401 - Token is invalid
 * - 404 - ExportLocation doesn't exist
 *
 * Response {@link FilesExportLocationSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_export_locations__export_location_id__}
 */
export const httpGetExportLocationsByExportLocationId = (
  exportLocationId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetExportLocationsByExportLocationId,
  method: httpMethod.get,
  url: `/API/files/v1/export_locations/${encodeURIComponent(exportLocationId)}/`,
  params: { exportLocationId },
  headers,
});

export type FilesExportLocationSchemaPartial =
  Partial<FilesExportLocationSchema>;

/**
 * `PATCH /v1/export_locations/{export_location_id}/`
 *
 * Update export_location
 *
 * Required roles:
 *  - can_write_export_locations
 *
 * Responses
 * - 200 - Returns an updated export_location
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesExportLocationSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/patch_v1_export_locations__export_location_id__}
 */
export const httpPatchExportLocationsByExportLocationId = (
  exportLocationId: string,
  body: FilesExportLocationSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPatchExportLocationsByExportLocationId,
  method: httpMethod.patch,
  url: `/API/files/v1/export_locations/${encodeURIComponent(exportLocationId)}/`,
  params: { exportLocationId },
  body,
  headers,
});

/**
 * `PUT /v1/export_locations/{export_location_id}/`
 *
 * Update export_location
 *
 * Required roles:
 *  - can_write_export_locations
 *
 * Responses
 * - 200 - Returns an updated export_location
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesExportLocationSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/put_v1_export_locations__export_location_id__}
 */
export const httpPutExportLocationsByExportLocationId = (
  exportLocationId: string,
  body: FilesExportLocationSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPutExportLocationsByExportLocationId,
  method: httpMethod.put,
  url: `/API/files/v1/export_locations/${encodeURIComponent(exportLocationId)}/`,
  params: { exportLocationId },
  body,
  headers,
});

export interface FilesHttpPostExportLocationsByExportLocationIdBulkExportQuery {
  /**
   * Enable transfer through iconik host (creates egress)
   */
  allow_host_transfer?: boolean;
}

/**
 * `POST /v1/export_locations/{export_location_id}/bulk_export/`
 *
 * Export multiple objects to export location
 *
 * Required roles:
 *  - can_write_exports
 *
 * Responses
 * - 200 - Returns an export job id
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_export_locations__export_location_id__bulk_export_}
 */
export const httpPostExportLocationsByExportLocationIdBulkExport = (
  exportLocationId: string,
  body: FilesBulkFilesetExportSchema,
  query?: FilesHttpPostExportLocationsByExportLocationIdBulkExportQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostExportLocationsByExportLocationIdBulkExport,
  method: httpMethod.post,
  url: `/API/files/v1/export_locations/${encodeURIComponent(exportLocationId)}/bulk_export/`,
  params: { exportLocationId },
  body,
  query,
  headers,
});

/**
 * `POST /v1/export_locations/{export_location_id}/reindex/`
 *
 * Trigger reindexing of a export location
 *
 * Required roles:
 *  - can_reindex_export_locations
 *
 * Responses
 * - 201 - ID and status of the job
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_export_locations__export_location_id__reindex_}
 */
export const httpPostExportLocationsByExportLocationIdReindex = (
  exportLocationId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostExportLocationsByExportLocationIdReindex,
  method: httpMethod.post,
  url: `/API/files/v1/export_locations/${encodeURIComponent(exportLocationId)}/reindex/`,
  params: { exportLocationId },
  headers,
});

/**
 * `POST /v1/exports/temporary_file_sets/{file_set_id}/storages/{storage_id}/`
 *
 * Queue export job completion between local storages
 *
 * Required roles:
 *  - can_read_files
 * - can_write_transfers
 *
 * Responses
 * - 202 - Export queued
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Permission on storage denied
 * - 404 - File set or storage not found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_exports_temporary_file_sets__file_set_id__storages__storage_id__}
 */
export const httpPostExportsTemporaryFileSetsByFileSetIdStoragesByStorageId = (
  fileSetId: string,
  storageId: string,
  body: FilesCompleteExportToLocalStorageSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostExportsTemporaryFileSetsByFileSetIdStoragesByStorageId,
  method: httpMethod.post,
  url: `/API/files/v1/exports/temporary_file_sets/${encodeURIComponent(fileSetId)}/storages/${encodeURIComponent(storageId)}/`,
  params: { fileSetId, storageId },
  body,
  headers,
});

export interface FilesHttpGetFileSetsByFileSetIdFilesQuery {
  /**
   * Set to false if you don't need a URL, will speed things up
   */
  generate_signed_url?: boolean;
}

/**
 * `GET /v1/file_sets/{file_set_id}/files/`
 *
 * Get files from a file set
 *
 * Required roles:
 *  - can_read_files
 *
 * Responses
 * - 200 - Returns files from a file set
 *
 * Response {@link FilesFilesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_file_sets__file_set_id__files_}
 * @deprecated
 */
export const httpGetFileSetsByFileSetIdFiles = (
  fileSetId: string,
  query?: FilesHttpGetFileSetsByFileSetIdFilesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetFileSetsByFileSetIdFiles,
  method: httpMethod.get,
  url: `/API/files/v1/file_sets/${encodeURIComponent(fileSetId)}/files/`,
  params: { fileSetId },
  query,
  headers,
});

export interface FilesHttpPostFileSetsByFileSetIdStoragesByStorageIdQuery {
  /**
   * Enable transfer through iconik host (creates egress)
   */
  allow_host_transfer?: boolean;
}

/**
 * `POST /v1/file_sets/{file_set_id}/storages/{storage_id}/`
 *
 * Queue copying of a file set with files from one storage to another
 *
 * Required roles:
 *  - can_read_files
 * - can_write_transfers
 *
 * Responses
 * - 202 - Copy job created
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Permission on storage denied
 * - 404 - File set or storage not found
 * - 409 - File set with same components already exists on storage.
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_file_sets__file_set_id__storages__storage_id__}
 */
export const httpPostFileSetsByFileSetIdStoragesByStorageId = (
  fileSetId: string,
  storageId: string,
  body: FilesTransferFromStorageSchema,
  query?: FilesHttpPostFileSetsByFileSetIdStoragesByStorageIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostFileSetsByFileSetIdStoragesByStorageId,
  method: httpMethod.post,
  url: `/API/files/v1/file_sets/${encodeURIComponent(fileSetId)}/storages/${encodeURIComponent(storageId)}/`,
  params: { fileSetId, storageId },
  body,
  query,
  headers,
});

export interface FilesHttpDeleteFileSetsByFileSetIdTransfersFromByStorageIdQuery {
  failed?: boolean;
}

/**
 * `DELETE /v1/file_sets/{file_set_id}/transfers_from/{storage_id}/`
 *
 * Delete file set transfer after handling it
 *
 * Required roles:
 *  - can_write_transfers
 *
 * Responses
 * - 204 - Transfer job was deleted
 * - 404 - Transfer job does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_file_sets__file_set_id__transfers_from__storage_id__}
 * @deprecated
 */
export const httpDeleteFileSetsByFileSetIdTransfersFromByStorageId = (
  fileSetId: string,
  storageId: string,
  query?: FilesHttpDeleteFileSetsByFileSetIdTransfersFromByStorageIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteFileSetsByFileSetIdTransfersFromByStorageId,
  method: httpMethod.delete,
  url: `/API/files/v1/file_sets/${encodeURIComponent(fileSetId)}/transfers_from/${encodeURIComponent(storageId)}/`,
  params: { fileSetId, storageId },
  query,
  headers,
});

export interface FilesHttpDeleteFileSetsByFileSetIdTransfersToByStorageIdQuery {
  failed?: boolean;
}

/**
 * `DELETE /v1/file_sets/{file_set_id}/transfers_to/{storage_id}/`
 *
 * Delete file set transfer after handling it
 *
 * Required roles:
 *  - can_write_transfers
 *
 * Responses
 * - 204 - Transfer job was deleted
 * - 404 - Transfer job does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_file_sets__file_set_id__transfers_to__storage_id__}
 * @deprecated
 */
export const httpDeleteFileSetsByFileSetIdTransfersToByStorageId = (
  fileSetId: string,
  storageId: string,
  query?: FilesHttpDeleteFileSetsByFileSetIdTransfersToByStorageIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteFileSetsByFileSetIdTransfersToByStorageId,
  method: httpMethod.delete,
  url: `/API/files/v1/file_sets/${encodeURIComponent(fileSetId)}/transfers_to/${encodeURIComponent(storageId)}/`,
  params: { fileSetId, storageId },
  query,
  headers,
});

export interface FilesHttpGetFilesChecksumByChecksumQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  last_id?: string;
}

/**
 * `GET /v1/files/checksum/{checksum}/`
 *
 * Get files by checksum
 *
 * Required roles:
 *  - can_read_files
 *
 * Responses
 * - 200 - Returns all files that has specified checksum
 * - 401 - Token is invalid
 * - 404 - Files with this checksum don't exist
 *
 * Response {@link FilesFilesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_files_checksum__checksum__}
 */
export const httpGetFilesChecksumByChecksum = (
  checksum: string,
  query?: FilesHttpGetFilesChecksumByChecksumQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetFilesChecksumByChecksum,
  method: httpMethod.get,
  url: `/API/files/v1/files/checksum/${encodeURIComponent(checksum)}/`,
  params: { checksum },
  query,
  headers,
});

export interface FilesHttpDeleteFilesMissingStoragesByStorageIdQuery {
  remove_assets?: boolean;
}

/**
 * `DELETE /v1/files/missing/storages/{storage_id}/`
 *
 * Delete all missing files from storage
 *
 * Required roles:
 *  - can_delete_files
 *
 * Responses
 * - 202 - Files cleanup scheduled
 * - 401 - Token is invalid
 * - 403 - Permission denied
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_files_missing_storages__storage_id__}
 */
export const httpDeleteFilesMissingStoragesByStorageId = (
  storageId: string,
  query?: FilesHttpDeleteFilesMissingStoragesByStorageIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteFilesMissingStoragesByStorageId,
  method: httpMethod.delete,
  url: `/API/files/v1/files/missing/storages/${encodeURIComponent(storageId)}/`,
  params: { storageId },
  query,
  headers,
});

export interface FilesHttpPostFilesStoragesByStorageIdQuery {
  get_file_size?: boolean;
}

/**
 * `POST /v1/files/storages/{storage_id}/`
 *
 * Check file is on storage
 *
 * Required roles:
 *  - can_read_files
 *
 * Responses
 * - 200 - File exists
 * - 401 - Token is invalid
 * - 404 - File doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_files_storages__storage_id__}
 */
export const httpPostFilesStoragesByStorageId = (
  storageId: string,
  body: FilesFileExistenceCheckSchema,
  query?: FilesHttpPostFilesStoragesByStorageIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostFilesStoragesByStorageId,
  method: httpMethod.post,
  url: `/API/files/v1/files/storages/${encodeURIComponent(storageId)}/`,
  params: { storageId },
  body,
  query,
  headers,
});

/**
 * `POST /v1/files/upload/`
 *
 * Upload small files
 *
 * Required roles:
 *  - can_write_files
 * - can_write_formats
 *
 * Responses
 * - 200 - File uploaded
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Permission denied
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_files_upload_}
 */
export const httpPostFilesUpload = (
  body: object,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostFilesUpload,
  method: httpMethod.post,
  url: '/API/files/v1/files/upload/',

  body,
  headers,
});

/**
 * `DELETE /v1/files/{file_id}/deletions_from/{storage_id}/`
 *
 * Delete file deletion job after handling it
 *
 * Required roles:
 *  - is_storage_worker
 *
 * Responses
 * - 204 - Deletion job was deleted
 * - 404 - Deletion job does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_files__file_id__deletions_from__storage_id__}
 * @deprecated
 */
export const httpDeleteFilesByFileIdDeletionsFromByStorageId = (
  fileId: string,
  storageId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteFilesByFileIdDeletionsFromByStorageId,
  method: httpMethod.delete,
  url: `/API/files/v1/files/${encodeURIComponent(fileId)}/deletions_from/${encodeURIComponent(storageId)}/`,
  params: { fileId, storageId },
  headers,
});

/**
 * `POST /v1/formats/{format_id}/storages/{storage_id}/`
 *
 * Queue copying of a formats file sets with files from one storage to another
 *
 * Required roles:
 *  - can_read_formats
 * - can_write_transfers
 *
 * Responses
 * - 202 - Copy job created
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Permission on storage denied
 * - 404 - File set or storage not found
 * - 409 - File set with same components already exists on storage.
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_formats__format_id__storages__storage_id__}
 */
export const httpPostFormatsByFormatIdStoragesByStorageId = (
  formatId: string,
  storageId: string,
  body: FilesTransferFromStorageSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostFormatsByFormatIdStoragesByStorageId,
  method: httpMethod.post,
  url: `/API/files/v1/formats/${encodeURIComponent(formatId)}/storages/${encodeURIComponent(storageId)}/`,
  params: { formatId, storageId },
  body,
  headers,
});

export interface FilesHttpPostFormatsByFormatNameArchiveBulkQuery {
  /**
   * Enable transfer through iconik host (creates egress)
   */
  allow_host_transfer?: boolean;
}

/**
 * `POST /v1/formats/{format_name}/archive/bulk/`
 *
 * Queue bulk archiving of assets, collections and saved_searches
 *
 * Required roles:
 *  - can_archive_formats
 *
 * Responses
 * - 202 - Archive job created
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Storage not found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_formats__format_name__archive_bulk_}
 */
export const httpPostFormatsByFormatNameArchiveBulk = (
  formatName: string,
  body: FilesBulkFilesetArchiveSchema,
  query?: FilesHttpPostFormatsByFormatNameArchiveBulkQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostFormatsByFormatNameArchiveBulk,
  method: httpMethod.post,
  url: `/API/files/v1/formats/${encodeURIComponent(formatName)}/archive/bulk/`,
  params: { formatName },
  body,
  query,
  headers,
});

export interface FilesHttpPostFormatsByFormatNameRestoreBulkQuery {
  /**
   * Enable transfer through iconik host (creates egress)
   */
  allow_host_transfer?: boolean;
}

/**
 * `POST /v1/formats/{format_name}/restore/bulk/`
 *
 * Queue bulk restore of previously archived assets, collections or saved_searches
 *
 * Required roles:
 *  - can_restore_archived_formats
 *
 * Responses
 * - 202 - Restore job created
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Storage not found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_formats__format_name__restore_bulk_}
 */
export const httpPostFormatsByFormatNameRestoreBulk = (
  formatName: string,
  body: FilesBulkFilesetRestoreSchema,
  query?: FilesHttpPostFormatsByFormatNameRestoreBulkQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostFormatsByFormatNameRestoreBulk,
  method: httpMethod.post,
  url: `/API/files/v1/formats/${encodeURIComponent(formatName)}/restore/bulk/`,
  params: { formatName },
  body,
  query,
  headers,
});

export interface FilesHttpGetLogosQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Set to false if you don't need a URL, will speed things up
   */
  generate_signed_url?: boolean;
  /**
   * ID of a last logo on previous page
   */
  last_id?: string;
}

/**
 * `GET /v1/logos/`
 *
 * Get all saved logos for the domain
 *
 * Required roles:
 *  - can_read_portals
 *
 * Responses
 * - 200 - Returns a list of logos
 * - 401 - Token is invalid
 *
 * Response {@link FilesLogosSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_logos_}
 */
export const httpGetLogos = (
  query?: FilesHttpGetLogosQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetLogos,
  method: httpMethod.get,
  url: '/API/files/v1/logos/',

  query,
  headers,
});

/**
 * `POST /v1/logos/`
 *
 * Create a new saved logo
 *
 * <br/>The image itself is uploaded by the client to the returned `upload_url`<br/>using the returned `upload_method` (PUT for S3, POST for GCS resumable).<br/>The image itself is uploaded by the client to the returned `upload_url`<br/>using the returned `upload_method` (PUT for S3, POST for GCS resumable).
 * Required roles:
 *  - can_write_portals
 *
 * Responses
 * - 201 - Returns the created logo with a pre-signed upload URL
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesLogoCreateSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_logos_}
 */
export const httpPostLogos = (
  body: FilesLogoCreateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostLogos,
  method: httpMethod.post,
  url: '/API/files/v1/logos/',

  body,
  headers,
});

/**
 * `DELETE /v1/logos/{logo_id}/`
 *
 * Delete a particular logo by id, removing the stored image
 *
 * Required roles:
 *  - can_write_portals
 *
 * Responses
 * - 204 - Without body
 * - 401 - Token is invalid
 * - 404 - Logo doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_logos__logo_id__}
 */
export const httpDeleteLogosByLogoId = (
  logoId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteLogosByLogoId,
  method: httpMethod.delete,
  url: `/API/files/v1/logos/${encodeURIComponent(logoId)}/`,
  params: { logoId },
  headers,
});

/**
 * `GET /v1/logos/{logo_id}/`
 *
 * Returns a particular logo by id
 *
 * Required roles:
 *  - can_read_portals
 *
 * Responses
 * - 200 - Returns a logo
 * - 401 - Token is invalid
 * - 404 - Logo doesn't exist
 *
 * Response {@link FilesLogoSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_logos__logo_id__}
 */
export const httpGetLogosByLogoId = (
  logoId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetLogosByLogoId,
  method: httpMethod.get,
  url: `/API/files/v1/logos/${encodeURIComponent(logoId)}/`,
  params: { logoId },
  headers,
});

export type FilesLogoSchemaPartial = Partial<FilesLogoSchema>;

/**
 * `PATCH /v1/logos/{logo_id}/`
 *
 * Rename a saved logo
 *
 * <br/>Only the name can be changed; the image itself is immutable.<br/>Only the name can be changed; the image itself is immutable.
 * Required roles:
 *  - can_write_portals
 *
 * Responses
 * - 200 - Returns the updated logo
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Logo doesn't exist
 *
 * Response {@link FilesLogoSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/patch_v1_logos__logo_id__}
 */
export const httpPatchLogosByLogoId = (
  logoId: string,
  body: FilesLogoSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPatchLogosByLogoId,
  method: httpMethod.patch,
  url: `/API/files/v1/logos/${encodeURIComponent(logoId)}/`,
  params: { logoId },
  body,
  headers,
});

export interface FilesHttpPutMultipartGcsComposeQuery {
  /**
   * Compose capability token, as issued in compose_url
   */
  token: string;
}

/**
 * `PUT /v1/multipart/gcs/compose/`
 *
 * Compose the parts of a GCS parallel upload into a single object.
 *
 *
 * Responses
 * - 200 - Without body
 * - 400 - Bad request
 * - 403 - Token is invalid
 * - 404 - Object is missing
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/put_v1_multipart_gcs_compose_}
 */
export const httpPutMultipartGcsCompose = (
  body: string,
  query?: FilesHttpPutMultipartGcsComposeQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPutMultipartGcsCompose,
  method: httpMethod.put,
  url: '/API/files/v1/multipart/gcs/compose/',

  body,
  query,
  headers,
});

export interface FilesHttpGetPlaylistsByPlaylistIdKeyframesQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Set to false if you don't need a URL, will speed things up
   */
  generate_signed_url?: boolean;
  /**
   * ID of a last playlist keyframe on previous page
   */
  last_id?: string;
}

/**
 * `GET /v1/playlists/{playlist_id}/keyframes/`
 *
 * Get all playlist's keyframes
 *
 * Required roles:
 *  - can_read_playlists
 *
 * Responses
 * - 200 - Returns all keyframes associated with this playlist
 * - 401 - Token is invalid
 * - 404 - Keyframes for this playlist don't exist
 *
 * Response {@link FilesPlaylistKeyframesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_playlists__playlist_id__keyframes_}
 */
export const httpGetPlaylistsByPlaylistIdKeyframes = (
  playlistId: string,
  query?: FilesHttpGetPlaylistsByPlaylistIdKeyframesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetPlaylistsByPlaylistIdKeyframes,
  method: httpMethod.get,
  url: `/API/files/v1/playlists/${encodeURIComponent(playlistId)}/keyframes/`,
  params: { playlistId },
  query,
  headers,
});

/**
 * `POST /v1/playlists/{playlist_id}/keyframes/`
 *
 * Create keyframe and associate to playlist
 *
 * Required roles:
 *  - can_write_keyframes
 *
 * Responses
 * - 201 - Returns a keyframe that was created for this playlist
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesPlaylistKeyframeCreateSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_playlists__playlist_id__keyframes_}
 */
export const httpPostPlaylistsByPlaylistIdKeyframes = (
  playlistId: string,
  body: FilesPlaylistKeyframeCreateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostPlaylistsByPlaylistIdKeyframes,
  method: httpMethod.post,
  url: `/API/files/v1/playlists/${encodeURIComponent(playlistId)}/keyframes/`,
  params: { playlistId },
  body,
  headers,
});

export interface FilesHttpDeletePlaylistsByPlaylistIdKeyframesByKeyframeIdQuery {
  /**
   * set to true to force a regeneration of default keyframes
   */
  regenerate_keyframes?: boolean;
}

/**
 * `DELETE /v1/playlists/{playlist_id}/keyframes/{keyframe_id}/`
 *
 * Delete playlist's keyframe
 *
 * Required roles:
 *  - can_write_keyframes
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Keyframe for this playlist don't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_playlists__playlist_id__keyframes__keyframe_id__}
 */
export const httpDeletePlaylistsByPlaylistIdKeyframesByKeyframeId = (
  playlistId: string,
  keyframeId: string,
  query?: FilesHttpDeletePlaylistsByPlaylistIdKeyframesByKeyframeIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeletePlaylistsByPlaylistIdKeyframesByKeyframeId,
  method: httpMethod.delete,
  url: `/API/files/v1/playlists/${encodeURIComponent(playlistId)}/keyframes/${encodeURIComponent(keyframeId)}/`,
  params: { playlistId, keyframeId },
  query,
  headers,
});

/**
 * `GET /v1/playlists/{playlist_id}/keyframes/{keyframe_id}/`
 *
 * Get playlist's keyframe
 *
 * Required roles:
 *  - can_read_playlists
 *
 * Responses
 * - 200 - Returns a keyframe associated with this playlist
 * - 401 - Token is invalid
 * - 404 - Keyframe for this playlist don't exist
 *
 * Response {@link FilesPlaylistKeyframeSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_playlists__playlist_id__keyframes__keyframe_id__}
 */
export const httpGetPlaylistsByPlaylistIdKeyframesByKeyframeId = (
  playlistId: string,
  keyframeId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetPlaylistsByPlaylistIdKeyframesByKeyframeId,
  method: httpMethod.get,
  url: `/API/files/v1/playlists/${encodeURIComponent(playlistId)}/keyframes/${encodeURIComponent(keyframeId)}/`,
  params: { playlistId, keyframeId },
  headers,
});

export type FilesPlaylistKeyframeSchemaPartial =
  Partial<FilesPlaylistKeyframeSchema>;

/**
 * `PATCH /v1/playlists/{playlist_id}/keyframes/{keyframe_id}/`
 *
 * Update keyframe information
 *
 * Required roles:
 *  - can_write_keyframes
 *
 * Responses
 * - 200 - Returns a keyframe that was updated
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Keyframe for this playlist don't exist
 *
 * Response {@link FilesPlaylistKeyframeSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/patch_v1_playlists__playlist_id__keyframes__keyframe_id__}
 */
export const httpPatchPlaylistsByPlaylistIdKeyframesByKeyframeId = (
  playlistId: string,
  keyframeId: string,
  body: FilesPlaylistKeyframeSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPatchPlaylistsByPlaylistIdKeyframesByKeyframeId,
  method: httpMethod.patch,
  url: `/API/files/v1/playlists/${encodeURIComponent(playlistId)}/keyframes/${encodeURIComponent(keyframeId)}/`,
  params: { playlistId, keyframeId },
  body,
  headers,
});

/**
 * `PUT /v1/playlists/{playlist_id}/keyframes/{keyframe_id}/`
 *
 * Update keyframe information
 *
 * Required roles:
 *  - can_write_keyframes
 *
 * Responses
 * - 200 - Returns a keyframe that was updated
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Keyframe for this playlist don't exist
 *
 * Response {@link FilesPlaylistKeyframeSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/put_v1_playlists__playlist_id__keyframes__keyframe_id__}
 */
export const httpPutPlaylistsByPlaylistIdKeyframesByKeyframeId = (
  playlistId: string,
  keyframeId: string,
  body: FilesPlaylistKeyframeSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPutPlaylistsByPlaylistIdKeyframesByKeyframeId,
  method: httpMethod.put,
  url: `/API/files/v1/playlists/${encodeURIComponent(playlistId)}/keyframes/${encodeURIComponent(keyframeId)}/`,
  params: { playlistId, keyframeId },
  body,
  headers,
});

export interface FilesHttpGetSharesStoragesByStorageIdFilesQuery {
  directory_path: string;
  /**
   * Filter by name
   */
  name: string;
}

/**
 * `GET /v1/shares/storages/{storage_id}/files/`
 *
 * Check if a specific file is already on the storage for shares
 *
 * Required roles:
 *  - can_write_files
 *
 * Responses
 * - 204 - File exists
 * - 401 - Token is invalid
 * - 404 - No files found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_shares_storages__storage_id__files_}
 */
export const httpGetSharesStoragesByStorageIdFiles = (
  storageId: string,
  query?: FilesHttpGetSharesStoragesByStorageIdFilesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetSharesStoragesByStorageIdFiles,
  method: httpMethod.get,
  url: `/API/files/v1/shares/storages/${encodeURIComponent(storageId)}/files/`,
  params: { storageId },
  query,
  headers,
});

export interface FilesHttpGetStorageGatewayClustersQuery {
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * A comma separated list of fieldnames with order. For example - name,asc;description,desc
   */
  sort?: string;
  query?: string;
  view_nodes?: boolean;
  view_stats?: boolean;
}

/**
 * `GET /v1/storage_gateway_clusters/`
 *
 * Get all storage gateway clusters
 *
 *
 * Responses
 * - 200 - Returns a list of storage gateway clusters
 * - 401 - Token is invalid
 *
 * Response {@link FilesIconikStorageGatewayClustersSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_storage_gateway_clusters_}
 */
export const httpGetStorageGatewayClusters = (
  query?: FilesHttpGetStorageGatewayClustersQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetStorageGatewayClusters,
  method: httpMethod.get,
  url: '/API/files/v1/storage_gateway_clusters/',

  query,
  headers,
});

/**
 * `POST /v1/storage_gateway_clusters/`
 *
 * Create a new storage gateway cluster
 *
 *
 * Responses
 * - 201 - Cluster created successfully
 * - 400 - Invalid input
 * - 401 - Token is invalid
 *
 * Response {@link FilesIconikStorageGatewayClusterSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_storage_gateway_clusters_}
 */
export const httpPostStorageGatewayClusters = (
  body: FilesIconikStorageGatewayClusterSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostStorageGatewayClusters,
  method: httpMethod.post,
  url: '/API/files/v1/storage_gateway_clusters/',

  body,
  headers,
});

/**
 * `DELETE /v1/storage_gateway_clusters/{cluster_id}/`
 *
 * Delete a storage gateway cluster
 *
 *
 * Responses
 * - 204 - Cluster deleted successfully
 * - 401 - Token is invalid
 * - 404 - Cluster doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_storage_gateway_clusters__cluster_id__}
 */
export const httpDeleteStorageGatewayClustersByClusterId = (
  clusterId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteStorageGatewayClustersByClusterId,
  method: httpMethod.delete,
  url: `/API/files/v1/storage_gateway_clusters/${encodeURIComponent(clusterId)}/`,
  params: { clusterId },
  headers,
});

export interface FilesHttpGetStorageGatewayClustersByClusterIdQuery {
  view_nodes?: boolean;
  view_stats?: boolean;
}

/**
 * `GET /v1/storage_gateway_clusters/{cluster_id}/`
 *
 * Get a specific storage gateway cluster
 *
 *
 * Responses
 * - 200 - Returns the cluster
 * - 401 - Token is invalid
 * - 404 - Cluster doesn't exist
 *
 * Response {@link FilesIconikStorageGatewayClusterReadSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_storage_gateway_clusters__cluster_id__}
 */
export const httpGetStorageGatewayClustersByClusterId = (
  clusterId: string,
  query?: FilesHttpGetStorageGatewayClustersByClusterIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetStorageGatewayClustersByClusterId,
  method: httpMethod.get,
  url: `/API/files/v1/storage_gateway_clusters/${encodeURIComponent(clusterId)}/`,
  params: { clusterId },
  query,
  headers,
});

export type FilesIconikStorageGatewayClusterSchemaPartial =
  Partial<FilesIconikStorageGatewayClusterSchema>;

/**
 * `PATCH /v1/storage_gateway_clusters/{cluster_id}/`
 *
 * Update a storage gateway cluster
 *
 *
 * Responses
 * - 200 - Cluster updated successfully
 * - 400 - Invalid input
 * - 401 - Token is invalid
 * - 404 - Cluster doesn't exist
 *
 * Response {@link FilesIconikStorageGatewayClusterSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/patch_v1_storage_gateway_clusters__cluster_id__}
 */
export const httpPatchStorageGatewayClustersByClusterId = (
  clusterId: string,
  body: FilesIconikStorageGatewayClusterSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPatchStorageGatewayClustersByClusterId,
  method: httpMethod.patch,
  url: `/API/files/v1/storage_gateway_clusters/${encodeURIComponent(clusterId)}/`,
  params: { clusterId },
  body,
  headers,
});

/**
 * `PUT /v1/storage_gateway_clusters/{cluster_id}/`
 *
 * Update a storage gateway cluster
 *
 *
 * Responses
 * - 200 - Cluster updated successfully
 * - 400 - Invalid input
 * - 401 - Token is invalid
 * - 404 - Cluster doesn't exist
 *
 * Response {@link FilesIconikStorageGatewayClusterSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/put_v1_storage_gateway_clusters__cluster_id__}
 */
export const httpPutStorageGatewayClustersByClusterId = (
  clusterId: string,
  body: FilesIconikStorageGatewayClusterSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPutStorageGatewayClustersByClusterId,
  method: httpMethod.put,
  url: `/API/files/v1/storage_gateway_clusters/${encodeURIComponent(clusterId)}/`,
  params: { clusterId },
  body,
  headers,
});

export interface FilesHttpGetStorageGatewaysQuery {
  cluster_id?: string;
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * The number of items for each page
   */
  per_page?: number;
  query?: string;
  /**
   * A comma separated list of fieldnames with order. For example - name,asc;description,desc
   */
  sort?: string;
}

/**
 * `GET /v1/storage_gateways/`
 *
 * Get all storage gateways
 *
 *
 * Responses
 * - 200 - Returns a list of storage gateways
 * - 401 - Token is invalid
 *
 * Response {@link FilesIconikStorageGatewaysSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_storage_gateways_}
 */
export const httpGetStorageGateways = (
  query?: FilesHttpGetStorageGatewaysQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetStorageGateways,
  method: httpMethod.get,
  url: '/API/files/v1/storage_gateways/',

  query,
  headers,
});

/**
 * `POST /v1/storage_gateways/`
 *
 * Create a new storage gateway
 *
 *
 * Responses
 * - 201 - Storage gateway created successfully
 * - 400 - Invalid input
 * - 401 - Token is invalid
 *
 * Response {@link FilesIconikStorageGatewaySchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_storage_gateways_}
 */
export const httpPostStorageGateways = (
  body: FilesIconikStorageGatewaySchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostStorageGateways,
  method: httpMethod.post,
  url: '/API/files/v1/storage_gateways/',

  body,
  headers,
});

export interface FilesHttpGetStorageGatewaysTelemetryQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * ID of a last item on previous page
   */
  last_id?: string;
}

/**
 * `GET /v1/storage_gateways/telemetry/`
 *
 * Get all telemetry records with optional filtering
 *
 * Required roles:
 *  - can_read_storages
 *
 * Responses
 * - 200 - Returns telemetry records
 * - 401 - Token is invalid
 *
 * Response {@link FilesIconikStorageGatewaysTelemetrySchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_storage_gateways_telemetry_}
 */
export const httpGetStorageGatewaysTelemetry = (
  query?: FilesHttpGetStorageGatewaysTelemetryQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetStorageGatewaysTelemetry,
  method: httpMethod.get,
  url: '/API/files/v1/storage_gateways/telemetry/',

  query,
  headers,
});

/**
 * `GET /v1/storage_gateways/telemetry/{worker_id}/`
 *
 * Get telemetry for a specific worker
 *
 * Required roles:
 *  - can_read_storages
 *
 * Responses
 * - 200 - Returns telemetry for the worker
 * - 401 - Token is invalid
 * - 404 - Telemetry doesn't exist
 *
 * Response {@link FilesIconikStorageGatewayTelemetrySchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_storage_gateways_telemetry__worker_id__}
 */
export const httpGetStorageGatewaysTelemetryByWorkerId = (
  workerId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetStorageGatewaysTelemetryByWorkerId,
  method: httpMethod.get,
  url: `/API/files/v1/storage_gateways/telemetry/${encodeURIComponent(workerId)}/`,
  params: { workerId },
  headers,
});

/**
 * `DELETE /v1/storage_gateways/{storage_gateway_id}/`
 *
 * Delete a storage gateway
 *
 *
 * Responses
 * - 204 - Storage gateway deleted successfully
 * - 401 - Token is invalid
 * - 404 - Storage gateway doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_storage_gateways__storage_gateway_id__}
 */
export const httpDeleteStorageGatewaysByStorageGatewayId = (
  storageGatewayId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteStorageGatewaysByStorageGatewayId,
  method: httpMethod.delete,
  url: `/API/files/v1/storage_gateways/${encodeURIComponent(storageGatewayId)}/`,
  params: { storageGatewayId },
  headers,
});

/**
 * `GET /v1/storage_gateways/{storage_gateway_id}/`
 *
 * Get a specific storage gateway
 *
 *
 * Responses
 * - 200 - Returns the storage gateway
 * - 401 - Token is invalid
 * - 404 - Storage gateway doesn't exist
 *
 * Response {@link FilesIconikStorageGatewayReadSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_storage_gateways__storage_gateway_id__}
 */
export const httpGetStorageGatewaysByStorageGatewayId = (
  storageGatewayId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetStorageGatewaysByStorageGatewayId,
  method: httpMethod.get,
  url: `/API/files/v1/storage_gateways/${encodeURIComponent(storageGatewayId)}/`,
  params: { storageGatewayId },
  headers,
});

export type FilesIconikStorageGatewaySchemaPartial =
  Partial<FilesIconikStorageGatewaySchema>;

/**
 * `PATCH /v1/storage_gateways/{storage_gateway_id}/`
 *
 * Update a storage gateway
 *
 *
 * Responses
 * - 200 - Storage gateway updated successfully
 * - 400 - Invalid input
 * - 401 - Token is invalid
 * - 404 - Storage gateway doesn't exist
 *
 * Response {@link FilesIconikStorageGatewaySchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/patch_v1_storage_gateways__storage_gateway_id__}
 */
export const httpPatchStorageGatewaysByStorageGatewayId = (
  storageGatewayId: string,
  body: FilesIconikStorageGatewaySchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPatchStorageGatewaysByStorageGatewayId,
  method: httpMethod.patch,
  url: `/API/files/v1/storage_gateways/${encodeURIComponent(storageGatewayId)}/`,
  params: { storageGatewayId },
  body,
  headers,
});

/**
 * `PUT /v1/storage_gateways/{storage_gateway_id}/`
 *
 * Update a storage gateway
 *
 *
 * Responses
 * - 200 - Storage gateway updated successfully
 * - 400 - Invalid input
 * - 401 - Token is invalid
 * - 404 - Storage gateway doesn't exist
 *
 * Response {@link FilesIconikStorageGatewaySchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/put_v1_storage_gateways__storage_gateway_id__}
 */
export const httpPutStorageGatewaysByStorageGatewayId = (
  storageGatewayId: string,
  body: FilesIconikStorageGatewaySchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPutStorageGatewaysByStorageGatewayId,
  method: httpMethod.put,
  url: `/API/files/v1/storage_gateways/${encodeURIComponent(storageGatewayId)}/`,
  params: { storageGatewayId },
  body,
  headers,
});

/**
 * Returns upload URL details for storage gateway logs
 */
export interface FilesHttpPostStorageGatewaysByStorageGatewayIdLogsResponse {
  method?: string;
  path?: string;
  upload_url?: string;
}

/**
 * `POST /v1/storage_gateways/{storage_gateway_id}/logs/`
 *
 * Upload storage logs
 *
 * Required roles:
 *  - is_storage_worker
 *
 * Responses
 * - 201 - Returns upload URL details for storage gateway logs
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Forbidden
 * - 404 - Storage gateway does not exist
 * - 503 - Failed to generate upload URL
 *
 * Response {@link FilesHttpPostStorageGatewaysByStorageGatewayIdLogsResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_storage_gateways__storage_gateway_id__logs_}
 */
export const httpPostStorageGatewaysByStorageGatewayIdLogs = (
  storageGatewayId: string,
  body: FilesUploadIconikStorageGatewayLogsSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostStorageGatewaysByStorageGatewayIdLogs,
  method: httpMethod.post,
  url: `/API/files/v1/storage_gateways/${encodeURIComponent(storageGatewayId)}/logs/`,
  params: { storageGatewayId },
  body,
  headers,
});

/**
 * `GET /v1/storage_gateways/{storage_gateway_id}/telemetry/`
 *
 * Get all telemetry for a specific storage gateway
 *
 * Required roles:
 *  - can_read_storages
 *
 * Responses
 * - 200 - Returns telemetry for the storage gateway
 * - 401 - Token is invalid
 * - 404 - Storage gateway doesn't exist
 *
 * Response {@link FilesIconikStorageGatewaysTelemetrySchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_storage_gateways__storage_gateway_id__telemetry_}
 */
export const httpGetStorageGatewaysByStorageGatewayIdTelemetry = (
  storageGatewayId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetStorageGatewaysByStorageGatewayIdTelemetry,
  method: httpMethod.get,
  url: `/API/files/v1/storage_gateways/${encodeURIComponent(storageGatewayId)}/telemetry/`,
  params: { storageGatewayId },
  headers,
});

/**
 * `POST /v1/storage_gateways/{storage_gateway_id}/telemetry/`
 *
 * Create telemetry
 *
 *
 * Responses
 * - 201 - Returns an empty object
 * - 400 - Invalid input
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_storage_gateways__storage_gateway_id__telemetry_}
 */
export const httpPostStorageGatewaysByStorageGatewayIdTelemetry = (
  storageGatewayId: string,
  body: FilesIconikStorageGatewayTelemetrySchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostStorageGatewaysByStorageGatewayIdTelemetry,
  method: httpMethod.post,
  url: `/API/files/v1/storage_gateways/${encodeURIComponent(storageGatewayId)}/telemetry/`,
  params: { storageGatewayId },
  body,
  headers,
});

export interface FilesHttpGetStoragesQuery {
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * A comma separated list of fieldnames with order. For example - status,asc;last_scanned,desc
   */
  sort?: string;
  /**
   * Filter by id
   */
  id?: string;
  /**
   * Filter by name
   */
  name?: string;
  /**
   * Filter by method
   */
  method?: string;
  /**
   * Filter by status
   */
  status?: string;
  /**
   * Filter by purpose
   */
  purpose?: string;
  /**
   * Filter by last_scanned
   */
  last_scanned?: string;
  /**
   * Filter by scanner_status
   */
  scanner_status?: string;
  /**
   * Filter by any of the above with wildcard support
   */
  query?: string;
  /**
   * Filter list of id:s (comma separated)
   */
  ids?: string;
}

/**
 * `GET /v1/storages/`
 *
 * Get all storages
 *
 * Required roles:
 *  - can_read_storages
 *
 * Responses
 * - 200 - Returns a list of storages
 * - 401 - Token is invalid
 *
 * Response {@link FilesStoragesReadSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_storages_}
 */
export const httpGetStorages = (
  query?: FilesHttpGetStoragesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetStorages,
  method: httpMethod.get,
  url: '/API/files/v1/storages/',

  query,
  headers,
});

/**
 * `POST /v1/storages/`
 *
 * Create a new storage
 *
 * Required roles:
 *  - can_write_storages
 *
 * Responses
 * - 201 - Returns a created storage entry
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesStorageSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_storages_}
 */
export const httpPostStorages = (
  body: FilesStorageSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostStorages,
  method: httpMethod.post,
  url: '/API/files/v1/storages/',

  body,
  headers,
});

/**
 * `GET /v1/storages/dropbox/oauth/`
 *
 * Get the parameters needed to start a Dropbox authorization
 *
 * Required roles:
 *  - can_write_storages
 *
 * Responses
 * - 200 - The Dropbox OAuth parameters
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_storages_dropbox_oauth_}
 */
export const httpGetStoragesDropboxOauth = (headers?: IconikApiHeaders) => ({
  id: FilesHttpGetStoragesDropboxOauth,
  method: httpMethod.get,
  url: '/API/files/v1/storages/dropbox/oauth/',

  headers,
});

export interface FilesHttpGetStoragesDropboxWebhookQuery {
  challenge: string;
}

/**
 * `GET /v1/storages/dropbox/webhook/`
 *
 * Echo the Dropbox webhook verification challenge
 *
 *
 * Responses
 * - 200 - The challenge, echoed back as text/plain
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_storages_dropbox_webhook_}
 */
export const httpGetStoragesDropboxWebhook = (
  query?: FilesHttpGetStoragesDropboxWebhookQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetStoragesDropboxWebhook,
  method: httpMethod.get,
  url: '/API/files/v1/storages/dropbox/webhook/',

  query,
  headers,
});

export interface FilesHttpPostStoragesDropboxWebhookHeader
  extends IconikApiHeaders {
  'X-Dropbox-Signature': string;
}

/**
 * `POST /v1/storages/dropbox/webhook/`
 *
 * Receive a Dropbox change notification
 *
 *
 * Responses
 * - 200 - Notification accepted
 * - 400 - Malformed notification body
 * - 403 - Signature is missing or invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_storages_dropbox_webhook_}
 */
export const httpPostStoragesDropboxWebhook = (
  headers: FilesHttpPostStoragesDropboxWebhookHeader,
) => ({
  id: FilesHttpPostStoragesDropboxWebhook,
  method: httpMethod.post,
  url: '/API/files/v1/storages/dropbox/webhook/',

  headers,
});

/**
 * `POST /v1/storages/files/reindex/`
 *
 * Trigger reindexing of all files
 *
 * Required roles:
 *  - can_reindex_storages
 *
 * Responses
 * - 201 - ID and status of the job
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_storages_files_reindex_}
 */
export const httpPostStoragesFilesReindex = (headers?: IconikApiHeaders) => ({
  id: FilesHttpPostStoragesFilesReindex,
  method: httpMethod.post,
  url: '/API/files/v1/storages/files/reindex/',

  headers,
});

/**
 * Returns version
 */
export interface FilesHttpGetStoragesIsgLatestVersionResponse {
  version?: string;
}

/**
 * `GET /v1/storages/isg/latest_version/`
 *
 * Get latest ISG version
 *
 * Required roles:
 *  - can_read_storages
 *
 * Responses
 * - 200 - Returns version
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Storage does not exist
 *
 * Response {@link FilesHttpGetStoragesIsgLatestVersionResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_storages_isg_latest_version_}
 */
export const httpGetStoragesIsgLatestVersion = (
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetStoragesIsgLatestVersion,
  method: httpMethod.get,
  url: '/API/files/v1/storages/isg/latest_version/',

  headers,
});

export interface FilesHttpGetStoragesMatchingByPurposeQuery {
  storage_id?: string;
}

/**
 * `GET /v1/storages/matching/{purpose}/`
 *
 * Returns a remote storage matching type
 *
 * Required roles:
 *  - can_read_storages
 *
 * Responses
 * - 200 - Returns a storage
 * - 401 - Token is invalid
 * - 404 - No matching storage exists
 *
 * Response {@link FilesStorageSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_storages_matching__purpose__}
 */
export const httpGetStoragesMatchingByPurpose = (
  purpose: string,
  query?: FilesHttpGetStoragesMatchingByPurposeQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetStoragesMatchingByPurpose,
  method: httpMethod.get,
  url: `/API/files/v1/storages/matching/${encodeURIComponent(purpose)}/`,
  params: { purpose },
  query,
  headers,
});

/**
 * `GET /v1/storages/matching/{purpose}/method/{method}/`
 *
 * Returns a remote storage matching type and method
 *
 * Required roles:
 *  - can_read_storages
 *
 * Responses
 * - 200 - Returns a storage
 * - 401 - Token is invalid
 * - 404 - No matching storage exists
 *
 * Response {@link FilesStorageSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_storages_matching__purpose__method__method__}
 */
export const httpGetStoragesMatchingByPurposeMethodByMethod = (
  purpose: string,
  method: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetStoragesMatchingByPurposeMethodByMethod,
  method: httpMethod.get,
  url: `/API/files/v1/storages/matching/${encodeURIComponent(purpose)}/method/${encodeURIComponent(method)}/`,
  params: { purpose, method },
  headers,
});

/**
 * `POST /v1/storages/reindex/`
 *
 * Trigger reindexing of all storages
 *
 * Required roles:
 *  - can_reindex_storages
 *
 * Responses
 * - 201 - ID and status of the job
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_storages_reindex_}
 */
export const httpPostStoragesReindex = (headers?: IconikApiHeaders) => ({
  id: FilesHttpPostStoragesReindex,
  method: httpMethod.post,
  url: '/API/files/v1/storages/reindex/',

  headers,
});

/**
 * `POST /v1/storages/swap/`
 *
 * Requires SuperAdmin access
 *
 *
 * Responses
 * - 201 - Scan started
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_storages_swap_}
 */
export const httpPostStoragesSwap = (
  body: FilesSwapStoragesSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostStoragesSwap,
  method: httpMethod.post,
  url: '/API/files/v1/storages/swap/',

  body,
  headers,
});

/**
 * Returns a document describing storage access
 */
export interface FilesHttpPostStoragesVerificationsAccessResponse {
  access_check?: boolean;
  error_message?: string;
}

/**
 * `POST /v1/storages/verifications/access/`
 *
 * Verify access prior to creating a storage
 *
 * Required roles:
 *  - can_read_storages
 *
 * Responses
 * - 200 - Returns a document describing storage access
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 501 - Not implemented
 *
 * Response {@link FilesHttpPostStoragesVerificationsAccessResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_storages_verifications_access_}
 */
export const httpPostStoragesVerificationsAccess = (
  body: FilesStorageAccessSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostStoragesVerificationsAccess,
  method: httpMethod.post,
  url: '/API/files/v1/storages/verifications/access/',

  body,
  headers,
});

/**
 * Returns a document describing storage permissions
 */
export interface FilesHttpPostStoragesVerificationsPermissionsResponse {
  cors?: boolean;
  cors_error?: string;
  delete_access?: boolean;
  delete_access_error?: string;
  error_message?: string;
  read_access?: boolean;
  read_access_error?: string;
  write_access?: boolean;
  write_access_error?: string;
}

/**
 * `POST /v1/storages/verifications/permissions/`
 *
 * Verify permissions prior to creating a storage
 *
 * Required roles:
 *  - can_write_storages
 *
 * Responses
 * - 200 - Returns a document describing storage permissions
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Storage does not exist
 * - 501 - Not implemented
 *
 * Response {@link FilesHttpPostStoragesVerificationsPermissionsResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_storages_verifications_permissions_}
 */
export const httpPostStoragesVerificationsPermissions = (
  body: FilesStoragePermissionsSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostStoragesVerificationsPermissions,
  method: httpMethod.post,
  url: '/API/files/v1/storages/verifications/permissions/',

  body,
  headers,
});

/**
 * `GET /v1/storages/{purpose}/default/`
 *
 * Get a purpose default storage
 *
 * Required roles:
 *  - can_read_storages
 *
 * Responses
 * - 200 - The default storage
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Permission denied
 * - 404 - Storage does not exist
 *
 * Response {@link FilesStorageSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_storages__purpose__default_}
 */
export const httpGetStoragesByPurposeDefault = (
  purpose: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetStoragesByPurposeDefault,
  method: httpMethod.get,
  url: `/API/files/v1/storages/${encodeURIComponent(purpose)}/default/`,
  params: { purpose },
  headers,
});

/**
 * `DELETE /v1/storages/{storage_id}/`
 *
 * Delete a particular storage by id
 *
 * Required roles:
 *  - can_delete_storages
 *
 * Responses
 * - 204 - Without body
 * - 401 - Token is invalid
 * - 404 - Storage doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_storages__storage_id__}
 */
export const httpDeleteStoragesByStorageId = (
  storageId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteStoragesByStorageId,
  method: httpMethod.delete,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/`,
  params: { storageId },
  headers,
});

/**
 * `GET /v1/storages/{storage_id}/`
 *
 * Returns a particular storage by id
 *
 * Required roles:
 *  - can_read_storages
 *
 * Responses
 * - 200 - Returns a storage
 * - 401 - Token is invalid
 * - 404 - Storage doesn't exist
 *
 * Response {@link FilesStorageSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_storages__storage_id__}
 */
export const httpGetStoragesByStorageId = (
  storageId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetStoragesByStorageId,
  method: httpMethod.get,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/`,
  params: { storageId },
  headers,
});

export type FilesStorageSchemaPartial = Partial<FilesStorageSchema>;

/**
 * `PATCH /v1/storages/{storage_id}/`
 *
 * Update storage
 *
 * Required roles:
 *  - can_write_storages
 *
 * Responses
 * - 200 - Returns an updated storage
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesStorageSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/patch_v1_storages__storage_id__}
 */
export const httpPatchStoragesByStorageId = (
  storageId: string,
  body: FilesStorageSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPatchStoragesByStorageId,
  method: httpMethod.patch,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/`,
  params: { storageId },
  body,
  headers,
});

/**
 * `PUT /v1/storages/{storage_id}/`
 *
 * Update storage
 *
 * Required roles:
 *  - can_write_storages
 *
 * Responses
 * - 200 - Returns an updated storage
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesStorageSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/put_v1_storages__storage_id__}
 */
export const httpPutStoragesByStorageId = (
  storageId: string,
  body: FilesStorageSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPutStoragesByStorageId,
  method: httpMethod.put,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/`,
  params: { storageId },
  body,
  headers,
});

/**
 * `DELETE /v1/storages/{storage_id}/auto_scan/`
 *
 * Disable cloud storage auto scan
 *
 * Required roles:
 *  - can_scan_bucket
 *
 * Responses
 * - 204 - Storage auto scan disabled
 * - 401 - Token is invalid
 * - 404 - Storage auto scan already disabled
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_storages__storage_id__auto_scan_}
 */
export const httpDeleteStoragesByStorageIdAutoScan = (
  storageId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteStoragesByStorageIdAutoScan,
  method: httpMethod.delete,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/auto_scan/`,
  params: { storageId },
  headers,
});

/**
 * `GET /v1/storages/{storage_id}/auto_scan/`
 *
 * Get cloud storage auto scan settings
 *
 * Required roles:
 *  - can_scan_bucket
 *
 * Responses
 * - 200 - Storage auto scan settings
 * - 401 - Token is invalid
 * - 404 - Storage auto scan is disabled
 *
 * Response {@link FilesStorageAutoScanSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_storages__storage_id__auto_scan_}
 */
export const httpGetStoragesByStorageIdAutoScan = (
  storageId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetStoragesByStorageIdAutoScan,
  method: httpMethod.get,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/auto_scan/`,
  params: { storageId },
  headers,
});

/**
 * `POST /v1/storages/{storage_id}/auto_scan/`
 *
 * Enable cloud storage auto scan
 *
 * Required roles:
 *  - can_scan_bucket
 *
 * Responses
 * - 200 - Storage auto scan enabled
 * - 401 - Token is invalid
 * - 404 - No matching storage exists
 *
 * Response {@link FilesStorageAutoScanSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_storages__storage_id__auto_scan_}
 */
export const httpPostStoragesByStorageIdAutoScan = (
  storageId: string,
  body: FilesStorageAutoScanSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostStoragesByStorageIdAutoScan,
  method: httpMethod.post,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/auto_scan/`,
  params: { storageId },
  body,
  headers,
});

export interface FilesHttpPostStoragesByStorageIdBulkQuery {
  /**
   * Enable transfer through iconik host (creates egress)
   */
  allow_host_transfer?: boolean;
}

/**
 * `POST /v1/storages/{storage_id}/bulk/`
 *
 * Queue copying of files from current storage to specified one
 *
 * Required roles:
 *  - can_read_files
 * - can_write_transfers
 *
 * Responses
 * - 202 - Copy job created
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Storage not found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_storages__storage_id__bulk_}
 */
export const httpPostStoragesByStorageIdBulk = (
  storageId: string,
  body: FilesBulkTransferToStorageSchema,
  query?: FilesHttpPostStoragesByStorageIdBulkQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostStoragesByStorageIdBulk,
  method: httpMethod.post,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/bulk/`,
  params: { storageId },
  body,
  query,
  headers,
});

/**
 * `DELETE /v1/storages/{storage_id}/default/`
 *
 * Removes the default flag on a storage
 *
 * Required roles:
 *  - can_write_storages
 *
 * Responses
 * - 204 - Success
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_storages__storage_id__default_}
 */
export const httpDeleteStoragesByStorageIdDefault = (
  storageId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteStoragesByStorageIdDefault,
  method: httpMethod.delete,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/default/`,
  params: { storageId },
  headers,
});

/**
 * `POST /v1/storages/{storage_id}/default/`
 *
 * Set a storage to the default of its purpose
 *
 * Required roles:
 *  - can_write_storages
 *
 * Responses
 * - 201 - Success
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_storages__storage_id__default_}
 */
export const httpPostStoragesByStorageIdDefault = (
  storageId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostStoragesByStorageIdDefault,
  method: httpMethod.post,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/default/`,
  params: { storageId },
  headers,
});

export interface FilesHttpGetStoragesByStorageIdDeletionsQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * ID of a last file deletion entity on previous page
   */
  last_id?: string;
}

/**
 * `GET /v1/storages/{storage_id}/deletions/`
 *
 * Get pending deletions of files from a local storage
 *
 * Required roles:
 *  - is_storage_worker
 *
 * Responses
 * - 200 - Returns pending deletions to be handled
 *
 * Response {@link FilesFileDeletionsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_storages__storage_id__deletions_}
 * @deprecated
 */
export const httpGetStoragesByStorageIdDeletions = (
  storageId: string,
  query?: FilesHttpGetStoragesByStorageIdDeletionsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetStoragesByStorageIdDeletions,
  method: httpMethod.get,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/deletions/`,
  params: { storageId },
  query,
  headers,
});

/**
 * `DELETE /v1/storages/{storage_id}/deletions/{deletion_id}/`
 *
 * Delete file deletion job after handling it
 *
 * Required roles:
 *  - is_storage_worker
 *
 * Responses
 * - 204 - Deletion job was deleted
 * - 404 - Deletion job does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_storages__storage_id__deletions__deletion_id__}
 * @deprecated
 */
export const httpDeleteStoragesByStorageIdDeletionsByDeletionId = (
  storageId: string,
  deletionId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteStoragesByStorageIdDeletionsByDeletionId,
  method: httpMethod.delete,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/deletions/${encodeURIComponent(deletionId)}/`,
  params: { storageId, deletionId },
  headers,
});

export interface FilesHttpGetStoragesByStorageIdDeletionsFromQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * ID of a last file deletion entity on previous page
   */
  last_id?: string;
}

/**
 * `GET /v1/storages/{storage_id}/deletions_from/`
 *
 * Get pending deletions of files from a local storage
 *
 * Required roles:
 *  - is_storage_worker
 *
 * Responses
 * - 200 - Returns pending deletions to be handled
 *
 * Response {@link FilesFileDeletionsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_storages__storage_id__deletions_from_}
 */
export const httpGetStoragesByStorageIdDeletionsFrom = (
  storageId: string,
  query?: FilesHttpGetStoragesByStorageIdDeletionsFromQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetStoragesByStorageIdDeletionsFrom,
  method: httpMethod.get,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/deletions_from/`,
  params: { storageId },
  query,
  headers,
});

export interface FilesHttpDeleteStoragesByStorageIdFilesQuery {
  path?: string;
  path_separator?: string;
  directory_path?: string;
  checksum?: string;
  /**
   * Filter by id
   */
  id?: string;
  /**
   * Filter by name
   */
  name?: string;
  /**
   * Filter by type
   */
  type?: string;
  /**
   * Filter by status
   */
  status?: string;
  /**
   * Filter by date_created
   */
  date_created?: string;
  /**
   * Filter by date_modified
   */
  date_modified?: string;
}

/**
 * `DELETE /v1/storages/{storage_id}/files/`
 *
 * DELETE files (with copies in different storages) from a storage folder, or a storage
 *
 * Required roles:
 *  - can_read_storages
 * - can_delete_files
 *
 * Responses
 * - 200 - Returns files
 * - 401 - Token is invalid
 * - 404 - No files found
 *
 * Response {@link FilesFilesElasticSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_storages__storage_id__files_}
 */
export const httpDeleteStoragesByStorageIdFiles = (
  storageId: string,
  query?: FilesHttpDeleteStoragesByStorageIdFilesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteStoragesByStorageIdFiles,
  method: httpMethod.delete,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/files/`,
  params: { storageId },
  query,
  headers,
});

export interface FilesHttpGetStoragesByStorageIdFilesQuery {
  path?: string;
  path_separator?: string;
  directory_path?: string;
  checksum?: string;
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * If true passed then uses scroll pagination instead of default one
   */
  scroll?: boolean;
  /**
   * In order to get next batch of results using scroll pagination the scroll_id is required
   */
  scroll_id?: string;
  /**
   * A comma separated list of fieldnames with order. For example - first_name,asc;last_name,desc
   */
  sort?: string;
  /**
   * Filter by id
   */
  id?: string;
  /**
   * Filter by name
   */
  name?: string;
  /**
   * Filter by type
   */
  type?: string;
  /**
   * Filter by status
   */
  status?: string;
  /**
   * Filter by date_created
   */
  date_created?: string;
  /**
   * Filter by date_modified
   */
  date_modified?: string;
}

/**
 * `GET /v1/storages/{storage_id}/files/`
 *
 * Get files in a storage folder, or all files on a storage
 *
 * Required roles:
 *  - can_list_storage_files
 *
 * Responses
 * - 200 - Returns files
 * - 401 - Token is invalid
 * - 404 - No files found
 *
 * Response {@link FilesFilesElasticSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_storages__storage_id__files_}
 */
export const httpGetStoragesByStorageIdFiles = (
  storageId: string,
  query?: FilesHttpGetStoragesByStorageIdFilesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetStoragesByStorageIdFiles,
  method: httpMethod.get,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/files/`,
  params: { storageId },
  query,
  headers,
});

export type FilesFileBaseSchemaPartial = Partial<FilesFileBaseSchema>;

/**
 * `PATCH /v1/storages/{storage_id}/files/`
 *
 * Update file by storage ID and path
 *
 * Required roles:
 *  - can_write_files
 *
 * Responses
 * - 200 - Returns updated file
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Asset access denied
 * - 404 - No file found
 *
 * Response {@link FilesFileBaseSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/patch_v1_storages__storage_id__files_}
 */
export const httpPatchStoragesByStorageIdFiles = (
  storageId: string,
  body: FilesFileBaseSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPatchStoragesByStorageIdFiles,
  method: httpMethod.patch,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/files/`,
  params: { storageId },
  body,
  headers,
});

/**
 * `POST /v1/storages/{storage_id}/files/`
 *
 * Create file without associating it to an asset
 *
 *
 * Responses
 * - 201 - Returns a file that was created
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesFileBaseSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_storages__storage_id__files_}
 */
export const httpPostStoragesByStorageIdFiles = (
  storageId: string,
  body: FilesFileBaseSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostStoragesByStorageIdFiles,
  method: httpMethod.post,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/files/`,
  params: { storageId },
  body,
  headers,
});

/**
 * `PUT /v1/storages/{storage_id}/files/`
 *
 * Update file by storage ID and path
 *
 * Required roles:
 *  - can_write_files
 *
 * Responses
 * - 200 - Returns updated file
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Asset access denied
 * - 404 - No file found
 *
 * Response {@link FilesFileBaseSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/put_v1_storages__storage_id__files_}
 */
export const httpPutStoragesByStorageIdFiles = (
  storageId: string,
  body: FilesFileBaseSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPutStoragesByStorageIdFiles,
  method: httpMethod.put,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/files/`,
  params: { storageId },
  body,
  headers,
});

/**
 * `POST /v1/storages/{storage_id}/files/reindex/`
 *
 * Trigger reindexing of all files
 *
 * Required roles:
 *  - can_reindex_storages
 *
 * Responses
 * - 201 - ID and status of the job
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_storages__storage_id__files_reindex_}
 */
export const httpPostStoragesByStorageIdFilesReindex = (
  storageId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostStoragesByStorageIdFilesReindex,
  method: httpMethod.post,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/files/reindex/`,
  params: { storageId },
  headers,
});

/**
 * `POST /v1/storages/{storage_id}/files/{file_id}/reindex/`
 *
 * Trigger reindexing for a file on a storage
 *
 * Required roles:
 *  - can_reindex_storages
 *
 * Responses
 * - 201 - ID and status of the job
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_storages__storage_id__files__file_id__reindex_}
 */
export const httpPostStoragesByStorageIdFilesByFileIdReindex = (
  storageId: string,
  fileId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostStoragesByStorageIdFilesByFileIdReindex,
  method: httpMethod.post,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/files/${encodeURIComponent(fileId)}/reindex/`,
  params: { storageId, fileId },
  headers,
});

export interface FilesHttpGetStoragesByStorageIdGatewayEventsQuery {
  last_id?: string;
}

/**
 * `GET /v1/storages/{storage_id}/gateway/events/`
 *
 * Get pending storage gateway events
 *
 *
 * Responses
 * - 201 - Returns a gateway storage events
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - No matching storage exists
 *
 * Response {@link FilesIconikStorageGatewayEventsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_storages__storage_id__gateway_events_}
 */
export const httpGetStoragesByStorageIdGatewayEvents = (
  storageId: string,
  query?: FilesHttpGetStoragesByStorageIdGatewayEventsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetStoragesByStorageIdGatewayEvents,
  method: httpMethod.get,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/gateway/events/`,
  params: { storageId },
  query,
  headers,
});

/**
 * `POST /v1/storages/{storage_id}/gateway/events/`
 *
 * Create new storage gateway event
 *
 *
 * Responses
 * - 201 - Returns a created gateway storage event
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - No matching storage exists
 *
 * Response {@link FilesIconikStorageGatewayEventSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_storages__storage_id__gateway_events_}
 */
export const httpPostStoragesByStorageIdGatewayEvents = (
  storageId: string,
  body: FilesIconikStorageGatewayEventSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostStoragesByStorageIdGatewayEvents,
  method: httpMethod.post,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/gateway/events/`,
  params: { storageId },
  body,
  headers,
});

/**
 * `POST /v1/storages/{storage_id}/gateway/events/purge/`
 *
 * Delete storage gateway events in bulk
 *
 *
 * Responses
 * - 204 - Success
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_storages__storage_id__gateway_events_purge_}
 */
export const httpPostStoragesByStorageIdGatewayEventsPurge = (
  storageId: string,
  body: FilesIconikStorageGatewayEventsPurgeSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostStoragesByStorageIdGatewayEventsPurge,
  method: httpMethod.post,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/gateway/events/purge/`,
  params: { storageId },
  body,
  headers,
});

/**
 * `DELETE /v1/storages/{storage_id}/gateway/events/{event_id}/`
 *
 * Delete storage gateway event
 *
 *
 * Responses
 * - 204 - Success
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_storages__storage_id__gateway_events__event_id__}
 */
export const httpDeleteStoragesByStorageIdGatewayEventsByEventId = (
  storageId: string,
  eventId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteStoragesByStorageIdGatewayEventsByEventId,
  method: httpMethod.delete,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/gateway/events/${encodeURIComponent(eventId)}/`,
  params: { storageId, eventId },
  headers,
});

/**
 * `GET /v1/storages/{storage_id}/gateway/report/`
 *
 * Get storage gateway report
 *
 *
 * Responses
 * - 200 - Returns storage gateway report
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - No matching storage exists
 *
 * Response {@link FilesGatewayReportSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_storages__storage_id__gateway_report_}
 */
export const httpGetStoragesByStorageIdGatewayReport = (
  storageId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetStoragesByStorageIdGatewayReport,
  method: httpMethod.get,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/gateway/report/`,
  params: { storageId },
  headers,
});

/**
 * `PUT /v1/storages/{storage_id}/gateway/report/`
 *
 * Create storage gateway report
 *
 * Required roles:
 *  - is_storage_worker
 *
 * Responses
 * - 200 - Returns empty dict
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - No matching storage exists
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/put_v1_storages__storage_id__gateway_report_}
 */
export const httpPutStoragesByStorageIdGatewayReport = (
  storageId: string,
  body: FilesGatewayReportSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPutStoragesByStorageIdGatewayReport,
  method: httpMethod.put,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/gateway/report/`,
  params: { storageId },
  body,
  headers,
});

/**
 * `PUT /v1/storages/{storage_id}/gateway/status/`
 *
 * Update storage gateway status
 *
 * Required roles:
 *  - is_storage_worker
 *
 * Responses
 * - 200 - Returns empty dict
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - No matching storage exists
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/put_v1_storages__storage_id__gateway_status_}
 */
export const httpPutStoragesByStorageIdGatewayStatus = (
  storageId: string,
  body: FilesGatewayStatusSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPutStoragesByStorageIdGatewayStatus,
  method: httpMethod.put,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/gateway/status/`,
  params: { storageId },
  body,
  headers,
});

/**
 * Returns upload_url and path for storage logs
 */
export interface FilesHttpPostStoragesByStorageIdLogsResponse {
  path?: string;
  upload_url?: string;
}

/**
 * `POST /v1/storages/{storage_id}/logs/`
 *
 * Upload storage logs
 *
 * Required roles:
 *  - is_storage_worker
 *
 * Responses
 * - 200 - Returns upload_url and path for storage logs
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Storage does not exist
 *
 * Response {@link FilesHttpPostStoragesByStorageIdLogsResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_storages__storage_id__logs_}
 */
export const httpPostStoragesByStorageIdLogs = (
  storageId: string,
  body: FilesUploadIconikStorageGatewayLogsSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostStoragesByStorageIdLogs,
  method: httpMethod.post,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/logs/`,
  params: { storageId },
  body,
  headers,
});

/**
 * `POST /v1/storages/{storage_id}/reindex/`
 *
 * Trigger reindexing of a storage
 *
 * Required roles:
 *  - can_reindex_storages
 *
 * Responses
 * - 201 - ID and status of the job
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_storages__storage_id__reindex_}
 */
export const httpPostStoragesByStorageIdReindex = (
  storageId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostStoragesByStorageIdReindex,
  method: httpMethod.post,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/reindex/`,
  params: { storageId },
  headers,
});

/**
 * `POST /v1/storages/{storage_id}/scan/`
 *
 * Requests to scan a storage
 *
 * Required roles:
 *  - can_scan_bucket
 *
 * Responses
 * - 201 - Scan started
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_storages__storage_id__scan_}
 */
export const httpPostStoragesByStorageIdScan = (
  storageId: string,
  body: FilesStorageScanSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostStoragesByStorageIdScan,
  method: httpMethod.post,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/scan/`,
  params: { storageId },
  body,
  headers,
});

/**
 * `PUT /v1/storages/{storage_id}/search_document/`
 *
 * Update search document for storage
 *
 * Required roles:
 *  - can_reindex_storages
 *
 * Responses
 * - 204 - Storage document updated
 * - 400 - No document supplied
 * - 401 - Token is invalid
 * - 404 - Storage does not exist in search index
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/put_v1_storages__storage_id__search_document_}
 * @deprecated
 */
export const httpPutStoragesByStorageIdSearchDocument = (
  storageId: string,
  body: FilesStorageSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPutStoragesByStorageIdSearchDocument,
  method: httpMethod.put,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/search_document/`,
  params: { storageId },
  body,
  headers,
});

export interface FilesHttpGetStoragesByStorageIdTemporaryFilesQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * ID of a last file on previous page
   */
  last_id?: string;
}

/**
 * `GET /v1/storages/{storage_id}/temporary_files/`
 *
 * Get storage's exported files
 *
 * Required roles:
 *  - can_read_storages
 *
 * Responses
 * - 200 - Returns exported files
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link FilesFilesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_storages__storage_id__temporary_files_}
 */
export const httpGetStoragesByStorageIdTemporaryFiles = (
  storageId: string,
  query?: FilesHttpGetStoragesByStorageIdTemporaryFilesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetStoragesByStorageIdTemporaryFiles,
  method: httpMethod.get,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/temporary_files/`,
  params: { storageId },
  query,
  headers,
});

export interface FilesHttpGetStoragesByStorageIdTranscodersQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * ID of a last transcoder on previous page
   */
  last_id?: string;
}

/**
 * `GET /v1/storages/{storage_id}/transcoders/`
 *
 * Get all transcoders for a particular storage
 *
 * Required roles:
 *  - can_read_storages
 * - can_read_transcoders
 *
 * Responses
 * - 200 - Returns a list of transcoders
 * - 401 - Token is invalid
 *
 * Response {@link FilesTranscodersByStorageSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_storages__storage_id__transcoders_}
 */
export const httpGetStoragesByStorageIdTranscoders = (
  storageId: string,
  query?: FilesHttpGetStoragesByStorageIdTranscodersQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetStoragesByStorageIdTranscoders,
  method: httpMethod.get,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/transcoders/`,
  params: { storageId },
  query,
  headers,
});

/**
 * `DELETE /v1/storages/{storage_id}/transcoders/{transcoder_id}/`
 *
 * Delete a transcoder from storage
 *
 * Required roles:
 *  - can_write_transcoders
 *
 * Responses
 * - 204 - Returns a created transcoder entry
 * - 401 - Token is invalid
 * - 404 - Storage or transcoder does not exists
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_storages__storage_id__transcoders__transcoder_id__}
 */
export const httpDeleteStoragesByStorageIdTranscodersByTranscoderId = (
  storageId: string,
  transcoderId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteStoragesByStorageIdTranscodersByTranscoderId,
  method: httpMethod.delete,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/transcoders/${encodeURIComponent(transcoderId)}/`,
  params: { storageId, transcoderId },
  headers,
});

/**
 * `PUT /v1/storages/{storage_id}/transcoders/{transcoder_id}/`
 *
 * Create a new transcoder for storage
 *
 * Required roles:
 *  - can_write_transcoders
 *
 * Responses
 * - 201 - Returns a created transcoder entry
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Storage or transcoder does not exists
 *
 * Response {@link FilesTranscoderByStorageReadSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/put_v1_storages__storage_id__transcoders__transcoder_id__}
 */
export const httpPutStoragesByStorageIdTranscodersByTranscoderId = (
  storageId: string,
  transcoderId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPutStoragesByStorageIdTranscodersByTranscoderId,
  method: httpMethod.put,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/transcoders/${encodeURIComponent(transcoderId)}/`,
  params: { storageId, transcoderId },
  headers,
});

export interface FilesHttpGetStoragesByStorageIdTransfersFromQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * ID of a last transfer on previous page
   */
  last_id?: string;
}

/**
 * `GET /v1/storages/{storage_id}/transfers_from/`
 *
 * Get pending transfers of file sets from a local storage
 *
 * Required roles:
 *  - can_read_transfers
 *
 * Responses
 * - 200 - Returns pending transfers to be handled
 *
 * Response {@link FilesTransfersFromStorageSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_storages__storage_id__transfers_from_}
 */
export const httpGetStoragesByStorageIdTransfersFrom = (
  storageId: string,
  query?: FilesHttpGetStoragesByStorageIdTransfersFromQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetStoragesByStorageIdTransfersFrom,
  method: httpMethod.get,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/transfers_from/`,
  params: { storageId },
  query,
  headers,
});

export interface FilesHttpDeleteStoragesByStorageIdTransfersFromByTransferIdQuery {
  failed?: boolean;
  completed?: boolean;
}

/**
 * `DELETE /v1/storages/{storage_id}/transfers_from/{transfer_id}/`
 *
 * Delete file set transfer after handling it
 *
 * Required roles:
 *  - can_write_transfers
 *
 * Responses
 * - 204 - Transfer job was deleted
 * - 404 - Transfer job does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_storages__storage_id__transfers_from__transfer_id__}
 */
export const httpDeleteStoragesByStorageIdTransfersFromByTransferId = (
  storageId: string,
  transferId: string,
  query?: FilesHttpDeleteStoragesByStorageIdTransfersFromByTransferIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteStoragesByStorageIdTransfersFromByTransferId,
  method: httpMethod.delete,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/transfers_from/${encodeURIComponent(transferId)}/`,
  params: { storageId, transferId },
  query,
  headers,
});

/**
 * `GET /v1/storages/{storage_id}/transfers_from/{transfer_id}/`
 *
 * Get file set transfer record
 *
 * Required roles:
 *  - can_read_transfers
 *
 * Responses
 * - 200 - Returns a file set transfer from local storage
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Transfer does not exist
 *
 * Response {@link FilesTransferFromStorageReadSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_storages__storage_id__transfers_from__transfer_id__}
 */
export const httpGetStoragesByStorageIdTransfersFromByTransferId = (
  storageId: string,
  transferId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetStoragesByStorageIdTransfersFromByTransferId,
  method: httpMethod.get,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/transfers_from/${encodeURIComponent(transferId)}/`,
  params: { storageId, transferId },
  headers,
});

export interface FilesHttpGetStoragesByStorageIdTransfersToQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * ID of a last transfer on previous page
   */
  last_id?: string;
}

/**
 * `GET /v1/storages/{storage_id}/transfers_to/`
 *
 * Get pending transfers of file sets to a local storage
 *
 * Required roles:
 *  - can_read_transfers
 *
 * Responses
 * - 200 - Returns pending transfers to be handled
 *
 * Response {@link FilesTransfersToStorageSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_storages__storage_id__transfers_to_}
 */
export const httpGetStoragesByStorageIdTransfersTo = (
  storageId: string,
  query?: FilesHttpGetStoragesByStorageIdTransfersToQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetStoragesByStorageIdTransfersTo,
  method: httpMethod.get,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/transfers_to/`,
  params: { storageId },
  query,
  headers,
});

export interface FilesHttpDeleteStoragesByStorageIdTransfersToByTransferIdQuery {
  failed?: boolean;
  completed?: boolean;
}

/**
 * `DELETE /v1/storages/{storage_id}/transfers_to/{transfer_id}/`
 *
 * Delete file set transfer after handling it
 *
 * Required roles:
 *  - can_write_transfers
 *
 * Responses
 * - 204 - Transfer job was deleted
 * - 404 - Transfer job does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_storages__storage_id__transfers_to__transfer_id__}
 */
export const httpDeleteStoragesByStorageIdTransfersToByTransferId = (
  storageId: string,
  transferId: string,
  query?: FilesHttpDeleteStoragesByStorageIdTransfersToByTransferIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteStoragesByStorageIdTransfersToByTransferId,
  method: httpMethod.delete,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/transfers_to/${encodeURIComponent(transferId)}/`,
  params: { storageId, transferId },
  query,
  headers,
});

/**
 * `GET /v1/storages/{storage_id}/transfers_to/{transfer_id}/`
 *
 * Get file set transfer record
 *
 * Required roles:
 *  - can_read_transfers
 *
 * Responses
 * - 200 - Returns a file set transfer to local storage
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Transfer does not exist
 *
 * Response {@link FilesTransferToStorageReadSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_storages__storage_id__transfers_to__transfer_id__}
 */
export const httpGetStoragesByStorageIdTransfersToByTransferId = (
  storageId: string,
  transferId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetStoragesByStorageIdTransfersToByTransferId,
  method: httpMethod.get,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/transfers_to/${encodeURIComponent(transferId)}/`,
  params: { storageId, transferId },
  headers,
});

/**
 * Returns a document describing storage access
 */
export interface FilesHttpGetStoragesByStorageIdVerificationsAccessResponse {
  access_check?: boolean;
  error_message?: string;
}

/**
 * `GET /v1/storages/{storage_id}/verifications/access/`
 *
 * Verify storage access
 *
 * Required roles:
 *  - can_read_storages
 *
 * Responses
 * - 200 - Returns a document describing storage access
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Storage does not exist
 *
 * Response {@link FilesHttpGetStoragesByStorageIdVerificationsAccessResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_storages__storage_id__verifications_access_}
 */
export const httpGetStoragesByStorageIdVerificationsAccess = (
  storageId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetStoragesByStorageIdVerificationsAccess,
  method: httpMethod.get,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/verifications/access/`,
  params: { storageId },
  headers,
});

/**
 * Returns a document describing storage permissions
 */
export interface FilesHttpGetStoragesByStorageIdVerificationsPermissionsResponse {
  cors?: boolean;
  cors_error?: string;
  delete_access?: boolean;
  delete_access_error?: string;
  error_message?: string;
  read_access?: boolean;
  read_access_error?: string;
  write_access?: boolean;
  write_access_error?: string;
}

/**
 * `GET /v1/storages/{storage_id}/verifications/permissions/`
 *
 * Verify storage permissions
 *
 * Required roles:
 *  - can_write_storages
 *
 * Responses
 * - 200 - Returns a document describing storage permissions
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Storage does not exist
 *
 * Response {@link FilesHttpGetStoragesByStorageIdVerificationsPermissionsResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_storages__storage_id__verifications_permissions_}
 */
export const httpGetStoragesByStorageIdVerificationsPermissions = (
  storageId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetStoragesByStorageIdVerificationsPermissions,
  method: httpMethod.get,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/verifications/permissions/`,
  params: { storageId },
  headers,
});

/**
 * `DELETE /v1/storages/{storage_id}/{object_type}/files/`
 *
 * Delete files from a particular storage from multiple objects
 *
 * Required roles:
 *  - can_read_storages
 * - can_delete_files
 *
 * Responses
 * - 202 - Returns the updated objects
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 501 - Invalid object type
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_storages__storage_id___object_type__files_}
 */
export const httpDeleteStoragesByStorageIdByObjectTypeFiles = (
  storageId: string,
  objectType: string,
  body: FilesStorageFilesDeleteBulkSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteStoragesByStorageIdByObjectTypeFiles,
  method: httpMethod.delete,
  url: `/API/files/v1/storages/${encodeURIComponent(storageId)}/${encodeURIComponent(objectType)}/files/`,
  params: { storageId, objectType },
  body,
  headers,
});

export interface FilesHttpGetTranscodersQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * Search query
   */
  query?: string;
  /**
   * Filter list of id:s (comma separated)
   */
  ids?: string;
  /**
   * A comma separated list of fieldnames with order. For example - first_name,asc;last_name,desc
   */
  sort?: string;
  /**
   * Include storage information for each transcoder
   */
  include_storages?: boolean;
}

/**
 * `GET /v1/transcoders/`
 *
 * Get all transcoders
 *
 * Required roles:
 *  - can_read_transcoders
 *
 * Responses
 * - 200 - Returns a list of transcoders
 * - 401 - Token is invalid
 *
 * Response {@link FilesTranscodersSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_transcoders_}
 */
export const httpGetTranscoders = (
  query?: FilesHttpGetTranscodersQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetTranscoders,
  method: httpMethod.get,
  url: '/API/files/v1/transcoders/',

  query,
  headers,
});

/**
 * `POST /v1/transcoders/`
 *
 * Create a new transcoder
 *
 * Required roles:
 *  - can_write_transcoders
 *
 * Responses
 * - 201 - Returns a created transcoder entry
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesTranscoderSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_transcoders_}
 */
export const httpPostTranscoders = (
  body: FilesTranscoderSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostTranscoders,
  method: httpMethod.post,
  url: '/API/files/v1/transcoders/',

  body,
  headers,
});

/**
 * `DELETE /v1/transcoders/{transcoder_id}/`
 *
 * Delete a particular transcoder by id
 *
 * Required roles:
 *  - can_delete_transcoders
 *
 * Responses
 * - 204 - Without body
 * - 401 - Token is invalid
 * - 404 - Transcoder doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/delete_v1_transcoders__transcoder_id__}
 */
export const httpDeleteTranscodersByTranscoderId = (
  transcoderId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpDeleteTranscodersByTranscoderId,
  method: httpMethod.delete,
  url: `/API/files/v1/transcoders/${encodeURIComponent(transcoderId)}/`,
  params: { transcoderId },
  headers,
});

/**
 * `GET /v1/transcoders/{transcoder_id}/`
 *
 * Returns a particular transcoder by id
 *
 * Required roles:
 *  - can_read_transcoders
 *
 * Responses
 * - 200 - Returns a transcoder
 * - 401 - Token is invalid
 * - 404 - Transcoder doesn't exist
 *
 * Response {@link FilesTranscoderSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_transcoders__transcoder_id__}
 */
export const httpGetTranscodersByTranscoderId = (
  transcoderId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetTranscodersByTranscoderId,
  method: httpMethod.get,
  url: `/API/files/v1/transcoders/${encodeURIComponent(transcoderId)}/`,
  params: { transcoderId },
  headers,
});

export type FilesTranscoderSchemaPartial = Partial<FilesTranscoderSchema>;

/**
 * `PATCH /v1/transcoders/{transcoder_id}/`
 *
 * Update transcoder
 *
 * Required roles:
 *  - can_write_transcoders
 *
 * Responses
 * - 200 - Returns an updated transcoder
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesTranscoderSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/patch_v1_transcoders__transcoder_id__}
 */
export const httpPatchTranscodersByTranscoderId = (
  transcoderId: string,
  body: FilesTranscoderSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPatchTranscodersByTranscoderId,
  method: httpMethod.patch,
  url: `/API/files/v1/transcoders/${encodeURIComponent(transcoderId)}/`,
  params: { transcoderId },
  body,
  headers,
});

/**
 * `PUT /v1/transcoders/{transcoder_id}/`
 *
 * Update transcoder
 *
 * Required roles:
 *  - can_write_transcoders
 *
 * Responses
 * - 200 - Returns an updated transcoder
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link FilesTranscoderSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/put_v1_transcoders__transcoder_id__}
 */
export const httpPutTranscodersByTranscoderId = (
  transcoderId: string,
  body: FilesTranscoderSchema,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPutTranscodersByTranscoderId,
  method: httpMethod.put,
  url: `/API/files/v1/transcoders/${encodeURIComponent(transcoderId)}/`,
  params: { transcoderId },
  body,
  headers,
});

/**
 * Returns upload_url and path for transcoder logs
 */
export interface FilesHttpPostTranscodersByTranscoderIdLogsResponse {
  path?: string;
  upload_url?: string;
}

export interface FilesHttpPostTranscodersByTranscoderIdLogsQuery {
  filename: string;
}

/**
 * `POST /v1/transcoders/{transcoder_id}/logs/`
 *
 * Upload transcoder logs
 *
 * Required roles:
 *  - is_storage_worker
 *
 * Responses
 * - 200 - Returns upload_url and path for transcoder logs
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Storage does not exist
 *
 * Response {@link FilesHttpPostTranscodersByTranscoderIdLogsResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_transcoders__transcoder_id__logs_}
 */
export const httpPostTranscodersByTranscoderIdLogs = (
  transcoderId: string,
  query?: FilesHttpPostTranscodersByTranscoderIdLogsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostTranscodersByTranscoderIdLogs,
  method: httpMethod.post,
  url: `/API/files/v1/transcoders/${encodeURIComponent(transcoderId)}/logs/`,
  params: { transcoderId },
  query,
  headers,
});

/**
 * `GET /v1/transcoders/{transcoder_id}/options/{option_name}/`
 *
 * Get options for a transcoder configuration.
 *
 * Required roles:
 *  - can_read_transcoders
 *
 * Responses
 * - 200 - Returns a list of value options for the specified transcoder configuration option.
 * - 401 - Token is invalid
 *
 * Response {@link FilesTranscoderOptionsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_transcoders__transcoder_id__options__option_name__}
 */
export const httpGetTranscodersByTranscoderIdOptionsByOptionName = (
  transcoderId: string,
  optionName: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetTranscodersByTranscoderIdOptionsByOptionName,
  method: httpMethod.get,
  url: `/API/files/v1/transcoders/${encodeURIComponent(transcoderId)}/options/${encodeURIComponent(optionName)}/`,
  params: { transcoderId, optionName },
  headers,
});

/**
 * `POST /v1/transcoders/{transcoder_id}/reindex/`
 *
 * Trigger reindexing of a transcoder
 *
 * Required roles:
 *  - can_reindex_transcoders
 *
 * Responses
 * - 201 - ID and status of the job
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_transcoders__transcoder_id__reindex_}
 */
export const httpPostTranscodersByTranscoderIdReindex = (
  transcoderId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostTranscodersByTranscoderIdReindex,
  method: httpMethod.post,
  url: `/API/files/v1/transcoders/${encodeURIComponent(transcoderId)}/reindex/`,
  params: { transcoderId },
  headers,
});

export interface FilesHttpGetTranscodersByTranscoderIdStoragesQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * ID of a last storage on previous page
   */
  last_id?: string;
}

/**
 * `GET /v1/transcoders/{transcoder_id}/storages/`
 *
 * Get storages linked to a transcoder
 *
 * Required roles:
 *  - can_read_transcoders
 *
 * Responses
 * - 200 - Returns a list of storages
 * - 401 - Token is invalid
 *
 * Response {@link FilesStoragesReadSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_transcoders__transcoder_id__storages_}
 */
export const httpGetTranscodersByTranscoderIdStorages = (
  transcoderId: string,
  query?: FilesHttpGetTranscodersByTranscoderIdStoragesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetTranscodersByTranscoderIdStorages,
  method: httpMethod.get,
  url: `/API/files/v1/transcoders/${encodeURIComponent(transcoderId)}/storages/`,
  params: { transcoderId },
  query,
  headers,
});

/**
 * `POST /v1/transfers/{transfer_id}/urls/`
 *
 * Generates a url for direct file downloads (for IGSs)
 *
 *
 * Responses
 * - 200 - Generated signed url
 * - 400 - Failed to generate url
 * - 403 - User not authorized to get url for job
 * - 404 - Transfer job does not exist
 *
 * Response {@link FilesTransferSignedURLSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v1_transfers__transfer_id__urls_}
 */
export const httpPostTransfersByTransferIdUrls = (
  transferId: string,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostTransfersByTransferIdUrls,
  method: httpMethod.post,
  url: `/API/files/v1/transfers/${encodeURIComponent(transferId)}/urls/`,
  params: { transferId },
  headers,
});

export interface FilesHttpGetTransfersByTransferIdUrlsVerifyQuery {
  user_id: string;
  signature: string;
}

/**
 * `GET /v1/transfers/{transfer_id}/urls/verify/`
 *
 * Verifies the signature of a url
 *
 *
 * Responses
 * - 200 - Verified signed url
 * - 400 - Not a valid signed url
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/get_v1_transfers__transfer_id__urls_verify_}
 */
export const httpGetTransfersByTransferIdUrlsVerify = (
  transferId: string,
  query?: FilesHttpGetTransfersByTransferIdUrlsVerifyQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpGetTransfersByTransferIdUrlsVerify,
  method: httpMethod.get,
  url: `/API/files/v1/transfers/${encodeURIComponent(transferId)}/urls/verify/`,
  params: { transferId },
  query,
  headers,
});

export interface FilesHttpPostV2AssetsBulkArchiveQuery {
  /**
   * Enable transfer through iconik host (creates egress)
   */
  allow_host_transfer?: boolean;
}

/**
 * `POST /v2/assets/bulk/archive/`
 *
 * Archive multiple assets to a storage.
 *
 * Required roles:
 *  - can_archive_formats
 *
 * Responses
 * - 202 - Archive jobs created
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Permission on storage denied
 * - 404 - Asset or storage not found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v2_assets_bulk_archive_}
 */
export const httpPostV2AssetsBulkArchive = (
  body: FilesBulkArchiveAssetRequestSchema,
  query?: FilesHttpPostV2AssetsBulkArchiveQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostV2AssetsBulkArchive,
  method: httpMethod.post,
  url: '/API/files/v2/assets/bulk/archive/',

  body,
  query,
  headers,
});

export interface FilesHttpPostV2AssetsBulkRestoreQuery {
  /**
   * Enable transfer through iconik host (creates egress)
   */
  allow_host_transfer?: boolean;
}

/**
 * `POST /v2/assets/bulk/restore/`
 *
 * Restore multiple objects.
 *
 * Required roles:
 *  - can_restore_archived_formats
 *
 * Responses
 * - 202 - Transfer jobs created
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Permission on storage denied
 * - 404 - Format or storage not found
 * - 409 - Format already exists on storage.
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v2_assets_bulk_restore_}
 */
export const httpPostV2AssetsBulkRestore = (
  body: FilesBulkRestoreAssetRequestSchema,
  query?: FilesHttpPostV2AssetsBulkRestoreQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostV2AssetsBulkRestore,
  method: httpMethod.post,
  url: '/API/files/v2/assets/bulk/restore/',

  body,
  query,
  headers,
});

export interface FilesHttpPostV2AssetsExportLocationsByExportLocationIdBulkExportQuery {
  /**
   * Enable transfer through iconik host (creates egress)
   */
  allow_host_transfer?: boolean;
}

/**
 * `POST /v2/assets/export_locations/{export_location_id}/bulk/export/`
 *
 * Export multiple assets.
 *
 * Required roles:
 *  - can_write_exports
 *
 * Responses
 * - 202 - Transfer jobs created
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Permission on storage denied
 * - 404 - Format or storage not found
 * - 409 - Format already exists on storage.
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v2_assets_export_locations__export_location_id__bulk_export_}
 */
export const httpPostV2AssetsExportLocationsByExportLocationIdBulkExport = (
  exportLocationId: string,
  body: FilesBulkExportAssetRequestSchema,
  query?: FilesHttpPostV2AssetsExportLocationsByExportLocationIdBulkExportQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostV2AssetsExportLocationsByExportLocationIdBulkExport,
  method: httpMethod.post,
  url: `/API/files/v2/assets/export_locations/${encodeURIComponent(exportLocationId)}/bulk/export/`,
  params: { exportLocationId },
  body,
  query,
  headers,
});

export interface FilesHttpPostV2AssetsStoragesByStorageIdBulkTransferQuery {
  /**
   * Enable transfer through iconik host (creates egress)
   */
  allow_host_transfer?: boolean;
}

/**
 * `POST /v2/assets/storages/{storage_id}/bulk/transfer/`
 *
 * Transfer multiple objects.
 *
 * Required roles:
 *  - can_write_transfers
 *
 * Responses
 * - 202 - Transfer jobs created
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Permission on storage denied
 * - 404 - Format or storage not found
 * - 409 - Format already exists on storage.
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v2_assets_storages__storage_id__bulk_transfer_}
 */
export const httpPostV2AssetsStoragesByStorageIdBulkTransfer = (
  storageId: string,
  body: FilesBulkTransferAssetRequestSchema,
  query?: FilesHttpPostV2AssetsStoragesByStorageIdBulkTransferQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostV2AssetsStoragesByStorageIdBulkTransfer,
  method: httpMethod.post,
  url: `/API/files/v2/assets/storages/${encodeURIComponent(storageId)}/bulk/transfer/`,
  params: { storageId },
  body,
  query,
  headers,
});

export interface FilesHttpPostV2AssetsByAssetIdFormatsByFormatIdArchiveQuery {
  /**
   * Enable transfer through iconik host (creates egress)
   */
  allow_host_transfer?: boolean;
}

/**
 * `POST /v2/assets/{asset_id}/formats/{format_id}/archive/`
 *
 * Archive format
 *
 * Required roles:
 *  - can_archive_formats
 *
 * Responses
 * - 202 - No body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Format for this asset doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v2_assets__asset_id__formats__format_id__archive_}
 */
export const httpPostV2AssetsByAssetIdFormatsByFormatIdArchive = (
  assetId: string,
  formatId: string,
  body: FilesArchiveAssetFormatSchema,
  query?: FilesHttpPostV2AssetsByAssetIdFormatsByFormatIdArchiveQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostV2AssetsByAssetIdFormatsByFormatIdArchive,
  method: httpMethod.post,
  url: `/API/files/v2/assets/${encodeURIComponent(assetId)}/formats/${encodeURIComponent(formatId)}/archive/`,
  params: { assetId, formatId },
  body,
  query,
  headers,
});

export interface FilesHttpPostV2AssetsByAssetIdFormatsByFormatIdStoragesByStorageIdQuery {
  /**
   * Enable transfer through iconik host (creates egress)
   */
  allow_host_transfer?: boolean;
}

/**
 * `POST /v2/assets/{asset_id}/formats/{format_id}/storages/{storage_id}/`
 *
 * Transfer formats file sets to another storage.
 *
 * Required roles:
 *  - can_write_transfers
 *
 * Responses
 * - 202 - Copy job created
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Permission on storage denied
 * - 404 - Format or storage not found
 * - 409 - Format already exists on storage.
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v2_assets__asset_id__formats__format_id__storages__storage_id__}
 */
export const httpPostV2AssetsByAssetIdFormatsByFormatIdStoragesByStorageId = (
  assetId: string,
  formatId: string,
  storageId: string,
  body: FilesTransferFormatToStorageSchema,
  query?: FilesHttpPostV2AssetsByAssetIdFormatsByFormatIdStoragesByStorageIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostV2AssetsByAssetIdFormatsByFormatIdStoragesByStorageId,
  method: httpMethod.post,
  url: `/API/files/v2/assets/${encodeURIComponent(assetId)}/formats/${encodeURIComponent(formatId)}/storages/${encodeURIComponent(storageId)}/`,
  params: { assetId, formatId, storageId },
  body,
  query,
  headers,
});

export interface FilesHttpPostV2CollectionsBulkArchiveQuery {
  /**
   * Enable transfer through iconik host (creates egress)
   */
  allow_host_transfer?: boolean;
}

/**
 * `POST /v2/collections/bulk/archive/`
 *
 * Archive multiple assets to a storage.
 *
 * Required roles:
 *  - can_archive_formats
 *
 * Responses
 * - 202 - Archive jobs created
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Permission on storage denied
 * - 404 - Asset or storage not found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v2_collections_bulk_archive_}
 */
export const httpPostV2CollectionsBulkArchive = (
  body: FilesBulkArchiveCollectionRequestSchema,
  query?: FilesHttpPostV2CollectionsBulkArchiveQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostV2CollectionsBulkArchive,
  method: httpMethod.post,
  url: '/API/files/v2/collections/bulk/archive/',

  body,
  query,
  headers,
});

export interface FilesHttpPostV2CollectionsBulkRestoreQuery {
  /**
   * Enable transfer through iconik host (creates egress)
   */
  allow_host_transfer?: boolean;
}

/**
 * `POST /v2/collections/bulk/restore/`
 *
 * Restore multiple collections to a storage.
 *
 * Required roles:
 *  - can_restore_archived_formats
 *
 * Responses
 * - 202 - Restore jobs created
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Permission on storage denied
 * - 404 - Asset or storage not found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v2_collections_bulk_restore_}
 */
export const httpPostV2CollectionsBulkRestore = (
  body: FilesBulkRestoreCollectionRequestSchema,
  query?: FilesHttpPostV2CollectionsBulkRestoreQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostV2CollectionsBulkRestore,
  method: httpMethod.post,
  url: '/API/files/v2/collections/bulk/restore/',

  body,
  query,
  headers,
});

export interface FilesHttpPostV2CollectionsExportLocationsByExportLocationIdBulkExportQuery {
  /**
   * Enable transfer through iconik host (creates egress)
   */
  allow_host_transfer?: boolean;
}

/**
 * `POST /v2/collections/export_locations/{export_location_id}/bulk/export/`
 *
 * Export multiple collections.
 *
 * Required roles:
 *  - can_write_exports
 *
 * Responses
 * - 202 - Transfer jobs created
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Permission on storage denied
 * - 404 - Format or storage not found
 * - 409 - Format already exists on storage.
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v2_collections_export_locations__export_location_id__bulk_export_}
 */
export const httpPostV2CollectionsExportLocationsByExportLocationIdBulkExport =
  (
    exportLocationId: string,
    body: FilesBulkExportCollectionRequestSchema,
    query?: FilesHttpPostV2CollectionsExportLocationsByExportLocationIdBulkExportQuery,
    headers?: IconikApiHeaders,
  ) => ({
    id: FilesHttpPostV2CollectionsExportLocationsByExportLocationIdBulkExport,
    method: httpMethod.post,
    url: `/API/files/v2/collections/export_locations/${encodeURIComponent(exportLocationId)}/bulk/export/`,
    params: { exportLocationId },
    body,
    query,
    headers,
  });

export interface FilesHttpPostV2CollectionsStoragesByStorageIdBulkTransferQuery {
  /**
   * Enable transfer through iconik host (creates egress)
   */
  allow_host_transfer?: boolean;
}

/**
 * `POST /v2/collections/storages/{storage_id}/bulk/transfer/`
 *
 * Transfer multiple objects.
 *
 * Required roles:
 *  - can_write_transfers
 *
 * Responses
 * - 202 - Transfer jobs created
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Permission on storage denied
 * - 404 - Format or storage not found
 * - 409 - Format already exists on storage.
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v2_collections_storages__storage_id__bulk_transfer_}
 */
export const httpPostV2CollectionsStoragesByStorageIdBulkTransfer = (
  storageId: string,
  body: FilesBulkTransferCollectionRequestSchema,
  query?: FilesHttpPostV2CollectionsStoragesByStorageIdBulkTransferQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostV2CollectionsStoragesByStorageIdBulkTransfer,
  method: httpMethod.post,
  url: `/API/files/v2/collections/storages/${encodeURIComponent(storageId)}/bulk/transfer/`,
  params: { storageId },
  body,
  query,
  headers,
});

export interface FilesHttpPostV2SavedSearchesBulkArchiveQuery {
  /**
   * Enable transfer through iconik host (creates egress)
   */
  allow_host_transfer?: boolean;
}

/**
 * `POST /v2/saved_searches/bulk/archive/`
 *
 * Transfer multiple objects.
 *
 * Required roles:
 *  - can_archive_formats
 *
 * Responses
 * - 202 - Transfer jobs created
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Permission on storage denied
 * - 404 - Format or storage not found
 * - 409 - Format already exists on storage.
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v2_saved_searches_bulk_archive_}
 */
export const httpPostV2SavedSearchesBulkArchive = (
  body: FilesBulkArchiveSavedSearchRequestSchema,
  query?: FilesHttpPostV2SavedSearchesBulkArchiveQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostV2SavedSearchesBulkArchive,
  method: httpMethod.post,
  url: '/API/files/v2/saved_searches/bulk/archive/',

  body,
  query,
  headers,
});

export interface FilesHttpPostV2SavedSearchesBulkRestoreQuery {
  /**
   * Enable transfer through iconik host (creates egress)
   */
  allow_host_transfer?: boolean;
}

/**
 * `POST /v2/saved_searches/bulk/restore/`
 *
 * Restore multiple saved searches.
 *
 * Required roles:
 *  - can_restore_archived_formats
 *
 * Responses
 * - 202 - Transfer jobs created
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Permission on storage denied
 * - 404 - Format or storage not found
 * - 409 - Format already exists on storage.
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v2_saved_searches_bulk_restore_}
 */
export const httpPostV2SavedSearchesBulkRestore = (
  body: FilesBulkRestoreSavedSearchRequestSchema,
  query?: FilesHttpPostV2SavedSearchesBulkRestoreQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostV2SavedSearchesBulkRestore,
  method: httpMethod.post,
  url: '/API/files/v2/saved_searches/bulk/restore/',

  body,
  query,
  headers,
});

export interface FilesHttpPostV2SavedSearchesExportLocationsByExportLocationIdBulkExportQuery {
  /**
   * Enable transfer through iconik host (creates egress)
   */
  allow_host_transfer?: boolean;
}

/**
 * `POST /v2/saved_searches/export_locations/{export_location_id}/bulk/export/`
 *
 * Export multiple saved searches.
 *
 * Required roles:
 *  - can_write_exports
 *
 * Responses
 * - 202 - Transfer jobs created
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Permission on storage denied
 * - 404 - Format or storage not found
 * - 409 - Format already exists on storage.
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v2_saved_searches_export_locations__export_location_id__bulk_export_}
 */
export const httpPostV2SavedSearchesExportLocationsByExportLocationIdBulkExport =
  (
    exportLocationId: string,
    body: FilesBulkExportSavedSearchRequestSchema,
    query?: FilesHttpPostV2SavedSearchesExportLocationsByExportLocationIdBulkExportQuery,
    headers?: IconikApiHeaders,
  ) => ({
    id: FilesHttpPostV2SavedSearchesExportLocationsByExportLocationIdBulkExport,
    method: httpMethod.post,
    url: `/API/files/v2/saved_searches/export_locations/${encodeURIComponent(exportLocationId)}/bulk/export/`,
    params: { exportLocationId },
    body,
    query,
    headers,
  });

export interface FilesHttpPostV2SavedSearchesStoragesByStorageIdBulkTransferQuery {
  /**
   * Enable transfer through iconik host (creates egress)
   */
  allow_host_transfer?: boolean;
}

/**
 * `POST /v2/saved_searches/storages/{storage_id}/bulk/transfer/`
 *
 * Transfer multiple objects.
 *
 * Required roles:
 *  - can_write_transfers
 *
 * Responses
 * - 202 - Transfer jobs created
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Permission on storage denied
 * - 404 - Format or storage not found
 * - 409 - Format already exists on storage.
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/files/spec/#/default/post_v2_saved_searches_storages__storage_id__bulk_transfer_}
 */
export const httpPostV2SavedSearchesStoragesByStorageIdBulkTransfer = (
  storageId: string,
  body: FilesBulkTransferSavedSearchRequestSchema,
  query?: FilesHttpPostV2SavedSearchesStoragesByStorageIdBulkTransferQuery,
  headers?: IconikApiHeaders,
) => ({
  id: FilesHttpPostV2SavedSearchesStoragesByStorageIdBulkTransfer,
  method: httpMethod.post,
  url: `/API/files/v2/saved_searches/storages/${encodeURIComponent(storageId)}/bulk/transfer/`,
  params: { storageId },
  body,
  query,
  headers,
});
